/* eslint-disable max-len */
export const LANGUAGE_OPTIONS = [
  {value: 'English', label: 'English'},
  {value: 'Latin', label: 'Latin'},
  {value: 'American', label: 'American'},
  {value: 'Spanish', label: 'Spanish'},
  {value: 'Brazilian', label: 'Brazilian'},
  {value: 'Japanes', label: 'Japanes'},
  {value: 'Chinese', label: 'Chinese'},
  {value: 'Other Please Specify', label: 'Other Please Specify'}
];

export const COMMODITY_OPTIONS = [
  {label: 'Timber products', value: 'Timber products'},
  {label: 'Palm oil', value: 'Palm oil'},
  {
    label: 'Cattle products',
    value: 'Cattle products'
  },
  {label: 'Cocoa', value: 'Cocoa'},
  {label: 'Coffee', value: 'Coffee'},
  {label: 'Soy', value: 'Soy'},
  {label: 'Rubber', value: 'Rubber'}
];

export const SUPPLIER_TIER_OPTIONS = [
  {value: 'Tier 1 suppliers', label: 'Tier 1 suppliers'},
  {value: 'Tier 2 suppliers', label: 'Tier 2 suppliers'},
  {value: 'Tier 3 suppliers', label: 'Tier 3 suppliers'},
  {value: 'Tier 4+ suppliers', label: 'Tier 4+ suppliers'}
];

export const PROJECT_OPTIONS = [
  {value: 'Project 1', label: 'Project 1'},
  {value: 'Project 2', label: 'Project 2'},
  {value: 'Project 3', label: 'Project 3'},
  {value: 'Project 4', label: 'Project 4'},
  {value: 'Project 5', label: 'Project 5'},
  {value: 'Project 6', label: 'Project 6'},
  {value: 'Project 7', label: 'Project 7'},
  {value: 'Project 8', label: 'Project 8'},
  {value: 'Project 9', label: 'Project 9'},
  {value: 'Project 10', label: 'Project 10'},
  {value: 'Project 11', label: 'Project 11'},
  {value: 'Project 12', label: 'Project 12'},
  {value: 'Project 13', label: 'Project 13'},
  {value: 'Project 14', label: 'Project 14'},
  {value: 'Project 15', label: 'Project 15'},
  {value: 'Project 16', label: 'Project 16'},
  {value: 'Project 17', label: 'Project 17'},
  {value: 'Project 18', label: 'Project 18'},
  {value: 'Project 19', label: 'Project 19'},
  {value: 'Project 20', label: 'Project 20'},
  {value: 'Project 21', label: 'Project 21'},
  {value: 'Project 22', label: 'Project 22'},
  {value: 'Project 23', label: 'Project 23'},
  {value: 'Project 24', label: 'Project 24'},
  {value: 'Project 25', label: 'Project 25'},
  {value: 'Project 26', label: 'Project 26'},
  {value: 'Project 27', label: 'Project 27'},
  {value: 'Project 28', label: 'Project 28'},
  {value: 'Project 29', label: 'Project 29'},
  {value: 'Project 30', label: 'Project 30'},
  {value: 'Project 31', label: 'Project 31'},
  {value: 'Project 32', label: 'Project 32'},
  {value: 'Project 33', label: 'Project 33'},
  {value: 'Project 34', label: 'Project 34'},
  {value: 'Project 35', label: 'Project 35'},
  {value: 'Project 36', label: 'Project 36'},
  {value: 'Project 37', label: 'Project 37'},
  {value: 'Project 38', label: 'Project 38'},
  {value: 'Project 39', label: 'Project 39'},
  {value: 'Project 40', label: 'Project 40'},
  {value: 'Project 41', label: 'Project 41'},
  {value: 'Project 42', label: 'Project 42'},
  {value: 'Project 43', label: 'Project 43'},
  {value: 'Project 44', label: 'Project 44'},
  {value: 'Project 45', label: 'Project 45'},
  {value: 'Project 46', label: 'Project 46'},
  {value: 'Project 47', label: 'Project 47'},
  {value: 'Project 48', label: 'Project 48'},
  {value: 'Project 49', label: 'Project 49'},
  {value: 'Project 50', label: 'Project 50'},
  {value: 'Project 51', label: 'Project 51'},
  {value: 'Project 52', label: 'Project 52'},
  {value: 'Project 53', label: 'Project 53'},
  {value: 'Project 54', label: 'Project 54'},
  {value: 'Project 55', label: 'Project 55'},
  {value: 'Project 56', label: 'Project 56'},
  {value: 'Project 57', label: 'Project 57'},
  {value: 'Project 58', label: 'Project 58'},
  {value: 'Project 59', label: 'Project 59'},
  {value: 'Project 60', label: 'Project 60'},
  {value: 'Project 61', label: 'Project 61'},
  {value: 'Project 62', label: 'Project 62'},
  {value: 'Project 63', label: 'Project 63'},
  {value: 'Project 64', label: 'Project 64'},
  {value: 'Project 65', label: 'Project 65'},
  {value: 'Project 66', label: 'Project 66'},
  {value: 'Project 67', label: 'Project 67'},
  {value: 'Project 68', label: 'Project 68'},
  {value: 'Project 69', label: 'Project 69'},
  {value: 'Project 70', label: 'Project 70'}
];

export const TOOLS_AND_METHODS_OPTIONS = [
  {
    label: 'Enterprise Risk Management',
    options: [
      {
        value: 'Enterprise Risk Management',
        label: 'Enterprise Risk Management'
      },
      {
        value: 'COSO Enterprise Risk Management Framework',
        label: 'COSO Enterprise Risk Management Framework'
      },
      {
        value: 'Enterprise Risk Management',
        label: 'Enterprise Risk Management'
      },
      {value: 'Field surveys [F, B only]', label: 'Field surveys [F, B only]'},
      {value: 'Internal company methods', label: 'Internal company methods'},
      {
        value: 'ISO 31000 Risk Management Standard',
        label: 'ISO 31000 Risk Management Standard'
      },
      {
        value: 'Landscape-scale field surveys [F, B only]',
        label: 'Landscape-scale field surveys [F, B only]'
      },
      {value: 'Risk models', label: 'Risk models'},
      {value: 'Stress tests', label: 'Stress tests'},
      {
        value: 'Other enterprise risk management, please specify',
        label: 'Other enterprise risk management, please specify'
      }
    ]
  },
  {
    label: 'International methodologies and standards',
    options: [
      {
        value: 'Alliance for Water Stewardship Standard [W only]',
        label: 'Alliance for Water Stewardship Standard [W only]'
      },
      {
        value: 'Environmental Impact Assessment',
        label: 'Environmental Impact Assessment'
      },
      {
        value: 'Global Forest Watch [F only]',
        label: 'Global Forest Watch [F only]'
      },
      {
        value: 'IPCC Climate Change Projections',
        label: 'IPCC Climate Change Projections'
      },
      {
        value: 'ISO 14001 Environmental Management Standard',
        label: 'ISO 14001 Environmental Management Standard'
      },
      {
        value: 'ISO 14046 Environmental Management – Water Footprint [W only]',
        label: 'ISO 14046 Environmental Management – Water Footprint [W only]'
      },
      {value: 'Life Cycle Assessment', label: 'Life Cycle Assessment'},
      {
        value: 'Paris Agreement Capital Transition Assessment (PACTA) tool',
        label: 'Paris Agreement Capital Transition Assessment (PACTA) tool'
      },
      {
        value:
          'UN Water Global Analysis and Assessment of Sanitation and Drinking Water (GLAAS) [W only]',
        label:
          'UN Water Global Analysis and Assessment of Sanitation and Drinking Water (GLAAS) [W only]'
      },
      {
        value:
          'Other international methodologies and standards, please specify',
        label: 'Other international methodologies and standards, please specify'
      }
    ]
  },
  {
    label: 'Databases',
    options: [
      {value: 'FAO/AQUASTAT [W only]', label: 'FAO/AQUASTAT [W only]'},
      {
        value: 'Maplecroft Global Water Security Risk Index [W only]',
        label: 'Maplecroft Global Water Security Risk Index [W only]'
      },
      {
        value: 'Nation-specific databases, tools, or standards',
        label: 'Nation-specific databases, tools, or standards'
      },
      {
        value: 'Regional government databases',
        label: 'Regional government databases'
      },
      {
        value: 'UNEP Vital Water Graphics [W only]',
        label: 'UNEP Vital Water Graphics [W only]'
      },
      {
        value: 'Other databases, please specify',
        label: 'Other databases, please specify'
      }
    ]
  },
  {
    label: 'Other',
    options: [
      {value: 'Desk-based research', label: 'Desk-based research'},
      {value: 'External consultants', label: 'External consultants'},
      {value: 'Internal company methods', label: 'Internal company methods'},
      {
        value: 'Jurisdictional/landscape assessment',
        label: 'Jurisdictional/landscape assessment'
      },
      {value: 'Materiality assessment', label: 'Materiality assessment'},
      {
        value: 'Partner and stakeholder consultation/analysis',
        label: 'Partner and stakeholder consultation/analysis'
      },
      {value: 'Scenario analysis', label: 'Scenario analysis'},
      {
        value: 'Source Water Vulnerability Assessment [W only]',
        label: 'Source Water Vulnerability Assessment [W only]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'},
      {
        value: 'BFM – Biodiversity Footprint Methodology [B only]',
        label: 'BFM – Biodiversity Footprint Methodology [B only]'
      },
      {
        value: 'BIM – Biodiversity Impact Metric [B only]',
        label: 'BIM – Biodiversity Impact Metric [B only]'
      },
      {
        value: 'Biodiversity indicators for site-based impacts [B only]',
        label: 'Biodiversity indicators for site-based impacts [B only]'
      },
      {
        value: 'Biological Diversity Protocol [B only]',
        label: 'Biological Diversity Protocol [B only]'
      },
      {value: 'Bioscope [B only]', label: 'Bioscope [B only]'},
      {
        value: 'BISI – Biodiversity Indicators for Site-based impacts [B only]',
        label: 'BISI – Biodiversity Indicators for Site-based impacts [B only]'
      },
      {
        value: 'BNGC – Biodiversity Net Gain Calculator [B only]',
        label: 'BNGC – Biodiversity Net Gain Calculator [B only]'
      },
      {
        value: 'CBF – Corporate Biodiversity Footprint [B only]',
        label: 'CBF – Corporate Biodiversity Footprint [B only]'
      },
      {
        value: 'CBD – Convention on Biological Diversity [B only]',
        label: 'CBD – Convention on Biological Diversity [B only]'
      },
      {value: 'Circulytics', label: 'Circulytics'},
      {value: 'Collect Earth', label: 'Collect Earth'},
      {value: 'EcoVadis [W only]', label: 'EcoVadis [W only]'},
      {
        value: 'Ecolab Water Risk Monetizer [W only]',
        label: 'Ecolab Water Risk Monetizer [W only]'
      },
      {
        value:
          'Ellen MacArthur Foundation Recyclability Assessment Tool [P only]',
        label:
          'Ellen MacArthur Foundation Recyclability Assessment Tool [P only]'
      },
      {value: 'Encore tool [B only]', label: 'Encore tool [B only]'},
      {
        value: 'F4B - Finance for Biodiversity [FS only] [B only]',
        label: 'F4B - Finance for Biodiversity [FS only] [B only]'
      },
      {
        value: 'GEMI Local Water Tool [W only]',
        label: 'GEMI Local Water Tool [W only]'
      },
      {
        value: 'Global Forest Watch Pro [F and B only]',
        label: 'Global Forest Watch Pro [F and B only]'
      },
      {
        value: 'Global Risk Assessment Services (GRAS) [F only]',
        label: 'Global Risk Assessment Services (GRAS) [F only]'
      },
      {value: 'IBAT for Business', label: 'IBAT for Business'},
      {
        value: 'IBAT – Integrated Biodiversity Assessment Tool [B only]',
        label: 'IBAT – Integrated Biodiversity Assessment Tool [B only]'
      },
      {
        value: 'LEAP (Locate, Evaluate, Assess and Prepare) approach, TNFD',
        label: 'LEAP (Locate, Evaluate, Assess and Prepare) approach, TNFD'
      },
      {
        value: 'Plastic Leak Project [P only]',
        label: 'Plastic Leak Project [P only]'
      },
      {
        value: 'Plastic Footprint Network [P only]',
        label: 'Plastic Footprint Network [P only]'
      },
      {
        value: 'Preferred by Nature Sourcing Hub [F only]',
        label: 'Preferred by Nature Sourcing Hub [F only]'
      },
      {
        value: 'RBA Country Risk Assessment Tool [W only]',
        label: 'RBA Country Risk Assessment Tool [W only]'
      },
      {value: 'ReCiPe [B only]', label: 'ReCiPe [B only]'},
      {value: 'SEDEX [W only]', label: 'SEDEX [W only]'},
      {value: 'SIWI Water Tool [W only]', label: 'SIWI Water Tool [W only]'},
      {value: 'Starling [F only]', label: 'Starling [F only]'},
      {
        value: 'Sustainability Policy Transparency Toolkit (SPOTT) [F only]',
        label: 'Sustainability Policy Transparency Toolkit (SPOTT) [F only]'
      },
      {
        value: 'TNFD – Taskforce on Nature-related Financial Disclosures',
        label: 'TNFD – Taskforce on Nature-related Financial Disclosures'
      },
      {value: 'Trase [F only]', label: 'Trase [F only]'},
      {
        value: 'Understanding Packaging (UP) Scorecard [P only]',
        label: 'Understanding Packaging (UP) Scorecard [P only]'
      },
      {
        value: 'UNEP Vital Water Graphics [W only]',
        label: 'UNEP Vital Water Graphics [W only]'
      },
      {
        value: 'Water Footprint Network Assessment tool [W only]',
        label: 'Water Footprint Network Assessment tool [W only]'
      },
      {value: 'Waterplan [W only]', label: 'Waterplan [W only]'},
      {
        value: 'WBCSD Corporate Ecosystem Services Review [B only]',
        label: 'WBCSD Corporate Ecosystem Services Review [B only]'
      },
      {value: 'WRI Aqueduct [W only]', label: 'WRI Aqueduct [W only]'},
      {
        value: 'WWF Biodiversity Risk Filter [B only]',
        label: 'WWF Biodiversity Risk Filter [B only]'
      },
      {
        value: 'WWF ReSource Footprint Tracker [P only]',
        label: 'WWF ReSource Footprint Tracker [P only]'
      },
      {
        value: 'WWF Water Risk Filter [W only]',
        label: 'WWF Water Risk Filter [W only]'
      },
      {
        value: 'Other commercially/publicly available tools, please specify',
        label: 'Other commercially/publicly available tools, please specify'
      }
    ]
  }
];

export const RISK_TYPES_AND_CRITERIA_OPTIONS = [
  {
    label: 'Policy',
    options: [
      {
        value: 'Carbon pricing mechanisms [C only]',
        label: 'Carbon pricing mechanisms [C only]'
      },
      {
        value: 'Changes to international law and bilateral agreements',
        label: 'Changes to international law and bilateral agreements'
      },
      {
        value: 'Changes to national legislation',
        label: 'Changes to national legislation'
      },
      {
        value: 'Increased difficulty in obtaining operations permits',
        label: 'Increased difficulty in obtaining operations permits'
      },
      {
        value:
          'Increased difficulty in obtaining water withdrawals permit [W only]',
        label:
          'Increased difficulty in obtaining water withdrawals permit [W only]'
      },
      {
        value: 'Increased pricing of water [W only]',
        label: 'Increased pricing of water [W only]'
      },
      {
        value:
          'Introduction of regulatory standards for previously unregulated contaminants [W only]',
        label:
          'Introduction of regulatory standards for previously unregulated contaminants [W only]'
      },
      {
        value: 'Lack of globally accepted and harmonized definitions [P only]',
        label: 'Lack of globally accepted and harmonized definitions [P only]'
      },
      {
        value: 'Lack of mature certification and sustainability standards',
        label: 'Lack of mature certification and sustainability standards'
      },
      {
        value: 'Limited or lack of river basin management [W only]',
        label: 'Limited or lack of river basin management [W only]'
      },
      {
        value: 'Limited or lack of transboundary water management [W only]',
        label: 'Limited or lack of transboundary water management [W only]'
      },
      {
        value:
          'Mandatory water efficiency, conservation, recycling, or process standards [W only]',
        label:
          'Mandatory water efficiency, conservation, recycling, or process standards [W only]'
      },
      {
        value: 'Poor coordination between regulatory bodies',
        label: 'Poor coordination between regulatory bodies'
      },
      {
        value: 'Poor enforcement of environmental regulation',
        label: 'Poor enforcement of environmental regulation'
      },
      {
        value: 'Protected area designation [M-B only]',
        label: 'Protected area designation [M-B only]'
      },
      {
        value: 'Regulation of discharge quality/volumes [W only]',
        label: 'Regulation of discharge quality/volumes [W only]'
      },
      {
        value:
          'Statutory water withdrawal limits/changes to water allocation [W only]',
        label:
          'Statutory water withdrawal limits/changes to water allocation [W only]'
      },
      {
        value:
          'Uncertainty and/or conflicts involving land tenure rights and water rights [F, B, W only]',
        label:
          'Uncertainty and/or conflicts involving land tenure rights and water rights [F, B, W only]'
      },
      {
        value: 'Other policy, please specify',
        label: 'Other policy, please specify'
      }
    ]
  },
  {
    label: 'Technology',
    options: [
      {
        value: 'Dependency on water-intensive energy sources [C, W only]',
        label: 'Dependency on water-intensive energy sources [C, W only]'
      },
      {
        value:
          'Inability to increase yield of existing production areas [F only]',
        label:
          'Inability to increase yield of existing production areas [F only]'
      },
      {
        value: 'Data access/availability or monitoring systems',
        label: 'Data access/availability or monitoring systems'
      },
      {
        value:
          'Limited access to drought-resistant crop varieties [W-AC/FB only]',
        label:
          'Limited access to drought-resistant crop varieties [W-AC/FB only]'
      },
      {
        value:
          'Limited access to soil conservation and other sustainable techniques [AC/FB/PF only]',
        label:
          'Limited access to soil conservation and other sustainable techniques [AC/FB/PF only]'
      },
      {
        value: 'Transition to bio-based chemicals (W-CH only)',
        label: 'Transition to bio-based chemicals (W-CH only)'
      },
      {
        value: 'Transition to reusable products [P only]',
        label: 'Transition to reusable products [P only]'
      },
      {
        value: 'Transition to recyclable plastic products [P only]',
        label: 'Transition to recyclable plastic products [P only]'
      },
      {
        value: 'Transition to increasing renewable content [P only]',
        label: 'Transition to increasing renewable content [P only]'
      },
      {
        value: 'Transition to increasing recycled content [P only]',
        label: 'Transition to increasing recycled content [P only]'
      },
      {
        value: 'Transition to lower emissions technology and products [C only]',
        label: 'Transition to lower emissions technology and products [C only]'
      },
      {
        value:
          'Transition to water efficient and low water intensity technologies and products [W only]',
        label:
          'Transition to water efficient and low water intensity technologies and products [W only]'
      },
      {
        value:
          'Transition to water intensive, low carbon energy sources [C, W only]',
        label:
          'Transition to water intensive, low carbon energy sources [C, W only]'
      },
      {
        value: 'Unsuccessful investment in new technologies',
        label: 'Unsuccessful investment in new technologies'
      },
      {
        value: 'Other technology, please specify',
        label: 'Other technology, please specify'
      }
    ]
  },
  {
    label: 'Market',
    options: [
      {
        value:
          'Availability and/or increased cost of certified sustainable material',
        label:
          'Availability and/or increased cost of certified sustainable material'
      },
      {
        value: 'Availability and/or increased cost of raw materials',
        label: 'Availability and/or increased cost of raw materials'
      },
      {
        value:
          'Availability and/or increased cost of recycled or renewable content [P only]',
        label:
          'Availability and/or increased cost of recycled or renewable content [P only]'
      },
      {
        value: 'Changing customer behavior',
        label: 'Changing customer behavior'
      },
      {
        value:
          'Contraction of insurance markets, leaving clients exposed and changing the risk parameters of the credit [FS only]',
        label:
          'Contraction of insurance markets, leaving clients exposed and changing the risk parameters of the credit [FS only]'
      },
      {
        value:
          'Inability to attract co-financiers and/or investors due to uncertain risks related to the environment [FS only]',
        label:
          'Inability to attract co-financiers and/or investors due to uncertain risks related to the environment [FS only]'
      },
      {
        value:
          'Inadequate access to water, sanitation, and hygiene services (WASH) [W only]',
        label:
          'Inadequate access to water, sanitation, and hygiene services (WASH) [W only]'
      },
      {value: 'Leakage markets [F only]', label: 'Leakage markets [F only]'},
      {
        value: 'Limited visibility of embedded commodities [F only]',
        label: 'Limited visibility of embedded commodities [F only]'
      },
      {
        value:
          'Loss of clients due to a fund’s poor environmental performance outcomes (e.g. if a fund has suffered climate-related writedowns) [CC-FS only]',
        label:
          'Loss of clients due to a fund’s poor environmental performance outcomes (e.g. if a fund has suffered climate-related writedowns) [CC-FS only]'
      },
      {
        value:
          'Rise in risk-based pricing of insurance policies (beyond demand elasticity) [FS only]',
        label:
          'Rise in risk-based pricing of insurance policies (beyond demand elasticity) [FS only]'
      },
      {
        value: 'Uncertainty about commodity origin and/or legality [F only]',
        label: 'Uncertainty about commodity origin and/or legality [F only]'
      },
      {
        value: 'Uncertainty in the market signals',
        label: 'Uncertainty in the market signals'
      },
      {
        value: 'Other market, please specify',
        label: 'Other market, please specify'
      }
    ]
  },
  {
    label: 'Liability',
    options: [
      {value: 'Exposure to litigation', label: 'Exposure to litigation'},
      {
        value: 'Moratoria and voluntary agreement [W, F only]',
        label: 'Moratoria and voluntary agreement [W, F only]'
      },
      {
        value: 'Non-compliance with regulations',
        label: 'Non-compliance with regulations'
      },
      {
        value:
          'Regulation and supervision of environmental risk in the financial sector [FS only]',
        label:
          'Regulation and supervision of environmental risk in the financial sector [FS only]'
      },
      {
        value: 'Other liability, please specify',
        label: 'Other liability, please specify'
      },
      {
        value:
          'Lending that could create or contribute to systemic risk for the economy [FS only]',
        label:
          'Lending that could create or contribute to systemic risk for the economy [FS only]'
      },
      {
        value:
          'Negative press coverage related to support of projects or activities with negative impacts on the environment (e.g. GHG emissions, deforestation & conversion, water stress)',
        label:
          'Negative press coverage related to support of projects or activities with negative impacts on the environment (e.g. GHG emissions, deforestation & conversion, water stress)'
      },
      {
        value:
          'Stakeholder conflicts concerning water resources at a basin/catchment level',
        label:
          'Stakeholder conflicts concerning water resources at a basin/catchment level'
      },
      {value: 'Stigmatization of sector', label: 'Stigmatization of sector'},
      {
        value: 'Other reputation, please specify',
        label: 'Other reputation, please specify'
      }
    ]
  },
  {
    label: 'Acute physical',
    options: [
      {value: 'Avalanche', label: 'Avalanche'},
      {value: 'Cold wave/frost', label: 'Cold wave/frost'},
      {
        value: 'Cyclones, hurricanes, typhoons',
        label: 'Cyclones, hurricanes, typhoons'
      },
      {value: 'Drought', label: 'Drought'},
      {
        value: 'Flood (coastal, fluvial, pluvial, ground water)',
        label: 'Flood (coastal, fluvial, pluvial, ground water)'
      },
      {value: 'Glacial lake outburst', label: 'Glacial lake outburst'},
      {value: 'Heat waves', label: 'Heat waves'},
      {
        value: 'Heavy precipitation (rain, hail, snow/ice)',
        label: 'Heavy precipitation (rain, hail, snow/ice)'
      },
      {value: 'Landslide', label: 'Landslide'},
      {
        value: 'Pollution incident [W, P only]',
        label: 'Pollution incident [W, P only]'
      },
      {
        value: 'Rupture of tailings dams and toxic spills [MM and CO only]',
        label: 'Rupture of tailings dams and toxic spills [MM and CO only]'
      },
      {
        value: 'Storm (including blizzards, dust, and sandstorms)',
        label: 'Storm (including blizzards, dust, and sandstorms)'
      },
      {value: 'Subsidence', label: 'Subsidence'},
      {value: 'Tornado', label: 'Tornado'},
      {value: 'Toxic spills [W only]', label: 'Toxic spills [W only]'},
      {value: 'Wildfires', label: 'Wildfires'},
      {
        value: 'Other acute physical risk, please specify',
        label: 'Other acute physical risk, please specify'
      }
    ]
  },
  {
    label: 'Chronic physical',
    options: [
      {
        value:
          'Acid rock drainage and metal leaching [MM,CO,M-B only] [W and B only]',
        label:
          'Acid rock drainage and metal leaching [MM,CO,M-B only] [W and B only]'
      },
      {value: 'Change in land-use', label: 'Change in land-use'},
      {
        value:
          'Changing precipitation patterns and types (rain, hail, snow/ice)',
        label:
          'Changing precipitation patterns and types (rain, hail, snow/ice)'
      },
      {
        value: 'Changing temperature (air, freshwater, marine water)',
        label: 'Changing temperature (air, freshwater, marine water)'
      },
      {
        value: 'Changing wind patterns [C only]',
        label: 'Changing wind patterns [C only]'
      },
      {value: 'Coastal erosion', label: 'Coastal erosion'},
      {
        value: 'Declining ecosystem services [F, W, B only]',
        label: 'Declining ecosystem services [F, W, B only]'
      },
      {
        value: 'Declining water quality [W only]',
        label: 'Declining water quality [W only]'
      },
      {
        value: 'Groundwater depletion [W only]',
        label: 'Groundwater depletion [W only]'
      },
      {value: 'Heat stress [C, F only]', label: 'Heat stress [C, F only]'},
      {
        value: 'Increased ecosystem vulnerability [F, W, B only]',
        label: 'Increased ecosystem vulnerability [F, W, B only]'
      },
      {
        value:
          'Increased levels of environmental pollutants in freshwater bodies [W only]',
        label:
          'Increased levels of environmental pollutants in freshwater bodies [W only]'
      },
      {
        value:
          'Increased levels of macro or microplastic leakage to air, soil, freshwater and/or marine bodies [P only]',
        label:
          'Increased levels of macro or microplastic leakage to air, soil, freshwater and/or marine bodies [P only]'
      },
      {
        value: 'Increased severity of extreme weather events',
        label: 'Increased severity of extreme weather events'
      },
      {
        value: 'Limited area for disposing solid waste [M-B only]',
        label: 'Limited area for disposing solid waste [M-B only]'
      },
      {
        value: 'Land loss to desertification [F only]',
        label: 'Land loss to desertification [F only]'
      },
      {
        value: 'Leaching of hazardous substances from plastics [P only]',
        label: 'Leaching of hazardous substances from plastics [P only]'
      },
      {value: 'Ocean acidification', label: 'Ocean acidification'},
      {
        value:
          'Operations in or adjacent to areas important for biodiversity [MB only]',
        label:
          'Operations in or adjacent to areas important for biodiversity [MB only]'
      },
      {
        value: 'Permafrost thawing [C, W only]',
        label: 'Permafrost thawing [C, W only]'
      },
      {
        value: 'Poorly managed sanitation [W only]',
        label: 'Poorly managed sanitation [W only]'
      },
      {
        value: 'Precipitation or hydrological variability',
        label: 'Precipitation or hydrological variability'
      },
      {
        value: 'Rationing of municipal water supply [W only]',
        label: 'Rationing of municipal water supply [W only]'
      },
      {
        value:
          'Reserves located in or adjacent to areas important for biodiversity [M-B only]',
        label:
          'Reserves located in or adjacent to areas important for biodiversity [M-B only]'
      },
      {
        value: 'Saline intrusion [F, W only]',
        label: 'Saline intrusion [F, W only]'
      },
      {
        value: 'Scarcity of land resources [F only]',
        label: 'Scarcity of land resources [F only]'
      },
      {value: 'Sea level rise', label: 'Sea level rise'},
      {
        value:
          'Seasonal supply variability/interannual variability [F, W only]',
        label: 'Seasonal supply variability/interannual variability [F, W only]'
      },
      {value: 'Soil degradation', label: 'Soil degradation'},
      {value: 'Soil erosion', label: 'Soil erosion'},
      {value: 'Solifluction', label: 'Solifluction'},
      {value: 'Temperature variability', label: 'Temperature variability'},
      {
        value: 'Threatened species in or near mining operation [M-B only]',
        label: 'Threatened species in or near mining operation [M-B only]'
      },
      {
        value: 'Water availability at a basin/catchment level',
        label: 'Water availability at a basin/catchment level'
      },
      {value: 'Water stress', label: 'Water stress'},
      {
        value: 'Water quality at a basin/catchment level',
        label: 'Water quality at a basin/catchment level'
      },
      {
        value: 'Other chronic physical driver, please specify',
        label: 'Other chronic physical driver, please specify'
      }
    ]
  }
];

export const TYPE_OF_ASSESSMENT_OPTIONS = [
  {value: 'Qualitative only', label: 'Qualitative only'},
  {value: 'Quantitative only', label: 'Quantitative only'},
  {value: 'Qualitative and quantitative', label: 'Qualitative and quantitative'}
];

export const INDUSTRY_SECTORS_OPTIONS = [
  {value: 'Apparel', label: 'Apparel'},
  {
    value: 'Biotech, health care & pharma',
    label: 'Biotech, health care & pharma'
  },
  {value: 'Food,beverage & agriculture', label: 'Food,beverage & agriculture'},
  {value: 'Fossil Fuels', label: 'Fossil Fuels'},
  {value: 'Hospitality', label: 'Hospitality'},
  {value: 'Infrastructure', label: 'Infrastructure'},
  {value: 'International bodies', label: 'International bodies'},
  {value: 'Manufacturing', label: 'Manufacturing'},
  {value: 'Materials', label: 'Materials'},
  {value: 'Power generation', label: 'Power generation'},
  {value: 'Retail', label: 'Retail'},
  {value: 'Services', label: 'Services'},
  {value: 'Transportation services', label: 'Transportation services'}
];

export const FREQUENCY_OF_ASSESSMENT_OPTIONS = [
  {value: 'More than once a year', label: 'More than once a year'},
  {value: 'Annually', label: 'Annually'},
  {value: 'Every two years', label: 'Every two years'},
  {value: 'Every three years or more', label: 'Every three years or more'},
  {value: 'As important matters arise', label: 'As important matters arise'},
  {value: 'Not defined', label: 'Not defined'}
];

export const PARTNERS_AND_STAKEHOLDERS_CONSIDERED_OPTIONS = [
  {value: 'Customers', label: 'Customers'},
  {value: 'Employees', label: 'Employees'},
  {value: 'Investors', label: 'Investors'},
  {value: 'Local communities', label: 'Local communities'},
  {value: 'Indigenous peoples', label: 'Indigenous peoples'},
  {value: 'NGOs', label: 'NGOs'},
  {value: 'Regulators', label: 'Regulators'},
  {value: 'Suppliers', label: 'Suppliers'},
  {
    value: 'Water utilities at a local level [W only]',
    label: 'Water utilities at a local level [W only]'
  },
  {
    value: 'Other commodity users/producers at a local level [B and F only]',
    label: 'Other commodity users/producers at a local level [B and F only]'
  },
  {
    value: 'Other water users at the basin/catchment level [B and W only]',
    label: 'Other water users at the basin/catchment level [B and W only]'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS = [
  {
    value:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
    label:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
  },
  {value: 'No standardized procedure', label: 'No standardized procedure'},
  {
    value: 'Judged to be unimportant or not relevant',
    label: 'Judged to be unimportant or not relevant'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const RISK_TYPE_AND_PRIMARY_ENVIRONMENTAL_RISK_DRIVER_OPTIONS = [
  {
    value: 'Carbon pricing mechanisms [C only]',
    label: 'Carbon pricing mechanisms [C only]'
  },
  {
    value: 'Changes to international law and bilateral agreements',
    label: 'Changes to international law and bilateral agreements'
  },
  {
    value: 'Changes to national legislation',
    label: 'Changes to national legislation'
  },
  {
    value: 'Increased difficulty in obtaining operations permits',
    label: 'Increased difficulty in obtaining operations permits'
  },
  {
    value:
      'Increased difficulty in obtaining water withdrawals permit [W only]',
    label: 'Increased difficulty in obtaining water withdrawals permit [W only]'
  },
  {
    value: 'Increased pricing of water [W only]',
    label: 'Increased pricing of water [W only]'
  },
  {
    value:
      'Introduction of regulatory standards for previously unregulated contaminants [W only]',
    label:
      'Introduction of regulatory standards for previously unregulated contaminants [W only]'
  },
  {
    value: 'Lack of globally accepted and harmonized definitions [P only]',
    label: 'Lack of globally accepted and harmonized definitions [P only]'
  },
  {
    value: 'Lack of mature certification and sustainability standards',
    label: 'Lack of mature certification and sustainability standards'
  },
  {
    value: 'Limited or lack of river basin management [W only]',
    label: 'Limited or lack of river basin management [W only]'
  },
  {
    value: 'Limited or lack of transboundary water management [W only]',
    label: 'Limited or lack of transboundary water management [W only]'
  },
  {
    value:
      'Mandatory water efficiency, conservation, recycling, or process standards [W only]',
    label:
      'Mandatory water efficiency, conservation, recycling, or process standards [W only]'
  },
  {
    value: 'Poor coordination between regulatory bodies',
    label: 'Poor coordination between regulatory bodies'
  },
  {
    value: 'Poor enforcement of environmental regulation',
    label: 'Poor enforcement of environmental regulation'
  },
  {
    value: 'Protected area designation [M-B only]',
    label: 'Protected area designation [M-B only]'
  },
  {
    value: 'Regulation of discharge quality/volumes [W only]',
    label: 'Regulation of discharge quality/volumes [W only]'
  },
  {
    value:
      'Statutory water withdrawal limits/changes to water allocation [W only]',
    label:
      'Statutory water withdrawal limits/changes to water allocation [W only]'
  },
  {
    value:
      'Uncertainty and/or conflicts involving land tenure rights and water rights [F, B, W only]',
    label:
      'Uncertainty and/or conflicts involving land tenure rights and water rights [F, B, W only]'
  },
  {
    value: 'Other policy, please specify',
    label: 'Other policy, please specify'
  },
  {
    value: 'Dependency on water-intensive energy sources [C, W only]',
    label: 'Dependency on water-intensive energy sources [C, W only]'
  },
  {
    value: 'Inability to increase yield of existing production areas [F only]',
    label: 'Inability to increase yield of existing production areas [F only]'
  },
  {
    value: 'Data access/availability or monitoring systems',
    label: 'Data access/availability or monitoring systems'
  },
  {
    value: 'Limited access to drought-resistant crop varieties [W-AC/FB only]',
    label: 'Limited access to drought-resistant crop varieties [W-AC/FB only]'
  },
  {
    value:
      'Limited access to soil conservation and other sustainable techniques [AC/FB/PF only]',
    label:
      'Limited access to soil conservation and other sustainable techniques [AC/FB/PF only]'
  },
  {
    value: 'Transition to bio-based chemicals [W-CH only]',
    label: 'Transition to bio-based chemicals [W-CH only]'
  },
  {
    value: 'Transition to reusable products [P only]',
    label: 'Transition to reusable products [P only]'
  },
  {
    value: 'Transition to recyclable plastic products [P only]',
    label: 'Transition to recyclable plastic products [P only]'
  },
  {
    value: 'Transition to increasing renewable content [P only]',
    label: 'Transition to increasing renewable content [P only]'
  },
  {
    value: 'Transition to increasing recycled content [P only]',
    label: 'Transition to increasing recycled content [P only]'
  },
  {
    value: 'Transition to lower emissions technology and products [C only]',
    label: 'Transition to lower emissions technology and products [C only]'
  },
  {
    value:
      'Transition to water efficient and low water intensity technologies and products [W only]',
    label:
      'Transition to water efficient and low water intensity technologies and products [W only]'
  },
  {
    value:
      'Transition to water intensive, low carbon energy sources [C, W only]',
    label:
      'Transition to water intensive, low carbon energy sources [C, W only]'
  },
  {
    value: 'Unsuccessful investment in new technologies',
    label: 'Unsuccessful investment in new technologies'
  },
  {
    value: 'Other technology, please specify',
    label: 'Other technology, please specify'
  },
  {
    value:
      'Exclusion of vulnerable and marginalized stakeholders (e.g., informal workers) [P only]',
    label:
      'Exclusion of vulnerable and marginalized stakeholders (e.g., informal workers) [P only]'
  },
  {value: 'Impact on human health', label: 'Impact on human health'},
  {
    value:
      'Increased partner and stakeholder concern and partner and stakeholder negative feedback',
    label:
      'Increased partner and stakeholder concern and partner and stakeholder negative feedback'
  },
  {
    value:
      'Insurance underwriting that could create or contribute to systemic risk for the economy [FS only]',
    label:
      'Insurance underwriting that could create or contribute to systemic risk for the economy [FS only]'
  },
  {
    value:
      'Investing that could create or contribute to systemic risk for the economy [FS only]',
    label:
      'Investing that could create or contribute to systemic risk for the economy [FS only]'
  },
  {
    value:
      'Lending that could create or contribute to systemic risk for the economy [FS only]',
    label:
      'Lending that could create or contribute to systemic risk for the economy [FS only]'
  },
  {
    value:
      'Negative press coverage related to support of projects or activities with negative impacts on the environment (e.g., GHG emissions, deforestation & conversion, water stress)',
    label:
      'Negative press coverage related to support of projects or activities with negative impacts on the environment (e.g., GHG emissions, deforestation & conversion, water stress)'
  },
  {
    value:
      'Stakeholder conflicts concerning water resources at a basin/catchment level',
    label:
      'Stakeholder conflicts concerning water resources at a basin/catchment level'
  },
  {value: 'Stigmatization of sector', label: 'Stigmatization of sector'},
  {
    value: 'Other reputation, please specify',
    label: 'Other reputation, please specify'
  },
  {value: 'Avalanche', label: 'Avalanche'},
  {value: 'Cold wave/frost', label: 'Cold wave/frost'},
  {
    value: 'Cyclones, hurricanes, typhoons',
    label: 'Cyclones, hurricanes, typhoons'
  },
  {value: 'Drought', label: 'Drought'},
  {
    value: 'Flood (coastal, fluvial, pluvial, groundwater)',
    label: 'Flood (coastal, fluvial, pluvial, groundwater)'
  },
  {value: 'Glacial lake outburst', label: 'Glacial lake outburst'},
  {value: 'Heat waves', label: 'Heat waves'},
  {
    value: 'Heavy precipitation (rain, hail, snow/ice)',
    label: 'Heavy precipitation (rain, hail, snow/ice)'
  },
  {value: 'Landslide', label: 'Landslide'},
  {
    value: 'Pollution incident [W, P only]',
    label: 'Pollution incident [W, P only]'
  },
  {
    value: 'Rupture of tailings dams and toxic spills [MM and CO only]',
    label: 'Rupture of tailings dams and toxic spills [MM and CO only]'
  },
  {
    value: 'Storm (including blizzards, dust, and sandstorms)',
    label: 'Storm (including blizzards, dust, and sandstorms)'
  },
  {value: 'Subsidence', label: 'Subsidence'},
  {value: 'Tornado', label: 'Tornado'},
  {value: 'Toxic spills [W only]', label: 'Toxic spills [W only]'},
  {value: 'Wildfires', label: 'Wildfires'},
  {
    value: 'Other acute physical risk, please specify',
    label: 'Other acute physical risk, please specify'
  },
  {
    value:
      'Acid rock drainage and metal leaching [MM, CO, M-B only] [W and B only]',
    label:
      'Acid rock drainage and metal leaching [MM, CO, M-B only] [W and B only]'
  },
  {value: 'Change in land-use', label: 'Change in land-use'},
  {
    value: 'Changing precipitation patterns and types (rain, hail, snow/ice)',
    label: 'Changing precipitation patterns and types (rain, hail, snow/ice)'
  },
  {
    value: 'Changing temperature (air, freshwater, marine water)',
    label: 'Changing temperature (air, freshwater, marine water)'
  },
  {
    value: 'Changing wind patterns [C only]',
    label: 'Changing wind patterns [C only]'
  },
  {value: 'Coastal erosion', label: 'Coastal erosion'},
  {
    value: 'Declining ecosystem services [F, W, B only]',
    label: 'Declining ecosystem services [F, W, B only]'
  },
  {
    value: 'Declining water quality [W only]',
    label: 'Declining water quality [W only]'
  },
  {
    value: 'Groundwater depletion [W only]',
    label: 'Groundwater depletion [W only]'
  },
  {value: 'Heat stress [C, F only]', label: 'Heat stress [C, F only]'},
  {
    value: 'Increased ecosystem vulnerability [F, W, B only]',
    label: 'Increased ecosystem vulnerability [F, W, B only]'
  },
  {
    value:
      'Increased levels of environmental pollutants in freshwater bodies [W only]',
    label:
      'Increased levels of environmental pollutants in freshwater bodies [W only]'
  },
  {
    value:
      'Increased levels of macro or microplastic leakage to air, soil, freshwater and/or marine bodies [P only]',
    label:
      'Increased levels of macro or microplastic leakage to air, soil, freshwater and/or marine bodies [P only]'
  },
  {
    value: 'Increased severity of extreme weather events',
    label: 'Increased severity of extreme weather events'
  },
  {
    value: 'Limited area for disposing solid waste [M-B only]',
    label: 'Limited area for disposing solid waste [M-B only]'
  },
  {
    value: 'Land loss to desertification [F only]',
    label: 'Land loss to desertification [F only]'
  },
  {
    value: 'Leaching of hazardous substances from plastics [P only]',
    label: 'Leaching of hazardous substances from plastics [P only]'
  },
  {value: 'Ocean acidification', label: 'Ocean acidification'},
  {
    value:
      'Operations in or adjacent to areas important for biodiversity [M-B only]',
    label:
      'Operations in or adjacent to areas important for biodiversity [M-B only]'
  },
  {
    value: 'Permafrost thawing [C, W only]',
    label: 'Permafrost thawing [C, W only]'
  },
  {
    value: 'Poorly managed sanitation [W only]',
    label: 'Poorly managed sanitation [W only]'
  },
  {
    value: 'Precipitation or hydrological variability',
    label: 'Precipitation or hydrological variability'
  },
  {
    value: 'Rationing of municipal water supply [W only]',
    label: 'Rationing of municipal water supply [W only]'
  },
  {
    value:
      'Reserves located in or adjacent to areas important for biodiversity [M-B only]',
    label:
      'Reserves located in or adjacent to areas important for biodiversity [M-B only]'
  },
  {
    value: 'Saline intrusion [F, W only]',
    label: 'Saline intrusion [F, W only]'
  },
  {
    value: 'Scarcity of land resources [F only]',
    label: 'Scarcity of land resources [F only]'
  },
  {value: 'Sea level rise', label: 'Sea level rise'},
  {
    value: 'Seasonal supply variability/interannual variability [F, W only]',
    label: 'Seasonal supply variability/interannual variability [F, W only]'
  },
  {value: 'Soil degradation', label: 'Soil degradation'},
  {value: 'Soil erosion', label: 'Soil erosion'},
  {value: 'Solifluction', label: 'Solifluction'},
  {value: 'Temperature variability', label: 'Temperature variability'},
  {
    value: 'Threatened species in or near mining operation [M-B only]',
    label: 'Threatened species in or near mining operation [M-B only]'
  },
  {
    value: 'Water availability at a basin/catchment level',
    label: 'Water availability at a basin/catchment level'
  },
  {value: 'Water stress', label: 'Water stress'},
  {
    value: 'Water quality at a basin/catchment level',
    label: 'Water quality at a basin/catchment level'
  },
  {
    value: 'Other chronic physical driver, please specify',
    label: 'Other chronic physical driver, please specify'
  },
  {
    value:
      'Availability and/or increased cost of certified sustainable material',
    label:
      'Availability and/or increased cost of certified sustainable material'
  },
  {
    value: 'Availability and/or increased cost of raw materials',
    label: 'Availability and/or increased cost of raw materials'
  },
  {
    value:
      'Availability and/or increased cost of recycled or renewable content [P only]',
    label:
      'Availability and/or increased cost of recycled or renewable content [P only]'
  },
  {value: 'Changing customer behavior', label: 'Changing customer behavior'},
  {
    value:
      'Contraction of insurance markets, leaving clients exposed and changing the risk parameters of the credit [FS only]',
    label:
      'Contraction of insurance markets, leaving clients exposed and changing the risk parameters of the credit [FS only]'
  },
  {
    value:
      'Inability to attract co-financiers and/or investors due to uncertain risks related to the environment [FS only]',
    label:
      'Inability to attract co-financiers and/or investors due to uncertain risks related to the environment [FS only]'
  },
  {
    value:
      'Inadequate access to water, sanitation, and hygiene services (WASH)',
    label: 'Inadequate access to water, sanitation, and hygiene services (WASH)'
  },
  {value: 'Leakage markets [F only]', label: 'Leakage markets [F only]'},
  {
    value: 'Limited visibility of embedded commodities [F only]',
    label: 'Limited visibility of embedded commodities [F only]'
  },
  {
    value:
      'Loss of clients due to a fund’s poor environmental performance outcomes (e.g., if a fund has suffered climate-related write-downs) [CC-FS only]',
    label:
      'Loss of clients due to a fund’s poor environmental performance outcomes (e.g., if a fund has suffered climate-related write-downs) [CC-FS only]'
  },
  {
    value:
      'Rise in risk-based pricing of insurance policies (beyond demand elasticity) [FS only]',
    label:
      'Rise in risk-based pricing of insurance policies (beyond demand elasticity) [FS only]'
  },
  {
    value: 'Uncertainty about commodity origin and/or legality [F only]',
    label: 'Uncertainty about commodity origin and/or legality [F only]'
  },
  {
    value: 'Uncertainty in the market signals',
    label: 'Uncertainty in the market signals'
  },
  {value: 'Other market, please specify', label: 'Other market, please specify'}
];

export const RISK_IDENTIFIED_OPTIONS = [
  {value: 'Risk 1', label: 'Risk 1'},
  {value: 'Risk 2', label: 'Risk 2'},
  {value: 'Risk 3', label: 'Risk 3'},
  {value: 'Risk 4', label: 'Risk 4'},
  {value: 'Risk 5', label: 'Risk 5'},
  {value: 'Risk 6', label: 'Risk 6'},
  {value: 'Risk 7', label: 'Risk 7'},
  {value: 'Risk 8', label: 'Risk 8'},
  {value: 'Risk 9', label: 'Risk 9'},
  {value: 'Risk 10', label: 'Risk 10'},
  {value: 'Risk 11', label: 'Risk 11'},
  {value: 'Risk 12', label: 'Risk 12'},
  {value: 'Risk 13', label: 'Risk 13'},
  {value: 'Risk 14', label: 'Risk 14'},
  {value: 'Risk 15', label: 'Risk 15'},
  {value: 'Risk 16', label: 'Risk 16'},
  {value: 'Risk 17', label: 'Risk 17'},
  {value: 'Risk 18', label: 'Risk 18'},
  {value: 'Risk 19', label: 'Risk 19'},
  {value: 'Risk 20', label: 'Risk 20'},
  {value: 'Risk 21', label: 'Risk 21'},
  {value: 'Risk 22', label: 'Risk 22'},
  {value: 'Risk 23', label: 'Risk 23'},
  {value: 'Risk 24', label: 'Risk 24'},
  {value: 'Risk 25', label: 'Risk 25'},
  {value: 'Risk 26', label: 'Risk 26'},
  {value: 'Risk 27', label: 'Risk 27'},
  {value: 'Risk 28', label: 'Risk 28'},
  {value: 'Risk 29', label: 'Risk 29'},
  {value: 'Risk 30', label: 'Risk 30'},
  {value: 'Risk 31', label: 'Risk 31'},
  {value: 'Risk 32', label: 'Risk 32'},
  {value: 'Risk 33', label: 'Risk 33'},
  {value: 'Risk 34', label: 'Risk 34'},
  {value: 'Risk 35', label: 'Risk 35'},
  {value: 'Risk 36', label: 'Risk 36'},
  {value: 'Risk 37', label: 'Risk 37'},
  {value: 'Risk 38', label: 'Risk 38'},
  {value: 'Risk 39', label: 'Risk 39'},
  {value: 'Risk 40', label: 'Risk 40'},
  {value: 'Risk 41', label: 'Risk 41'},
  {value: 'Risk 42', label: 'Risk 42'},
  {value: 'Risk 43', label: 'Risk 43'},
  {value: 'Risk 44', label: 'Risk 44'},
  {value: 'Risk 45', label: 'Risk 45'},
  {value: 'Risk 46', label: 'Risk 46'},
  {value: 'Risk 47', label: 'Risk 47'},
  {value: 'Risk 48', label: 'Risk 48'},
  {value: 'Risk 49', label: 'Risk 49'},
  {value: 'Risk 50', label: 'Risk 50'},
  {value: 'Risk 51', label: 'Risk 51'},
  {value: 'Risk 52', label: 'Risk 52'},
  {value: 'Risk 53', label: 'Risk 53'},
  {value: 'Risk 54', label: 'Risk 54'},
  {value: 'Risk 55', label: 'Risk 55'},
  {value: 'Risk 56', label: 'Risk 56'},
  {value: 'Risk 57', label: 'Risk 57'},
  {value: 'Risk 58', label: 'Risk 58'},
  {value: 'Risk 59', label: 'Risk 59'},
  {value: 'Risk 60', label: 'Risk 60'},
  {value: 'Risk 61', label: 'Risk 61'},
  {value: 'Risk 62', label: 'Risk 62'},
  {value: 'Risk 63', label: 'Risk 63'},
  {value: 'Risk 64', label: 'Risk 64'},
  {value: 'Risk 65', label: 'Risk 65'},
  {value: 'Risk 66', label: 'Risk 66'},
  {value: 'Risk 67', label: 'Risk 67'},
  {value: 'Risk 68', label: 'Risk 68'},
  {value: 'Risk 69', label: 'Risk 69'},
  {value: 'Risk 70', label: 'Risk 70'},
  {value: 'Risk 71', label: 'Risk 71'},
  {value: 'Risk 72', label: 'Risk 72'},
  {value: 'Risk 73', label: 'Risk 73'},
  {value: 'Risk 74', label: 'Risk 74'},
  {value: 'Risk 75', label: 'Risk 75'},
  {value: 'Risk 76', label: 'Risk 76'},
  {value: 'Risk 77', label: 'Risk 77'},
  {value: 'Risk 78', label: 'Risk 78'},
  {value: 'Risk 79', label: 'Risk 79'},
  {value: 'Risk 80', label: 'Risk 80'},
  {value: 'Risk 81', label: 'Risk 81'},
  {value: 'Risk 82', label: 'Risk 82'},
  {value: 'Risk 83', label: 'Risk 83'},
  {value: 'Risk 84', label: 'Risk 84'},
  {value: 'Risk 85', label: 'Risk 85'},
  {value: 'Risk 86', label: 'Risk 86'},
  {value: 'Risk 87', label: 'Risk 87'},
  {value: 'Risk 88', label: 'Risk 88'},
  {value: 'Risk 89', label: 'Risk 89'},
  {value: 'Risk 90', label: 'Risk 90'},
  {value: 'Risk 91', label: 'Risk 91'},
  {value: 'Risk 92', label: 'Risk 92'},
  {value: 'Risk 93', label: 'Risk 93'},
  {value: 'Risk 94', label: 'Risk 94'},
  {value: 'Risk 95', label: 'Risk 95'},
  {value: 'Risk 96', label: 'Risk 96'},
  {value: 'Risk 97', label: 'Risk 97'},
  {value: 'Risk 98', label: 'Risk 98'},
  {value: 'Risk 99', label: 'Risk 99'},
  {value: 'Risk 100', label: 'Risk 100'}
];

export const PRIMARY_RESPONSE_TO_RISK_OPTIONS = [
  {
    label: 'Agricultural practices',
    options: [
      {
        value:
          'Adopt alternative crop management strategies to reduce fertilizer and pesticide use [W-AC/FB only]',
        label:
          'Adopt alternative crop management strategies to reduce fertilizer and pesticide use [W-AC/FB only]'
      },
      {
        value: 'Adopt alternative livestock management practices [AC/FB only]',
        label: 'Adopt alternative livestock management practices [AC/FB only]'
      },
      {
        value: 'Adopt better animal waste management practices [W-AC/FB only]',
        label: 'Adopt better animal waste management practices [W-AC/FB only]'
      },
      {
        value: 'Adopt sustainable irrigation practices [W only]',
        label: 'Adopt sustainable irrigation practices [W only]'
      },
      {
        value:
          'Avoid sourcing from jurisdictions with a high risk of deforestation and conversion of other natural ecosystems [F only]',
        label:
          'Avoid sourcing from jurisdictions with a high risk of deforestation and conversion of other natural ecosystems [F only]'
      },
      {
        value: 'Improve soil health [F, W only]',
        label: 'Improve soil health [F, W only]'
      },
      {
        value: 'Reduce food waste throughout the value chain [AC/FB only]',
        label: 'Reduce food waste throughout the value chain [AC/FB only]'
      },
      {
        value: 'Species management and/or recovery [F only]',
        label: 'Species management and/or recovery [F only]'
      },
      {
        value:
          'Transition from production/sourcing of cattle products [F - Cattle only]',
        label:
          'Transition from production/sourcing of cattle products [F - Cattle only]'
      },
      {
        value:
          'Transition towards a diversified product portfolio that includes alternative proteins [F - Cattle only]',
        label:
          'Transition towards a diversified product portfolio that includes alternative proteins [F - Cattle only]'
      },
      {
        value:
          'Transition towards a diversified product portfolio that includes alternative materials [recycled and/or plant-based] [F - Cattle only]',
        label:
          'Transition towards a diversified product portfolio that includes alternative materials [recycled and/or plant-based] [F - Cattle only]'
      },
      {
        value: 'Use drought resistant crop varieties [AC/FB only]',
        label: 'Use drought resistant crop varieties [AC/FB only]'
      },
      {
        value: 'Other agricultural practice, please specify',
        label: 'Other agricultural practice, please specify'
      }
    ]
  },
  {
    label: 'Infrastructure, technology and spending',
    options: [
      {
        value:
          'Adopt water efficiency, water reuse, recycling and conservation practices [W only]',
        label:
          'Adopt water efficiency, water reuse, recycling and conservation practices [W only]'
      },
      {
        value:
          'Ensure no deforestation and no conversion in own operations [F only]',
        label:
          'Ensure no deforestation and no conversion in own operations [F only]'
      },
      {
        value: 'Establish site-specific targets',
        label: 'Establish site-specific targets'
      },
      {
        value: 'Establish organization-wide targets',
        label: 'Establish organization-wide targets'
      },
      {
        value:
          'Establish and improve end-of-life infrastructure and/or technology [P only]',
        label:
          'Establish and improve end-of-life infrastructure and/or technology [P only]'
      },
      {
        value: 'Implementing buffer stocks or dual sourcing',
        label: 'Implementing buffer stocks or dual sourcing'
      },
      {
        value: 'Improve maintenance of infrastructure [C, W only]',
        label: 'Improve maintenance of infrastructure [C, W only]'
      },
      {
        value: 'Improve pollution abatement and control measures [P, W only]',
        label: 'Improve pollution abatement and control measures [P, W only]'
      },
      {
        value: 'Increase environment-related capital expenditure',
        label: 'Increase environment-related capital expenditure'
      },
      {
        value: 'Increase geographic diversity of facilities',
        label: 'Increase geographic diversity of facilities'
      },
      {
        value: 'Increase investment in R&D',
        label: 'Increase investment in R&D'
      },
      {
        value:
          'Increase investment in water, sanitation and hygiene [WASH] [W only]',
        label:
          'Increase investment in water, sanitation and hygiene [WASH] [W only]'
      },
      {
        value: 'Greater focus on brownfield expansion [M-B only]',
        label: 'Greater focus on brownfield expansion [M-B only]'
      },
      {
        value: 'Secure alternative water supply [W only]',
        label: 'Secure alternative water supply [W only]'
      },
      {
        value:
          'Take action to move from single-use plastic products/packaging towards reuse models [P only]',
        label:
          'Take action to move from single-use plastic products/packaging towards reuse models [P only]'
      },
      {
        value:
          'Take action to remove single-use plastic products/packaging [P only]',
        label:
          'Take action to remove single-use plastic products/packaging [P only]'
      },
      {
        value:
          'Take action to switch to recycled content to reduce virgin plastic [P only]',
        label:
          'Take action to switch to recycled content to reduce virgin plastic [P only]'
      },
      {
        value:
          'Take action to switch to technically recyclable plastic [P only]',
        label:
          'Take action to switch to technically recyclable plastic [P only]'
      },
      {
        value:
          'Take action to switch to plastic which is recyclable in practice and at scale [P only]',
        label:
          'Take action to switch to plastic which is recyclable in practice and at scale [P only]'
      },
      {
        value: 'Take action to reduce microplastic emissions [P only]',
        label: 'Take action to reduce microplastic emissions [P only]'
      },
      {
        value: 'Utilize aquifer storage to accrue recharge credits [W only]',
        label: 'Utilize aquifer storage to accrue recharge credits [W only]'
      },
      {
        value: 'Other infrastructure, technology and spending, please specify',
        label: 'Other infrastructure, technology and spending, please specify'
      }
    ]
  },
  {
    label: 'Diversification',
    options: [
      {
        value: 'Develop new products, services and/or markets',
        label: 'Develop new products, services and/or markets'
      },
      {
        value: 'Increase supplier diversification',
        label: 'Increase supplier diversification'
      },
      {value: 'Marketing campaign[s]', label: 'Marketing campaign[s]'},
      {value: 'Market expansion', label: 'Market expansion'},
      {
        value:
          'Improve emergency response systems in sourcing regions [F only]',
        label: 'Improve emergency response systems in sourcing regions [F only]'
      },
      {
        value: 'Improve fire management systems in sourcing regions [F only]',
        label: 'Improve fire management systems in sourcing regions [F only]'
      },
      {
        value: 'Other diversification, please specify',
        label: 'Other diversification, please specify'
      }
    ]
  },
  {
    label: 'Engagement',
    options: [
      {
        value:
          'Align organization’s public policy engagement with its environmental strategy',
        label:
          'Align organization’s public policy engagement with its environmental strategy'
      },
      {
        value: 'Engage in multi-stakeholder initiatives',
        label: 'Engage in multi-stakeholder initiatives'
      },
      {value: 'Engage with customers', label: 'Engage with customers'},
      {
        value: 'Engage with local communities',
        label: 'Engage with local communities'
      },
      {
        value: 'Engage with NGOs/special interest groups',
        label: 'Engage with NGOs/special interest groups'
      },
      {
        value: 'Engage with regulators/policy makers',
        label: 'Engage with regulators/policy makers'
      },
      {
        value: 'Engage with River Basin Organizations [W only]',
        label: 'Engage with River Basin Organizations [W only]'
      },
      {value: 'Engage with suppliers', label: 'Engage with suppliers'},
      {value: 'Engage with trade unions', label: 'Engage with trade unions'},
      {
        value:
          'Ensure grievance mechanisms are available to relevant stakeholders [F, W]',
        label:
          'Ensure grievance mechanisms are available to relevant stakeholders [F, W]'
      },
      {
        value: 'Introduce/strengthen environmental incentives',
        label: 'Introduce/strengthen environmental incentives'
      },
      {
        value: 'Other engagement, please specify',
        label: 'Other engagement, please specify'
      }
    ]
  },
  {
    label: 'Nature-based solutions, restoration and conservation',
    options: [
      {
        value: 'Biodiversity offsetting [F, M-B only]',
        label: 'Biodiversity offsetting [F, M-B only]'
      },
      {
        value:
          'Implement ecosystem restoration and long-term protection [C, F, W only]',
        label:
          'Implement ecosystem restoration and long-term protection [C, F, W only]'
      },
      {
        value:
          'Engage and support landscape and jurisdictional initiatives [F, M-B only]',
        label:
          'Engage and support landscape and jurisdictional initiatives [F, M-B only]'
      },
      {
        value: 'Implement nature-based solutions',
        label: 'Implement nature-based solutions'
      },
      {
        value:
          'Promotion of sustainable forest management, including financial incentives [F only]',
        label:
          'Promotion of sustainable forest management, including financial incentives [F only]'
      },
      {
        value: 'Support catchment and river restoration [W only]',
        label: 'Support catchment and river restoration [W only]'
      },
      {
        value: 'Support river basin restoration [W only]',
        label: 'Support river basin restoration [W only]'
      },
      {
        value:
          'Voluntary engagement in conservation projects (including reforestation, afforestation and ecosystem restoration) [F, M-B only]',
        label:
          'Voluntary engagement in conservation projects (including reforestation, afforestation and ecosystem restoration) [F, M-B only]'
      },
      {
        value:
          'Other nature-based solution, restoration and conservation, please specify',
        label:
          'Other nature-based solution, restoration and conservation, please specify'
      }
    ]
  },
  {
    label: 'Policies and plans',
    options: [
      {
        value: 'Adopt regenerative agriculture policies [F and W only]',
        label: 'Adopt regenerative agriculture policies [F and W only]'
      },
      {
        value: 'Amend the Business Continuity Plan',
        label: 'Amend the Business Continuity Plan'
      },
      {
        value:
          'Consider relevant transboundary water policies and agreements at national, bilateral or regional level [W only]',
        label:
          'Consider relevant transboundary water policies and agreements at national, bilateral or regional level [W only]'
      },
      {
        value: 'Develop a circular economy plan [P only]',
        label: 'Develop a circular economy plan [P only]'
      },
      {
        value:
          'Develop a plan to reduce macro and microplastic leakage [P only]',
        label:
          'Develop a plan to reduce macro and microplastic leakage [P only]'
      },
      {
        value: 'Develop a climate transition plan [C only]',
        label: 'Develop a climate transition plan [C only]'
      },
      {
        value: 'Greater compliance with regulatory requirements',
        label: 'Greater compliance with regulatory requirements'
      },
      {value: 'Greater due diligence', label: 'Greater due diligence'},
      {
        value: 'Greater traceability of commodities [F only]',
        label: 'Greater traceability of commodities [F only]'
      },
      {
        value:
          'Implementation of environmental best practices in direct operations',
        label:
          'Implementation of environmental best practices in direct operations'
      },
      {
        value: 'Improve monitoring of direct operations',
        label: 'Improve monitoring of direct operations'
      },
      {
        value: 'Improve monitoring of upstream and downstream activities',
        label: 'Improve monitoring of upstream and downstream activities'
      },
      {
        value: 'New or tighter supplier performance standards',
        label: 'New or tighter supplier performance standards'
      },
      {
        value: 'Promotion of best practice and awareness in the value chain',
        label: 'Promotion of best practice and awareness in the value chain'
      },
      {
        value:
          'Promotion of certification, including financial incentives [F, M-B only]',
        label:
          'Promotion of certification, including financial incentives [F, M-B only]'
      },
      {
        value: 'Develop drought emergency plans',
        label: 'Develop drought emergency plans'
      },
      {
        value: 'Develop flood emergency plans',
        label: 'Develop flood emergency plans'
      },
      {
        value:
          'Improve alignment of public policy influencing activity with environmental commitments [C, F, W only]',
        label:
          'Improve alignment of public policy influencing activity with environmental commitments [C, F, W only]'
      },
      {
        value: 'Increase insurance coverage',
        label: 'Increase insurance coverage'
      },
      {
        value: 'Increased use of sustainably sourced materials',
        label: 'Increased use of sustainably sourced materials'
      },
      {
        value: 'More ambitious environmental commitments and policies',
        label: 'More ambitious environmental commitments and policies'
      },
      {
        value: 'More ambitious no-conversion commitments and policies [F only]',
        label: 'More ambitious no-conversion commitments and policies [F only]'
      },
      {
        value:
          'More ambitious policies and commitments to protect natural ecosystems [F, W, M-B only]',
        label:
          'More ambitious policies and commitments to protect natural ecosystems [F, W, M-B only]'
      },
      {
        value:
          'Participation in environmental collaborative industry frameworks, initiatives and/or',
        label:
          'Participation in environmental collaborative industry frameworks, initiatives and/or'
      },
      {
        value: 'Use risk transfer instruments',
        label: 'Use risk transfer instruments'
      },
      {
        value: 'Other policies or plans, please specify',
        label: 'Other policies or plans, please specify'
      }
    ]
  },
  {
    label: 'Pricing and credits',
    options: [
      {
        value: 'Implement internal price on carbon [C only]',
        label: 'Implement internal price on carbon [C only]'
      },
      {
        value: 'Implement internal price on water [W only]',
        label: 'Implement internal price on water [W only]'
      },
      {
        value: 'Increase internal price on carbon [C only]',
        label: 'Increase internal price on carbon [C only]'
      },
      {
        value: 'Increase internal price on water [W only]',
        label: 'Increase internal price on water [W only]'
      },
      {
        value: 'Purchase water quality credits [W only]',
        label: 'Purchase water quality credits [W only]'
      },
      {
        value: 'Promotion/purchase of carbon credits [C, F only]',
        label: 'Promotion/purchase of carbon credits [C, F only]'
      },
      {
        value: 'Other pricing or credit, please specify',
        label: 'Other pricing or credit, please specify'
      }
    ]
  }
];

export const DESCRIBE_YOUR_ORGANIZATION_OPTIONS = [
  {
    value: '2030 Water Resources Group [W only]',
    label: '2030 Water Resources Group [W only]'
  },
  {
    value: 'Alliance for Climate Action (ACA)',
    label: 'Alliance for Climate Action (ACA)'
  },
  {
    value: 'Alliance for Water Stewardship (AWS) [W only]',
    label: 'Alliance for Water Stewardship (AWS) [W only]'
  },
  {
    value: 'Aluminum Stewardship Initiative (ASI) [M-B only]',
    label: 'Aluminum Stewardship Initiative (ASI) [M-B only]'
  },
  {
    value: 'Amazon Conservation Association (ACA) [F only]',
    label: 'Amazon Conservation Association (ACA) [F only]'
  },
  {
    value: 'Apparel and Footwear International RSL Management (AFIRM) Group',
    label: 'Apparel and Footwear International RSL Management (AFIRM) Group'
  },
  {
    value: 'Asia Investor Group on Climate Change (AIGCC) [FS only]',
    label: 'Asia Investor Group on Climate Change (AIGCC) [FS only]'
  },
  {
    value: 'Asia Sustainable Finance Initiative (ASFI) [FS only]',
    label: 'Asia Sustainable Finance Initiative (ASFI) [FS only]'
  },
  {value: 'B Corporation', label: 'B Corporation'},
  {
    value: 'Banking Environment Initiative [FS only]',
    label: 'Banking Environment Initiative [FS only]'
  },
  {
    value: 'Better Cotton Initiative (BCI)',
    label: 'Better Cotton Initiative (BCI)'
  },
  {value: 'Bettercoal [CO, M-B only]', label: 'Bettercoal [CO, M-B only]'},
  {
    value:
      'BioCarbon Fund Initiative for Sustainable Forest Landscapes [F only]',
    label:
      'BioCarbon Fund Initiative for Sustainable Forest Landscapes [F only]'
  },
  {value: 'Bonn Challenge', label: 'Bonn Challenge'},
  {
    value: 'Brazilian Roundtable on Sustainable Livestock (GTPS) [AC/FB only]',
    label: 'Brazilian Roundtable on Sustainable Livestock (GTPS) [AC/FB only]'
  },
  {value: 'Business 4 Nature', label: 'Business 4 Nature'},
  {
    value: 'Business and Biodiversity Pledge [B only]',
    label: 'Business and Biodiversity Pledge [B only]'
  },
  {value: 'Business Declares', label: 'Business Declares'},
  {value: 'Carbon Market Institute', label: 'Carbon Market Institute'},
  {
    value: 'Cattle Agreement (TAC) [AC/FB only]',
    label: 'Cattle Agreement (TAC) [AC/FB only]'
  },
  {
    value: 'CDP Investor Signatory [FS only]',
    label: 'CDP Investor Signatory [FS only]'
  },
  {value: 'CEO Water Mandate [W only]', label: 'CEO Water Mandate [W only]'},
  {value: 'Ceres', label: 'Ceres'},
  {
    value: 'Ceres Valuing Water Initiative [FS only]',
    label: 'Ceres Valuing Water Initiative [FS only]'
  },
  {value: 'Cerrado Funding Coalition', label: 'Cerrado Funding Coalition'},
  {value: 'Cerrado Manifesto [F only]', label: 'Cerrado Manifesto [F only]'},
  {value: 'Cerrado Working Group (GTC)', label: 'Cerrado Working Group (GTC)'},
  {value: 'Chambers Climate Coalition', label: 'Chambers Climate Coalition'},
  {
    value: 'China Sustainable Palm Oil Alliance (CSPOA) [F only]',
    label: 'China Sustainable Palm Oil Alliance (CSPOA) [F only]'
  },
  {
    value: 'Chinese Sustainable Meat Declaration (CSMD) [AC/FB only]',
    label: 'Chinese Sustainable Meat Declaration (CSMD) [AC/FB only]'
  },
  {value: 'Climate Action 100+', label: 'Climate Action 100+'},
  {
    value: 'Climate Bonds Initiative Partnership Programme [FS only]',
    label: 'Climate Bonds Initiative Partnership Programme [FS only]'
  },
  {value: 'ClimateWise Principles', label: 'ClimateWise Principles'},
  {
    value: 'Coalition for Sustainable Livelihoods (CSL)',
    label: 'Coalition for Sustainable Livelihoods (CSL)'
  },
  {
    value: 'Collective Commitment to Climate Action',
    label: 'Collective Commitment to Climate Action'
  },
  {
    value: 'Compromiso Gran Chaco Argentino 2030',
    label: 'Compromiso Gran Chaco Argentino 2030'
  },
  {
    value: 'Consumer Goods Forum Forests Positive Coalition [F only]',
    label: 'Consumer Goods Forum Forests Positive Coalition [F only]'
  },
  {
    value: 'Corporate Leaders Group (CLG)',
    label: 'Corporate Leaders Group (CLG)'
  },
  {
    value: 'Cross Sector Biodiversity Initiative (CSBI) [B only]',
    label: 'Cross Sector Biodiversity Initiative (CSBI) [B only]'
  },
  {
    value: 'Ellen MacArthur Foundation Global Commitment [P only]',
    label: 'Ellen MacArthur Foundation Global Commitment [P only]'
  },
  {value: 'Energy Efficiency Council', label: 'Energy Efficiency Council'},
  {
    value: 'Equator Principles [FS only]',
    label: 'Equator Principles [FS only]'
  },
  {
    value: 'EU Sustainable Tropical Timber Coalition (STTC) [F only]',
    label: 'EU Sustainable Tropical Timber Coalition (STTC) [F only]'
  },
  {value: 'European Climate Pact', label: 'European Climate Pact'},
  {
    value: 'European Palm Oil Alliance (EPAO) [F only]',
    label: 'European Palm Oil Alliance (EPAO) [F only]'
  },
  {
    value: 'Exponential Roadmap Initiative',
    label: 'Exponential Roadmap Initiative'
  },
  {
    value: 'Extractive Industries Transparency Initiative (EITI) [M-B only]',
    label: 'Extractive Industries Transparency Initiative (EITI) [M-B only]'
  },
  {
    value: 'Fair Water Footprints (FWF) [W only]',
    label: 'Fair Water Footprints (FWF) [W only]'
  },
  {
    value: 'Finnish Network for Sustainable Mining [M-B only]',
    label: 'Finnish Network for Sustainable Mining [M-B only]'
  },
  {value: 'Fire Free Alliance (FFA)', label: 'Fire Free Alliance (FFA)'},
  {
    value: 'Forest Stewardship Council (FSC) [F only]',
    label: 'Forest Stewardship Council (FSC) [F only]'
  },
  {
    value: 'Forests, Farms and Finance Initiative [F only]',
    label: 'Forests, Farms and Finance Initiative [F only]'
  },
  {
    value: 'Forum for Sustainable Palm Oil (FONAP) [F only]',
    label: 'Forum for Sustainable Palm Oil (FONAP) [F only]'
  },
  {value: 'Future Net Zero with CBN', label: 'Future Net Zero with CBN'},
  {
    value: 'G7 Investors Global Initiative [FS only]',
    label: 'G7 Investors Global Initiative [FS only]'
  },
  {
    value: 'Glasgow Financial Alliance for Net Zero (GFANZ) [FS only]',
    label: 'Glasgow Financial Alliance for Net Zero (GFANZ) [FS only]'
  },
  {
    value: 'Global Agri-business Alliance (GAA) [FB/AC only]',
    label: 'Global Agri-business Alliance (GAA) [FB/AC only]'
  },
  {
    value: 'Global Alliance for Banking on Values (GABV) [FS only]',
    label: 'Global Alliance for Banking on Values (GABV) [FS only]'
  },
  {
    value: 'Global e-Sustainability Initiative',
    label: 'Global e-Sustainability Initiative'
  },
  {
    value: 'Global Forest and Trade Network (GFTN) [F only]',
    label: 'Global Forest and Trade Network (GFTN) [F only]'
  },
  {
    value: 'Global Forest Watch [F only]',
    label: 'Global Forest Watch [F only]'
  },
  {
    value: 'Global Plastic Action Partnership [P only]',
    label: 'Global Plastic Action Partnership [P only]'
  },
  {
    value: 'Global Platform on Sustainable Natural Rubber (GPSNR) [F only]',
    label: 'Global Platform on Sustainable Natural Rubber (GPSNR) [F only]'
  },
  {
    value: 'Global Reporting Initiative (GRI) Community Member',
    label: 'Global Reporting Initiative (GRI) Community Member'
  },
  {
    value: 'Global Roundtable for Sustainable Beef (GRSB) [AC/FB only]',
    label: 'Global Roundtable for Sustainable Beef (GRSB) [AC/FB only]'
  },
  {
    value: 'Global Sustainable Plastic Packaging Programme [P only]',
    label: 'Global Sustainable Plastic Packaging Programme [P only]'
  },
  {
    value: 'Green Municipalities Program',
    label: 'Green Municipalities Program'
  },
  {value: 'Health Care Without Harm', label: 'Health Care Without Harm'},
  {value: 'HerProject', label: 'HerProject'},
  {
    value: 'High Carbon Stock Approach Steering Group',
    label: 'High Carbon Stock Approach Steering Group'
  },
  {
    value: 'High Conservation Value (HCV) Resource Network [F and B only]',
    label: 'High Conservation Value (HCV) Resource Network [F and B only]'
  },
  {
    value: 'IIF Forum on Implementation of TCFD Recommendations',
    label: 'IIF Forum on Implementation of TCFD Recommendations'
  },
  {
    value: 'Industry Task Team on Climate Change',
    label: 'Industry Task Team on Climate Change'
  },
  {
    value: 'Initiative for Responsible Mining (IRMA) [M-B only]',
    label: 'Initiative for Responsible Mining (IRMA) [M-B only]'
  },
  {
    value: 'Institutional Investors Group on Climate Change (IIGCC) [FS only]',
    label: 'Institutional Investors Group on Climate Change (IIGCC) [FS only]'
  },
  {
    value: 'International Corporate Governance Network (ICGN)',
    label: 'International Corporate Governance Network (ICGN)'
  },
  {
    value: 'International Council on Mining and Metals (ICMM) [MM, M-B only]',
    label: 'International Council on Mining and Metals (ICMM) [MM, M-B only]'
  },
  {
    value: 'International Sustainability & Carbon Certification (ISCC)',
    label: 'International Sustainability & Carbon Certification (ISCC)'
  },
  {
    value: 'International Water Stewardship Programme (IWaSP) [W only]',
    label: 'International Water Stewardship Programme (IWaSP) [W only]'
  },
  {
    value: 'International Wineries for Climate Action',
    label: 'International Wineries for Climate Action'
  },
  {
    value: 'Investor Group on Climate Change (IGCC) [FS only]',
    label: 'Investor Group on Climate Change (IGCC) [FS only]'
  },
  {
    value: 'Investor Network on Climate Risk (INCR) [FS only]',
    label: 'Investor Network on Climate Risk (INCR) [FS only]'
  },
  {
    value: 'Japan Climate Initiative (JCI)',
    label: 'Japan Climate Initiative (JCI)'
  },
  {
    value: 'Japan Climate Leaders’ Partnership (JCLP)',
    label: 'Japan Climate Leaders’ Partnership (JCLP)'
  },
  {value: 'Leather Working Group', label: 'Leather Working Group'},
  {value: 'Make Fashion Circular', label: 'Make Fashion Circular'},
  {
    value: 'Mission Possible Partnership',
    label: 'Mission Possible Partnership'
  },
  {
    value: 'National Business Initiative',
    label: 'National Business Initiative'
  },
  {value: 'Natural Capital Coalition', label: 'Natural Capital Coalition'},
  {
    value: 'Natural Capital Finance Alliance (NCFA) [FS only]',
    label: 'Natural Capital Finance Alliance (NCFA) [FS only]'
  },
  {
    value: 'Net Zero Asset Managers Initiative [FS only]',
    label: 'Net Zero Asset Managers Initiative [FS only]'
  },
  {
    value: 'Net Zero Asset Owner Alliance [FS only]',
    label: 'Net Zero Asset Owner Alliance [FS only]'
  },
  {
    value: 'Net Zero Banking Alliance [FS only]',
    label: 'Net Zero Banking Alliance [FS only]'
  },
  {
    value: 'Net Zero Financial Service Providers Alliance [FS only]',
    label: 'Net Zero Financial Service Providers Alliance [FS only]'
  },
  {
    value: 'Net Zero Insurance Alliance [FS only]',
    label: 'Net Zero Insurance Alliance [FS only]'
  },
  {
    value: 'Net Zero Investment Consultants Initiative [FS only]',
    label: 'Net Zero Investment Consultants Initiative [FS only]'
  },
  {
    value: 'New York Declaration on Forests [F only]',
    label: 'New York Declaration on Forests [F only]'
  },
  {
    value: 'Organic Cotton Accelerator (OCA)',
    label: 'Organic Cotton Accelerator (OCA)'
  },
  {
    value: 'Palm Oil Innovation Group (POIG) [F only]',
    label: 'Palm Oil Innovation Group (POIG) [F only]'
  },
  {
    value: 'Palm Oil Transparency Coalition (POTC) [F only]',
    label: 'Palm Oil Transparency Coalition (POTC) [F only]'
  },
  {
    value: 'Paris Agreement Capital Transition Assessment (PACTA) [FS only]',
    label: 'Paris Agreement Capital Transition Assessment (PACTA) [FS only]'
  },
  {
    value: 'Paris Aligned Investment Initiative [FS only]',
    label: 'Paris Aligned Investment Initiative [FS only]'
  },
  {
    value:
      'Partnership for Biodiversity Accounting Financials (PBAF) [FS only]',
    label: 'Partnership for Biodiversity Accounting Financials (PBAF) [FS only]'
  },
  {
    value: 'Partnership for Carbon Accounting Financials (PCAF) [FS only]',
    label: 'Partnership for Carbon Accounting Financials (PCAF) [FS only]'
  },
  {
    value: 'Partnership for Cleaner Textile (PaCT)',
    label: 'Partnership for Cleaner Textile (PaCT)'
  },
  {value: 'Planet Mark', label: 'Planet Mark'},
  {
    value: 'Plastic Pact Network [P only]',
    label: 'Plastic Pact Network [P only]'
  },
  {value: 'Pledge to Net Zero', label: 'Pledge to Net Zero'},
  {value: 'Positive Impact Initiative', label: 'Positive Impact Initiative'},
  {
    value: 'Principles for Responsible Investment (PRI) [FS only]',
    label: 'Principles for Responsible Investment (PRI) [FS only]'
  },
  {
    value: 'Produce, Conserve and Include (PCI)',
    label: 'Produce, Conserve and Include (PCI)'
  },
  {
    value: 'Production, Protection and Inclusion (PPI)',
    label: 'Production, Protection and Inclusion (PPI)'
  },
  {
    value:
      'Programme for the Endorsement of Forest Certification (PEFC) [F only]',
    label:
      'Programme for the Endorsement of Forest Certification (PEFC) [F only]'
  },
  {value: 'Project WET [W only]', label: 'Project WET [W only]'},
  {value: 'Race to Zero Campaign', label: 'Race to Zero Campaign'},
  {value: 'RE100', label: 'RE100'},
  {
    value: 'Responsible Jewellery Council (RJC) [MM, M-B only]',
    label: 'Responsible Jewellery Council (RJC) [MM, M-B only]'
  },
  {
    value: 'ResponsibleSteel [ST, M-B only]',
    label: 'ResponsibleSteel [ST, M-B only]'
  },
  {
    value: 'Roundtable on Sustainable Biomaterials (RSB) [F only]',
    label: 'Roundtable on Sustainable Biomaterials (RSB) [F only]'
  },
  {
    value: 'Roundtable on Sustainable Palm Oil (RSPO) [F only]',
    label: 'Roundtable on Sustainable Palm Oil (RSPO) [F only]'
  },
  {
    value: 'Roundtable on Sustainable Soy (RTRS) [AC/FB only]',
    label: 'Roundtable on Sustainable Soy (RTRS) [AC/FB only]'
  },
  {
    value: 'RSPO Jurisdictional Approach to Certification',
    label: 'RSPO Jurisdictional Approach to Certification'
  },
  {
    value: 'Science-Based Targets for Nature (SBTN)',
    label: 'Science-Based Targets for Nature (SBTN)'
  },
  {
    value: 'Science-Based Targets Initiative (SBTi)',
    label: 'Science-Based Targets Initiative (SBTi)'
  },
  {
    value:
      'Science-Based Targets Initiative for Financial Institutions (SBTi-FI) [FS only]',
    label:
      'Science-Based Targets Initiative for Financial Institutions (SBTi-FI) [FS only]'
  },
  {value: 'SME Climate Hub', label: 'SME Climate Hub'},
  {
    value: '‘Soft Commodities’ Compact [F only]',
    label: '‘Soft Commodities’ Compact [F only]'
  },
  {
    value: 'Soy Buyers Coalition [F only]',
    label: 'Soy Buyers Coalition [F only]'
  },
  {value: 'Soy Moratorium [F only]', label: 'Soy Moratorium [F only]'},
  {value: 'Sports for Climate Action', label: 'Sports for Climate Action'},
  {
    value: 'Support Asia for Sustainable Palm Oil (SASPO) [F only]',
    label: 'Support Asia for Sustainable Palm Oil (SASPO) [F only]'
  },
  {
    value: 'Sustainable Agriculture Initiative (SAI) [AC/FB only]',
    label: 'Sustainable Agriculture Initiative (SAI) [AC/FB only]'
  },
  {
    value: 'Sustainable Apparel Coalition (SAC)',
    label: 'Sustainable Apparel Coalition (SAC)'
  },
  {
    value: 'Sustainable Districts Association (Lingkar Temu Kabupaten Lestari)',
    label: 'Sustainable Districts Association (Lingkar Temu Kabupaten Lestari)'
  },
  {
    value: 'Sustainable Forestry Initiative (SFI) [F only]',
    label: 'Sustainable Forestry Initiative (SFI) [F only]'
  },
  {
    value: 'Sustainable Mining Initiative – SMI (India) [M-B only]',
    label: 'Sustainable Mining Initiative – SMI (India) [M-B only]'
  },
  {
    value: 'Sustainable Soy Trade Platform (SSTP) [AC/FB only]',
    label: 'Sustainable Soy Trade Platform (SSTP) [AC/FB only]'
  },
  {
    value: 'Task Force on Climate-related Financial Disclosures (TCFD)',
    label: 'Task Force on Climate-related Financial Disclosures (TCFD)'
  },
  {
    value: 'Task Force on Nature-related Financial Disclosures (TNFD)',
    label: 'Task Force on Nature-related Financial Disclosures (TNFD)'
  },
  {value: 'Terra Carta', label: 'Terra Carta'},
  {value: 'Textile Exchange', label: 'Textile Exchange'},
  {value: 'The B Team', label: 'The B Team'},
  {value: 'The Climate Pledge', label: 'The Climate Pledge'},
  {value: 'The Fashion Pact', label: 'The Fashion Pact'},
  {
    value: 'The Investor Agenda [FS only]',
    label: 'The Investor Agenda [FS only]'
  },
  {value: 'The Water Council [W only]', label: 'The Water Council [W only]'},
  {
    value:
      'Towards Sustainable Mining – TSM (Mining Association of Canada) [M-B only]',
    label:
      'Towards Sustainable Mining – TSM (Mining Association of Canada) [M-B only]'
  },
  {
    value: 'Transition Pathway Initiative',
    label: 'Transition Pathway Initiative'
  },
  {
    value: 'Tropical Forest Alliance 2020 (TFA) [F only]',
    label: 'Tropical Forest Alliance 2020 (TFA) [F only]'
  },
  {
    value: 'UK Roundtable on Sustainable Soy [AC/FB only]',
    label: 'UK Roundtable on Sustainable Soy [AC/FB only]'
  },
  {value: 'UN Global Compact', label: 'UN Global Compact'},
  {value: 'UNEP FI [FS only]', label: 'UNEP FI [FS only]'},
  {
    value: 'UNEP FI Portfolio Decarbonization Coalition [FS only]',
    label: 'UNEP FI Portfolio Decarbonization Coalition [FS only]'
  },
  {
    value: 'UNEP FI Principles for Responsible Banking [FS only]',
    label: 'UNEP FI Principles for Responsible Banking [FS only]'
  },
  {
    value: 'UNEP FI Principles for Sustainable Insurance [FS only]',
    label: 'UNEP FI Principles for Sustainable Insurance [FS only]'
  },
  {
    value: 'UNEP FI’s Climate Risk and TCFD Programme [FS only]',
    label: 'UNEP FI’s Climate Risk and TCFD Programme [FS only]'
  },
  {value: 'Verified Sourcing Areas', label: 'Verified Sourcing Areas'},
  {
    value: 'Waste and Resources Action Programme (WRAP) [W only]',
    label: 'Waste and Resources Action Programme (WRAP) [W only]'
  },
  {
    value: 'Wastewater Zero Commitment [W only]',
    label: 'Wastewater Zero Commitment [W only]'
  },
  {
    value: 'Water Action Hub (by CEO Water Mandate) [W only]',
    label: 'Water Action Hub (by CEO Water Mandate) [W only]'
  },
  {value: 'Water Europe [W only]', label: 'Water Europe [W only]'},
  {
    value: 'Water Resilience Coalition [W only]',
    label: 'Water Resilience Coalition [W only]'
  },
  {
    value: 'WBCSD Forest Solutions Group [F only]',
    label: 'WBCSD Forest Solutions Group [F only]'
  },
  {value: 'We Are Still In', label: 'We Are Still In'},
  {value: 'We Mean Business', label: 'We Mean Business'},
  {
    value: 'World Business Council for Sustainable Development (WBCSD)',
    label: 'World Business Council for Sustainable Development (WBCSD)'
  },
  {
    value: 'WWF ReSource: Plastic [P only]',
    label: 'WWF ReSource: Plastic [P only]'
  },
  {
    value: 'Zero Discharge of Hazardous Chemicals (ZDHC) [W only]',
    label: 'Zero Discharge of Hazardous Chemicals (ZDHC) [W only]'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TRADE_ASSOCIATION_OPTIONS = [
  {
    value: 'Business Unity South Africa (BUSA)',
    label: 'Business Unity South Africa (BUSA)'
  },
  {
    value: 'Minerals Council South Africa [CO and MM only]',
    label: 'Minerals Council South Africa [CO and MM only]'
  },
  {
    value: 'South African Wind Energy Association (SAWEA)',
    label: 'South African Wind Energy Association (SAWEA)'
  },
  {
    value: 'Other trade association in Africa, please specify',
    label: 'Other trade association in Africa, please specify'
  },
  {value: 'Australian Energy Council', label: 'Australian Energy Council'},
  {value: 'Australian Hydrogen Council', label: 'Australian Hydrogen Council'},
  {
    value: 'Australian Industry Group (Ai Group)',
    label: 'Australian Industry Group (Ai Group)'
  },
  {
    value: 'Business Council of Australia',
    label: 'Business Council of Australia'
  },
  {value: 'China Meat Association', label: 'China Meat Association'},
  {value: 'Clean Energy Council', label: 'Clean Energy Council'},
  {
    value: 'Confederation of Indian Industries (CII)',
    label: 'Confederation of Indian Industries (CII)'
  },
  {value: 'Energy Networks Australia', label: 'Energy Networks Australia'},
  {
    value: 'Federation of Indian Chambers of Commerce & Industry (FICCI)',
    label: 'Federation of Indian Chambers of Commerce & Industry (FICCI)'
  },
  {
    value: 'Hong Kong General Chamber of Commerce (HKGCC)',
    label: 'Hong Kong General Chamber of Commerce (HKGCC)'
  },
  {
    value: 'Indonesia Chamber of Commerce and Industry (KADIN)',
    label: 'Indonesia Chamber of Commerce and Industry (KADIN)'
  },
  {
    value: 'Indonesia Employers Association (APINDO)',
    label: 'Indonesia Employers Association (APINDO)'
  },
  {
    value: 'Indonesian Palm Oil Association (GAPKI)',
    label: 'Indonesian Palm Oil Association (GAPKI)'
  },
  {
    value: 'Japan Business Federation (Keidanren)',
    label: 'Japan Business Federation (Keidanren)'
  },
  {
    value: 'Japan Chemical Industry Association [CH only]',
    label: 'Japan Chemical Industry Association [CH only]'
  },
  {
    value: 'Japan Iron and Steel Federation',
    label: 'Japan Iron and Steel Federation'
  },
  {
    value: 'Minerals Council of Australia',
    label: 'Minerals Council of Australia'
  },
  {
    value: 'Renewable Energy Council (REC)',
    label: 'Renewable Energy Council (REC)'
  },
  {
    value: 'The Japan Electrical Manufacturers’ Association (JEMA)',
    label: 'The Japan Electrical Manufacturers’ Association (JEMA)'
  },
  {
    value: 'Other trade association in Asia and Pacific, please specify',
    label: 'Other trade association in Asia and Pacific, please specify'
  },
  {
    value:
      'Association of Chocolate, Biscuit and Confectionary Industries of Europe (CAOBISCO) [FBT only]',
    label:
      'Association of Chocolate, Biscuit and Confectionary Industries of Europe (CAOBISCO) [FBT only]'
  },
  {value: 'British Water', label: 'British Water'},
  {value: 'BusinessEurope', label: 'BusinessEurope'},
  {
    value: 'CEMBUREAU: The European Cement Association [CE only]',
    label: 'CEMBUREAU: The European Cement Association [CE only]'
  },
  {
    value: 'Confederation of British Industry (CBI)',
    label: 'Confederation of British Industry (CBI)'
  },
  {
    value: 'Confederation of Italian Industry (Confindustria)',
    label: 'Confederation of Italian Industry (Confindustria)'
  },
  {
    value: 'EU Vegetable Oil and Proteinmeal Industry (FEDIOL)',
    label: 'EU Vegetable Oil and Proteinmeal Industry (FEDIOL)'
  },
  {value: 'Eurelectric', label: 'Eurelectric'},
  {value: 'Eurometaux', label: 'Eurometaux'},
  {
    value:
      'European Association of Trade in Cereals, Oilseeds, Rice, Pulses, Olive Oils and Fats, and Agrosupply (COCERAL)',
    label:
      'European Association of Trade in Cereals, Oilseeds, Rice, Pulses, Olive Oils and Fats, and Agrosupply (COCERAL)'
  },
  {
    value: 'European Automobile Manufacturers Association',
    label: 'European Automobile Manufacturers Association'
  },
  {
    value: 'European Chemical Industry Council (CEFIC) [CH only]',
    label: 'European Chemical Industry Council (CEFIC) [CH only]'
  },
  {
    value:
      'European Federation of National Associations of Water Services (EurEau)',
    label:
      'European Federation of National Associations of Water Services (EurEau)'
  },
  {
    value: 'European Feed Manufacturers’ Federation (FEFAC)',
    label: 'European Feed Manufacturers’ Federation (FEFAC)'
  },
  {
    value: 'European Margarine Association (IMACE)',
    label: 'European Margarine Association (IMACE)'
  },
  {
    value: 'European Palm Oil Alliance (EPOA)',
    label: 'European Palm Oil Alliance (EPOA)'
  },
  {
    value: 'European Roundtable for Industry (ERT)',
    label: 'European Roundtable for Industry (ERT)'
  },
  {
    value: 'European Seaports Organisation (ESPO)',
    label: 'European Seaports Organisation (ESPO)'
  },
  {
    value: 'European Steel Association (Eurofer) [ST only]',
    label: 'European Steel Association (Eurofer) [ST only]'
  },
  {
    value: 'European Timber Trade Federation (ETTF)',
    label: 'European Timber Trade Federation (ETTF)'
  },
  {
    value: 'Federation of German Industries (BDI)',
    label: 'Federation of German Industries (BDI)'
  },
  {value: 'FoodDrinkEurope [FBT only]', label: 'FoodDrinkEurope [FBT only]'},
  {value: 'FuelsEurope', label: 'FuelsEurope'},
  {value: 'Future Water Association', label: 'Future Water Association'},
  {
    value: 'Gas Distributors for Sustainability (GD4S)',
    label: 'Gas Distributors for Sustainability (GD4S)'
  },
  {
    value: 'German Automotive Association (VDA)',
    label: 'German Automotive Association (VDA)'
  },
  {
    value: 'German Chemical Industry Association (VCI)',
    label: 'German Chemical Industry Association (VCI)'
  },
  {value: 'Hydrogen Europe', label: 'Hydrogen Europe'},
  {value: 'International Gas Union', label: 'International Gas Union'},
  {
    value: 'Offshore Energies UK (OEUK) (Formerly OGUK)',
    label: 'Offshore Energies UK (OEUK) (Formerly OGUK)'
  },
  {
    value: 'Mouvement des Entreprises de France (MEDEF)',
    label: 'Mouvement des Entreprises de France (MEDEF)'
  },
  {value: 'SolarPower Europe', label: 'SolarPower Europe'},
  {value: 'SmartEN', label: 'SmartEN'},
  {value: 'WindEurope', label: 'WindEurope'},
  {
    value: 'Other trade association in Europe, please specify',
    label: 'Other trade association in Europe, please specify'
  },
  {
    value: 'American Association of Port Authorities',
    label: 'American Association of Port Authorities'
  },
  {
    value: 'Advanced Energy Economy (AEE)',
    label: 'Advanced Energy Economy (AEE)'
  },
  {value: 'Advanced Energy United', label: 'Advanced Energy United'},
  {
    value: 'Alliance for Automotive Innovation',
    label: 'Alliance for Automotive Innovation'
  },
  {value: 'American Chemistry Council', label: 'American Chemistry Council'},
  {
    value: 'American Fuel & Petrochemical Manufacturers',
    label: 'American Fuel & Petrochemical Manufacturers'
  },
  {value: 'American Gas Association', label: 'American Gas Association'},
  {
    value: 'American Hardwood Export Council (AHEC)',
    label: 'American Hardwood Export Council (AHEC)'
  },
  {
    value: 'American Public Power Association',
    label: 'American Public Power Association'
  },
  {
    value: 'American Petroleum Institute',
    label: 'American Petroleum Institute'
  },
  {
    value: 'American Water Resources Association',
    label: 'American Water Resources Association'
  },
  {
    value: 'American Clean Power Association (formerly AWEA)',
    label: 'American Clean Power Association (formerly AWEA)'
  },
  {value: 'Business Council of Canada', label: 'Business Council of Canada'},
  {value: 'Canada Business Roundtable', label: 'Canada Business Roundtable'},
  {
    value: 'California Chamber of Commerce',
    label: 'California Chamber of Commerce'
  },
  {
    value: 'Canadian Association of Petroleum Producers',
    label: 'Canadian Association of Petroleum Producers'
  },
  {
    value: 'Edison Electric Institute (EII)',
    label: 'Edison Electric Institute (EII)'
  },
  {
    value: 'Forest Products Society (FPS)',
    label: 'Forest Products Society (FPS)'
  },
  {
    value: 'National Association of Clean Water Agencies',
    label: 'National Association of Clean Water Agencies'
  },
  {
    value: 'National Association of Manufacturers',
    label: 'National Association of Manufacturers'
  },
  {
    value: 'National Association of Water Companies',
    label: 'National Association of Water Companies'
  },
  {value: 'National Farmers Union', label: 'National Farmers Union'},
  {
    value: 'National Ground Water Association',
    label: 'National Ground Water Association'
  },
  {value: 'National Mining Association', label: 'National Mining Association'},
  {
    value: 'National Rural Water Association',
    label: 'National Rural Water Association'
  },
  {value: 'Portland Cement Association', label: 'Portland Cement Association'},
  {
    value: 'Solar Energy Industries Association (SEIA)',
    label: 'Solar Energy Industries Association (SEIA)'
  },
  {value: 'US Chamber of Commerce', label: 'US Chamber of Commerce'},
  {
    value: 'Zero Emission Transportation Association (ZETA)',
    label: 'Zero Emission Transportation Association (ZETA)'
  },
  {
    value: 'Other trade association in North America, please specify',
    label: 'Other trade association in North America, please specify'
  },
  {
    value:
      'Brazilian Association of Soybean Growers (Aprosoja Brasil) [AC only]',
    label:
      'Brazilian Association of Soybean Growers (Aprosoja Brasil) [AC only]'
  },
  {
    value: 'Brazilian Beef Exporters Association (ABIEC)',
    label: 'Brazilian Beef Exporters Association (ABIEC)'
  },
  {
    value: 'Brazilian Confederation of Agriculture and Livestock (CNA)',
    label: 'Brazilian Confederation of Agriculture and Livestock (CNA)'
  },
  {
    value: 'Brazilian Roundtable on Sustainable Livestock (GTPS)',
    label: 'Brazilian Roundtable on Sustainable Livestock (GTPS)'
  },
  {
    value: 'Brazilian Grain Exporters Association (ANEC)',
    label: 'Brazilian Grain Exporters Association (ANEC)'
  },
  {
    value: 'Brazilian Vegetable Oil Industry Association (ABIOVE)',
    label: 'Brazilian Vegetable Oil Industry Association (ABIOVE)'
  },
  {
    value:
      'Fedepalma – National Federation of Oil Palm Growers of Colombia [AC and FBT only]',
    label:
      'Fedepalma – National Federation of Oil Palm Growers of Colombia [AC and FBT only]'
  },
  {
    value: 'Other trade association in South America, please specify',
    label: 'Other trade association in South America, please specify'
  },
  {
    value: 'Airports Council International',
    label: 'Airports Council International'
  },
  {
    value: 'Association of Water Technologies',
    label: 'Association of Water Technologies'
  },
  {value: 'Consumer Goods Forum (CGF)', label: 'Consumer Goods Forum (CGF)'},
  {value: 'FutureCoal', label: 'FutureCoal'},
  {
    value: 'Global Off-Grid Lighting Association (GOGLA)',
    label: 'Global Off-Grid Lighting Association (GOGLA)'
  },
  {
    value: 'Global Wind Energy Council (GWEC)',
    label: 'Global Wind Energy Council (GWEC)'
  },
  {
    value: 'International Air Transport Association',
    label: 'International Air Transport Association'
  },
  {
    value: 'International Association of Oil and Gas Producers (IOGP)',
    label: 'International Association of Oil and Gas Producers (IOGP)'
  },
  {
    value: 'International Association of Ports and Harbors',
    label: 'International Association of Ports and Harbors'
  },
  {
    value: 'International Chamber of Commerce (ICC)',
    label: 'International Chamber of Commerce (ICC)'
  },
  {
    value: 'International Chamber of Shipping',
    label: 'International Chamber of Shipping'
  },
  {
    value: 'International Coffee Organization (ICO) [FBT only]',
    label: 'International Coffee Organization (ICO) [FBT only]'
  },
  {
    value: 'International Council on Mining & Metals (ICMM) [CO and MM only]',
    label: 'International Council on Mining & Metals (ICMM) [CO and MM only]'
  },
  {value: 'World Steel Association', label: 'World Steel Association'},
  {
    value: 'International Soybean Growers Alliance (ISGA) [AC and FBT only]',
    label: 'International Soybean Growers Alliance (ISGA) [AC and FBT only]'
  },
  {
    value: 'International Wood Products Association (IWPA)',
    label: 'International Wood Products Association (IWPA)'
  },
  {
    value: 'International Tropical Timber Technical Association (ATIBT)',
    label: 'International Tropical Timber Technical Association (ATIBT)'
  },
  {
    value: 'Other global trade association, please specify',
    label: 'Other global trade association, please specify'
  }
];

export const DETAILS_OF_PROCEDURE_OPTIONS = [
  {
    label: 'Acceptable risk levels',
    options: [
      {
        value:
          'Establishment of site-level guidance and standards for acceptable risk levels based on an evaluation of potential chemical and physical risks',
        label:
          'Establishment of site-level guidance and standards for acceptable risk levels based on an evaluation of potential chemical and physical risks'
      },
      {
        value:
          'Establishment of site-level guidance and standards for acceptable risk levels for third party safety in consultation with potentially affected communities, employees and relevant government bodies',
        label:
          'Establishment of site-level guidance and standards for acceptable risk levels for third party safety in consultation with potentially affected communities, employees and relevant government bodies'
      },
      {
        value:
          'Establishment of site-level guidance and standards for acceptable risk levels across all life stages including post-closure',
        label:
          'Establishment of site-level guidance and standards for acceptable risk levels across all life stages including post-closure'
      },
      {
        value:
          'Establishment of company-wide standards for acceptable risk levels that follow a company policy to eliminate or minimize water-related risks associated with tailings dams',
        label:
          'Establishment of company-wide standards for acceptable risk levels that follow a company policy to eliminate or minimize water-related risks associated with tailings dams'
      },
      {
        value: 'Other acceptable risk level, please specify',
        label: 'Other acceptable risk level, please specify'
      }
    ]
  },
  {
    label: 'Operating plan',
    options: [
      {
        value:
          'An operating plan that is aligned with your established acceptable risk levels and critical controls framework',
        label:
          'An operating plan that is aligned with your established acceptable risk levels and critical controls framework'
      },
      {
        value:
          'An operating plan that includes the operating constraints of the dam and its construction method',
        label:
          'An operating plan that includes the operating constraints of the dam and its construction method'
      },
      {
        value:
          'An operating plan that considers the consequences of breaching the operating constraints of the dam',
        label:
          'An operating plan that considers the consequences of breaching the operating constraints of the dam'
      },
      {
        value:
          'An operating plan that includes periodic review of the foundations and slope materials',
        label:
          'An operating plan that includes periodic review of the foundations and slope materials'
      },
      {
        value:
          'An operating plan that evaluates the effectiveness of the risk management measures and whether performance objectives are being met',
        label:
          'An operating plan that evaluates the effectiveness of the risk management measures and whether performance objectives are being met'
      },
      {
        value: 'Other operating plan, please specify',
        label: 'Other operating plan, please specify'
      }
    ]
  },
  {
    label: 'Life of facility plan',
    options: [
      {
        value:
          'A life of facility plan that identifies minimum specifications and performance objectives for the operating and closure phases',
        label:
          'A life of facility plan that identifies minimum specifications and performance objectives for the operating and closure phases'
      },
      {
        value:
          'A life of facility plan that includes an identification of potential chemical and physical risks from the design and construction phases',
        label:
          'A life of facility plan that includes an identification of potential chemical and physical risks from the design and construction phases'
      },
      {
        value:
          'A life of facility plan that considers post-closure land and water use',
        label:
          'A life of facility plan that considers post-closure land and water use'
      },
      {
        value:
          'A life of facility plan that details the financial and human resources needed',
        label:
          'A life of facility plan that details the financial and human resources needed'
      },
      {
        value: 'Other life of facility plan, please specify',
        label: 'Other life of facility plan, please specify'
      }
    ]
  },
  {
    label: 'Assurance program',
    options: [
      {
        value:
          'An assurance program for the operating phase of the facility that details the procedures for the inspections, audits and reviews',
        label:
          'An assurance program for the operating phase of the facility that details the procedures for the inspections, audits and reviews'
      },
      {
        value:
          'An assurance program for each phase of the facility’s life that includes the frequency of the various levels of inspections, audits and reviews',
        label:
          'An assurance program for each phase of the facility’s life that includes the frequency of the various levels of inspections, audits and reviews'
      },
      {
        value:
          'An assurance program for each phase of the facility’s life that includes the scope of the various levels of inspections, audits and reviews',
        label:
          'An assurance program for each phase of the facility’s life that includes the scope of the various levels of inspections, audits and reviews'
      },
      {
        value:
          'An assurance program that details the competence requirements for the persons undertaking the inspections, audits and reviews',
        label:
          'An assurance program that details the competence requirements for the persons undertaking the inspections, audits and reviews'
      },
      {
        value:
          'An assurance program that includes an external audit covering the life of facility or the operating plans',
        label:
          'An assurance program that includes an external audit covering the life of facility or the operating plans'
      },
      {
        value: 'Other assurance program, please specify',
        label: 'Other assurance program, please specify'
      }
    ]
  },
  {
    label: 'Change management process',
    options: [
      {
        value:
          'Inclusion of a formal change management process for the construction phase of the facility',
        label:
          'Inclusion of a formal change management process for the construction phase of the facility'
      },
      {
        value:
          'Inclusion of a formal change management process for the operating phase of the facility',
        label:
          'Inclusion of a formal change management process for the operating phase of the facility'
      },
      {
        value:
          'Inclusion of a formal change management process for the closure and decommissioning phase of the facility',
        label:
          'Inclusion of a formal change management process for the closure and decommissioning phase of the facility'
      },
      {
        value:
          'Inclusion of a change management process in the assurance program',
        label:
          'Inclusion of a change management process in the assurance program'
      },
      {
        value:
          'Inclusion of the results from external audits of operating plans or life of facility plans into the change management process',
        label:
          'Inclusion of the results from external audits of operating plans or life of facility plans into the change management process'
      },
      {
        value: 'Other change management process, please specify',
        label: 'Other change management process, please specify'
      }
    ]
  },
  {
    label: 'Approval ',
    options: [
      {
        value:
          'A policy to eliminate or minimize water-related risks associated with tailings dams is approved by a C-suite officer',
        label:
          'A policy to eliminate or minimize water-related risks associated with tailings dams is approved by a C-suite officer'
      },
      {
        value:
          'The operating plan and the life of facility plan are approved by the EHS manager',
        label:
          'The operating plan and the life of facility plan are approved by the EHS manager'
      },
      {
        value:
          'The operating plan and the life of facility plan are approved by a C-suite officer',
        label:
          'The operating plan and the life of facility plan are approved by a C-suite officer'
      },
      {
        value:
          'The results of the assurance program and the change management process are approved by the EHS manager',
        label:
          'The results of the assurance program and the change management process are approved by the EHS manager'
      },
      {
        value:
          'The results of the assurance program and the change management process are approved by a C-suite officer',
        label:
          'The results of the assurance program and the change management process are approved by a C-suite officer'
      },
      {
        value: 'Other approval, please specify',
        label: 'Other approval, please specify'
      }
    ]
  },
  {
    label: 'Other management procedure',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const OPPORTUNITY_TYPE_PRIMARY_ENVIRONMENTAL_OPPORTUNITY_DRIVER_OPTIONS =
  [
    {
      label: 'Capital flow and financing',
      options: [
        {
          label: 'Access to new financing options',
          value: 'Access to new financing options'
        },
        {
          label: 'Access to sustainability linked loans',
          value: 'Access to sustainability linked loans'
        },
        {
          label:
            'Incentives to promote low-carbon agriculture [CAC/FB/PF only]',
          value: 'Incentives to promote low-carbon agriculture [CAC/FB/PF only]'
        },
        {
          label: 'Financial reward from buyers',
          value: 'Financial reward from buyers'
        },
        {
          label: 'Payment for ecosystem services (other than REDD+)',
          value: 'Payment for ecosystem services (other than REDD+)'
        },
        {
          label:
            'Price premium for deforestation and conversion-free materials [F only]',
          value:
            'Price premium for deforestation and conversion-free materials [F only]'
        },
        {label: 'REDD+', value: 'REDD+'},
        {
          label: 'Other capital flow and financing opportunity, please specify',
          value: 'Other capital flow and financing opportunity, please specify'
        }
      ]
    },
    {
      label: 'Energy source [CC only]',
      options: [
        {
          label: 'Participation in carbon market [CC only]',
          value: 'Participation in carbon market [CC only]'
        },
        {
          label: 'Shift toward decentralized energy generation [CC only]',
          value: 'Shift toward decentralized energy generation [CC only]'
        },
        {
          label: 'Use of carbon capture and storage [CC only]',
          value: 'Use of carbon capture and storage [CC only]'
        },
        {
          label: 'Use of low-carbon energy sources [CC only]',
          value: 'Use of low-carbon energy sources [CC only]'
        },
        {
          label: 'Use of renewable energy sources [CC only]',
          value: 'Use of renewable energy sources [CC only]'
        },
        {
          label: 'Other energy source opportunity, please specify [CC only]',
          value: 'Other energy source opportunity, please specify [CC only]'
        }
      ]
    },
    {
      label: 'Markets',
      options: [
        {
          label: 'Easier access to cheaper and/or more available credit',
          value: 'Easier access to cheaper and/or more available credit'
        },
        {
          label:
            'Enhanced financial performance of investee companies as a result of being able to access new markets and develop new products to meet green consumer demand [FS only]',
          value:
            'Enhanced financial performance of investee companies as a result of being able to access new markets and develop new products to meet green consumer demand [FS only]'
        },
        {
          label: 'Expansion into new markets',
          value: 'Expansion into new markets'
        },
        {label: 'Increased brand value', value: 'Increased brand value'},
        {
          label:
            'Increased demand for transparency in mineral supply chains [MM, M-B only]',
          value:
            'Increased demand for transparency in mineral supply chains [MM, M-B only]'
        },
        {
          label: 'Improved supply chain engagement',
          value: 'Improved supply chain engagement'
        },
        {
          label:
            'Increased availability of products with reduced environmental impact [other than certified products]',
          value:
            'Increased availability of products with reduced environmental impact [other than certified products]'
        },
        {
          label: 'Increased demand for certified and sustainable materials',
          value: 'Increased demand for certified and sustainable materials'
        },
        {
          label:
            'Increased demand for funds that invest in companies that have positive environmental credentials [FS only]',
          value:
            'Increased demand for funds that invest in companies that have positive environmental credentials [FS only]'
        },
        {
          label:
            'Increased diversification of financial assets [e.g., green bonds and infrastructure] [FS only]',
          value:
            'Increased diversification of financial assets [e.g., green bonds and infrastructure] [FS only]'
        },
        {
          label:
            'Increased growth in the alternative protein market [Cattle and soy only] [F]',
          value:
            'Increased growth in the alternative protein market [Cattle and soy only] [F]'
        },
        {
          label:
            'Increased sales of liability and other insurance to cover environmental risks [FS only]',
          value:
            'Increased sales of liability and other insurance to cover environmental risks [FS only]'
        },
        {
          label:
            'More timely preparation for investors in adhering to current and potentially stricter future regulation in relation to fiduciary duty [FS only]',
          value:
            'More timely preparation for investors in adhering to current and potentially stricter future regulation in relation to fiduciary duty [FS only]'
        },
        {
          label:
            'Reduced risk of asset stranding considered in investment decision making [FS only]',
          value:
            'Reduced risk of asset stranding considered in investment decision making [FS only]'
        },
        {
          label: 'Stronger competitive advantage',
          value: 'Stronger competitive advantage'
        },
        {
          label: 'Use of public sector incentives',
          value: 'Use of public sector incentives'
        },
        {
          label: 'Other markets opportunity, please specify',
          value: 'Other markets opportunity, please specify'
        }
      ]
    },
    {
      label: 'Products and services',
      options: [
        {
          label: 'Ability to diversify business activities',
          value: 'Ability to diversify business activities'
        },
        {
          label:
            'Development of climate adaptation, resilience and insurance risk solutions [FS only]',
          value:
            'Development of climate adaptation, resilience and insurance risk solutions [FS only]'
        },
        {
          label:
            'Development of new products or services through R&D and innovation',
          value:
            'Development of new products or services through R&D and innovation'
        },
        {
          label: 'Increased sales of existing products and services',
          value: 'Increased sales of existing products and services'
        },
        {
          label: 'Increased security of production [F, B only]',
          value: 'Increased security of production [F, B only]'
        },
        {
          label: 'Increased value chain transparency',
          value: 'Increased value chain transparency'
        },
        {
          label: 'Reduced impact of product use on water resources [W only]',
          value: 'Reduced impact of product use on water resources [W only]'
        },
        {
          label: 'Shift in consumer preferences',
          value: 'Shift in consumer preferences'
        },
        {
          label: 'Other products and services opportunity, please specify',
          value: 'Other products and services opportunity, please specify'
        }
      ]
    },
    {
      label: 'Reputational capital ',
      options: [
        {
          label: 'Improved community relations',
          value: 'Improved community relations'
        },
        {
          label: 'Improved ratings by sustainability/ESG indexes',
          value: 'Improved ratings by sustainability/ESG indexes'
        },
        {
          label:
            'Reputational benefits resulting in increased demand for products/services',
          value:
            'Reputational benefits resulting in increased demand for products/services'
        },
        {
          label: 'Strengthened social license to operate',
          value: 'Strengthened social license to operate'
        },
        {
          label: 'Other reputational capital opportunity, please specify',
          value: 'Other reputational capital opportunity, please specify'
        }
      ]
    },
    {
      label: 'Resilience',
      options: [
        {
          label: 'Capacity building [M-B only]',
          value: 'Capacity building [M-B only]'
        },
        {
          label: 'Contribution to biodiversity knowledge [M-B only]',
          value: 'Contribution to biodiversity knowledge [M-B only]'
        },
        {
          label: 'Improved customer education [M-B only]',
          value: 'Improved customer education [M-B only]'
        },
        {
          label: 'Improved resilience to future regulatory changes',
          value: 'Improved resilience to future regulatory changes'
        },
        {label: 'Improved staff retention', value: 'Improved staff retention'},
        {
          label:
            'Increased reliability and environmental resilience of investment chain [FS only]',
          value:
            'Increased reliability and environmental resilience of investment chain [FS only]'
        },
        {
          label: 'Increased resilience to impacts of climate change',
          value: 'Increased resilience to impacts of climate change'
        },
        {
          label: 'Increased upstream value chain resilience',
          value: 'Increased upstream value chain resilience'
        },
        {
          label:
            'Participation in environmental collaborative industry frameworks, initiatives and/or commitments',
          value:
            'Participation in environmental collaborative industry frameworks, initiatives and/or commitments'
        },
        {label: 'Shift in business model', value: 'Shift in business model'},
        {
          label: 'Other resilience opportunity, please specify',
          value: 'Other resilience opportunity, please specify'
        }
      ]
    },
    {
      label: 'Resource efficiency  ',
      options: [
        {
          label: 'Agricultural expansion in degraded land [F only]',
          value: 'Agricultural expansion in degraded land [F only]'
        },
        {label: 'Cost savings', value: 'Cost savings'},
        {
          label: 'Improved field recovery factor [W-OG only]',
          value: 'Improved field recovery factor [W-OG only]'
        },
        {
          label:
            'Increased efficiency of production and/or distribution processes',
          value:
            'Increased efficiency of production and/or distribution processes'
        },
        {
          label: 'Move to more energy/resource efficient buildings [CC only]',
          value: 'Move to more energy/resource efficient buildings [CC only]'
        },
        {
          label: 'Reduced water usage and consumption [CC, W only]',
          value: 'Reduced water usage and consumption [CC, W only]'
        },
        {
          label:
            'Reduction of food loss and waste in the value chain [AC/FB only]',
          value:
            'Reduction of food loss and waste in the value chain [AC/FB only]'
        },
        {
          label: 'Regenerative production [F, W, B]',
          value: 'Regenerative production [F, W, B]'
        },
        {
          label: 'Use of more efficient modes of transport [CC only]',
          value: 'Use of more efficient modes of transport [CC only]'
        },
        {label: 'Use of recycling', value: 'Use of recycling'},
        {
          label: 'Water recovery from sewage treatment [W only]',
          value: 'Water recovery from sewage treatment [W only]'
        },
        {label: 'Use of new technologies', value: 'Use of new technologies'},
        {
          label: 'Other resource efficiency opportunity, please specify',
          value: 'Other resource efficiency opportunity, please specify'
        }
      ]
    }
  ];

export const PROCESS_PLACE_OPTIONS = [
  {value: 'Yes', label: 'Yes'},
  {
    value: 'No, but we plan to within the next two years',
    label: 'No, but we plan to within the next two years'
  },
  {
    value: 'No, and we do not plan to within the next two years',
    label: 'No, and we do not plan to within the next two years'
  }
];

export const SCENARIO_TRANSTION_SCENARIO_OPTIONS = [
  {
    label: 'Climate transition scenarios',
    options: [
      {value: 'IEA NZE 2050', label: 'IEA NZE 2050'},
      {value: 'IEA B2DS', label: 'IEA B2DS'},
      {value: 'IEA 2DS', label: 'IEA 2DS'},
      {value: 'IEA 450', label: 'IEA 450'},
      {value: 'IEA SDS', label: 'IEA SDS'},
      {value: 'IEA APS', label: 'IEA APS'},
      {
        value: 'IEA STEPS (previously IEA NPS)',
        label: 'IEA STEPS (previously IEA NPS)'
      },
      {value: 'IEA CPS', label: 'IEA CPS'},
      {value: 'Greenpeace', label: 'Greenpeace'},
      {value: 'DDP', label: 'DDP'},
      {value: 'IRENA', label: 'IRENA'},
      {value: 'BNEF NEO', label: 'BNEF NEO'},
      {
        value: 'NGFS scenarios framework, please specify',
        label: 'NGFS scenarios framework, please specify'
      },
      {
        value:
          'Customized publicly available climate transition scenario, please specify',
        label:
          'Customized publicly available climate transition scenario, please specify'
      },
      {
        value: 'Bespoke climate transition scenario',
        label: 'Bespoke climate transition scenario'
      }
    ]
  },
  {
    label: 'Physical climate scenarios',
    options: [
      {value: 'RCP 1.9', label: 'RCP 1.9'},
      {value: 'RCP 2.6', label: 'RCP 2.6'},
      {value: 'RCP 3.4', label: 'RCP 3.4'},
      {value: 'RCP 4.5', label: 'RCP 4.5'},
      {value: 'RCP 6.0', label: 'RCP 6.0'},
      {value: 'RCP 7.0', label: 'RCP 7.0'},
      {value: 'RCP 8.5', label: 'RCP 8.5'},
      {
        value:
          'Customized publicly available physical climate scenario,please specify',
        label:
          'Customized publicly available physical climate scenario,please specify'
      },
      {
        value: 'Bespoke physical climate scenario',
        label: 'Bespoke physical climate scenario'
      }
    ]
  },
  {
    label: 'Water scenarios',
    options: [
      {value: 'WRI Aqueduct', label: 'WRI Aqueduct'},
      {value: 'WWF Water Risk Filter', label: 'WWF Water Risk Filter'},
      {
        value: 'Customized publicly available water scenario, please specify',
        label: 'Customized publicly available water scenario, please specify'
      },
      {value: 'Bespoke water scenario', label: 'Bespoke water scenario'}
    ]
  },
  {
    label: 'Forests scenarios',
    options: [
      {
        value: 'Customized publicly available forests scenario, please specify',
        label: 'Customized publicly available forests scenario, please specify'
      },
      {value: 'Bespoke forests scenario', label: 'Bespoke forests scenario'}
    ]
  }
];

export const DRIVING_FORCES_IN_SCENARIO_OPTIONS = [
  {
    label: 'Local ecosystem asset interactions, dependencies and impacts',
    options: [
      {
        value: 'Changes to the state of nature',
        label: 'Changes to the state of nature'
      },
      {
        value: 'Number of ecosystems impacted',
        label: 'Number of ecosystems impacted'
      },
      {
        value: 'Changes in ecosystem services provision',
        label: 'Changes in ecosystem services provision'
      },
      {
        value: 'Speed of change (to state of nature and/or ecosystem services)',
        label: 'Speed of change (to state of nature and/or ecosystem services)'
      },
      {
        value: 'Climate change (one of five drivers of nature change)',
        label: 'Climate change (one of five drivers of nature change)'
      },
      {
        value:
          'Other local ecosystem asset interactions, dependencies and impacts driving forces, please specify',
        label:
          'Other local ecosystem asset interactions, dependencies and impacts driving forces, please specify'
      }
    ]
  },
  {
    label: 'Finance and insurance',
    options: [
      {value: 'Cost of capital', label: 'Cost of capital'},
      {
        value: 'Sensitivity of capital (to nature impacts and dependencies)',
        label: 'Sensitivity of capital (to nature impacts and dependencies)'
      },
      {
        value: 'Other finance and insurance driving forces, please specify',
        label: 'Other finance and insurance driving forces, please specify'
      }
    ]
  },
  {
    label: 'Stakeholder and customer demands',
    options: [
      {value: 'Consumer sentiment', label: 'Consumer sentiment'},
      {
        value: 'Consumer attention to impact',
        label: 'Consumer attention to impact'
      },
      {
        value: 'Impact of nature footprint on reputation',
        label: 'Impact of nature footprint on reputation'
      },
      {
        value: 'Impact of nature service delivery on consumer',
        label: 'Impact of nature service delivery on consumer'
      },
      {
        value: 'Sensitivity to inequity of nature impacts',
        label: 'Sensitivity to inequity of nature impacts'
      },
      {
        value:
          'Other stakeholder and customer demands driving forces, please specify',
        label:
          'Other stakeholder and customer demands driving forces, please specify'
      }
    ]
  },
  {
    label: 'Regulators, legal and policy regimes',
    options: [
      {value: 'Global regulation', label: 'Global regulation'},
      {
        value: 'Political impact of science (from galvanizing to paralyzing)',
        label: 'Political impact of science (from galvanizing to paralyzing)'
      },
      {
        value: 'Level of action (from local to global)',
        label: 'Level of action (from local to global)'
      },
      {value: 'Global targets', label: 'Global targets'},
      {
        value: 'Methodologies and expectations for science-based targets',
        label: 'Methodologies and expectations for science-based targets'
      },
      {
        value:
          'Other regulators, legal and policy regimes driving forces, please specify',
        label:
          'Other regulators, legal and policy regimes driving forces, please specify'
      }
    ]
  },
  {
    label: 'Relevant technology and science',
    options: [
      {
        value: 'Granularity of available data (from aggregated to local)',
        label: 'Granularity of available data (from aggregated to local)'
      },
      {
        value: 'Data regime (from closed to open)',
        label: 'Data regime (from closed to open)'
      },
      {
        value:
          'Other relevant technology and science driving forces,please specify',
        label:
          'Other relevant technology and science driving forces,please specify'
      }
    ]
  },
  {
    label: 'Direct interaction with climate',
    options: [
      {
        value: 'On asset values, on the corporate',
        label: 'On asset values, on the corporate'
      },
      {
        value: 'Perception of efficacy of climate regime',
        label: 'Perception of efficacy of climate regime'
      },
      {
        value:
          'Other direct interaction with climate driving forces, please specify',
        label:
          'Other direct interaction with climate driving forces, please specify'
      }
    ]
  },
  {
    label: 'Macro and microeconomy',
    options: [
      {value: 'Domestic growth', label: 'Domestic growth'},
      {value: 'Globalizing markets', label: 'Globalizing markets'},
      {
        value: 'Other macro and microeconomy driving forces, please specify',
        label: 'Other macro and microeconomy driving forces, please specify'
      }
    ]
  }
];

export const ECONOMIC_ACTIVITY_OPTIONS = [
  {
    value: 'Acquisition and ownership of buildings',
    label: 'Acquisition and ownership of buildings'
  },
  {value: 'Afforestation', label: 'Afforestation'},
  {
    value: 'Air transport ground handling operations',
    label: 'Air transport ground handling operations'
  },
  {value: 'Airport infrastructure', label: 'Airport infrastructure'},
  {
    value: 'Anaerobic digestion of bio-waste',
    label: 'Anaerobic digestion of bio-waste'
  },
  {
    value: 'Anaerobic digestion of sewage sludge',
    label: 'Anaerobic digestion of sewage sludge'
  },
  {
    value: 'Close to market research, development and innovation',
    label: 'Close to market research, development and innovation'
  },
  {
    value: 'Cogeneration of heat/cool and power from bioenergy',
    label: 'Cogeneration of heat/cool and power from bioenergy'
  },
  {
    value: 'Cogeneration of heat/cool and power from geothermal energy',
    label: 'Cogeneration of heat/cool and power from geothermal energy'
  },
  {
    value:
      'Cogeneration of heat/cool and power from renewable non-fossil gaseous and liquid fuels',
    label:
      'Cogeneration of heat/cool and power from renewable non-fossil gaseous and liquid fuels'
  },
  {
    value: 'Cogeneration of heat/cool and power from solar energy',
    label: 'Cogeneration of heat/cool and power from solar energy'
  },
  {
    value:
      'Collection and transport of nonhazardous waste in source segregated fractions',
    label:
      'Collection and transport of nonhazardous waste in source segregated fractions'
  },
  {value: 'Composting of bio-waste', label: 'Composting of bio-waste'},
  {
    value: 'Computer programming, consultancy and related activities',
    label: 'Computer programming, consultancy and related activities'
  },
  {value: 'Conservation forestry', label: 'Conservation forestry'},
  {
    value:
      'Construction and safe operation of new nuclear power plants, for the generation of electricity or heat, including for hydrogen production, using best-available technologies',
    label:
      'Construction and safe operation of new nuclear power plants, for the generation of electricity or heat, including for hydrogen production, using best-available technologies'
  },
  {
    value: 'Construction of new buildings',
    label: 'Construction of new buildings'
  },
  {
    value:
      'Construction, extension and operation of waste water collection and treatment',
    label:
      'Construction, extension and operation of waste water collection and treatment'
  },
  {
    value:
      'Construction, extension and operation of water collection, treatment and supply systems',
    label:
      'Construction, extension and operation of water collection, treatment and supply systems'
  },
  {
    value: 'Consultancy for physical climate risk management and adaptation',
    label: 'Consultancy for physical climate risk management and adaptation'
  },
  {
    value: 'Creative, arts and entertainment activities',
    label: 'Creative, arts and entertainment activities'
  },
  {
    value: 'Data processing, hosting and related activities',
    label: 'Data processing, hosting and related activities'
  },
  {
    value: 'Data-driven solutions for GHG emissions reductions',
    label: 'Data-driven solutions for GHG emissions reductions'
  },
  {value: 'Desalination', label: 'Desalination'},
  {
    value: 'Disaster risk management -Emergency services',
    label: 'Disaster risk management -Emergency services'
  },
  {
    value: 'District heating/cooling distribution',
    label: 'District heating/cooling distribution'
  },
  {value: 'Education', label: 'Education'},
  {
    value: 'Electricity generation from bioenergy',
    label: 'Electricity generation from bioenergy'
  },
  {
    value: 'Electricity generation from fossil gaseous fuels',
    label: 'Electricity generation from fossil gaseous fuels'
  },
  {
    value: 'Electricity generation from geothermal energy',
    label: 'Electricity generation from geothermal energy'
  },
  {
    value: 'Electricity generation from hydropower',
    label: 'Electricity generation from hydropower'
  },
  {
    value:
      'Electricity generation from nuclear energy in existing installations',
    label:
      'Electricity generation from nuclear energy in existing installations'
  },
  {
    value: 'Electricity generation from ocean energy technologies',
    label: 'Electricity generation from ocean energy technologies'
  },
  {
    value:
      'Electricity generation from renewable non-fossil gaseous and liquid fuels',
    label:
      'Electricity generation from renewable non-fossil gaseous and liquid fuels'
  },
  {
    value: 'Electricity generation from wind power',
    label: 'Electricity generation from wind power'
  },
  {
    value:
      'Electricity generation using concentrated solar power (CSP) technology',
    label:
      'Electricity generation using concentrated solar power (CSP) technology'
  },
  {
    value: 'Electricity generation using solar photovoltaic technology',
    label: 'Electricity generation using solar photovoltaic technology'
  },
  {
    value:
      'Engineering activities and related technical consultancy dedicated to adaptation to Climate change',
    label:
      'Engineering activities and related technical consultancy dedicated to adaptation to Climate change'
  },
  {
    value: 'Flood risk prevention and protection infrastructure',
    label: 'Flood risk prevention and protection infrastructure'
  },
  {value: 'Forest management', label: 'Forest management'},
  {
    value: 'Infrastructure enabling road transport and public transport',
    label: 'Infrastructure enabling road transport and public transport'
  },
  {
    value: 'Infrastructure for personal mobility, cycle logistics',
    label: 'Infrastructure for personal mobility, cycle logistics'
  },
  {
    value: 'Infrastructure for rail transport',
    label: 'Infrastructure for rail transport'
  },
  {
    value: 'Infrastructure for water transport',
    label: 'Infrastructure for water transport'
  },
  {
    value: 'Inland freight water transport',
    label: 'Inland freight water transport'
  },
  {
    value: 'Inland passenger water transport',
    label: 'Inland passenger water transport'
  },
  {
    value: 'Installation and operation of electric heat pumps',
    label: 'Installation and operation of electric heat pumps'
  },
  {
    value:
      'Installation, maintenance and repair of charging stations for electric vehicles in buildings (and parking spaces attached to buildings)',
    label:
      'Installation, maintenance and repair of charging stations for electric vehicles in buildings (and parking spaces attached to buildings)'
  },
  {
    value:
      'Installation, maintenance and repair of energy efficiency equipment',
    label: 'Installation, maintenance and repair of energy efficiency equipment'
  },
  {
    value:
      'Installation, maintenance and repair of instruments and devices for measuring, regulation and controlling energy performance of buildings',
    label:
      'Installation, maintenance and repair of instruments and devices for measuring, regulation and controlling energy performance of buildings'
  },
  {
    value:
      'Installation, maintenance and repair of renewable energy technologies',
    label:
      'Installation, maintenance and repair of renewable energy technologies'
  },
  {
    value: 'Landfill gas capture and utilization',
    label: 'Landfill gas capture and utilization'
  },
  {value: 'Leasing of aircraft', label: 'Leasing of aircraft'},
  {
    value: 'Libraries, archives, museums and cultural activities',
    label: 'Libraries, archives, museums and cultural activities'
  },
  {
    value: 'Low carbon airport infrastructure',
    label: 'Low carbon airport infrastructure'
  },
  {value: 'Manufacture of aluminum', label: 'Manufacture of aluminum'},
  {
    value: 'Manufacture of anhydrous ammonia',
    label: 'Manufacture of anhydrous ammonia'
  },
  {
    value: 'Manufacture of automotive and mobility components',
    label: 'Manufacture of automotive and mobility components'
  },
  {value: 'Manufacture of batteries', label: 'Manufacture of batteries'},
  {
    value:
      'Manufacture of biogas and biofuels for use in transport and of bioliquids',
    label:
      'Manufacture of biogas and biofuels for use in transport and of bioliquids'
  },
  {value: 'Manufacture of carbon black', label: 'Manufacture of carbon black'},
  {value: 'Manufacture of cement', label: 'Manufacture of cement'},
  {value: 'Manufacture of chlorine', label: 'Manufacture of chlorine'},
  {
    value: 'Manufacture of energy efficiency equipment for buildings',
    label: 'Manufacture of energy efficiency equipment for buildings'
  },
  {
    value: 'Manufacture of equipment for the production and use of hydrogen',
    label: 'Manufacture of equipment for the production and use of hydrogen'
  },
  {value: 'Manufacture of hydrogen', label: 'Manufacture of hydrogen'},
  {
    value: 'Manufacture of iron and steel',
    label: 'Manufacture of iron and steel'
  },
  {
    value: 'Manufacture of low carbon technologies for transport',
    label: 'Manufacture of low carbon technologies for transport'
  },
  {value: 'Manufacture of nitric acid', label: 'Manufacture of nitric acid'},
  {
    value: 'Manufacture of organic basic chemicals',
    label: 'Manufacture of organic basic chemicals'
  },
  {
    value: 'Manufacture of other low carbon technologies',
    label: 'Manufacture of other low carbon technologies'
  },
  {
    value: 'Manufacture of plastics in primary form',
    label: 'Manufacture of plastics in primary form'
  },
  {
    value: 'Manufacture of rail rolling stock constituents',
    label: 'Manufacture of rail rolling stock constituents'
  },
  {
    value: 'Manufacture of renewable energy technologies',
    label: 'Manufacture of renewable energy technologies'
  },
  {value: 'Manufacture of soda ash', label: 'Manufacture of soda ash'},
  {
    value:
      'Manufacture, installation, and servicing of high, medium and low voltage electrical equipment for electrical transmission and distribution that result in or enable a substantial contribution to climate change mitigation',
    label:
      'Manufacture, installation, and servicing of high, medium and low voltage electrical equipment for electrical transmission and distribution that result in or enable a substantial contribution to climate change mitigation'
  },
  {value: 'Manufacturing of aircraft', label: 'Manufacturing of aircraft'},
  {
    value: 'Passenger and freight air transport',
    label: 'Passenger and freight air transport'
  },
  {
    value: 'Passenger interurban rail transport',
    label: 'Passenger interurban rail transport'
  },
  {
    value:
      'Pre-commercial stages of advanced technologies to produce energy from nuclear processes with minimal wast from the fuel cycle',
    label:
      'Pre-commercial stages of advanced technologies to produce energy from nuclear processes with minimal wast from the fuel cycle'
  },
  {
    value: 'Production of heat/cool from bioenergy',
    label: 'Production of heat/cool from bioenergy'
  },
  {
    value:
      'Production of heat/cool from fossil gaseous fuels in an efficient district heating and cooling system',
    label:
      'Production of heat/cool from fossil gaseous fuels in an efficient district heating and cooling system'
  },
  {
    value: 'Production of heat/cool from geothermal energy',
    label: 'Production of heat/cool from geothermal energy'
  },
  {
    value:
      'Production of heat/cool from renewable non-fossil gaseous and liquid fuels',
    label:
      'Production of heat/cool from renewable non-fossil gaseous and liquid fuels'
  },
  {
    value: 'Production of heat/cool from solar thermal heating',
    label: 'Production of heat/cool from solar thermal heating'
  },
  {
    value: 'Production of heat/cool using waste heat',
    label: 'Production of heat/cool using waste heat'
  },
  {
    value: 'Professional services related to energy performance of buildings',
    label: 'Professional services related to energy performance of buildings'
  },
  {
    value: 'Programming and broadcasting activities',
    label: 'Programming and broadcasting activities'
  },
  {
    value:
      'Rehabilitation and restoration of forests, including reforestation and natural forest regeneration after an extreme event',
    label:
      'Rehabilitation and restoration of forests, including reforestation and natural forest regeneration after an extreme event'
  },
  {value: 'Reinsurance', label: 'Reinsurance'},
  {
    value: 'Renewal of waste water collection and treatment',
    label: 'Renewal of waste water collection and treatment'
  },
  {
    value: 'Renewal of water collection, treatment and supply systems',
    label: 'Renewal of water collection, treatment and supply systems'
  },
  {
    value: 'Renovation of existing buildings',
    label: 'Renovation of existing buildings'
  },
  {
    value: 'Research, development and innovation for direct air capture of CO2',
    label: 'Research, development and innovation for direct air capture of CO2'
  },
  {value: 'Residential care activities', label: 'Residential care activities'},
  {value: 'Restoration of wetlands', label: 'Restoration of wetlands'},
  {
    value: 'Retrofitting of inland water passenger and freight transport',
    label: 'Retrofitting of inland water passenger and freight transport'
  },
  {
    value:
      'Retrofitting of sea and coastal freight and passenger water transport',
    label:
      'Retrofitting of sea and coastal freight and passenger water transport'
  },
  {
    value:
      'Sea and coastal freight water transport, vessels for port operations and auxiliary activities',
    label:
      'Sea and coastal freight water transport, vessels for port operations and auxiliary activities'
  },
  {
    value: 'Sea and coastal passenger water transport',
    label: 'Sea and coastal passenger water transport'
  },
  {
    value: 'Software enabling physical climate risk management and adaptation',
    label: 'Software enabling physical climate risk management and adaptation'
  },
  {value: 'Storage of electricity', label: 'Storage of electricity'},
  {value: 'Storage of hydrogen', label: 'Storage of hydrogen'},
  {value: 'Storage of thermal energy', label: 'Storage of thermal energy'},
  {
    value:
      'Transmission and distribution networks for renewable and lowcarbon gases',
    label:
      'Transmission and distribution networks for renewable and lowcarbon gases'
  },
  {
    value: 'Transmission and distribution of electricity',
    label: 'Transmission and distribution of electricity'
  },
  {
    value:
      'Transport by motorbikes, passenger cars and light commercial vehicles',
    label:
      'Transport by motorbikes, passenger cars and light commercial vehicles'
  },
  {value: 'Transport of CO2', label: 'Transport of CO2'},
  {
    value: 'Underground permanent geological storage of CO2',
    label: 'Underground permanent geological storage of CO2'
  },
  {
    value: 'Urban and suburban transport, road passenger transport',
    label: 'Urban and suburban transport, road passenger transport'
  }
];

export const TECHNOLOGY_AREA_OPTIONS = [
  {
    label: 'Coal',
    options: [
      {value: 'Control systems', label: 'Control systems'},
      {
        value: 'Carbon capture, utilization, and storage (CCUS)',
        label: 'Carbon capture, utilization, and storage (CCUS)'
      },
      {value: 'Coal bed methane capture', label: 'Coal bed methane capture'},
      {
        value: 'Combustion optimization and modification',
        label: 'Combustion optimization and modification'
      },
      {
        value: 'Monitoring systems to reduce emissions',
        label: 'Monitoring systems to reduce emissions'
      },
      {value: 'Process improvements', label: 'Process improvements'},
      {value: 'Renewable energy', label: 'Renewable energy'},
      {value: 'Other please specify', label: 'Other please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  },
  {
    label: ' Electric Utilities',
    options: [
      {
        value: 'Carbon capture, utilization, and storage (CCUS)',
        label: 'Carbon capture, utilization, and storage (CCUS)'
      },
      {value: 'Demand response', label: 'Demand response'},
      {
        value: 'Efficient transmission technology',
        label: 'Efficient transmission technology'
      },
      {
        value: 'Hydropower energy generation',
        label: 'Hydropower energy generation'
      },
      {value: 'Mechanical storage', label: 'Mechanical storage'},
      {value: 'Nuclear energy generation', label: 'Nuclear energy generation'},
      {
        value: 'Ocean thermal energy generation',
        label: 'Ocean thermal energy generation'
      },
      {value: 'Smart grid integration', label: 'Smart grid integration'},
      {value: 'Solar energy generation', label: 'Solar energy generation'},
      {value: 'Tidal energy generation', label: 'Tidal energy generation'},
      {value: 'Wave energy generation', label: 'Wave energy generation'},
      {value: 'Wind energy generation', label: 'Wind energy generation'},
      {value: 'Other please specify', label: 'Other please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  },
  {
    label: 'Oil and Gas',
    options: [
      {
        value: 'Advanced monitoring techniques',
        label: 'Advanced monitoring techniques'
      },
      {value: 'Alternative liquid fuels', label: 'Alternative liquid fuels'},
      {
        value: 'Carbon capture, utilization, and storage (CCUS)',
        label: 'Carbon capture, utilization, and storage (CCUS)'
      },
      {
        value: 'Energy efficiency in transport',
        label: 'Energy efficiency in transport'
      },
      {value: 'Hydrogen', label: 'Hydrogen'},
      {value: 'Hydrogen storage', label: 'Hydrogen storage'},
      {
        value: 'Methane reforming with CCUS',
        label: 'Methane reforming with CCUS'
      },
      {value: 'Pipeline', label: 'Pipeline'},
      {value: 'Other please specify', label: 'Other please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  }
];

export const TECHNOLOGY_AREAS_OPTIONS = [
  {
    label: 'Light Duty Vehicles (LDV)',
    options: [
      {
        value: 'Alternative battery technology',
        label: 'Alternative battery technology'
      },
      {
        value: 'Automated and connected vehicles (level 4+)',
        label: 'Automated and connected vehicles (level 4+)'
      },
      {value: 'Battery electric vehicle', label: 'Battery electric vehicle'},
      {
        value: 'Dynamic charging or electric road system',
        label: 'Dynamic charging or electric road system'
      },
      {
        value: 'Ethanol-fuelled diesel engine',
        label: 'Ethanol-fuelled diesel engine'
      },
      {value: 'Fast charging', label: 'Fast charging'},
      {value: 'Hydrogen fuel cell', label: 'Hydrogen fuel cell'},
      {value: 'Hydrogen tank', label: 'Hydrogen tank'},
      {value: 'Infrastructure', label: 'Infrastructure'},
      {value: 'Materials', label: 'Materials'},
      {value: 'Smart charging', label: 'Smart charging'},
      {value: 'Other, please specify', label: 'Other, please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  },
  {
    label: 'Heavy Duty Vehicles (HDV)',
    options: [
      {
        value: 'Alternative battery technology',
        label: 'Alternative battery technology'
      },
      {
        value: 'Automated and connected vehicles (level 4+)',
        label: 'Automated and connected vehicles (level 4+)'
      },
      {value: 'Battery electric vehicle', label: 'Battery electric vehicle'},
      {
        value: 'Dynamic charging or electric road system',
        label: 'Dynamic charging or electric road system'
      },
      {
        value: 'Ethanol-fuelled diesel engine',
        label: 'Ethanol-fuelled diesel engine'
      },
      {value: 'Fast charging', label: 'Fast charging'},
      {value: 'Hydrogen fuel cell', label: 'Hydrogen fuel cell'},
      {value: 'Hydrogen tank', label: 'Hydrogen tank'},
      {value: 'Infrastructure', label: 'Infrastructure'},
      {value: 'Management', label: 'Management'},
      {value: 'Materials', label: 'Materials'},
      {value: 'Operations', label: 'Operations'},
      {value: 'Smart charging', label: 'Smart charging'},
      {value: 'Other, please specify', label: 'Other, please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  },
  {
    label: 'Rail',
    options: [
      {value: 'Alternative fuels', label: 'Alternative fuels'},
      {value: 'Control systems', label: 'Control systems'},
      {value: 'Electrification', label: 'Electrification'},
      {value: 'Hyperloop', label: 'Hyperloop'},
      {value: 'Infrastructure', label: 'Infrastructure'},
      {value: 'Management', label: 'Management'},
      {value: 'Materials', label: 'Materials'},
      {value: 'Other, please specify', label: 'Other, please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  },
  {
    label: 'Marine',
    options: [
      {value: 'Ammonia bunkering', label: 'Ammonia bunkering'},
      {value: 'Ammonia fuel cell', label: 'Ammonia fuel cell'},
      {value: 'Ammonia-fuelled engine', label: 'Ammonia-fuelled engine'},
      {value: 'Battery electric vehicle', label: 'Battery electric vehicle'},
      {value: 'Cold ironing', label: 'Cold ironing'},
      {
        value: 'Hydrodynamics/fluid mechanics',
        label: 'Hydrodynamics/fluid mechanics'
      },
      {value: 'Hydrogen bunkering', label: 'Hydrogen bunkering'},
      {value: 'Hydrogen fuel cell', label: 'Hydrogen fuel cell'},
      {value: 'Hydrogen-fuelled vehicle', label: 'Hydrogen-fuelled vehicle'},
      {value: 'Materials', label: 'Materials'},
      {value: 'Operations', label: 'Operations'},
      {value: 'Rotor sail', label: 'Rotor sail'},
      {value: 'Other, please specify', label: 'Other, please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  },
  {
    label: 'Aviation',
    options: [
      {value: 'Aerodynamics', label: 'Aerodynamics'},
      {value: 'Airframe', label: 'Airframe'},
      {value: 'Alternative fuels', label: 'Alternative fuels'},
      {value: 'Electronics', label: 'Electronics'},
      {
        value: 'Geared Turbo Fan – Ultra-High Bypass Ratio engine',
        label: 'Geared Turbo Fan – Ultra-High Bypass Ratio engine'
      },
      {
        value: 'Ground handling operations',
        label: 'Ground handling operations'
      },
      {value: 'Management', label: 'Management'},
      {value: 'Open rotor', label: 'Open rotor'},
      {value: 'Operations', label: 'Operations'},
      {
        value: 'Other propulsion technology, please specify',
        label: 'Other propulsion technology, please specify'
      },
      {value: 'Other, please specify', label: 'Other, please specify'},
      {
        value: 'Unable to disaggregate by technology area',
        label: 'Unable to disaggregate by technology area'
      }
    ]
  }
];

export const OBJECTIVES_FOR_IMPLEMENTING_INTERNAL_PRICE_OPTIONS = [
  {
    value: 'Conduct cost-benefit analysis',
    label: 'Conduct cost-benefit analysis'
  },
  {value: 'Drive energy efficiency', label: 'Drive energy efficiency'},
  {value: 'Drive low-carbon investment', label: 'Drive low-carbon investment'},
  {
    value:
      'Incentivize consideration of climate-related issues in decision making',
    label:
      'Incentivize consideration of climate-related issues in decision making'
  },
  {
    value:
      'Incentivize consideration of climate-related issues in risk assessment',
    label:
      'Incentivize consideration of climate-related issues in risk assessment'
  },
  {
    value: 'Identify and evaluate financing opportunities',
    label: 'Identify and evaluate financing opportunities'
  },
  {
    value: 'Identify and seize low-carbon opportunities',
    label: 'Identify and seize low-carbon opportunities'
  },
  {
    value: 'Influence strategy and/or financial planning',
    label: 'Influence strategy and/or financial planning'
  },
  {value: 'Navigate regulations', label: 'Navigate regulations'},
  {
    value: 'Reduce upstream value chain emissions',
    label: 'Reduce upstream value chain emissions'
  },
  {
    value: 'Setting and/or achieving of climate-related policies and targets',
    label: 'Setting and/or achieving of climate-related policies and targets'
  },
  {value: 'Set a carbon offset budget', label: 'Set a carbon offset budget'},
  {value: 'Stress test investments', label: 'Stress test investments'},
  {
    value: 'Inform credit risk assessments for existing loans or credit lines',
    label: 'Inform credit risk assessments for existing loans or credit lines'
  },
  {
    value: 'Inform credit risk assessments for new loans',
    label: 'Inform credit risk assessments for new loans'
  },
  {
    value:
      'Inform credit risk assessments for renewals of terms for existing loans',
    label:
      'Inform credit risk assessments for renewals of terms for existing loans'
  },
  {
    value:
      'Use an internal price for corporate engagement/stewardship purposes',
    label: 'Use an internal price for corporate engagement/stewardship purposes'
  },
  {value: 'Other please specify', label: 'Other please specify'}
];

export const FACTORS_CONSIDERED_WHEN_DETERMINING_THE_PRICE_OPTIONS = [
  {
    value: 'Alignment to international standards',
    label: 'Alignment to international standards'
  },
  {
    value: 'Alignment to scientific guidance',
    label: 'Alignment to scientific guidance'
  },
  {
    value: 'Alignment with the price of a carbon tax',
    label: 'Alignment with the price of a carbon tax'
  },
  {
    value:
      'Alignment with the price of allowances under an Emissions Trading Scheme',
    label:
      'Alignment with the price of allowances under an Emissions Trading Scheme'
  },
  {
    value: 'Alignment with the price of carbon border adjustment mechanism',
    label: 'Alignment with the price of carbon border adjustment mechanism'
  },
  {value: 'Benchmarking against peers', label: 'Benchmarking against peers'},
  {
    value: 'Cost of required measures to achieve climate-related targets',
    label: 'Cost of required measures to achieve climate-related targets'
  },
  {
    value: 'Existing or pending legislation',
    label: 'Existing or pending legislation'
  },
  {
    value: 'Price with substantive impact on business decisions',
    label: 'Price with substantive impact on business decisions'
  },
  {
    value: 'Price/cost of renewable energy procurement',
    label: 'Price/cost of renewable energy procurement'
  },
  {
    value: 'Price/cost of voluntary carbon offset credits',
    label: 'Price/cost of voluntary carbon offset credits'
  },
  {value: 'Scenario analysis', label: 'Scenario analysis'},
  {
    value: 'Social cost of climate-related impact',
    label: 'Social cost of climate-related impact'
  },
  {value: 'Other please specify', label: 'Other please specify'}
];

export const SCOPES_COVERED_OPTIONS = [
  {value: 'Scope 1', label: 'Scope 1'},
  {value: 'Scope 2', label: 'Scope 2'},
  {
    value: 'Scope 3, Category 1 - Purchased goods and services',
    label: 'Scope 3, Category 1 - Purchased goods and services'
  },
  {
    value: 'Scope 3, Category 2 - Capital goods',
    label: 'Scope 3, Category 2 - Capital goods'
  },
  {
    value:
      'Scope 3, Category 3 - Fuel- and energy-related activities (not included in Scope 1 or 2)',
    label:
      'Scope 3, Category 3 - Fuel- and energy-related activities (not included in Scope 1 or 2)'
  },
  {
    value: 'Scope 3, Category 4 - Upstream transportation and distribution',
    label: 'Scope 3, Category 4 - Upstream transportation and distribution'
  },
  {
    value: 'Scope 3, Category 5 - Waste generated in operations',
    label: 'Scope 3, Category 5 - Waste generated in operations'
  },
  {
    value: 'Scope 3, Category 6 - Business travel',
    label: 'Scope 3, Category 6 - Business travel'
  },
  {
    value: 'Scope 3, Category 7 - Employee commuting',
    label: 'Scope 3, Category 7 - Employee commuting'
  },
  {
    value: 'Scope 3, Category 8 - Upstream leased assets',
    label: 'Scope 3, Category 8 - Upstream leased assets'
  },
  {
    value: 'Scope 3, Category 9 - Downstream transportation and distribution',
    label: 'Scope 3, Category 9 - Downstream transportation and distribution'
  },
  {
    value: 'Scope 3, Category 10 - Processing of sold products',
    label: 'Scope 3, Category 10 - Processing of sold products'
  },
  {
    value: 'Scope 3, Category 11 - Use of sold products',
    label: 'Scope 3, Category 11 - Use of sold products'
  },
  {
    value: 'Scope 3, Category 12 - End-of-life treatment of sold products',
    label: 'Scope 3, Category 12 - End-of-life treatment of sold products'
  },
  {
    value: 'Scope 3, Category 13 - Downstream leased assets',
    label: 'Scope 3, Category 13 - Downstream leased assets'
  },
  {
    value: 'Scope 3, Category 14 - Franchises',
    label: 'Scope 3, Category 14 - Franchises'
  },
  {
    value: 'Scope 3, Category 15 - Investments',
    label: 'Scope 3, Category 15 - Investments'
  },
  {value: 'Scope 3, other (upstream)', label: 'Scope 3, other (upstream)'},
  {value: 'Scope 3, other (downstream)', label: 'Scope 3, other (downstream)'}
];

export const BUSINESS_DECISIONMAKING_PROCESSES_THE_INTERNAL_PRICE_IS_APPLIED_TO_OPTIONS =
  [
    {value: 'Capital expenditure', label: 'Capital expenditure'},
    {value: 'Dependencies management', label: 'Dependencies management'},
    {value: 'Impact management', label: 'Impact management'},
    {value: 'Operations', label: 'Operations'},
    {value: 'Procurement', label: 'Procurement'},
    {value: 'Product and R&D', label: 'Product and R&D'},
    {value: 'Remuneration', label: 'Remuneration'},
    {value: 'Risk management', label: 'Risk management'},
    {value: 'Opportunity management', label: 'Opportunity management'},
    {value: 'Value chain engagement', label: 'Value chain engagement'},
    {value: 'Public policy engagement', label: 'Public policy engagement'},
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const TYPE_OF_PRICING_SCHEME_OPTIONS = [
  {value: 'Shadow price', label: 'Shadow price'},
  {value: 'Internal fee', label: 'Internal fee'},
  {value: 'Internal trading', label: 'Internal trading'},
  {value: 'Implicit price', label: 'Implicit price'},
  {value: 'Other please specify', label: 'Other please specify'}
];

export const ASSESSMENT_OF_SUPPLIER_DEPENDENCIES_AND_OR_IMPACTS_ON_THE_ENVIRONMENT_OPTIONS =
  [
    {
      value: 'Basin/landscape condition [FW]',
      label: 'Basin/landscape condition [FW]'
    },
    {
      value: 'Contribution to supplier-related Scope 3 emissions [CC only]',
      label: 'Contribution to supplier-related Scope 3 emissions [CC only]'
    },
    {
      value: 'Dependence on water [W only]',
      label: 'Dependence on water [W only]'
    },
    {
      value: 'Dependence on commodities [F only]',
      label: 'Dependence on commodities [F only]'
    },
    {
      value: 'Dependence on ecosystem services/environmental assets [FPW]',
      label: 'Dependence on ecosystem services/environmental assets [FPW]'
    },
    {
      value: 'Impact on water availability [W only]',
      label: 'Impact on water availability [W only]'
    },
    {
      value:
        'Impact on deforestation or conversion of other natural ecosystems [F only]',
      label:
        'Impact on deforestation or conversion of other natural ecosystems [F only]'
    },
    {
      value: 'Impact on plastic waste and pollution [P only]',
      label: 'Impact on plastic waste and pollution [P only]'
    },
    {
      value: 'Impact on pollution levels [FPW]',
      label: 'Impact on pollution levels [FPW]'
    },
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const PERCENT_TIER_1_SUPPLIERS_ASSESSED_OPTIONS = [
  {value: 'None', label: 'None'},
  {value: 'Less than 1%', label: 'Less than 1%'},
  {value: '1-25%', label: '1-25%'},
  {value: '26-50%', label: '26-50%'},
  {value: '51-75%', label: '51-75%'},
  {value: '76-99%', label: '76-99%'},
  {value: '100%', label: '100%'},
  {value: 'Unknown', label: 'Unknown'}
];

export const CRITERIA_INFORMING_WHICH_SUPPLIERS_ARE_PRIORITIZED_FOR_ENGAGEMENT_ON_THIS_ENVIRONMENTAL_ISSUE_OPTIONS =
  [
    {
      value:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to climate change [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Climate change” row of 5.11.1, CC only]',
      label:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to climate change [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Climate change” row of 5.11.1, CC only]'
    },
    {
      value:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to forests [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Forests” row of 5.11.1; F only]',
      label:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to forests [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Forests” row of 5.11.1; F only]'
    },
    {
      value:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to water [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Water” row of 5.11.1; W only]',
      label:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to water [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Water” row of 5.11.1; W only]'
    },
    {
      value:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to plastics [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Plastics” row of 5.11.1; P only]',
      label:
        'In line with the criteria used to classify suppliers as having substantive dependencies and/or impacts relating to plastics [appears if “Yes, we assess the impacts/dependencies of our suppliers” is selected in column 1, “Plastics” row of 5.11.1; P only]'
    },
    {value: 'Business risk mitigation', label: 'Business risk mitigation'},
    {value: 'Leverage over suppliers', label: 'Leverage over suppliers'},
    {value: 'Material sourcing', label: 'Material sourcing'},
    {value: 'Procurement spend', label: 'Procurement spend'},
    {value: 'Product lifecycle', label: 'Product lifecycle'},
    {
      value: 'Product safety and compliance',
      label: 'Product safety and compliance'
    },
    {value: 'Regulatory compliance', label: 'Regulatory compliance'},
    {value: 'Reputation management', label: 'Reputation management'},
    {
      value: 'Strategic status of suppliers',
      label: 'Strategic status of suppliers'
    },
    {
      value: 'Supplier performance improvement',
      label: 'Supplier performance improvement'
    },
    {value: 'Vulnerability of suppliers', label: 'Vulnerability of suppliers'},
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const TYPE_AND_DETAILS_OF_ENGAGEMENT_OPTIONS = [
  {
    label: 'Capacity building',
    options: [
      {
        value: 'Develop or distribute value chain mapping tool (FW)',
        label: 'Develop or distribute value chain mapping tool (FW)'
      },
      {
        value:
          'Provide training, support and best practices on how to make credible renewable energy usage claims (CC only)',
        label:
          'Provide training, support and best practices on how to make credible renewable energy usage claims (CC only)'
      },
      {
        value:
          'Provide training, support and best practices on how to measure GHG emissions (CC only)',
        label:
          'Provide training, support and best practices on how to measure GHG emissions (CC only)'
      },
      {
        value:
          'Provide training, support and best practices on how to set science-based targets (CFW)',
        label:
          'Provide training, support and best practices on how to set science-based targets (CFW)'
      },
      {
        value:
          'Support clients to develop public, time-bound action plans with clear milestones (CFW)',
        label:
          'Support clients to develop public, time-bound action plans with clear milestones (CFW)'
      },
      {
        value:
          'Support clients to set their own environmental commitments across their operations (CFW)',
        label:
          'Support clients to set their own environmental commitments across their operations (CFW)'
      },
      {
        value: 'Other capacity building activity, please specify (CFW)',
        label: 'Other capacity building activity, please specify (CFW)'
      }
    ]
  },
  {
    label: 'Financial incentives',
    options: [
      {
        value: 'Provide financial incentives for environmental performance',
        label: 'Provide financial incentives for environmental performance'
      },
      {
        value:
          'Provide financial incentives for progress against water pollution targets (W only)',
        label:
          'Provide financial incentives for progress against water pollution targets (W only)'
      },
      {
        value:
          'Provide financial incentives for progress against water withdrawal targets (W only)',
        label:
          'Provide financial incentives for progress against water withdrawal targets (W only)'
      },
      {
        value:
          'Provide financial incentives for progress against forests-related targets (F only)',
        label:
          'Provide financial incentives for progress against forests-related targets (F only)'
      },
      {
        value:
          'Provide financial incentives for certified products and services (F only)',
        label:
          'Provide financial incentives for certified products and services (F only)'
      },
      {
        value:
          'Provide financial incentives for clients with a climate transition plan (CC only)',
        label:
          'Provide financial incentives for clients with a climate transition plan (CC only)'
      },
      {
        value:
          'Provide financial incentives for clients increasing renewable energy use (CC only)',
        label:
          'Provide financial incentives for clients increasing renewable energy use (CC only)'
      },
      {
        value:
          'Provide financial incentives for progress against climate-related targets (CC only)',
        label:
          'Provide financial incentives for progress against climate-related targets (CC only)'
      },
      {
        value: 'Other financial incentive, please specify (CFW)',
        label: 'Other financial incentive, please specify (CFW)'
      }
    ]
  },
  {
    label: 'Information collection',
    options: [
      {
        value:
          'Collect climate transition plan information at least annually from clients (CC only)',
        label:
          'Collect climate transition plan information at least annually from clients (CC only)'
      },
      {
        value:
          'Collect environmental risk and opportunity information at least annually from clients (CFW)',
        label:
          'Collect environmental risk and opportunity information at least annually from clients (CFW)'
      },
      {
        value:
          'Collect GHG emissions data at least annually from clients (CC only)',
        label:
          'Collect GHG emissions data at least annually from clients (CC only)'
      },
      {
        value:
          'Collect targets information at least annually from clients (CFW)',
        label:
          'Collect targets information at least annually from clients (CFW)'
      },
      {
        value:
          'Collect WASH information at least annually from clients (W only)',
        label:
          'Collect WASH information at least annually from clients (W only)'
      },
      {
        value:
          'Collect water quality information at least annually from clients (e.g., discharge quality, pollution incidents, hazardous substances) (W only)',
        label:
          'Collect water quality information at least annually from clients (e.g., discharge quality, pollution incidents, hazardous substances) (W only)'
      },
      {
        value:
          'Collect water quantity information at least annually from clients (e.g., withdrawal and discharge volumes) (W only)',
        label:
          'Collect water quantity information at least annually from clients (e.g., withdrawal and discharge volumes) (W only)'
      },
      {
        value: 'Other information collection activity, please specify (CFW)',
        label: 'Other information collection activity, please specify (CFW)'
      }
    ]
  },
  {
    label: 'Innovation and collaboration',
    options: [
      {
        value:
          'Collaborate with clients on innovations to reduce environmental impacts in products and services (CFW)',
        label:
          'Collaborate with clients on innovations to reduce environmental impacts in products and services (CFW)'
      },
      {
        value:
          'Collaborate with clients on innovative business models and corporate renewable energy sourcing mechanisms (CC only)',
        label:
          'Collaborate with clients on innovative business models and corporate renewable energy sourcing mechanisms (CC only)'
      },
      {
        value:
          'Encourage clients to take Beyond Value Chain Mitigation (BVCM) actions (CC only)',
        label:
          'Encourage clients to take Beyond Value Chain Mitigation (BVCM) actions (CC only)'
      },
      {
        value:
          'Encourage collaborative work in landscapes or jurisdictions (FW)',
        label:
          'Encourage collaborative work in landscapes or jurisdictions (FW)'
      },
      {
        value:
          'Incentivize collaborative sustainable water management in river basins (W only)',
        label:
          'Incentivize collaborative sustainable water management in river basins (W only)'
      },
      {
        value:
          'Engage with clients to advocate for policy or regulatory change to address environmental challenges (CFW)',
        label:
          'Engage with clients to advocate for policy or regulatory change to address environmental challenges (CFW)'
      },
      {
        value:
          'Facilitate adoption of a unified climate transition approach with clients (CC only)',
        label:
          'Facilitate adoption of a unified climate transition approach with clients (CC only)'
      },
      {
        value:
          'Invest jointly with clients in R&D of relevant low-carbon technologies (CC only)',
        label:
          'Invest jointly with clients in R&D of relevant low-carbon technologies (CC only)'
      },
      {
        value:
          'Run a campaign to encourage innovation to reduce environmental impacts on products and services (CFW)',
        label:
          'Run a campaign to encourage innovation to reduce environmental impacts on products and services (CFW)'
      },
      {
        value:
          'Other innovation and collaboration activity, please specify (CFW)',
        label:
          'Other innovation and collaboration activity, please specify (CFW)'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  }
];

export const STAFF_IN_YOUR_ORGANIZATION_CARRYING_OUT_THE_ENGAGEMENT_OPTIONS = [
  {
    value: 'Specialized in-house engagement teams',
    label: 'Specialized in-house engagement teams'
  },
  {value: 'Fund managers', label: 'Fund managers'},
  {value: 'Equity/credit analysts', label: 'Equity/credit analysts'},
  {value: 'Senior-level roles', label: 'Senior-level roles'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const ROLES_OF_INDIVIDUALS_AT_THE_PORTFOLIO_ORGANIZATIONS_YOU_SEEK_TO_ENGAGE_WITH_OPTIONS =
  [
    {value: 'Board members', label: 'Board members'},
    {value: 'Board chair', label: 'Board chair'},
    {value: 'CEO', label: 'CEO'},
    {value: 'Corporate secretary', label: 'Corporate secretary'},
    {
      value: 'Investor relations managers',
      label: 'Investor relations managers'
    },
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const ENVIRONMENTAL_REQUIREMENT_OPTIONS = [
  {
    value: 'Adoption of the UN International Labour Organization Principles',
    label: 'Adoption of the UN International Labour Organization Principles'
  },
  {
    value: 'Compliance with an environmental certification, please specify',
    label: 'Compliance with an environmental certification, please specify'
  },
  {
    value:
      'Disclosure of GHG emissions to your organization (Scope 1 and 2) [CC only]',
    label:
      'Disclosure of GHG emissions to your organization (Scope 1 and 2) [CC only]'
  },
  {
    value:
      'Disclosure of GHG emissions to your organization (Scope 1, 2 and 3) [CC only]',
    label:
      'Disclosure of GHG emissions to your organization (Scope 1, 2 and 3) [CC only]'
  },
  {
    value: 'Environmental disclosure through a non-public platform',
    label: 'Environmental disclosure through a non-public platform'
  },
  {
    value: 'Environmental disclosure through a public platform',
    label: 'Environmental disclosure through a public platform'
  },
  {
    value: 'Implementation of a climate transition plan [CC only]',
    label: 'Implementation of a climate transition plan [CC only]'
  },
  {
    value: 'Implementation of emissions reduction initiatives [C only]',
    label: 'Implementation of emissions reduction initiatives [C only]'
  },
  {
    value: 'Measuring product-level emissions [CC only]',
    label: 'Measuring product-level emissions [CC only]'
  },
  {
    value: 'Regular environmental risk assessments (at least once annually)',
    label: 'Regular environmental risk assessments (at least once annually)'
  },
  {
    value: 'Reporting against a sustainability index (e.g., DJSI, CDP etc.)',
    label: 'Reporting against a sustainability index (e.g., DJSI, CDP etc.)'
  },
  {
    value:
      'Secure Free, Prior and Informed Consent (FPIC) of Indigenous Peoples and local communities',
    label:
      'Secure Free, Prior and Informed Consent (FPIC) of Indigenous Peoples and local communities'
  },
  {
    value: 'Setting a low-carbon or renewable energy target [CC only]',
    label: 'Setting a low-carbon or renewable energy target [CC only]'
  },
  {
    value:
      'Setting a no deforestation or conversion of other natural ecosystems commitment across entire commodity business [F only]',
    label:
      'Setting a no deforestation or conversion of other natural ecosystems commitment across entire commodity business [F only]'
  },
  {
    value: 'Setting a science-based emissions reduction target [C only]',
    label: 'Setting a science-based emissions reduction target [C only]'
  },
  {
    value: 'Setting and monitoring water pollution-related targets [W only]',
    label: 'Setting and monitoring water pollution-related targets [W only]'
  },
  {
    value: 'Setting and monitoring withdrawal reduction targets [W only]',
    label: 'Setting and monitoring withdrawal reduction targets [W only]'
  },
  {
    value:
      'Monitoring and reduction of Product Carbon Footprint (PCF)/product life-cycle emissions [CC only]',
    label:
      'Monitoring and reduction of Product Carbon Footprint (PCF)/product life-cycle emissions [CC only]'
  },
  {
    value:
      'No deforestation or conversion of other natural ecosystems [F only]',
    label: 'No deforestation or conversion of other natural ecosystems [F only]'
  },
  {
    value: 'No development on peat regardless of depth [F only]',
    label: 'No development on peat regardless of depth [F only]'
  },
  {
    value:
      'Provision of fully-functioning, safely managed WASH services to all employees [W only]',
    label:
      'Provision of fully-functioning, safely managed WASH services to all employees [W only]'
  },
  {
    value: 'Purchasing of low-carbon or renewable energy [CC only]',
    label: 'Purchasing of low-carbon or renewable energy [CC only]'
  },
  {
    value: 'Substitution of hazardous substances with less harmful substances',
    label: 'Substitution of hazardous substances with less harmful substances'
  },
  {
    value: 'Total water withdrawal volumes reduction [W only]',
    label: 'Total water withdrawal volumes reduction [W only]'
  },
  {
    value: 'Waste and resource reduction and material circularity',
    label: 'Waste and resource reduction and material circularity'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const MECHANISMS_FOR_MONITORING_COMPLIANCE_WITH_THIS_ENVIRONMENTAL_REQUIREMENT_OPTIONS =
  [
    {
      value: 'No mechanism for monitoring compliance',
      label: 'No mechanism for monitoring compliance'
    },
    {value: 'Certification', label: 'Certification'},
    {value: 'Community-based monitoring', label: 'Community-based monitoring'},
    {value: 'Fines and penalties', label: 'Fines and penalties'},
    {value: 'First-party verification', label: 'First-party verification'},
    {value: 'Geospatial monitoring tool', label: 'Geospatial monitoring tool'},
    {
      value: 'Grievance mechanism/Whistleblowing hotline',
      label: 'Grievance mechanism/Whistleblowing hotline'
    },
    {
      value: 'Ground-based monitoring system',
      label: 'Ground-based monitoring system'
    },
    {value: 'Off-site third-party audit', label: 'Off-site third-party audit'},
    {value: 'On-site third-party audit', label: 'On-site third-party audit'},
    {value: 'Second-party verification', label: 'Second-party verification'},
    {
      value: 'Supplier scorecard or rating',
      label: 'Supplier scorecard or rating'
    },
    {value: 'Supplier self-assessment', label: 'Supplier self-assessment'},
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const ACTION_DRIVEN_BY_SUPPLIER_ENGAGEMENT_OPTIONS = [
  {
    value: 'No other supplier engagement',
    label: 'No other supplier engagement'
  },
  {
    value: 'Adaptation to climate change [CFW]',
    label: 'Adaptation to climate change [CFW]'
  },
  {
    value:
      'Adoption of the United Nation’s International Labour Organization principles [CFW]',
    label:
      'Adoption of the United Nation’s International Labour Organization principles [CFW]'
  },
  {value: 'Carbon removals [C only]', label: 'Carbon removals [C only]'},
  {value: 'Circular economy', label: 'Circular economy'},
  {value: 'Emissions reduction [CP]', label: 'Emissions reduction [CP]'},
  {
    value: 'Macro and microplastic leakage reduction [PW]',
    label: 'Macro and microplastic leakage reduction [PW]'
  },
  {
    value:
      'No deforestation and/or conversion of other natural ecosystems [F only]',
    label:
      'No deforestation and/or conversion of other natural ecosystems [F only]'
  },
  {
    value:
      'Provision of fully-functioning, safely managed WASH services to all employees [W only]',
    label:
      'Provision of fully-functioning, safely managed WASH services to all employees [W only]'
  },
  {
    value: 'Removal of plastic from the environment [PW]',
    label: 'Removal of plastic from the environment [PW]'
  },
  {
    value: 'Remediation of past natural ecosystem conversion [F only]',
    label: 'Remediation of past natural ecosystem conversion [F only]'
  },
  {
    value: 'Natural ecosystem restoration and long-term protection [F only]',
    label: 'Natural ecosystem restoration and long-term protection [F only]'
  },
  {
    value:
      'Secure Free, Prior and Informed Consent (FPIC) of Indigenous Peoples and local communities [CFW]',
    label:
      'Secure Free, Prior and Informed Consent (FPIC) of Indigenous Peoples and local communities [CFW]'
  },
  {
    value:
      'Substitution of hazardous substances with less harmful substances [PW]',
    label:
      'Substitution of hazardous substances with less harmful substances [PW]'
  },
  {
    value: 'Upstream value chain transparency and human rights',
    label: 'Upstream value chain transparency and human rights'
  },
  {
    value: 'Total water withdrawal volumes reduction [W only]',
    label: 'Total water withdrawal volumes reduction [W only]'
  },
  {
    value:
      'Waste and resource reduction and improved end-of-life management [PW]',
    label:
      'Waste and resource reduction and improved end-of-life management [PW]'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TYPE_AND_DETAILS_OF_ENGAGEMENT_EDUCATION_OPTIONS = [
  {
    label: 'Education/Information sharing',
    options: [
      {
        value:
          'Educate and work with stakeholders on understanding and measuring exposure to environmental risks [CFW]',
        label:
          'Educate and work with stakeholders on understanding and measuring exposure to environmental risks [CFW]'
      },
      {
        value:
          'Run an engagement campaign to educate stakeholders about the environmental impacts of your products, goods and/or services [CFW]',
        label:
          'Run an engagement campaign to educate stakeholders about the environmental impacts of your products, goods and/or services [CFW]'
      },
      {
        value:
          'Share information about your products and relevant certification schemes [CFW]',
        label:
          'Share information about your products and relevant certification schemes [CFW]'
      },
      {
        value:
          'Share information on environmental initiatives, progress, and achievements [CFW]',
        label:
          'Share information on environmental initiatives, progress, and achievements [CFW]'
      },
      {
        value: 'Other education/information sharing, please specify [CFW]',
        label: 'Other education/information sharing, please specify [CFW]'
      }
    ]
  },
  {
    label: 'Innovation and collaboration',
    options: [
      {
        value:
          'Align your organization’s goals to support customers’ targets and ambitions [CFW]',
        label:
          'Align your organization’s goals to support customers’ targets and ambitions [CFW]'
      },
      {
        value:
          'Collaborate with stakeholders in creation and review of your climate transition plan [CC only]',
        label:
          'Collaborate with stakeholders in creation and review of your climate transition plan [CC only]'
      },
      {
        value:
          'Collaborate with stakeholders on innovations to reduce environmental impacts in products and services [CFW]',
        label:
          'Collaborate with stakeholders on innovations to reduce environmental impacts in products and services [CFW]'
      },
      {
        value:
          'Encourage collaborative work in multi-stakeholder landscape towards initiatives for sustainable land-use goals [FW]',
        label:
          'Encourage collaborative work in multi-stakeholder landscape towards initiatives for sustainable land-use goals [FW]'
      },
      {
        value:
          'Engage with stakeholders to advocate for policy or regulatory change [CFW]',
        label:
          'Engage with stakeholders to advocate for policy or regulatory change [CFW]'
      },
      {
        value:
          'Incentivize collaborative sustainable water management in river basins [W only]',
        label:
          'Incentivize collaborative sustainable water management in river basins [W only]'
      },
      {
        value:
          'Run a campaign to encourage innovation to reduce environmental impacts [CFW]',
        label:
          'Run a campaign to encourage innovation to reduce environmental impacts [CFW]'
      },
      {
        value: 'Other innovation and collaboration, please specify [CFW]',
        label: 'Other innovation and collaboration, please specify [CFW]'
      }
    ]
  },
  {
    label: 'Other',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const INITIATIVE_CATEGORY_AND_TYPE_OPTIONS = [
  {
    label: 'Certification',
    options: [
      {
        value: 'Increase coverage of commodity certified [F only]',
        label: 'Increase coverage of commodity certified [F only]'
      },
      {
        value: 'Other certification, please specify',
        label: 'Other certification, please specify'
      }
    ]
  },
  {
    label: 'Change to provision of goods and services',
    options: [
      {
        value: 'More online/virtual provision of services [CC only]',
        label: 'More online/virtual provision of services [CC only]'
      },
      {value: 'Reduce packaging weight', label: 'Reduce packaging weight'},
      {
        value: 'Reduce water-related impacts [W only]',
        label: 'Reduce water-related impacts [W only]'
      },
      {
        value:
          'Other change to provision of goods and services, please specify',
        label: 'Other change to provision of goods and services, please specify'
      }
    ]
  },
  {
    label: 'Change to supplier operations',
    options: [
      {
        value:
          'Assess life-cycle impact of products or services to identify efficiencies',
        label:
          'Assess life-cycle impact of products or services to identify efficiencies'
      },
      {
        value: 'Implement energy reduction projects [CC only]',
        label: 'Implement energy reduction projects [CC only]'
      },
      {
        value: 'Increase proportion of renewable energy purchased [CC only]',
        label: 'Increase proportion of renewable energy purchased [CC only]'
      },
      {
        value: 'Increase water efficiency in operations [W only]',
        label: 'Increase water efficiency in operations [W only]'
      },
      {
        value: 'Other change to supplier operations, please specify',
        label: 'Other change to supplier operations, please specify'
      }
    ]
  },
  {
    label: 'Communications',
    options: [
      {
        value: 'Awards – apply for external awards together',
        label: 'Awards – apply for external awards together'
      },
      {
        value: 'Joint case studies or marketing campaign',
        label: 'Joint case studies or marketing campaign'
      },
      {
        value: 'Other communications, please specify',
        label: 'Other communications, please specify'
      }
    ]
  },
  {
    label: 'Innovation',
    options: [
      {
        value:
          'Implement new techniques/technologies to ensure sustainable production [F only]',
        label:
          'Implement new techniques/technologies to ensure sustainable production [F only]'
      },
      {
        value:
          'New product or service that has a lower upstream emissions footprint [CC only]',
        label:
          'New product or service that has a lower upstream emissions footprint [CC only]'
      },
      {
        value:
          'New product or service that has a lower upstream impact on forests [F only]',
        label:
          'New product or service that has a lower upstream impact on forests [F only]'
      },
      {
        value:
          'New product or service that has a lower upstream water impacts [W only]',
        label:
          'New product or service that has a lower upstream water impacts [W only]'
      },
      {
        value:
          'New product or service that reduces customers’ operational emissions [CC only]',
        label:
          'New product or service that reduces customers’ operational emissions [CC only]'
      },
      {
        value: `New product or service that reduces ${'customers'}' operational water consumption [W only]`,
        label: `New product or service that reduces ${'customers'}' operational water consumption [W only]`
      },
      {
        value:
          'New product or service that reduces customers’ products/services commodity consumption [F only]',
        label:
          'New product or service that reduces customers’ products/services commodity consumption [F only]'
      },
      {
        value:
          'New product or service that reduces customers’ products/services operational emissions [CC only]',
        label:
          'New product or service that reduces customers’ products/services operational emissions [CC only]'
      },
      {value: 'Reduce packaging', label: 'Reduce packaging'},
      {
        value: 'Other innovation, please specify',
        label: 'Other innovation, please specify'
      }
    ]
  },
  {
    label: 'Logistical change',
    options: [
      {
        value: 'Change timing of logistics [CC only]',
        label: 'Change timing of logistics [CC only]'
      },
      {
        value:
          'Change transportation mode (e.g., switch from aviation to rail) [CC only]',
        label:
          'Change transportation mode (e.g., switch from aviation to rail) [CC only]'
      },
      {
        value: 'Consolidate logistics [CC only]',
        label: 'Consolidate logistics [CC only]'
      },
      {
        value: 'Route optimization [CC only]',
        label: 'Route optimization [CC only]'
      },
      {
        value: 'Other logistical change, please specify',
        label: 'Other logistical change, please specify'
      }
    ]
  },
  {
    label: 'Promote collective action',
    options: [
      {
        value:
          'Invite customer to collaborate with other users in their river basins to reduce impact [W only]',
        label:
          'Invite customer to collaborate with other users in their river basins to reduce impact [W only]'
      },
      {
        value:
          'Invite customer to collaborate in landscape or jurisdictional initiatives [F only]',
        label:
          'Invite customer to collaborate in landscape or jurisdictional initiatives [F only]'
      },
      {
        value: 'Other collective action, please specify',
        label: 'Other collective action, please specify'
      }
    ]
  },
  {
    label: 'Relationship sustainability assessment',
    options: [
      {
        value: 'Align goals to feed into customers targets and ambitions',
        label: 'Align goals to feed into customers targets and ambitions'
      },
      {
        value: 'Sustainability audit of existing relationship',
        label: 'Sustainability audit of existing relationship'
      },
      {
        value: 'Other assessment, please specify',
        label: 'Other assessment, please specify'
      }
    ]
  },
  {
    label: 'Traceability and transparency',
    options: [
      {
        value: 'Improve existing traceability system [F only]',
        label: 'Improve existing traceability system [F only]'
      },
      {
        value: 'New traceability system [F only]',
        label: 'New traceability system [F only]'
      },
      {
        value: 'Other traceability system, please specify',
        label: 'Other traceability system, please specify'
      }
    ]
  },
  {
    label: 'Other',
    options: [
      {
        value: 'Other initiative type, please specify',
        label: 'Other initiative type, please specify'
      }
    ]
  }
];

export const EXPECTED_BENEFITS_OPTIONS = [
  {
    value: 'Higher incomes due to increased productivity',
    label: 'Higher incomes due to increased productivity'
  },
  {
    value: 'Improved resource use and efficiency',
    label: 'Improved resource use and efficiency'
  },
  {
    value: 'Improved water quality [W only]',
    label: 'Improved water quality [W only]'
  },
  {
    value: 'Improved water stewardship [W only]',
    label: 'Improved water stewardship [W only]'
  },
  {
    value: 'Increase in use of certified materials [F only]',
    label: 'Increase in use of certified materials [F only]'
  },
  {
    value: 'Increased transparency of upstream/downstream value chain',
    label: 'Increased transparency of upstream/downstream value chain'
  },
  {value: 'Lower price per unit', label: 'Lower price per unit'},
  {
    value:
      'Price premiums for deforestation and conversion-free materials [F only]',
    label:
      'Price premiums for deforestation and conversion-free materials [F only]'
  },
  {
    value:
      'Reduction of customers’ operational emissions (customer scope 1 & 2)',
    label:
      'Reduction of customers’ operational emissions (customer scope 1 & 2)'
  },
  {
    value: 'Reduction of own operational emissions (own scope 1 & 2)',
    label: 'Reduction of own operational emissions (own scope 1 & 2)'
  },
  {
    value: 'Reduction of downstream value chain emissions (own scope 3)',
    label: 'Reduction of downstream value chain emissions (own scope 3)'
  },
  {
    value:
      'Reduction of customers’ operational water withdrawals and/or consumption [W only]',
    label:
      'Reduction of customers’ operational water withdrawals and/or consumption [W only]'
  },
  {
    value:
      'Reduction of own operational water withdrawals and/or consumption [W only]',
    label:
      'Reduction of own operational water withdrawals and/or consumption [W only]'
  },
  {
    value:
      'Reduction of downstream value chain water withdrawals and/or consumption [W only]',
    label:
      'Reduction of downstream value chain water withdrawals and/or consumption [W only]'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRIMARY_REASONS_FOR_NOT_IMPLEMENTING_ENVIRONMENTAL_INITIATIVES_OPTIONS =
  [
    {
      value:
        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
      label:
        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
    },
    {value: 'No standardized procedure', label: 'No standardized procedure'},
    {
      value: 'Not an immediate strategic priority',
      label: 'Not an immediate strategic priority'
    },
    {
      value: 'Judged to be unimportant or not relevant',
      label: 'Judged to be unimportant or not relevant'
    },
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const ISSUES_SUPPORTED_IN_SHAREHOLDER_RESOLUTIONS_OPTIONS = [
  {
    value: 'Aligning public policy position (lobbying)',
    label: 'Aligning public policy position (lobbying)'
  },
  {
    value: 'Board oversight of environmental issues',
    label: 'Board oversight of environmental issues'
  },
  {
    value: 'Climate transition plans [CC only]',
    label: 'Climate transition plans [CC only]'
  },
  {
    value: 'Elimination of hazardous chemicals [W only]',
    label: 'Elimination of hazardous chemicals [W only]'
  },
  {
    value: 'Emissions reduction targets [CC only]',
    label: 'Emissions reduction targets [CC only]'
  },
  {value: 'Environmental disclosures', label: 'Environmental disclosures'},
  {
    value:
      'Halting deforestation and/or conversion of natural ecosystems [F only]',
    label:
      'Halting deforestation and/or conversion of natural ecosystems [F only]'
  },
  {
    value: 'Improve water efficiency [W only]',
    label: 'Improve water efficiency [W only]'
  },
  {
    value: 'Net zero emissions by 2050 [CC only]',
    label: 'Net zero emissions by 2050 [CC only]'
  },
  {
    value: 'Phase out of fossil fuel financing [CC only]',
    label: 'Phase out of fossil fuel financing [CC only]'
  },
  {
    value: 'Reduce water pollution [W only]',
    label: 'Reduce water pollution [W only]'
  },
  {
    value: 'Reduce water withdrawal and/or consumption [W only]',
    label: 'Reduce water withdrawal and/or consumption [W only]'
  },
  {
    value:
      'Water, Sanitation and Hygiene (WASH) provisions for all employees [W only]',
    label:
      'Water, Sanitation and Hygiene (WASH) provisions for all employees [W only]'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const RIVER_BASIN_OPTIONS = [
  {
    label: 'Afghanistan',
    options: [
      {value: 'Amu Darya', label: 'Amu Darya'},
      {value: 'Hamun-I-Lora', label: 'Hamun-I-Lora'},
      {value: 'Hamun', label: 'Hamun'},
      {value: 'Helmand', label: 'Helmand'},
      {value: 'Indus', label: 'Indus'},
      {value: 'Tarim', label: 'Tarim'},
      {value: 'Murghab - Hari Rud', label: 'Murghab - Hari Rud'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Åland Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Albania',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Danube', label: 'Danube'},
      {value: 'Drin', label: 'Drin'},
      {value: 'Vijose', label: 'Vijose'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Algeria',
    options: [
      {value: 'Chelif', label: 'Chelif'},
      {value: 'Chergui', label: 'Chergui'},
      {value: 'Daoura', label: 'Daoura'},
      {value: 'Djerid', label: 'Djerid'},
      {value: 'Dra', label: 'Dra'},
      {value: 'Guir', label: 'Guir'},
      {value: 'Hodna', label: 'Hodna'},
      {value: 'Medjerda', label: 'Medjerda'},
      {value: 'Lake Chad', label: 'Lake Chad'},
      {value: 'Melrhir', label: 'Melrhir'},
      {value: 'Moulouya', label: 'Moulouya'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Rharsa', label: 'Rharsa'},
      {value: 'Tafna', label: 'Tafna'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'American Samoa',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Andorra',
    options: [
      {value: 'Ebro', label: 'Ebro'},
      {value: 'Garonne', label: 'Garonne'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Angola',
    options: [
      {
        value: 'Chiloango (Shiloango, Louango)',
        label: 'Chiloango (Shiloango, Louango)'
      },
      {value: 'Congo', label: 'Congo'},
      {value: 'Cuanza', label: 'Cuanza'},
      {value: 'Cunene', label: 'Cunene'},
      {value: 'Cuvelai', label: 'Cuvelai'},
      {value: 'Okavango', label: 'Okavango'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Anguilla',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Antarctica',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Antigua and Barbuda',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Argentina',
    options: [
      {value: 'Azopardo', label: 'Azopardo'},
      {value: 'Baker', label: 'Baker'},
      {value: 'Biobio', label: 'Biobio'},
      {value: 'Chubut', label: 'Chubut'},
      {value: 'Cisnes', label: 'Cisnes'},
      {value: 'Coig', label: 'Coig'},
      {value: 'Colorado (Argentina)', label: 'Colorado (Argentina)'},
      {value: 'Gallegos-Chico', label: 'Gallegos-Chico'},
      {value: 'Huasco', label: 'Huasco'},
      {value: 'Deseado', label: 'Deseado'},
      {value: 'Laguna Del Bayo', label: 'Laguna Del Bayo'},
      {value: 'Laguna Escondida', label: 'Laguna Escondida'},
      {value: 'Laguna Mucar', label: 'Laguna Mucar'},
      {value: 'Limari', label: 'Limari'},
      {value: 'Palena', label: 'Palena'},
      {value: 'Parana', label: 'Parana'},
      {value: 'Lake Mar Chiquita', label: 'Lake Mar Chiquita'},
      {value: 'Lake Titicaca', label: 'Lake Titicaca'},
      {value: 'Rapel', label: 'Rapel'},
      {value: 'Pascua', label: 'Pascua'},
      {value: 'Rio Grande', label: 'Rio Grande'},
      {value: 'Rio Salado', label: 'Rio Salado'},
      {value: 'Salado', label: 'Salado'},
      {value: 'Puelo', label: 'Puelo'},
      {value: 'Negro (Argentina)', label: 'Negro (Argentina)'},
      {value: 'Santa Cruz', label: 'Santa Cruz'},
      {value: 'Rio De La Plata', label: 'Rio De La Plata'},
      {value: 'Salar Del Pular', label: 'Salar Del Pular'},
      {value: 'Salina De Jama', label: 'Salina De Jama'},
      {value: 'Serrano', label: 'Serrano'},
      {value: 'Uruguay', label: 'Uruguay'},
      {value: 'Valdivia', label: 'Valdivia'},
      {value: 'Yelcho', label: 'Yelcho'},
      {value: 'Zapaleri', label: 'Zapaleri'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Armenia',
    options: [
      {value: 'Kura - Ozero Sevan', label: 'Kura - Ozero Sevan'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Aruba',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Australia',
    options: [
      {value: 'Ashburton River', label: 'Ashburton River'},
      {value: 'Bancannia Lake', label: 'Bancannia Lake'},
      {value: 'Blackwood River', label: 'Blackwood River'},
      {value: 'Burdekin', label: 'Burdekin'},
      {value: 'Daly', label: 'Daly'},
      {value: 'Drysdale', label: 'Drysdale'},
      {value: 'De Grey River', label: 'De Grey River'},
      {value: 'Durack', label: 'Durack'},
      {value: 'Eyre Lake', label: 'Eyre Lake'},
      {value: 'Fitzroy', label: 'Fitzroy'},
      {value: 'Fitzroy River', label: 'Fitzroy River'},
      {value: 'Flinders River', label: 'Flinders River'},
      {value: 'Fortescue River', label: 'Fortescue River'},
      {value: 'Lake Gairdner', label: 'Lake Gairdner'},
      {value: 'Gascoyne River', label: 'Gascoyne River'},
      {value: 'Gilbert River', label: 'Gilbert River'},
      {value: 'Lake Torrens', label: 'Lake Torrens'},
      {value: 'Leichhardt River', label: 'Leichhardt River'},
      {value: 'Macarthur River', label: 'Macarthur River'},
      {value: 'Murray - Darling', label: 'Murray - Darling'},
      {value: 'Mitchell River (N. Au)', label: 'Mitchell River (N. Au)'},
      {value: 'Murchison River', label: 'Murchison River'},
      {value: 'Ord', label: 'Ord'},
      {value: 'Roper River', label: 'Roper River'},
      {value: 'South Esk River', label: 'South Esk River'},
      {value: 'Victoria River', label: 'Victoria River'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Austria',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Elbe River', label: 'Elbe River'},
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Azerbaijan',
    options: [
      {value: 'Kura - Ozero Sevan', label: 'Kura - Ozero Sevan'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bahamas',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bahrain',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bangladesh',
    options: [
      {value: 'Ganges - Brahmaputra', label: 'Ganges - Brahmaputra'},
      {value: 'Karnaphuli', label: 'Karnaphuli'},
      {value: 'Meghna', label: 'Meghna'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Barbados',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Belarus',
    options: [
      {value: 'Dniepr', label: 'Dniepr'},
      {value: 'Narva', label: 'Narva'},
      {value: 'Neman', label: 'Neman'},
      {value: 'Vuoksi - Neva', label: 'Vuoksi - Neva'},
      {value: 'Western Dvina (Daugava)', label: 'Western Dvina (Daugava)'},
      {value: 'Wisla', label: 'Wisla'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Belgium',
    options: [
      {value: 'Meuse', label: 'Meuse'},
      {value: 'Schelde (Escaut)', label: 'Schelde (Escaut)'},
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Seine', label: 'Seine'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Belize',
    options: [
      {value: 'Grisalva', label: 'Grisalva'},
      {value: 'Hondo', label: 'Hondo'},
      {value: 'Sarstoon', label: 'Sarstoon'},
      {value: 'Usumacinta', label: 'Usumacinta'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Benin',
    options: [
      {value: 'Mono', label: 'Mono'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Oueme', label: 'Oueme'},
      {value: 'Volta', label: 'Volta'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bermuda',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bhutan',
    options: [
      {value: 'Ganges - Brahmaputra', label: 'Ganges - Brahmaputra'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bolivia (Plurinational State of)',
    options: [
      {value: 'Amazonas', label: 'Amazonas'},
      {value: 'Blanca', label: 'Blanca'},
      {value: 'Cancosa', label: 'Cancosa'},
      {value: 'Cosapilla', label: 'Cosapilla'},
      {value: 'Lake Titicaca', label: 'Lake Titicaca'},
      {value: 'Lauca', label: 'Lauca'},
      {value: 'Loa', label: 'Loa'},
      {value: 'Parana', label: 'Parana'},
      {value: 'Poopo', label: 'Poopo'},
      {value: 'Zapaleri', label: 'Zapaleri'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bonaire, Sint Eustatius and Saba',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bosnia & Herzegovina',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Botswana',
    options: [
      {value: 'Limpopo', label: 'Limpopo'},
      {value: 'Okavango', label: 'Okavango'},
      {value: 'Orange', label: 'Orange'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bouvet Island',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Brazil',
    options: [
      {value: 'Amazonas', label: 'Amazonas'},
      {value: 'Chuy (Shu)', label: 'Chuy (Shu)'},
      {value: 'Corantijn', label: 'Corantijn'},
      {value: 'Cuyuni - Essequibo', label: 'Cuyuni - Essequibo'},
      {value: 'Jequitinhonha', label: 'Jequitinhonha'},
      {value: 'Lagoon Mirim', label: 'Lagoon Mirim'},
      {value: 'Maroni', label: 'Maroni'},
      {value: 'Mucuri', label: 'Mucuri'},
      {value: 'Negro (Uruguay)', label: 'Negro (Uruguay)'},
      {value: 'Orinoco', label: 'Orinoco'},
      {value: 'Paraiba Do Sul', label: 'Paraiba Do Sul'},
      {value: 'Oyapock', label: 'Oyapock'},
      {value: 'Parana', label: 'Parana'},
      {value: 'Rio Acarau', label: 'Rio Acarau'},
      {value: 'Rio Araguari', label: 'Rio Araguari'},
      {value: 'Rio Capim', label: 'Rio Capim'},
      {value: 'Rio De Contas', label: 'Rio De Contas'},
      {value: 'Rio Doce', label: 'Rio Doce'},
      {value: 'Rio Gurupi', label: 'Rio Gurupi'},
      {value: 'Rio De La Plata', label: 'Rio De La Plata'},
      {value: 'Sao Francisco', label: 'Sao Francisco'},
      {value: 'Salsa', label: 'Salsa'},
      {value: 'Rio Itapecuru', label: 'Rio Itapecuru'},
      {value: 'Rio Itapicuru', label: 'Rio Itapicuru'},
      {value: 'Rio Jacui', label: 'Rio Jacui'},
      {value: 'Rio Jaguaribe', label: 'Rio Jaguaribe'},
      {value: 'Rio Mearim', label: 'Rio Mearim'},
      {value: 'Rio Paraguacu', label: 'Rio Paraguacu'},
      {value: 'Rio Paraiba', label: 'Rio Paraiba'},
      {value: 'Rio Parnaiba', label: 'Rio Parnaiba'},
      {value: 'Rio Pindare', label: 'Rio Pindare'},
      {value: 'Rio Prado', label: 'Rio Prado'},
      {value: 'Rio Ribeira Do Iguape', label: 'Rio Ribeira Do Iguape'},
      {value: 'Rio Vaza-Barris', label: 'Rio Vaza-Barris'},
      {value: 'Tocantins', label: 'Tocantins'},
      {value: 'Uruguay', label: 'Uruguay'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'British Indian Ocean Territory',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'British Virgin Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Brunei Darussalam',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Bulgaria',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Nestos (Mesta)', label: 'Nestos (Mesta)'},
      {value: 'Maritsa', label: 'Maritsa'},
      {value: 'Rezvaya', label: 'Rezvaya'},
      {value: 'Struma', label: 'Struma'},
      {value: 'Vardar', label: 'Vardar'},
      {value: 'Veleka', label: 'Veleka'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Burkina Faso',
    options: [
      {value: 'Comoe', label: 'Comoe'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Volta', label: 'Volta'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Burundi',
    options: [
      {value: 'Congo', label: 'Congo'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cabo Verde',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cambodia',
    options: [
      {value: 'Dong Nai', label: 'Dong Nai'},
      {value: 'Vam Co', label: 'Vam Co'},
      {value: 'Chao Phraya', label: 'Chao Phraya'},
      {value: 'Mekong', label: 'Mekong'},
      {value: 'Saigon', label: 'Saigon'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cameroon',
    options: [
      {value: 'Congo', label: 'Congo'},
      {value: 'Cross', label: 'Cross'},
      {value: 'Lake Chad', label: 'Lake Chad'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Ntem', label: 'Ntem'},
      {value: 'Nyong', label: 'Nyong'},
      {value: 'Ogooue', label: 'Ogooue'},
      {value: 'Sanaga', label: 'Sanaga'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Canada',
    options: [
      {value: 'Albany River', label: 'Albany River'},
      {value: 'Alsek River', label: 'Alsek River'},
      {value: 'Anderson River', label: 'Anderson River'},
      {value: 'Arnaud', label: 'Arnaud'},
      {value: 'Attawapiskat River', label: 'Attawapiskat River'},
      {
        value: 'Baleine Grande Riviere De La',
        label: 'Baleine Grande Riviere De La'
      },
      {value: 'Caniapiscau - Aux Melezes', label: 'Caniapiscau - Aux Melezes'},
      {value: 'Churchill River', label: 'Churchill River'},
      {
        value: 'Churchill Fleuve (Labrador)',
        label: 'Churchill Fleuve (Labrador)'
      },
      {value: 'Columbia River', label: 'Columbia River'},
      {value: 'Connecticut River', label: 'Connecticut River'},
      {value: 'Copper River', label: 'Copper River'},
      {value: 'Coppermine River', label: 'Coppermine River'},
      {value: 'Eastmain', label: 'Eastmain'},
      {value: 'Ellice River', label: 'Ellice River'},
      {value: 'Ferguson River', label: 'Ferguson River'},
      {value: 'Feuilles (Riviere Aux)', label: 'Feuilles (Riviere Aux)'},
      {value: 'Fraser River', label: 'Fraser River'},
      {value: 'George River', label: 'George River'},
      {value: 'Grande Riviere', label: 'Grande Riviere'},
      {
        value: 'Grande Riviere De La Baleine',
        label: 'Grande Riviere De La Baleine'
      },
      {
        value: 'Hayes River (Trib. Arctic Ocean) - Back River',
        label: 'Hayes River (Trib. Arctic Ocean) - Back River'
      },
      {
        value: 'Hayes River (Trib. Hudson Bay)',
        label: 'Hayes River (Trib. Hudson Bay)'
      },
      {value: 'Hornaday River', label: 'Hornaday River'},
      {value: 'Horton River', label: 'Horton River'},
      {value: 'Little Mecatina River', label: 'Little Mecatina River'},
      {value: 'Mackenzie River', label: 'Mackenzie River'},
      {value: 'Manicouagan (Riviere)', label: 'Manicouagan (Riviere)'},
      {value: 'Mississippi River', label: 'Mississippi River'},
      {
        value: 'Moose River (Trib. Hudson Bay)',
        label: 'Moose River (Trib. Hudson Bay)'
      },
      {value: 'Nass River', label: 'Nass River'},
      {value: 'Natashquan (Riviere)', label: 'Natashquan (Riviere)'},
      {value: 'Nelson River', label: 'Nelson River'},
      {value: 'Nottaway', label: 'Nottaway'},
      {value: 'Penobscot River', label: 'Penobscot River'},
      {value: 'Quoich River', label: 'Quoich River'},
      {value: 'Rupert River', label: 'Rupert River'},
      {value: 'Saguenay (Riviere)', label: 'Saguenay (Riviere)'},
      {value: 'Saint John River', label: 'Saint John River'},
      {value: 'Seal River', label: 'Seal River'},
      {
        value: 'Severn River (Trib. Hudson Bay)',
        label: 'Severn River (Trib. Hudson Bay)'
      },
      {value: 'Skagit', label: 'Skagit'},
      {value: 'Skeena River', label: 'Skeena River'},
      {value: 'St.Croix River', label: 'St.Croix River'},
      {value: 'St.Lawrence', label: 'St.Lawrence'},
      {value: 'Stikine River', label: 'Stikine River'},
      {value: 'Taku River', label: 'Taku River'},
      {value: 'Thelon River', label: 'Thelon River'},
      {value: 'Thlewiaza River', label: 'Thlewiaza River'},
      {value: 'Winisk River', label: 'Winisk River'},
      {value: 'Yukon River', label: 'Yukon River'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cayman Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Central African Republic',
    options: [
      {value: 'Congo', label: 'Congo'},
      {value: 'Lake Chad', label: 'Lake Chad'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Sanaga', label: 'Sanaga'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Chad',
    options: [
      {value: 'Lake Chad', label: 'Lake Chad'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Chile',
    options: [
      {value: 'Aisen', label: 'Aisen'},
      {value: 'Azopardo', label: 'Azopardo'},
      {value: 'Baker', label: 'Baker'},
      {value: 'Biobio', label: 'Biobio'},
      {value: 'Blanca', label: 'Blanca'},
      {value: 'Cancosa', label: 'Cancosa'},
      {value: 'Cisnes', label: 'Cisnes'},
      {value: 'Chubut', label: 'Chubut'},
      {value: 'Colorado (Argentina)', label: 'Colorado (Argentina)'},
      {value: 'Copiapo', label: 'Copiapo'},
      {value: 'Cosapilla', label: 'Cosapilla'},
      {value: 'Gallegos-Chico', label: 'Gallegos-Chico'},
      {value: 'Huasco', label: 'Huasco'},
      {value: 'Laguna Del Bayo', label: 'Laguna Del Bayo'},
      {value: 'Laguna Escondida', label: 'Laguna Escondida'},
      {value: 'Laguna Mucar', label: 'Laguna Mucar'},
      {value: 'Lake Titicaca', label: 'Lake Titicaca'},
      {value: 'Lauca', label: 'Lauca'},
      {value: 'Limari', label: 'Limari'},
      {value: 'Loa', label: 'Loa'},
      {value: 'Negro (Argentina)', label: 'Negro (Argentina)'},
      {value: 'Palena', label: 'Palena'},
      {value: 'Pascua', label: 'Pascua'},
      {value: 'Puelo', label: 'Puelo'},
      {value: 'Rapel', label: 'Rapel'},
      {value: 'Rio Grande', label: 'Rio Grande'},
      {value: 'Salar Del Pular', label: 'Salar Del Pular'},
      {value: 'Salina De Jama', label: 'Salina De Jama'},
      {value: 'Santa Cruz', label: 'Santa Cruz'},
      {value: 'Serrano', label: 'Serrano'},
      {value: 'Valdivia', label: 'Valdivia'},
      {value: 'Yelcho', label: 'Yelcho'},
      {value: 'Zapaleri', label: 'Zapaleri'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'China',
    options: [
      {value: 'Alakol', label: 'Alakol'},
      {value: 'Amu Darya', label: 'Amu Darya'},
      {value: 'Ganges - Brahmaputra', label: 'Ganges - Brahmaputra'},
      {value: 'Amur', label: 'Amur'},
      {value: 'Huang He (Yellow River)', label: 'Huang He (Yellow River)'},
      {value: 'Indus', label: 'Indus'},
      {value: 'Huai He', label: 'Huai He'},
      {value: 'Mekong', label: 'Mekong'},
      {value: 'Qiantang Jiang', label: 'Qiantang Jiang'},
      {value: 'Tarim', label: 'Tarim'},
      {value: 'Tumen', label: 'Tumen'},
      {value: 'Ulungur Hu', label: 'Ulungur Hu'},
      {value: 'Zhu', label: 'Zhu'},
      {value: 'Balkhash', label: 'Balkhash'},
      {value: 'Dalinghe', label: 'Dalinghe'},
      {value: 'Dong Jiang', label: 'Dong Jiang'},
      {value: 'Fuchun Jiang', label: 'Fuchun Jiang'},
      {value: 'Han Jiang', label: 'Han Jiang'},
      {value: 'Hong (Red River)', label: 'Hong (Red River)'},
      {value: 'Irrawaddy', label: 'Irrawaddy'},
      {value: 'Liao He', label: 'Liao He'},
      {value: 'Luan He', label: 'Luan He'},
      {value: 'Min Jiang', label: 'Min Jiang'},
      {value: 'Ob', label: 'Ob'},
      {value: 'Salween', label: 'Salween'},
      {value: 'Syr Darya', label: 'Syr Darya'},
      {value: 'Xi Jiang - Bei Jiang', label: 'Xi Jiang - Bei Jiang'},
      {value: 'Yalu Jiang', label: 'Yalu Jiang'},
      {
        value: 'Yangtze River (Chang Jiang)',
        label: 'Yangtze River (Chang Jiang)'
      },
      {value: 'Yongding He', label: 'Yongding He'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'China, Macao Special Administrative Region',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Christmas Island',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cocos (Keeling) Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Colombia',
    options: [
      {value: 'Amazonas', label: 'Amazonas'},
      {value: 'Atrato', label: 'Atrato'},
      {value: 'Catatumbo', label: 'Catatumbo'},
      {value: 'Jurado', label: 'Jurado'},
      {value: 'Orinoco', label: 'Orinoco'},
      {value: 'Magdalena', label: 'Magdalena'},
      {value: 'Mira', label: 'Mira'},
      {value: 'Patia', label: 'Patia'},
      {
        value: 'San Juan (Columbia - Pacific)',
        label: 'San Juan (Columbia - Pacific)'
      },
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Comoros',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Congo',
    options: [
      {
        value: 'Chiloango (Shiloango, Louango)',
        label: 'Chiloango (Shiloango, Louango)'
      },
      {value: 'Congo', label: 'Congo'},
      {value: 'Kouilou', label: 'Kouilou'},
      {value: 'Nyanga', label: 'Nyanga'},
      {value: 'Ogooue', label: 'Ogooue'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cook Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Costa Rica',
    options: [
      {value: 'Changuinola', label: 'Changuinola'},
      {value: 'Sixaola', label: 'Sixaola'},
      {value: 'San Juan', label: 'San Juan'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: `${'Côte'} d'Ivoire`,
    options: [
      {value: 'Bandama', label: 'Bandama'},
      {value: 'Bia', label: 'Bia'},
      {value: 'Cavally', label: 'Cavally'},
      {value: 'Cestos', label: 'Cestos'},
      {value: 'Comoe', label: 'Comoe'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Sassandra - Davo', label: 'Sassandra - Davo'},
      {value: 'St John', label: 'St John'},
      {value: 'Tano', label: 'Tano'},
      {value: 'Volta', label: 'Volta'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Croatia',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cuba',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Curaçao',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cyprus',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Czechia',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Elbe River', label: 'Elbe River'},
      {value: 'Oder River', label: 'Oder River'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: `Democratic ${'People'}'s Republic of Korea`,
    options: [
      {value: 'Amur', label: 'Amur'},
      {value: 'Tumen', label: 'Tumen'},
      {value: 'Han-Gang (Han River)', label: 'Han-Gang (Han River)'},
      {value: 'Yalu Jiang', label: 'Yalu Jiang'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Democratic Republic of the Congo',
    options: [
      {
        value: 'Chiloango (Shiloango, Louango)',
        label: 'Chiloango (Shiloango, Louango)'
      },
      {value: 'Congo', label: 'Congo'},
      {value: 'Kouilou', label: 'Kouilou'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Denmark',
    options: [
      {value: 'Gudena', label: 'Gudena'},
      {value: 'Skjern A', label: 'Skjern A'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Djibouti',
    options: [
      {value: 'Abhe Bad (Abhe Bid Hayk)', label: 'Abhe Bad (Abhe Bid Hayk)'},
      {value: 'Awash', label: 'Awash'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Dominica',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Dominican Republic',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Ecuador',
    options: [
      {value: 'Amazonas', label: 'Amazonas'},
      {value: 'Guayas', label: 'Guayas'},
      {value: 'Mira', label: 'Mira'},
      {value: 'Patia', label: 'Patia'},
      {value: 'Chira', label: 'Chira'},
      {value: 'Daule & Vinces', label: 'Daule & Vinces'},
      {value: 'Esmeraldas', label: 'Esmeraldas'},
      {value: 'Tumbes', label: 'Tumbes'},
      {value: 'Zarumilla', label: 'Zarumilla'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Egypt',
    options: [
      {value: 'Dead Sea', label: 'Dead Sea'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'El Salvador',
    options: [
      {value: 'Goascoran', label: 'Goascoran'},
      {value: 'Paz', label: 'Paz'},
      {value: 'Lempa', label: 'Lempa'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Equatorial Guinea',
    options: [
      {value: 'Mbini (Woleu)', label: 'Mbini (Woleu)'},
      {value: 'Ntem', label: 'Ntem'},
      {value: 'Ogooue', label: 'Ogooue'},
      {value: 'Utamboni (Mitemboni)', label: 'Utamboni (Mitemboni)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Eritrea',
    options: [
      {value: 'Baraka', label: 'Baraka'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Estonia',
    options: [
      {value: 'Narva', label: 'Narva'},
      {value: 'Western Dvina (Daugava)', label: 'Western Dvina (Daugava)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Eswatini',
    options: [
      {value: 'Umbeluzi (Umbuluzi)', label: 'Umbeluzi (Umbuluzi)'},
      {value: 'Incomati', label: 'Incomati'},
      {value: 'Maputo', label: 'Maputo'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Ethiopia',
    options: [
      {value: 'Abhe Bad (Abhe Bid Hayk)', label: 'Abhe Bad (Abhe Bid Hayk)'},
      {value: 'Awash', label: 'Awash'},
      {
        value: 'Chew Bahir (Lake Stefanie)',
        label: 'Chew Bahir (Lake Stefanie)'
      },
      {value: 'Jubba (Genale Wenz)', label: 'Jubba (Genale Wenz)'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Lake Turkana', label: 'Lake Turkana'},
      {value: 'Shebelle', label: 'Shebelle'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Falkland Islands (Malvinas)',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Faroe Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Fiji',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Finland',
    options: [
      {
        value: 'Tornealven (Tornionjoki, Tornionvayla)',
        label: 'Tornealven (Tornionjoki, Tornionvayla)'
      },
      {value: 'Iijoki', label: 'Iijoki'},
      {value: 'Kem', label: 'Kem'},
      {value: 'Kemijoki', label: 'Kemijoki'},
      {value: 'Kokemaenjoki', label: 'Kokemaenjoki'},
      {value: 'Kymijoki', label: 'Kymijoki'},
      {value: 'Muonio', label: 'Muonio'},
      {value: 'Oulujoki', label: 'Oulujoki'},
      {value: 'Tana (in Europe)', label: 'Tana (in Europe)'},
      {value: 'Tuloma', label: 'Tuloma'},
      {value: 'Vuoksi - Neva', label: 'Vuoksi - Neva'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'France',
    options: [
      {value: 'Dordogne', label: 'Dordogne'},
      {value: 'Ebro', label: 'Ebro'},
      {value: 'Garonne', label: 'Garonne'},
      {value: 'Loire', label: 'Loire'},
      {value: 'Muga', label: 'Muga'},
      {value: 'Po', label: 'Po'},
      {value: 'Meuse', label: 'Meuse'},
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Schelde (Escaut)', label: 'Schelde (Escaut)'},
      {value: 'Rhone', label: 'Rhone'},
      {value: 'Roia', label: 'Roia'},
      {value: 'Seine', label: 'Seine'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'French Guiana',
    options: [
      {value: 'Amazonas', label: 'Amazonas'},
      {value: 'Maroni', label: 'Maroni'},
      {value: 'Oyapock', label: 'Oyapock'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'French Polynesia',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'French Southern Territories',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Gabon',
    options: [
      {value: 'Congo', label: 'Congo'},
      {value: 'Kouilou', label: 'Kouilou'},
      {value: 'Mbini (Woleu)', label: 'Mbini (Woleu)'},
      {value: 'Ntem', label: 'Ntem'},
      {value: 'Nyanga', label: 'Nyanga'},
      {value: 'Ogooue', label: 'Ogooue'},
      {value: 'Utamboni (Mitemboni)', label: 'Utamboni (Mitemboni)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Gambia',
    options: [
      {value: 'Gambia', label: 'Gambia'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Georgia',
    options: [
      {value: 'Kura - Ozero Sevan', label: 'Kura - Ozero Sevan'},
      {value: 'Coruh', label: 'Coruh'},
      {value: 'Kuban', label: 'Kuban'},
      {value: 'Terek', label: 'Terek'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Germany',
    options: [
      {value: 'Weser', label: 'Weser'},
      {value: 'Danube', label: 'Danube'},
      {value: 'Elbe River', label: 'Elbe River'},
      {value: 'Meuse', label: 'Meuse'},
      {value: 'Oder River', label: 'Oder River'},
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Ghana',
    options: [
      {value: 'Bia', label: 'Bia'},
      {value: 'Comoe', label: 'Comoe'},
      {value: 'Pra', label: 'Pra'},
      {value: 'Tano', label: 'Tano'},
      {value: 'Volta', label: 'Volta'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Gibraltar',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Greece',
    options: [
      {value: 'Maritsa', label: 'Maritsa'},
      {value: 'Nestos (Mesta)', label: 'Nestos (Mesta)'},
      {value: 'Struma', label: 'Struma'},
      {value: 'Vardar', label: 'Vardar'},
      {value: 'Vijose', label: 'Vijose'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Greenland',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Grenada',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Guadeloupe',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Guam',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Guatemala',
    options: [
      {value: 'Candelaria', label: 'Candelaria'},
      {value: 'Coatan', label: 'Coatan'},
      {value: 'Grisalva', label: 'Grisalva'},
      {value: 'Hondo', label: 'Hondo'},
      {value: 'Lempa', label: 'Lempa'},
      {value: 'Paz', label: 'Paz'},
      {value: 'Sarstoon', label: 'Sarstoon'},
      {value: 'Suchiate', label: 'Suchiate'},
      {value: 'Usumacinta', label: 'Usumacinta'},
      {value: 'Motagua', label: 'Motagua'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Guernsey',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Guinea',
    options: [
      {value: 'Cavally', label: 'Cavally'},
      {value: 'Cestos', label: 'Cestos'},
      {value: 'Gambia', label: 'Gambia'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Senegal', label: 'Senegal'},
      {value: 'St Paul', label: 'St Paul'},
      {value: 'Corubal', label: 'Corubal'},
      {value: 'Geba', label: 'Geba'},
      {value: 'Great Scarcies', label: 'Great Scarcies'},
      {value: 'Little Scarcies', label: 'Little Scarcies'},
      {value: 'Lofa', label: 'Lofa'},
      {value: 'Mano-Morro', label: 'Mano-Morro'},
      {value: 'Moa', label: 'Moa'},
      {value: 'Sassandra - Davo', label: 'Sassandra - Davo'},
      {value: 'St John', label: 'St John'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Guinea-Bissau',
    options: [
      {value: 'Corubal', label: 'Corubal'},
      {value: 'Geba', label: 'Geba'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Guyana',
    options: [
      {value: 'Amacuro (Amakura)', label: 'Amacuro (Amakura)'},
      {value: 'Amazonas', label: 'Amazonas'},
      {value: 'Barima', label: 'Barima'},
      {value: 'Corantijn', label: 'Corantijn'},
      {value: 'Cuyuni - Essequibo', label: 'Cuyuni - Essequibo'},
      {value: 'Orinoco', label: 'Orinoco'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Haiti',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Heard Island and McDonald Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Holy See',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Honduras',
    options: [
      {value: 'Choluteca', label: 'Choluteca'},
      {value: 'Coco', label: 'Coco'},
      {value: 'Goascoran', label: 'Goascoran'},
      {value: 'Lempa', label: 'Lempa'},
      {value: 'Motagua', label: 'Motagua'},
      {value: 'Patacua', label: 'Patacua'},
      {value: 'Ulua', label: 'Ulua'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Hong Kong SAR, China',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Hungary',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Iceland',
    options: [
      {value: 'Joekulsa A Fjoellum', label: 'Joekulsa A Fjoellum'},
      {value: 'Lagarfljot', label: 'Lagarfljot'},
      {value: 'Oelfusa', label: 'Oelfusa'},
      {value: 'Svarta (Skagafiroi)', label: 'Svarta (Skagafiroi)'},
      {value: 'Thjorsa', label: 'Thjorsa'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'India',
    options: [
      {value: 'Ganges - Brahmaputra', label: 'Ganges - Brahmaputra'},
      {value: 'Indus', label: 'Indus'},
      {value: 'Irrawaddy', label: 'Irrawaddy'},
      {value: 'Karnaphuli', label: 'Karnaphuli'},
      {value: 'Meghna', label: 'Meghna'},
      {value: 'Brahmani River (Bhahmani)', label: 'Brahmani River (Bhahmani)'},
      {value: 'Cauvery River', label: 'Cauvery River'},
      {value: 'Damodar River', label: 'Damodar River'},
      {value: 'Godavari', label: 'Godavari'},
      {value: 'Kaladan', label: 'Kaladan'},
      {value: 'Krishna', label: 'Krishna'},
      {value: 'Mahanadi River (Mahahadi)', label: 'Mahanadi River (Mahahadi)'},
      {value: 'Mahi River', label: 'Mahi River'},
      {value: 'Narmada', label: 'Narmada'},
      {value: 'Penner River', label: 'Penner River'},
      {value: 'Tapti River', label: 'Tapti River'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Indonesia',
    options: [
      {value: 'Bulungan', label: 'Bulungan'},
      {value: 'Batang Hari', label: 'Batang Hari'},
      {value: 'Batang Kuantan', label: 'Batang Kuantan'},
      {value: 'Brantas', label: 'Brantas'},
      {value: 'Eilanden', label: 'Eilanden'},
      {value: 'Fly', label: 'Fly'},
      {value: 'Lorentz', label: 'Lorentz'},
      {value: 'Mamberamo', label: 'Mamberamo'},
      {value: 'Rajang', label: 'Rajang'},
      {value: 'Sembakung', label: 'Sembakung'},
      {value: 'Sepik', label: 'Sepik'},
      {value: 'Solo (Bengawan Solo)', label: 'Solo (Bengawan Solo)'},
      {value: 'Sungai Kajan', label: 'Sungai Kajan'},
      {value: 'Sungai Kapuas', label: 'Sungai Kapuas'},
      {value: 'Sungai Mahakam', label: 'Sungai Mahakam'},
      {value: 'Uwimbu', label: 'Uwimbu'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Iran (Islamic Republic of)',
    options: [
      {value: 'Hamun', label: 'Hamun'},
      {value: 'Helmand', label: 'Helmand'},
      {value: 'Hamun-I-Mashkel', label: 'Hamun-I-Mashkel'},
      {value: 'Kura - Ozero Sevan', label: 'Kura - Ozero Sevan'},
      {value: 'Murghab - Hari Rud', label: 'Murghab - Hari Rud'},
      {value: 'Shatt Al Arab', label: 'Shatt Al Arab'},
      {value: 'Tigris & Euphrates', label: 'Tigris & Euphrates'},
      {value: 'Atrek', label: 'Atrek'},
      {value: 'Daryacheh-Ye Orumieh', label: 'Daryacheh-Ye Orumieh'},
      {value: 'Dasht', label: 'Dasht'},
      {value: 'Van Golu', label: 'Van Golu'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Iraq',
    options: [
      {value: 'Daryacheh-Ye Orumieh', label: 'Daryacheh-Ye Orumieh'},
      {value: 'Dead Sea', label: 'Dead Sea'},
      {value: 'Shatt Al Arab', label: 'Shatt Al Arab'},
      {value: 'Tigris & Euphrates', label: 'Tigris & Euphrates'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Ireland',
    options: [
      {value: 'Shannon', label: 'Shannon'},
      {value: 'Bann', label: 'Bann'},
      {value: 'Fane', label: 'Fane'},
      {value: 'Foyle', label: 'Foyle'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Isle of Man',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Israel',
    options: [
      {value: 'Dead Sea', label: 'Dead Sea'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Italy',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Po', label: 'Po'},
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Rhone', label: 'Rhone'},
      {value: 'Roia', label: 'Roia'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Jamaica',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Japan',
    options: [
      {value: 'Gono (Go)', label: 'Gono (Go)'},
      {value: 'Ishikari', label: 'Ishikari'},
      {value: 'Kiso', label: 'Kiso'},
      {value: 'Kitakami', label: 'Kitakami'},
      {value: 'Mogami', label: 'Mogami'},
      {value: 'Shinano (Chikuma)', label: 'Shinano (Chikuma)'},
      {value: 'Tenryu', label: 'Tenryu'},
      {value: 'Tone', label: 'Tone'},
      {value: 'Yodo', label: 'Yodo'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Jersey',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Jordan',
    options: [
      {value: 'Dead Sea', label: 'Dead Sea'},
      {value: 'Shatt Al Arab', label: 'Shatt Al Arab'},
      {value: 'Tigris & Euphrates', label: 'Tigris & Euphrates'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Kazakhstan',
    options: [
      {value: 'Alakol', label: 'Alakol'},
      {value: 'Amu Darya', label: 'Amu Darya'},
      {value: 'Balkhash', label: 'Balkhash'},
      {value: 'Ob', label: 'Ob'},
      {value: 'Sarysu', label: 'Sarysu'},
      {value: 'Syr Darya', label: 'Syr Darya'},
      {value: 'Talas', label: 'Talas'},
      {value: 'Tarim', label: 'Tarim'},
      {value: 'Torghay', label: 'Torghay'},
      {value: 'Zhem (Emba)', label: 'Zhem (Emba)'},
      {value: 'Aral Drainage', label: 'Aral Drainage'},
      {value: 'Issyk-Kul', label: 'Issyk-Kul'},
      {value: 'Ural', label: 'Ural'},
      {value: 'Volga', label: 'Volga'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Kenya',
    options: [
      {
        value: 'Chew Bahir (Lake Stefanie)',
        label: 'Chew Bahir (Lake Stefanie)'
      },
      {value: 'Galana', label: 'Galana'},
      {value: 'Lake Turkana', label: 'Lake Turkana'},
      {value: 'Lake Natron', label: 'Lake Natron'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Shebelle', label: 'Shebelle'},
      {value: 'Jubba (Genale Wenz)', label: 'Jubba (Genale Wenz)'},
      {value: 'Pangani', label: 'Pangani'},
      {value: 'Umba', label: 'Umba'},
      {value: 'Tana (in Africa)', label: 'Tana (in Africa)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Kiribati',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Kuwait',
    options: [
      {value: 'Tigris & Euphrates', label: 'Tigris & Euphrates'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Kyrgyzstan',
    options: [
      {value: 'Amu Darya', label: 'Amu Darya'},
      {value: 'Balkhash', label: 'Balkhash'},
      {value: 'Issyk-Kul', label: 'Issyk-Kul'},
      {value: 'Syr Darya', label: 'Syr Darya'},
      {value: 'Talas', label: 'Talas'},
      {value: 'Tarim', label: 'Tarim'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: `Lao ${'People'}'s Democratic Republic`,
    options: [
      {value: 'Chao Phraya', label: 'Chao Phraya'},
      {value: 'Hong (Red River)', label: 'Hong (Red River)'},
      {value: 'Lam (Xongka)', label: 'Lam (Xongka)'},
      {value: 'Mekong', label: 'Mekong'},
      {value: 'Ca', label: 'Ca'},
      {value: 'Ma', label: 'Ma'},
      {value: 'Tranh (Nr Thu Bon)', label: 'Tranh (Nr Thu Bon)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Latvia',
    options: [
      {value: 'Narva', label: 'Narva'},
      {value: 'Neman', label: 'Neman'},
      {value: 'Western Dvina (Daugava)', label: 'Western Dvina (Daugava)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Lebanon',
    options: [
      {value: 'Asi (Orontes)', label: 'Asi (Orontes)'},
      {value: 'Dead Sea', label: 'Dead Sea'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Lesotho',
    options: [
      {value: 'Orange', label: 'Orange'},
      {value: 'Tugela', label: 'Tugela'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Liberia',
    options: [
      {value: 'Cavally', label: 'Cavally'},
      {value: 'Cestos', label: 'Cestos'},
      {value: 'Lofa', label: 'Lofa'},
      {value: 'Mano-Morro', label: 'Mano-Morro'},
      {value: 'Moa', label: 'Moa'},
      {value: 'St John', label: 'St John'},
      {value: 'St Paul', label: 'St Paul'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Libya',
    options: [
      {value: 'Lake Chad', label: 'Lake Chad'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Liechtenstein',
    options: [
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Lithuania',
    options: [
      {value: 'Neman', label: 'Neman'},
      {value: 'Western Dvina (Daugava)', label: 'Western Dvina (Daugava)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Luxembourg',
    options: [
      {value: 'Meuse', label: 'Meuse'},
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Madagascar',
    options: [
      {value: 'Betisboka', label: 'Betisboka'},
      {value: 'Mangoky', label: 'Mangoky'},
      {value: 'Tsiribihina', label: 'Tsiribihina'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Malawi',
    options: [
      {value: 'Congo', label: 'Congo'},
      {value: 'Rovuma', label: 'Rovuma'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Malaysia',
    options: [
      {value: 'Kolok', label: 'Kolok'},
      {value: 'Kelantan', label: 'Kelantan'},
      {value: 'Kinabatangan', label: 'Kinabatangan'},
      {value: 'Pahang', label: 'Pahang'},
      {value: 'Perak', label: 'Perak'},
      {value: 'Rajang', label: 'Rajang'},
      {value: 'Sembakung', label: 'Sembakung'},
      {value: 'Sungai Kajan', label: 'Sungai Kajan'},
      {value: 'Sungai Kapuas', label: 'Sungai Kapuas'},
      {value: 'Sungai Mahakam', label: 'Sungai Mahakam'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Maldives',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Mali',
    options: [
      {value: 'Bandama', label: 'Bandama'},
      {value: 'Comoe', label: 'Comoe'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Senegal', label: 'Senegal'},
      {value: 'Volta', label: 'Volta'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Malta',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Marshall Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Martinique',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Mauritania',
    options: [
      {value: 'Atoui', label: 'Atoui'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Senegal', label: 'Senegal'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Mauritius',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Mayotte',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Mexico',
    options: [
      {value: 'Candelaria', label: 'Candelaria'},
      {value: 'Coatan', label: 'Coatan'},
      {value: 'Grisalva', label: 'Grisalva'},
      {value: 'Hondo', label: 'Hondo'},
      {value: 'Suchiate', label: 'Suchiate'},
      {value: 'Usumacinta', label: 'Usumacinta'},
      {value: 'Armeria', label: 'Armeria'},
      {value: 'Balsas', label: 'Balsas'},
      {value: 'Bravo', label: 'Bravo'},
      {
        value: 'Colorado River (Pacific Ocean)',
        label: 'Colorado River (Pacific Ocean)'
      },
      {value: 'Conception', label: 'Conception'},
      {value: 'Fuerte', label: 'Fuerte'},
      {value: 'Panuco', label: 'Panuco'},
      {value: 'Papaloapan', label: 'Papaloapan'},
      {value: 'San Pedro', label: 'San Pedro'},
      {value: 'Santiago', label: 'Santiago'},
      {value: 'Verde', label: 'Verde'},
      {value: 'Yaqui', label: 'Yaqui'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Micronesia (Federated States of)',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Monaco',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Mongolia',
    options: [
      {value: 'Amur', label: 'Amur'},
      {value: 'Har Us Nuur', label: 'Har Us Nuur'},
      {value: 'Lake Ubsa', label: 'Lake Ubsa'},
      {value: 'Ob', label: 'Ob'},
      {value: 'Yenisei', label: 'Yenisei'},
      {value: 'Ulungur Hu', label: 'Ulungur Hu'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Montenegro',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Drin', label: 'Drin'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Montserrat',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Morocco',
    options: [
      {value: 'Chergui', label: 'Chergui'},
      {value: 'Daoura', label: 'Daoura'},
      {value: 'Dra', label: 'Dra'},
      {value: 'Guir', label: 'Guir'},
      {value: 'Moulouya', label: 'Moulouya'},
      {value: 'Sebou', label: 'Sebou'},
      {value: 'Tafna', label: 'Tafna'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Mozambique',
    options: [
      {value: 'Incomati', label: 'Incomati'},
      {value: 'Limpopo', label: 'Limpopo'},
      {value: 'Maputo', label: 'Maputo'},
      {value: 'Pungwe (Pungoe)', label: 'Pungwe (Pungoe)'},
      {value: 'Rovuma', label: 'Rovuma'},
      {value: 'Umbeluzi (Umbuluzi)', label: 'Umbeluzi (Umbuluzi)'},
      {value: 'Buzi', label: 'Buzi'},
      {value: 'Lurio', label: 'Lurio'},
      {value: 'Messalo', label: 'Messalo'},
      {value: 'Save', label: 'Save'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Myanmar',
    options: [
      {value: 'Mae Klong', label: 'Mae Klong'},
      {value: 'Meghna', label: 'Meghna'},
      {value: 'Sittang River', label: 'Sittang River'},
      {value: 'Pakchan', label: 'Pakchan'},
      {value: 'Chao Phraya', label: 'Chao Phraya'},
      {value: 'Ganges - Brahmaputra', label: 'Ganges - Brahmaputra'},
      {value: 'Irrawaddy', label: 'Irrawaddy'},
      {value: 'Kaladan', label: 'Kaladan'},
      {value: 'Mekong', label: 'Mekong'},
      {value: 'Salween', label: 'Salween'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Namibia',
    options: [
      {value: 'Cunene', label: 'Cunene'},
      {value: 'Cuvelai', label: 'Cuvelai'},
      {value: 'Okavango', label: 'Okavango'},
      {value: 'Orange', label: 'Orange'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Nauru',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Nepal',
    options: [
      {value: 'Ganges - Brahmaputra', label: 'Ganges - Brahmaputra'},
      {value: 'Indus', label: 'Indus'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Netherlands',
    options: [
      {value: 'Meuse', label: 'Meuse'},
      {value: 'Rhine', label: 'Rhine'},
      {value: 'Schelde (Escaut)', label: 'Schelde (Escaut)'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'New Caledonia',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'New Zealand',
    options: [
      {value: 'Buller', label: 'Buller'},
      {value: 'Waiau', label: 'Waiau'},
      {value: 'Clutha', label: 'Clutha'},
      {value: 'Waikato River', label: 'Waikato River'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Nicaragua',
    options: [
      {value: 'Choluteca', label: 'Choluteca'},
      {value: 'Grande De Matagalpa', label: 'Grande De Matagalpa'},
      {value: 'Coco', label: 'Coco'},
      {value: 'Patacua', label: 'Patacua'},
      {value: 'San Juan', label: 'San Juan'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Niger',
    options: [
      {value: 'Lake Chad', label: 'Lake Chad'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Nigeria',
    options: [
      {value: 'Cross', label: 'Cross'},
      {value: 'Lake Chad', label: 'Lake Chad'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Oueme', label: 'Oueme'},
      {value: 'Sanaga', label: 'Sanaga'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Niue',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Norfolk Island',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'North Macedonia',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Drin', label: 'Drin'},
      {value: 'Struma', label: 'Struma'},
      {value: 'Vardar', label: 'Vardar'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Northern Mariana Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Norway',
    options: [
      {value: 'Angerman', label: 'Angerman'},
      {value: 'Dalalven', label: 'Dalalven'},
      {value: 'Dramselv', label: 'Dramselv'},
      {value: 'Gloma', label: 'Gloma'},
      {value: 'Lule', label: 'Lule'},
      {
        value: 'Tornealven (Tornionjoki, Tornionvayla)',
        label: 'Tornealven (Tornionjoki, Tornionvayla)'
      },
      {value: 'Kemijoki', label: 'Kemijoki'},
      {value: 'Muonio', label: 'Muonio'},
      {value: 'Tana (in Europe)', label: 'Tana (in Europe)'},
      {value: 'Vaenern-Goeta', label: 'Vaenern-Goeta'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Oman',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Pakistan',
    options: [
      {value: 'Amu Darya', label: 'Amu Darya'},
      {value: 'Dasht', label: 'Dasht'},
      {value: 'Hamun', label: 'Hamun'},
      {value: 'Hamun-I-Lora', label: 'Hamun-I-Lora'},
      {value: 'Hamun-I-Mashkel', label: 'Hamun-I-Mashkel'},
      {value: 'Helmand', label: 'Helmand'},
      {value: 'Hingol', label: 'Hingol'},
      {value: 'Indus', label: 'Indus'},
      {value: 'Tarim', label: 'Tarim'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Palau',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Panama',
    options: [
      {value: 'Atrato', label: 'Atrato'},
      {value: 'Changuinola', label: 'Changuinola'},
      {value: 'Jurado', label: 'Jurado'},
      {value: 'Sixaola', label: 'Sixaola'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Papua New Guinea',
    options: [
      {value: 'Purari', label: 'Purari'},
      {value: 'Fly', label: 'Fly'},
      {value: 'Mamberamo', label: 'Mamberamo'},
      {value: 'Sepik', label: 'Sepik'},
      {value: 'Uwimbu', label: 'Uwimbu'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Paraguay',
    options: [
      {value: 'Parana', label: 'Parana'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Peru',
    options: [
      {value: 'Amazonas', label: 'Amazonas'},
      {value: 'Blanca', label: 'Blanca'},
      {value: 'Chira', label: 'Chira'},
      {value: 'Cosapilla', label: 'Cosapilla'},
      {value: 'Lake Titicaca', label: 'Lake Titicaca'},
      {value: 'Canete', label: 'Canete'},
      {value: 'Majes', label: 'Majes'},
      {value: 'Ocona', label: 'Ocona'},
      {value: 'Santa', label: 'Santa'},
      {value: 'Tumbes', label: 'Tumbes'},
      {value: 'Zarumilla', label: 'Zarumilla'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Philippines',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Pitcairn',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Poland',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Dniestr', label: 'Dniestr'},
      {value: 'Elbe River', label: 'Elbe River'},
      {value: 'Neman', label: 'Neman'},
      {value: 'Oder River', label: 'Oder River'},
      {value: 'Wisla', label: 'Wisla'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Portugal',
    options: [
      {value: 'Douro', label: 'Douro'},
      {value: 'Guadiana', label: 'Guadiana'},
      {value: 'Lima', label: 'Lima'},
      {value: 'Mino', label: 'Mino'},
      {value: 'Tejo', label: 'Tejo'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Puerto Rico',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Qatar',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Republic of Korea',
    options: [
      {value: 'Han-Gang (Han River)', label: 'Han-Gang (Han River)'},
      {value: 'Naktong', label: 'Naktong'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Republic of Moldova',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Dniestr', label: 'Dniestr'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Réunion',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Romania',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Russian Federation',
    options: [
      {value: 'Amur', label: 'Amur'},
      {value: 'Alazeya', label: 'Alazeya'},
      {value: 'Dniepr', label: 'Dniepr'},
      {value: 'Har us Nuur', label: 'Har us Nuur'},
      {value: 'Kem', label: 'Kem'},
      {value: 'Kemijoki', label: 'Kemijoki'},
      {value: 'Anabar', label: 'Anabar'},
      {value: 'Kuban', label: 'Kuban'},
      {value: 'Kura - Ozero Sevan', label: 'Kura - Ozero Sevan'},
      {value: 'Anadyr', label: 'Anadyr'},
      {value: 'Lake Ubsa', label: 'Lake Ubsa'},
      {value: 'Narva', label: 'Narva'},
      {value: 'Neman', label: 'Neman'},
      {value: 'Ob', label: 'Ob'},
      {value: 'Oulujoki', label: 'Oulujoki'},
      {value: 'Terek', label: 'Terek'},
      {value: 'Torghay', label: 'Torghay'},
      {value: 'Tuloma', label: 'Tuloma'},
      {value: 'Tumen', label: 'Tumen'},
      {value: 'Ural', label: 'Ural'},
      {value: 'Volga', label: 'Volga'},
      {value: 'Vuoksi - Neva', label: 'Vuoksi - Neva'},
      {value: 'Western Dvina (Daugava)', label: 'Western Dvina (Daugava)'},
      {value: 'Yenisei', label: 'Yenisei'},
      {value: 'Don', label: 'Don'},
      {value: 'Indigirka', label: 'Indigirka'},
      {value: 'Kamchatka', label: 'Kamchatka'},
      {value: 'Khatanga', label: 'Khatanga'},
      {value: 'Kolyma', label: 'Kolyma'},
      {value: 'Kovda', label: 'Kovda'},
      {value: 'Lake Taymur', label: 'Lake Taymur'},
      {value: 'Lena', label: 'Lena'},
      {value: 'Mezen', label: 'Mezen'},
      {value: 'Nadym', label: 'Nadym'},
      {value: 'Nizhny Vyg (Soroka)', label: 'Nizhny Vyg (Soroka)'},
      {
        value: 'Northern Dvina (Severnaya Dvina)',
        label: 'Northern Dvina (Severnaya Dvina)'
      },
      {value: 'Olenek', label: 'Olenek'},
      {value: 'Omoloy', label: 'Omoloy'},
      {value: 'Onega', label: 'Onega'},
      {value: 'Palyavaam', label: 'Palyavaam'},
      {value: 'Pechora', label: 'Pechora'},
      {value: 'Ponoy', label: 'Ponoy'},
      {value: 'Popigay', label: 'Popigay'},
      {value: 'Pur', label: 'Pur'},
      {value: 'Pyasina', label: 'Pyasina'},
      {value: 'Taz', label: 'Taz'},
      {value: 'Varzuga', label: 'Varzuga'},
      {value: 'Yana', label: 'Yana'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Rwanda',
    options: [
      {value: 'Congo', label: 'Congo'},
      {value: 'Nile', label: 'Nile'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saint Barthélemy',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saint Helena',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saint Kitts and Nevis',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saint Lucia',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saint Martin (French Part)',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saint Pierre and Miquelon',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saint Vincent and the Grenadines',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Samoa',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'San Marino',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Sao Tome and Principe',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Saudi Arabia',
    options: [
      {value: 'Dead Sea', label: 'Dead Sea'},
      {value: 'Shatt Al Arab', label: 'Shatt Al Arab'},
      {value: 'Tigris & Euphrates', label: 'Tigris & Euphrates'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Senegal',
    options: [
      {value: 'Gambia', label: 'Gambia'},
      {value: 'Geba', label: 'Geba'},
      {value: 'Senegal', label: 'Senegal'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Serbia',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Drin', label: 'Drin'},
      {value: 'Struma', label: 'Struma'},
      {value: 'Vardar', label: 'Vardar'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Seychelles',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Sierra Leone',
    options: [
      {value: 'Great Scarcies', label: 'Great Scarcies'},
      {value: 'Little Scarcies', label: 'Little Scarcies'},
      {value: 'Mano-Morro', label: 'Mano-Morro'},
      {value: 'Moa', label: 'Moa'},
      {value: 'Niger', label: 'Niger'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Singapore',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Sint Maarten (Dutch part)',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Slovakia',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Oder River', label: 'Oder River'},
      {value: 'Wisla', label: 'Wisla'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Slovenia',
    options: [
      {value: 'Danube', label: 'Danube'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Tijuana (Tia Juana)',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'United States Virgin Islands',
    options: [
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Uruguay',
    options: [
      {value: 'Chuy (Shu)', label: 'Chuy (Shu)'},
      {value: 'Lagoon Mirim', label: 'Lagoon Mirim'},
      {value: 'Negro (Uruguay)', label: 'Negro (Uruguay)'},
      {value: 'Rio De La Plata', label: 'Rio De La Plata'},
      {value: 'Uruguay', label: 'Uruguay'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },

  {
    label: 'Uzbekistan',

    options: [
      {value: 'Amu Darya', label: 'Amu Darya'},

      {value: 'Aral Drainage', label: 'Aral Drainage'},

      {value: 'Issyk-Kul', label: 'Issyk-Kul'},

      {value: 'Syr Darya', label: 'Syr Darya'},

      {value: 'Unknown', label: 'Unknown'},

      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },

  {
    label: 'Vanuatu',

    options: [
      {value: 'Unknown', label: 'Unknown'},

      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },

  {
    label: 'Venezuela (Bolivarian Republic of)',

    options: [
      {value: 'Amacuro (Amakura)', label: 'Amacuro (Amakura)'},

      {value: 'Amazonas', label: 'Amazonas'},

      {value: 'Barima', label: 'Barima'},

      {value: 'Catatumbo', label: 'Catatumbo'},

      {value: 'Cuyuni - Essequibo', label: 'Cuyuni - Essequibo'},

      {value: 'Magdalena', label: 'Magdalena'},

      {value: 'Orinoco', label: 'Orinoco'},

      {value: 'Unknown', label: 'Unknown'},

      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },

  {
    label: 'Viet Nam',

    options: [
      {value: 'Ca', label: 'Ca'},

      {value: 'Chao Phraya', label: 'Chao Phraya'},

      {value: 'Dong Nai', label: 'Dong Nai'},

      {value: 'Hong (Red River)', label: 'Hong (Red River)'},

      {value: 'Lam (Xongka)', label: 'Lam (Xongka)'},

      {value: 'Ma', label: 'Ma'},

      {value: 'Mekong', label: 'Mekong'},

      {value: 'Saigon', label: 'Saigon'},

      {value: 'Tranh (Nr Thu Bon)', label: 'Tranh (Nr Thu Bon)'},

      {value: 'Vam Co', label: 'Vam Co'},

      {value: 'Xi Jiang - Bei Jiang', label: 'Xi Jiang - Bei Jiang'},

      {value: 'Zhu', label: 'Zhu'},

      {value: 'Unknown', label: 'Unknown'},

      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },

  {
    label: 'Wallis and Futuna Islands',

    options: [
      {value: 'Unknown', label: 'Unknown'},

      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },

  {
    label: 'Western Sahara',

    options: [
      {value: 'Atoui', label: 'Atoui'},

      {value: 'Unknown', label: 'Unknown'},

      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },

  {
    label: 'Yemen',

    options: [
      {value: 'Tuban', label: 'Tuban'},

      {value: 'Unknown', label: 'Unknown'},

      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Zambia',
    options: [
      {value: 'Congo', label: 'Congo'},
      {value: 'Rukwa', label: 'Rukwa'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Zimbabwe',
    options: [
      {value: 'Buzi', label: 'Buzi'},
      {value: 'Limpopo', label: 'Limpopo'},
      {value: 'Okavango', label: 'Okavango'},
      {value: 'Pungwe (Pungoe)', label: 'Pungwe (Pungoe)'},
      {value: 'Save', label: 'Save'},
      {value: 'Zambezi', label: 'Zambezi'},
      {value: 'Unknown', label: 'Unknown'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  }
];

export const SCOPE_RECALCULATED_OPTIONS = [
  {value: 'Yes', label: 'Yes'},
  {
    value:
      'No, because we have not evaluated whether the changes should trigger a base year recalculation',
    label:
      'No, because we have not evaluated whether the changes should trigger a base year recalculation'
  },
  {
    value: 'No, because the impact does not meet our significance threshold',
    label: 'No, because the impact does not meet our significance threshold'
  },
  {
    value:
      'No, because the operations acquired or divested did not exist in the base year',
    label:
      'No, because the operations acquired or divested did not exist in the base year'
  },
  {
    value:
      'No, because we do not have the data yet and plan to recalculate next year',
    label:
      'No, because we do not have the data yet and plan to recalculate next year'
  }
];

export const SCOPE_OR_SCOPE_3_CATEGORY_OPTIONS = [
  {value: 'Scope 1', label: 'Scope 1'},
  {value: 'Scope 2 (location-based)', label: 'Scope 2 (location-based)'},
  {value: 'Scope 2 (market-based)', label: 'Scope 2 (market-based)'},
  {
    value: 'Scope 3: Purchased goods and services',
    label: 'Scope 3: Purchased goods and services'
  },
  {value: 'Scope 3: Capital goods', label: 'Scope 3: Capital goods'},
  {
    value:
      'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)',
    label:
      'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)'
  },
  {
    value: 'Scope 3: Upstream transportation and distribution',
    label: 'Scope 3: Upstream transportation and distribution'
  },
  {
    value: 'Scope 3: Waste generated in operations',
    label: 'Scope 3: Waste generated in operations'
  },
  {value: 'Scope 3: Business travel', label: 'Scope 3: Business travel'},
  {value: 'Scope 3: Employee commuting', label: 'Scope 3: Employee commuting'},
  {
    value: 'Scope 3: Upstream leased assets',
    label: 'Scope 3: Upstream leased assets'
  },
  {
    value: 'Scope 3: Downstream transportation and distribution',
    label: 'Scope 3: Downstream transportation and distribution'
  },
  {
    value: 'Scope 3: Processing of sold products',
    label: 'Scope 3: Processing of sold products'
  },
  {
    value: 'Scope 3: Use of sold products',
    label: 'Scope 3: Use of sold products'
  },
  {
    value: 'Scope 3: End-of-life treatment of sold products',
    label: 'Scope 3: End-of-life treatment of sold products'
  },
  {
    value: 'Scope 3: Downstream leased assets',
    label: 'Scope 3: Downstream leased assets'
  },
  {value: 'Scope 3: Franchises', label: 'Scope 3: Franchises'},
  {
    value: 'Scope 3: Investments [hidden for FS sector companies]',
    label: 'Scope 3: Investments [hidden for FS sector companies]'
  },
  {value: 'Scope 3: Other (upstream)', label: 'Scope 3: Other (upstream)'},
  {value: 'Scope 3: Other (downstream)', label: 'Scope 3: Other (downstream)'}
];

export const RELEVANCE_OF_SCOPE_OPTIONS = [
  {value: 'Emissions are not relevant', label: 'Emissions are not relevant'},
  {
    value: 'Emissions are relevant but not yet calculated',
    label: 'Emissions are relevant but not yet calculated'
  },
  {
    value: 'Emissions are relevant and calculated, but not disclosed',
    label: 'Emissions are relevant and calculated, but not disclosed'
  },
  {
    value: 'Emissions excluded due to a recent acquisition or merger',
    label: 'Emissions excluded due to a recent acquisition or merger'
  },
  {value: 'Emissions are not evaluated', label: 'Emissions are not evaluated'}
];

export const SCOPE_3_CATEGORY_OPTIONS = [
  {
    value: 'Purchased goods and services',
    label: 'Purchased goods and services'
  },
  {value: 'Capital goods', label: 'Capital goods'},
  {
    value: 'Fuel- and energy-related activities (not included in Scope 1 or 2)',
    label: 'Fuel- and energy-related activities (not included in Scope 1 or 2)'
  },
  {
    value: 'Upstream transportation and distribution',
    label: 'Upstream transportation and distribution'
  },
  {
    value: 'Waste generated in operations',
    label: 'Waste generated in operations'
  },
  {value: 'Business travel', label: 'Business travel'},
  {value: 'Employee commuting', label: 'Employee commuting'},
  {value: 'Upstream leased assets', label: 'Upstream leased assets'},
  {
    value: 'Downstream transportation and distribution',
    label: 'Downstream transportation and distribution'
  },
  {value: 'Processing of sold products', label: 'Processing of sold products'},
  {value: 'Use of sold products', label: 'Use of sold products'},
  {
    value: 'End-of-life treatment of sold products',
    label: 'End-of-life treatment of sold products'
  },
  {value: 'Downstream leased assets', label: 'Downstream leased assets'},
  {value: 'Franchises', label: 'Franchises'},
  {
    value:
      'Investments [row hidden for FS sector companies, data point requested in 12.1.1]',
    label:
      'Investments [row hidden for FS sector companies, data point requested in 12.1.1]'
  },
  {value: 'Other (upstream)', label: 'Other (upstream)'},
  {value: 'Other (downstream)', label: 'Other (downstream)'}
];

export const EVALUATION_STATUS_OPTIONS = [
  {value: 'Relevant, calculated', label: 'Relevant, calculated'},
  {
    value: 'Relevant, not yet calculated',
    label: 'Relevant, not yet calculated'
  },
  {value: 'Not relevant, calculated', label: 'Not relevant, calculated'},
  {
    value: 'Not relevant, explanation provided',
    label: 'Not relevant, explanation provided'
  },
  {value: 'Not evaluated', label: 'Not evaluated'}
];

export const EMISSIONS_CALCULATION_METHODOLOGY_OPTIONS = [
  {value: 'Asset-specific method', label: 'Asset-specific method'},
  {value: 'Average data method', label: 'Average data method'},
  {value: 'Average product method', label: 'Average product method'},
  {value: 'Average spend-based method', label: 'Average spend-based method'},
  {value: 'Distance-based method', label: 'Distance-based method'},
  {value: 'Franchise-specific method', label: 'Franchise-specific method'},
  {value: 'Fuel-based method', label: 'Fuel-based method'},
  {value: 'Hybrid method', label: 'Hybrid method'},
  {value: 'Investment-specific method', label: 'Investment-specific method'},
  {value: 'Lessor-specific method', label: 'Lessor-specific method'},
  {value: 'Site-specific method', label: 'Site-specific method'},
  {value: 'Spend-based method', label: 'Spend-based method'},
  {value: 'Supplier-specific method', label: 'Supplier-specific method'},
  {value: 'Waste-type-specific method', label: 'Waste-type-specific method'},
  {
    value: 'Methodology for direct use phase emissions, please specify',
    label: 'Methodology for direct use phase emissions, please specify'
  },
  {
    value: 'Methodology for indirect use phase emissions, please specify',
    label: 'Methodology for indirect use phase emissions, please specify'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const VERIFICATION_ASSURANCE_STATUS = [
  {value: 'No emissions data provided', label: 'No emissions data provided'},
  {
    value: 'No third-party verification or assurance',
    label: 'No third-party verification or assurance'
  },
  {
    value: 'Third-party verification or assurance process in place',
    label: 'Third-party verification or assurance process in place'
  }
];

export const VERIFICATION_ASSURANCE_CYCLE_OPTIONS = [
  {value: 'Annual process', label: 'Annual process'},
  {value: 'Biennial process', label: 'Biennial process'},
  {value: 'Triennial process', label: 'Triennial process'}
];

export const STATUS_IN_CURRENT_REPORTING_YEAR_OPTIONS = [
  {
    value: 'No verification or assurance of current reporting year',
    label: 'No verification or assurance of current reporting year'
  },
  {
    value:
      'Underway but not complete for current reporting year - first year it has taken place',
    label:
      'Underway but not complete for current reporting year - first year it has taken place'
  },
  {
    value:
      'Underway but not complete for reporting year - previous statement of process attached',
    label:
      'Underway but not complete for reporting year - previous statement of process attached'
  },
  {value: 'Complete', label: 'Complete'}
];

export const VERIFICATION_ASSURANCE_TYPE_OPTIONS = [
  {value: 'Not applicable', label: 'Not applicable'},
  {value: 'Limited assurance', label: 'Limited assurance'},
  {value: 'Moderate assurance', label: 'Moderate assurance'},
  {value: 'Reasonable assurance', label: 'Reasonable assurance'},
  {value: 'High assurance', label: 'High assurance'},
  {
    value: 'Third party verification/assurance underway',
    label: 'Third party verification/assurance underway'
  }
];

export const RELEVANT_STANDARD_OPTIONS = [
  {value: 'AA1000AS', label: 'AA1000AS'},
  {
    value:
      'ABNT NBR ISO 14064-3:2007 (Associação Brasileira de Normas Técnicas)',
    label:
      'ABNT NBR ISO 14064-3:2007 (Associação Brasileira de Normas Técnicas)'
  },
  {
    value:
      'Advanced technologies promotion Subsidy Scheme with Emission reduction Target (ASSET)',
    label:
      'Advanced technologies promotion Subsidy Scheme with Emission reduction Target (ASSET)'
  },
  {
    value:
      'Airport Carbon Accreditation (ACA) des Airports Council International Europe',
    label:
      'Airport Carbon Accreditation (ACA) des Airports Council International Europe'
  },
  {
    value: 'Alberta Technology Innovation and Emissions Reduction (TIER)',
    label: 'Alberta Technology Innovation and Emissions Reduction (TIER)'
  },
  {value: 'ASAE3000', label: 'ASAE3000'},
  {
    value: 'Attestation standards established by AICPA (AT105)',
    label: 'Attestation standards established by AICPA (AT105)'
  },
  {
    value: 'Australian National GHG emission regulation (NGER)',
    label: 'Australian National GHG emission regulation (NGER)'
  },
  {
    value: 'California Mandatory GHG Reporting Regulations (CARB)',
    label: 'California Mandatory GHG Reporting Regulations (CARB)'
  },
  {
    value:
      'Canadian Institute of Chartered Accountants (CICA) Handbook: Assurance Section 5025',
    label:
      'Canadian Institute of Chartered Accountants (CICA) Handbook: Assurance Section 5025'
  },
  {value: 'Carbon Trust Standard', label: 'Carbon Trust Standard'},
  {
    value: 'Chicago Climate Exchange (CCX) verification standard',
    label: 'Chicago Climate Exchange (CCX) verification standard'
  },
  {
    value: `The Climate ${'Registry'}'s General Verification Protocol (also known as California Climate Action Registry (CCAR))`,
    label: `The Climate ${'Registry'}'s General Verification Protocol (also known as California Climate Action Registry (CCAR))`
  },
  {
    value: 'Compagnie Nationale des Commissaires aux Comptes (CNCC)',
    label: 'Compagnie Nationale des Commissaires aux Comptes (CNCC)'
  },
  {
    value: 'Corporate GHG verification guidelines from ERT',
    label: 'Corporate GHG verification guidelines from ERT'
  },
  {
    value:
      'DNV VeriSustain Protocol/Verification Protocol for Sustainability Reporting',
    label:
      'DNV VeriSustain Protocol/Verification Protocol for Sustainability Reporting'
  },
  {value: 'Dutch Standard 3000A', label: 'Dutch Standard 3000A'},
  {value: 'Earthcheck Certification', label: 'Earthcheck Certification'},
  {
    value: 'ERM GHG Performance Data Assurance Methodology',
    label: 'ERM GHG Performance Data Assurance Methodology'
  },
  {
    value: 'European Union Emissions Trading System (EU ETS)',
    label: 'European Union Emissions Trading System (EU ETS)'
  },
  {
    value:
      'IDW PS 821: IDW Prüfungsstandard: Grundsätze ordnungsmäßiger Prüfung oder prüferischer Durchsicht von Berichten im Bereich der Nachhaltigkeit',
    label:
      'IDW PS 821: IDW Prüfungsstandard: Grundsätze ordnungsmäßiger Prüfung oder prüferischer Durchsicht von Berichten im Bereich der Nachhaltigkeit'
  },
  {
    value:
      'IDW AsS 821: IDW Assurance Standard: Generally Accepted Assurance Principles for the Audit or Review of Reports on Sustainability Issues',
    label:
      'IDW AsS 821: IDW Assurance Standard: Generally Accepted Assurance Principles for the Audit or Review of Reports on Sustainability Issues'
  },
  {value: 'ISAE3000', label: 'ISAE3000'},
  {value: 'ISAE 3410', label: 'ISAE 3410'},
  {value: 'ISO14064-1', label: 'ISO14064-1'},
  {value: 'ISO14064-3', label: 'ISO14064-3'},
  {
    value:
      'Japan voluntary emissions trading scheme (JVETS) guideline for verification',
    label:
      'Japan voluntary emissions trading scheme (JVETS) guideline for verification'
  },
  {
    value: 'Korean GHG and energy target management system',
    label: 'Korean GHG and energy target management system'
  },
  {
    value:
      'NMX-SAA-14064-3-IMNC: Instituto Mexicano de Normalización y Certificación A.C',
    label:
      'NMX-SAA-14064-3-IMNC: Instituto Mexicano de Normalización y Certificación A.C'
  },
  {
    value: 'RevR6 procedure for assurance of sustainability report',
    label: 'RevR6 procedure for assurance of sustainability report'
  },
  {
    value: 'Saitama Prefecture Target-Setting Emissions Trading Program',
    label: 'Saitama Prefecture Target-Setting Emissions Trading Program'
  },
  {
    value: 'SGS Sustainability Report Assurance',
    label: 'SGS Sustainability Report Assurance'
  },
  {
    value: 'Spanish Institute of Registered Auditors (ICJCE)',
    label: 'Spanish Institute of Registered Auditors (ICJCE)'
  },
  {value: 'SSAE 3000', label: 'SSAE 3000'},
  {
    value:
      'Standard 3810N Assurance engagements relating to sustainability reports of the Royal Netherlands Institute of Registered Accountants',
    label:
      'Standard 3810N Assurance engagements relating to sustainability reports of the Royal Netherlands Institute of Registered Accountants'
  },
  {
    value:
      'State of Israel Ministry of Environmental Protection, Verification of GHG and emissions reduction in Israel Guidance Document',
    label:
      'State of Israel Ministry of Environmental Protection, Verification of GHG and emissions reduction in Israel Guidance Document'
  },
  {
    value: 'Swiss Climate CO2 Label for Businesses',
    label: 'Swiss Climate CO2 Label for Businesses'
  },
  {
    value:
      'Thai Greenhouse Gas Management Organisation (TGO) Greenhouse Gas (GHG) Verification Protocol',
    label:
      'Thai Greenhouse Gas Management Organisation (TGO) Greenhouse Gas (GHG) Verification Protocol'
  },
  {
    value: 'Toitū Envirocare’s carbonreduce certification standard',
    label: 'Toitū Envirocare’s carbonreduce certification standard'
  },
  {
    value: 'Tokyo Emissions Trading Scheme',
    label: 'Tokyo Emissions Trading Scheme'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const SCOPE_3_CATEGORY_OPTIONS_2 = [
  {
    value: 'Scope 3: Purchased goods and services',
    label: 'Scope 3: Purchased goods and services'
  },
  {value: 'Scope 3: Capital goods', label: 'Scope 3: Capital goods'},
  {
    value:
      'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)',
    label:
      'Scope 3: Fuel and energy-related activities (not included in Scopes 1 or 2)'
  },
  {
    value: 'Scope 3: Upstream transportation and distribution',
    label: 'Scope 3: Upstream transportation and distribution'
  },
  {
    value: 'Scope 3: Waste generated in operations',
    label: 'Scope 3: Waste generated in operations'
  },
  {value: 'Scope 3: Business travel', label: 'Scope 3: Business travel'},
  {value: 'Scope 3: Employee commuting', label: 'Scope 3: Employee commuting'},
  {
    value: 'Scope 3: Upstream leased assets',
    label: 'Scope 3: Upstream leased assets'
  },
  {value: 'Scope 3: Investments', label: 'Scope 3: Investments'},
  {
    value: 'Scope 3: Downstream transportation and distribution',
    label: 'Scope 3: Downstream transportation and distribution'
  },
  {
    value: 'Scope 3: Processing of sold products',
    label: 'Scope 3: Processing of sold products'
  },
  {
    value: 'Scope 3: Use of sold products',
    label: 'Scope 3: Use of sold products'
  },
  {
    value: 'Scope 3: End-of-life treatment of sold products',
    label: 'Scope 3: End-of-life treatment of sold products'
  },
  {
    value: 'Scope 3: Downstream leased assets',
    label: 'Scope 3: Downstream leased assets'
  },
  {value: 'Scope 3: Franchises', label: 'Scope 3: Franchises'}
];

export const GLOBAL_EMISSIONS_COMPARISON_OPTIONS = [
  {value: 'Increased', label: 'Increased'},
  {value: 'Decreased', label: 'Decreased'},
  {value: 'Remained the same overall', label: 'Remained the same overall'},
  {
    value:
      'This is our first year of reporting, so we cannot compare to last year',
    label:
      'This is our first year of reporting, so we cannot compare to last year'
  },
  {
    value: 'We don’t have any emissions data',
    label: 'We don’t have any emissions data'
  }
];

export const SCOPE_2_EMISSIONS_COMPARISON_OPTIONS = [
  {value: 'Location-based', label: 'Location-based'},
  {value: 'Market-based', label: 'Market-based'},
  {value: 'Dont know', label: 'Dont know'}
];

export const SCOPE_3_EMISSIONS_COMPARISON_OPTIONS = [
  {value: 'Increased', label: 'Increased'},
  {value: 'Decreased', label: 'Decreased'},
  {value: 'Remained the same overall', label: 'Remained the same overall'},
  {
    value: 'This is our first year of reporting',
    label: 'This is our first year of reporting'
  },
  {
    value: 'We don’t have any Scope 3 emissions data',
    label: 'We don’t have any Scope 3 emissions data'
  }
];

export const DIRECTION_OF_CHANGE_OPTIONS = [
  {value: 'Increased', label: 'Increased'},
  {value: 'Decreased', label: 'Decreased'},
  {value: 'No change', label: 'No change'},
  {
    value: 'First year of reporting this category',
    label: 'First year of reporting this category'
  }
];

export const PRIMARY_REASON_FOR_CHANGE_OPTIONS = [
  {
    value: 'Change in renewable energy consumption',
    label: 'Change in renewable energy consumption'
  },
  {
    value: 'Change in renewable energy generation',
    label: 'Change in renewable energy generation'
  },
  {
    value: 'Change in product efficiency',
    label: 'Change in product efficiency'
  },
  {
    value: 'Change in material efficiency',
    label: 'Change in material efficiency'
  },
  {
    value: 'Change in supplier or distributor',
    label: 'Change in supplier or distributor'
  },
  {
    value: 'Other emissions reduction activities',
    label: 'Other emissions reduction activities'
  },
  {value: 'Divestment', label: 'Divestment'},
  {value: 'Acquisitions', label: 'Acquisitions'},
  {value: 'Mergers', label: 'Mergers'},
  {value: 'Change in output', label: 'Change in output'},
  {value: 'Change in methodology', label: 'Change in methodology'},
  {value: 'Change in boundary', label: 'Change in boundary'},
  {
    value: 'Change in physical operating conditions',
    label: 'Change in physical operating conditions'
  },
  {value: 'Unidentified', label: 'Unidentified'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METHODOLOGY_OPTIONS = [
  {value: 'Default emissions factors', label: 'Default emissions factors'},
  {
    value: 'Region-specific emissions factors',
    label: 'Region-specific emissions factors'
  },
  {value: 'Empirical models', label: 'Empirical models'},
  {value: 'Process-based models', label: 'Process-based models'},
  {value: 'Field measurements', label: 'Field measurements'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const GHG_EMISSIONS_FOR_COMMODITY_OPTIONS = [
  {value: 'Yes', label: 'Yes'},
  {
    value: 'No, but we intend to calculate this data within the next two years',
    label: 'No, but we intend to calculate this data within the next two years'
  },
  {
    value:
      'No, and we do not intend to calculate this data within the next two years',
    label:
      'No, and we do not intend to calculate this data within the next two years'
  }
];

export const DENOMINATOR_OPTIONS = [
  {value: 'Kilograms', label: 'Kilograms'},
  {value: 'Liters', label: 'Liters'},
  {value: 'Metric tons', label: 'Metric tons'},
  {value: 'Unit of product', label: 'Unit of product'},
  {value: 'Unit of revenue', label: 'Unit of revenue'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS = [
  {value: 'Much lower', label: 'Much lower'},
  {value: 'Lower', label: 'Lower'},
  {value: 'About the same', label: 'About the same'},
  {value: 'Higher', label: 'Higher'},
  {value: 'Much higher', label: 'Much higher'},
  {
    value: 'This is our first year of measurement',
    label: 'This is our first year of measurement'
  }
];

export const GREENHOUSE_GAS_TYPE_OPTIONS = [
  {value: 'CO2', label: 'CO2'},
  {value: 'CH4', label: 'CH4'},
  {value: 'N2O', label: 'N2O'},
  {value: 'HFCs', label: 'HFCs'},
  {value: 'PFCs', label: 'PFCs'},
  {value: 'SF6', label: 'SF6'},
  {value: 'NF3', label: 'NF3'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const GWP_REFERENCE_OPTIONS = [
  {
    value: 'IPCC Sixth Assessment Report (AR6 – 100 year)',
    label: 'IPCC Sixth Assessment Report (AR6 – 100 year)'
  },
  {
    value: 'IPCC Fifth Assessment Report (AR5 – 100 year)',
    label: 'IPCC Fifth Assessment Report (AR5 – 100 year)'
  },
  {
    value: 'IPCC Fourth Assessment Report (AR4 - 100 year)',
    label: 'IPCC Fourth Assessment Report (AR4 - 100 year)'
  },
  {
    value: 'IPCC Third Assessment Report (TAR - 100 year)',
    label: 'IPCC Third Assessment Report (TAR - 100 year)'
  },
  {
    value: 'IPCC Second Assessment Report (SAR - 100 year)',
    label: 'IPCC Second Assessment Report (SAR - 100 year)'
  },
  {
    value: 'IPCC Sixth Assessment Report (AR6 – 20 year)',
    label: 'IPCC Sixth Assessment Report (AR6 – 20 year)'
  },
  {
    value: 'IPCC Fifth Assessment Report (AR5 – 20 year)',
    label: 'IPCC Fifth Assessment Report (AR5 – 20 year)'
  },
  {
    value: 'IPCC Fourth Assessment Report (AR4 - 20 year)',
    label: 'IPCC Fourth Assessment Report (AR4 - 20 year)'
  },
  {
    value: 'IPCC Third Assessment Report (TAR - 20 year)',
    label: 'IPCC Third Assessment Report (TAR - 20 year)'
  },
  {
    value: 'IPCC Second Assessment Report (SAR - 20 year)',
    label: 'IPCC Second Assessment Report (SAR - 20 year)'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const EMISSIONS_CATEGORY_OPTIONS = [
  {
    value: 'Combustion (excluding flaring)',
    label: 'Combustion (excluding flaring)'
  },
  {value: 'Flaring', label: 'Flaring'},
  {value: 'Venting', label: 'Venting'},
  {value: 'Fugitives', label: 'Fugitives'},
  {
    value: 'Process (feedstock) emissions',
    label: 'Process (feedstock) emissions'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const VALUE_CHAIN_OPTIONS = [
  {value: 'Upstream', label: 'Upstream'},
  {value: 'Midstream', label: 'Midstream'},
  {value: 'Downstream', label: 'Downstream'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRODUCT_OPTIONS = [
  {value: 'Oil', label: 'Oil'},
  {value: 'Gas', label: 'Gas'},
  {value: 'Unable to disaggregate', label: 'Unable to disaggregate'}
];

export const ACTIVITY_OPTIONS = [
  {value: 'Production', label: 'Production'},
  {value: 'Processing / Manufacturing', label: 'Processing / Manufacturing'},
  {value: 'Distribution', label: 'Distribution'},
  {value: 'Consumption', label: 'Consumption'},
  {value: 'Agricultural / Forestry', label: 'Agricultural / Forestry'}
];

export const EMISSIONS_CATEGORY_MECHANICAL_OPTIONS = [
  {value: 'Non-mechanical', label: 'Non-mechanical'},
  {value: 'Land use change', label: 'Land use change'},
  {value: 'Mechanical', label: 'Mechanical'},
  {value: 'Total', label: 'Total'}
];

export const SECTOR_PRODUCTION_ACTIVITY_OPTIONS = [
  {
    value: 'Cement production activities',
    label: 'Cement production activities'
  },
  {
    value: 'Chemicals production activities',
    label: 'Chemicals production activities'
  },
  {value: 'Coal production activities', label: 'Coal production activities'},
  {value: 'Electric utility activities', label: 'Electric utility activities'},
  {
    value: 'Metals and mining production activities',
    label: 'Metals and mining production activities'
  },
  {
    value: 'Oil and gas production activities (upstream)',
    label: 'Oil and gas production activities (upstream)'
  },
  {
    value: 'Oil and gas production activities (midstream)',
    label: 'Oil and gas production activities (midstream)'
  },
  {
    value: 'Oil and gas production activities (downstream)',
    label: 'Oil and gas production activities (downstream)'
  },
  {value: 'Steel production activities', label: 'Steel production activities'},
  {value: 'Transport OEM activities', label: 'Transport OEM activities'},
  {
    value: 'Transport services activities',
    label: 'Transport services activities'
  }
];

export const SCOPE_EMISSIONS_BREAKDOWN_OPTIONS = [
  {value: 'By business division', label: 'By business division'},
  {value: 'By facility', label: 'By facility'},
  {value: 'By activity', label: 'By activity'}
];

export const OIL_AND_GAS_BUSINESS_DIVISION_OPTIONS = [
  {value: 'Upstream', label: 'Upstream'},
  {value: 'Midstream', label: 'Midstream'},
  {value: 'Downstream', label: 'Downstream'},
  {value: 'Chemicals', label: 'Chemicals'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const OBSERVATIONAL_DATA_OPTIONS = [
  {value: 'Observational data only', label: 'Observational data only'},
  {
    value: 'Both observational data and estimated or modelled data',
    label: 'Both observational data and estimated or modelled data'
  },
  {
    value: 'Estimated or modelled data only',
    label: 'Estimated or modelled data only'
  }
];

export const PURCHASED_FEEDSTOCK_OPTIONS = [
  {
    value: 'High Value Chemicals (Steam cracking)',
    label: 'High Value Chemicals (Steam cracking)'
  },
  {value: 'Ammonia', label: 'Ammonia'},
  {value: 'Aromatics extraction', label: 'Aromatics extraction'},
  {value: 'Methanol', label: 'Methanol'},
  {value: 'Butylene', label: 'Butylene'},
  {value: 'Propylene (FCC)', label: 'Propylene (FCC)'},
  {value: 'Ethanol', label: 'Ethanol'},
  {value: 'Butadiene (C4 sep.)', label: 'Butadiene (C4 sep.)'},
  {value: 'Nitric acid', label: 'Nitric acid'},
  {value: 'Adipic acid', label: 'Adipic acid'},
  {value: 'Caprolactam', label: 'Caprolactam'},
  {value: 'Soda ash', label: 'Soda ash'},
  {value: 'Carbon black', label: 'Carbon black'},
  {value: 'Polymers', label: 'Polymers'},
  {value: 'Specialty chemicals', label: 'Specialty chemicals'},
  {value: 'Other base chemicals', label: 'Other base chemicals'},
  {value: 'Anthracite', label: 'Anthracite'},
  {value: 'Coal', label: 'Coal'},
  {value: 'Lignite', label: 'Lignite'},
  {value: 'Coke', label: 'Coke'},
  {value: 'Patent fuel / BKB', label: 'Patent fuel / BKB'},
  {value: 'Petroleum coke', label: 'Petroleum coke'},
  {value: 'Diesel oil', label: 'Diesel oil'},
  {value: 'Gas oil', label: 'Gas oil'},
  {value: 'Heavy fuel oil', label: 'Heavy fuel oil'},
  {value: 'Oil shale', label: 'Oil shale'},
  {value: 'Gasoline', label: 'Gasoline'},
  {value: 'White Spirit / SBP', label: 'White Spirit / SBP'},
  {value: 'Lubricants', label: 'Lubricants'},
  {value: 'Naphtha', label: 'Naphtha'},
  {value: 'Special Naphtha', label: 'Special Naphtha'},
  {value: 'Propane liquid', label: 'Propane liquid'},
  {value: 'Propane gas', label: 'Propane gas'},
  {value: 'Ethane', label: 'Ethane'},
  {value: 'Butane', label: 'Butane'},
  {value: 'LPG', label: 'LPG'},
  {value: 'Refinery gas', label: 'Refinery gas'},
  {value: 'Natural gas', label: 'Natural gas'},
  {value: 'Solid biomass', label: 'Solid biomass'},
  {value: 'Liquid biofuel', label: 'Liquid biofuel'},
  {value: 'Waste biofuel', label: 'Waste biofuel'},
  {value: 'Biogas', label: 'Biogas'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const OUTPUT_PRODUCT_OPTIONS = [
  {value: 'Carbon dioxide (CO₂)', label: 'Carbon dioxide (CO₂)'},
  {value: 'Methane (CH₄)', label: 'Methane (CH₄)'},
  {value: 'Nitrous oxide (N₂O)', label: 'Nitrous oxide (N₂O)'},
  {value: 'Hydrofluorocarbons (HFC)', label: 'Hydrofluorocarbons (HFC)'},
  {value: 'Perfluorocarbons (PFC)', label: 'Perfluorocarbons (PFC)'},
  {value: 'Sulphur hexafluoride (SF₆)', label: 'Sulphur hexafluoride (SF₆)'},
  {value: 'Nitrogen trifluoride (NF₃)', label: 'Nitrogen trifluoride (NF₃)'}
];

export const SCOPE_OF_EMISSIONS_OPTIONS = [
  {value: 'Scope 1', label: 'Scope 1'},
  {value: 'Scope 2: location-based', label: 'Scope 2: location-based'},
  {value: 'Scope 2: market-based', label: 'Scope 2: market-based'},
  {value: 'Scope 3', label: 'Scope 3'}
];

export const SCOPE_3_CATEGORIES_OPTIONS = [
  {
    value: 'Category 1: Purchased goods and services',
    label: 'Category 1: Purchased goods and services'
  },
  {value: 'Category 2: Capital goods', label: 'Category 2: Capital goods'},
  {
    value:
      'Category 3: Fuel- and energy-related activities (not included in Scopes 1 or 2)',
    label:
      'Category 3: Fuel- and energy-related activities (not included in Scopes 1 or 2)'
  },
  {
    value: 'Category 4: Upstream transportation and distribution',
    label: 'Category 4: Upstream transportation and distribution'
  },
  {
    value: 'Category 5: Waste generated in operations',
    label: 'Category 5: Waste generated in operations'
  },
  {value: 'Category 6: Business travel', label: 'Category 6: Business travel'},
  {
    value: 'Category 7: Employee commuting',
    label: 'Category 7: Employee commuting'
  },
  {
    value: 'Category 8: Upstream leased assets',
    label: 'Category 8: Upstream leased assets'
  },
  {
    value: 'Category 9: Downstream transportation and distribution',
    label: 'Category 9: Downstream transportation and distribution'
  },
  {
    value: 'Category 10: Processing of sold products',
    label: 'Category 10: Processing of sold products'
  },
  {
    value: 'Category 11: Use of sold products',
    label: 'Category 11: Use of sold products'
  },
  {
    value: 'Category 12: End-of-life treatment of sold products',
    label: 'Category 12: End-of-life treatment of sold products'
  },
  {
    value: 'Category 13: Downstream leased assets',
    label: 'Category 13: Downstream leased assets'
  },
  {value: 'Category 14: Franchises', label: 'Category 14: Franchises'},
  {value: 'Category 15: Investments', label: 'Category 15: Investments'},
  {value: 'Other (upstream)', label: 'Other (upstream)'},
  {value: 'Other (downstream)', label: 'Other (downstream)'}
];

export const ALLOCATION_LEVEL_OPTIONS = [
  {value: 'Company-wide', label: 'Company-wide'},
  {
    value: 'Business unit (subsidiary company)',
    label: 'Business unit (subsidiary company)'
  },
  {value: 'Facility', label: 'Facility'},
  {value: 'Commodity', label: 'Commodity'}
];

export const ALLOCATION_METHOD_OPTIONS = [
  {
    value: 'Allocation not necessary due to type of primary data available',
    label: 'Allocation not necessary due to type of primary data available'
  },
  {
    value: 'Allocation not necessary as secondary data used',
    label: 'Allocation not necessary as secondary data used'
  },
  {
    value: 'Allocation based on mass of products purchased',
    label: 'Allocation based on mass of products purchased'
  },
  {
    value: 'Allocation based on the volume of products purchased',
    label: 'Allocation based on the volume of products purchased'
  },
  {
    value: 'Allocation based on the energy content of products purchased',
    label: 'Allocation based on the energy content of products purchased'
  },
  {
    value: 'Allocation based on the chemical content of products purchased',
    label: 'Allocation based on the chemical content of products purchased'
  },
  {
    value: 'Allocation based on the number of units purchased',
    label: 'Allocation based on the number of units purchased'
  },
  {value: 'Allocation based on area', label: 'Allocation based on area'},
  {
    value: 'Allocation based on another physical factor',
    label: 'Allocation based on another physical factor'
  },
  {
    value: 'Allocation based on the market value of products purchased',
    label: 'Allocation based on the market value of products purchased'
  },
  {
    value: 'Other allocation method, please specify',
    label: 'Other allocation method, please specify'
  }
];

export const UNIT_FOR_MARKET_VALUE_OR_QUANTITY_OF_GOODS_SERVICES_SUPPLIED_OPTIONS =
  [
    {value: 'Currency', label: 'Currency'},
    {value: 'Kilograms', label: 'Kilograms'},
    {value: 'Pounds (lb)', label: 'Pounds (lb)'},
    {value: 'Metric tons', label: 'Metric tons'},
    {value: 'Gallons', label: 'Gallons'},
    {value: 'Liters', label: 'Liters'},
    {value: 'Cubic feet', label: 'Cubic feet'},
    {value: 'Cubic meters', label: 'Cubic meters'},
    {value: 'Square meters', label: 'Square meters'},
    {value: 'Hectares', label: 'Hectares'},
    {value: 'Megawatt hours (MWh)', label: 'Megawatt hours (MWh)'},
    {
      value: 'Full time equivalents (FTE)',
      label: 'Full time equivalents (FTE)'
    },
    {value: 'Hours', label: 'Hours'},
    {value: 'Kilometers', label: 'Kilometers'},
    {value: 'Passenger kilometers', label: 'Passenger kilometers'},
    {value: 'Other unit, please specify', label: 'Other unit, please specify'}
  ];

export const ALLOCATION_CHALLENGES_OPTIONS = [
  {
    value:
      'Diversity of product lines makes accurately accounting for each product/product line cost ineffective',
    label:
      'Diversity of product lines makes accurately accounting for each product/product line cost ineffective'
  },
  {
    value:
      'Customer base is too large and diverse to accurately track emissions to the customer level',
    label:
      'Customer base is too large and diverse to accurately track emissions to the customer level'
  },
  {
    value:
      'Managing the different emission factors of diverse and numerous geographies makes calculating total footprint difficult',
    label:
      'Managing the different emission factors of diverse and numerous geographies makes calculating total footprint difficult'
  },
  {
    value:
      'Doing so would require we disclose business sensitive/proprietary information',
    label:
      'Doing so would require we disclose business sensitive/proprietary information'
  },
  {value: 'We face no challenges', label: 'We face no challenges'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRIMARY_REASON_FOR_NO_PLANS_TO_DEVELOP_CAPABILITIES_TO_ALLOCATE_EMISSIONS_TO_CUSTOMERS_OPTIONS =
  [
    {
      value:
        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
      label:
        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
    },
    {value: 'No standardized procedure', label: 'No standardized procedure'},
    {
      value: 'Not an immediate strategic priority',
      label: 'Not an immediate strategic priority'
    },
    {
      value: 'Judged to be unimportant or not relevant',
      label: 'Judged to be unimportant or not relevant'
    },
    {
      value:
        'Capabilities to allocate emissions to customers already maximized',
      label: 'Capabilities to allocate emissions to customers already maximized'
    },
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const PERCENTAGE_OF_TOTAL_OPERATIONAL_SPEND_ON_ENERGY_OPTIONS = [
  {value: '0%', label: '0%'},
  {
    value: 'More than 0% but less than or equal to 5%',
    label: 'More than 0% but less than or equal to 5%'
  },
  {
    value: 'More than 5% but less than or equal to 10%',
    label: 'More than 5% but less than or equal to 10%'
  },
  {
    value: 'More than 10% but less than or equal to 15%',
    label: 'More than 10% but less than or equal to 15%'
  },
  {
    value: 'More than 15% but less than or equal to 20%',
    label: 'More than 15% but less than or equal to 20%'
  },
  {
    value: 'More than 20% but less than or equal to 25%',
    label: 'More than 20% but less than or equal to 25%'
  },
  {
    value: 'More than 25% but less than or equal to 30%',
    label: 'More than 25% but less than or equal to 30%'
  },
  {
    value: 'More than 30% but less than or equal to 35%',
    label: 'More than 30% but less than or equal to 35%'
  },
  {
    value: 'More than 35% but less than or equal to 40%',
    label: 'More than 35% but less than or equal to 40%'
  },
  {
    value: 'More than 40% but less than or equal to 45%',
    label: 'More than 40% but less than or equal to 45%'
  },
  {
    value: 'More than 45% but less than or equal to 50%',
    label: 'More than 45% but less than or equal to 50%'
  },
  {
    value: 'More than 50% but less than or equal to 55%',
    label: 'More than 50% but less than or equal to 55%'
  },
  {
    value: 'More than 55% but less than or equal to 60%',
    label: 'More than 55% but less than or equal to 60%'
  },
  {
    value: 'More than 60% but less than or equal to 65%',
    label: 'More than 60% but less than or equal to 65%'
  },
  {
    value: 'More than 65% but less than or equal to 70%',
    label: 'More than 65% but less than or equal to 70%'
  },
  {
    value: 'More than 70% but less than or equal to 75%',
    label: 'More than 70% but less than or equal to 75%'
  },
  {
    value: 'More than 75% but less than or equal to 80%',
    label: 'More than 75% but less than or equal to 80%'
  },
  {
    value: 'More than 80% but less than or equal to 85%',
    label: 'More than 80% but less than or equal to 85%'
  },
  {
    value: 'More than 85% but less than or equal to 90%',
    label: 'More than 85% but less than or equal to 90%'
  },
  {
    value: 'More than 90% but less than or equal to 95%',
    label: 'More than 90% but less than or equal to 95%'
  },
  {
    value: 'More than 95% but less than or equal to 100%',
    label: 'More than 95% but less than or equal to 100%'
  },
  {value: 'Don’t know', label: 'Don’t know'}
];

export const HEATING_VALUE_OPTIONS = [
  {value: 'LHV (lower heating value)', label: 'LHV (lower heating value)'},
  {value: 'HHV (higher heating value)', label: 'HHV (higher heating value)'},
  {
    value: 'Unable to confirm heating value',
    label: 'Unable to confirm heating value'
  }
];

export const SOURCING_METHOD_OPTIONS = [
  {
    value:
      'None (no active purchases of low-carbon electricity, heat, steam or cooling)',
    label:
      'None (no active purchases of low-carbon electricity, heat, steam or cooling)'
  },
  {
    value:
      'Purchase from an on-site installation owned by a third party (on-site PPA)',
    label:
      'Purchase from an on-site installation owned by a third party (on-site PPA)'
  },
  {
    value:
      'Direct line to an off-site generator owned by a third party with no grid transfers (direct line PPA)',
    label:
      'Direct line to an off-site generator owned by a third party with no grid transfers (direct line PPA)'
  },
  {
    value:
      'Physical power purchase agreement (physical PPA) with a grid-connected generator',
    label:
      'Physical power purchase agreement (physical PPA) with a grid-connected generator'
  },
  {
    value: 'Financial (virtual) power purchase agreement (VPPA)',
    label: 'Financial (virtual) power purchase agreement (VPPA)'
  },
  {
    value: 'Project-specific contract with an electricity supplier',
    label: 'Project-specific contract with an electricity supplier'
  },
  {
    value:
      'Retail supply contract with an electricity supplier (retail green electricity)',
    label:
      'Retail supply contract with an electricity supplier (retail green electricity)'
  },
  {
    value: 'Unbundled procurement of energy attribute certificates (EACs)',
    label: 'Unbundled procurement of energy attribute certificates (EACs)'
  },
  {
    value:
      'Default delivered electricity from the grid (e.g. standard product offering by an energy supplier), supported by energy attribute certificates',
    label:
      'Default delivered electricity from the grid (e.g. standard product offering by an energy supplier), supported by energy attribute certificates'
  },
  {
    value:
      'Default delivered electricity from the grid (e.g. standard product offering by an energy supplier) from a grid that is 95% or more low-carbon and where there is no mechanism for specifically allocating low-carbon electricity',
    label:
      'Default delivered electricity from the grid (e.g. standard product offering by an energy supplier) from a grid that is 95% or more low-carbon and where there is no mechanism for specifically allocating low-carbon electricity'
  },
  {
    value: 'Heat/steam/cooling supply agreement',
    label: 'Heat/steam/cooling supply agreement'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const ENERGY_CARRIER_OPTIONS = [
  {value: 'Electricity', label: 'Electricity'},
  {value: 'Heat', label: 'Heat'},
  {value: 'Steam', label: 'Steam'},
  {value: 'Cooling', label: 'Cooling'},
  {
    value: 'Heat, steam and cooling combined',
    label: 'Heat, steam and cooling combined'
  }
];

export const LOW_CARBON_TECHNOLOGY_TYPE_OPTIONS = [
  {value: 'Solar', label: 'Solar'},
  {value: 'Wind', label: 'Wind'},
  {value: 'Large hydropower (>25 MW)', label: 'Large hydropower (>25 MW)'},
  {value: 'Small hydropower (<25 MW)', label: 'Small hydropower (<25 MW)'},
  {
    value: 'Hydropower (capacity unknown)',
    label: 'Hydropower (capacity unknown)'
  },
  {value: 'Nuclear', label: 'Nuclear'},
  {value: 'Sustainable biomass', label: 'Sustainable biomass'},
  {value: 'Other biomass', label: 'Other biomass'},
  {
    value: 'Renewable hydrogen fuel cell',
    label: 'Renewable hydrogen fuel cell'
  },
  {value: 'Marine', label: 'Marine'},
  {value: 'Geothermal', label: 'Geothermal'},
  {
    value: 'Fossil-fuel plants fitted with CCS',
    label: 'Fossil-fuel plants fitted with CCS'
  },
  {
    value: 'Low-carbon energy mix, please specify',
    label: 'Low-carbon energy mix, please specify'
  },
  {
    value: 'Renewable energy mix, please specify',
    label: 'Renewable energy mix, please specify'
  }
];

export const TRACKING_INSTRUMENT_USED_OPTIONS = [
  {value: 'Contract', label: 'Contract'},
  {value: 'GEC', label: 'GEC'},
  {value: 'GO', label: 'GO'},
  {value: 'Indian REC', label: 'Indian REC'},
  {value: 'I-REC', label: 'I-REC'},
  {value: 'J-Credit (Renewable)', label: 'J-Credit (Renewable)'},
  {value: 'Korean REC', label: 'Korean REC'},
  {value: 'Australian LGC', label: 'Australian LGC'},
  {value: 'NFC – Renewable', label: 'NFC – Renewable'},
  {value: 'NZECS', label: 'NZECS'},
  {value: 'REGO', label: 'REGO'},
  {value: 'TIGR', label: 'TIGR'},
  {value: 'T-REC', label: 'T-REC'},
  {value: 'US-REC', label: 'US-REC'},
  {value: 'zaREC', label: 'zaREC'},
  {value: 'Other, please specify', label: 'Other, please specify'},
  {value: 'No instrument used.', label: 'No instrument used.'}
];

export const SOURCING_METHOD_2_OPTIONS = [
  {
    value:
      'Purchase from an on-site installation owned by a third party (on-site PPA)',
    label:
      'Purchase from an on-site installation owned by a third party (on-site PPA)'
  },
  {
    value:
      'Direct line to an off-site generator owned by a third party with no grid transfers (direct-line PPA)',
    label:
      'Direct line to an off-site generator owned by a third party with no grid transfers (direct-line PPA)'
  },
  {
    value:
      'Physical power purchase agreement (physical PPA) with a grid-connected generator',
    label:
      'Physical power purchase agreement (physical PPA) with a grid-connected generator'
  },
  {
    value: 'Financial (virtual) power purchase agreement (VPPA)',
    label: 'Financial (virtual) power purchase agreement (VPPA)'
  },
  {
    value: 'Project-specific contract with an electricity supplier',
    label: 'Project-specific contract with an electricity supplier'
  },
  {
    value:
      'Retail supply contract with an electricity supplier (retail green electricity)',
    label:
      'Retail supply contract with an electricity supplier (retail green electricity)'
  },
  {
    value: 'Unbundled procurement of Energy Attribute Certificates (EACs)',
    label: 'Unbundled procurement of Energy Attribute Certificates (EACs)'
  },
  {
    value:
      'Default delivered renewable electricity from the grid, supported by energy attribute certificates',
    label:
      'Default delivered renewable electricity from the grid, supported by energy attribute certificates'
  },
  {
    value:
      'Default delivered renewable electricity from the grid in a market with 95% or more renewable electricity capacity and where there is no mechanism for specifically allocating renewable electricity',
    label:
      'Default delivered renewable electricity from the grid in a market with 95% or more renewable electricity capacity and where there is no mechanism for specifically allocating renewable electricity'
  }
];

export const RENEWABLE_ELECTRICITY_TECHNOLOGY_TYPE_OPTIONS = [
  {value: 'Solar', label: 'Solar'},
  {value: 'Wind', label: 'Wind'},
  {value: 'Large hydropower (>25 MW)', label: 'Large hydropower (>25 MW)'},
  {value: 'Small hydropower (<25 MW)', label: 'Small hydropower (<25 MW)'},
  {
    value: 'Hydropower (capacity unknown)',
    label: 'Hydropower (capacity unknown)'
  },
  {value: 'Sustainable biomass', label: 'Sustainable biomass'},
  {
    value: 'Renewable hydrogen fuel cell',
    label: 'Renewable hydrogen fuel cell'
  },
  {value: 'Marine', label: 'Marine'},
  {value: 'Geothermal', label: 'Geothermal'},
  {
    value: 'Renewable electricity mix, please specify.',
    label: 'Renewable electricity mix, please specify.'
  }
];

export const TRACKING_INSTRUMENT_USED_2_OPTIONS = [
  {value: 'Contract', label: 'Contract'},
  {value: 'GEC', label: 'GEC'},
  {value: 'GO', label: 'GO'},
  {value: 'Indian REC', label: 'Indian REC'},
  {value: 'I-REC', label: 'I-REC'},
  {value: 'J-Credit (Renewable)', label: 'J-Credit (Renewable)'},
  {value: 'Korean REC', label: 'Korean REC'},
  {value: 'Australian LGC', label: 'Australian LGC'},
  {value: 'NFC – Renewable', label: 'NFC – Renewable'},
  {value: 'NZECS', label: 'NZECS'},
  {value: 'REGO', label: 'REGO'},
  {value: 'TIGR', label: 'TIGR'},
  {value: 'T-REC', label: 'T-REC'},
  {value: 'US-REC', label: 'US-REC'},
  {value: 'zaREC', label: 'zaREC'},
  {value: 'Other, please specify', label: 'Other, please specify'},
  {value: 'No instrument used.', label: 'No instrument used.'}
];

export const VINTAGE_OF_RENEWABLE_ENERGY_ATTRIBUTE_OPTIONS = [
  {value: 'Before 2020', label: 'Before 2020'},
  {value: '2020', label: '2020'},
  {value: '2021', label: '2021'},
  {value: '2022', label: '2022'},
  {value: '2023', label: '2023'},
  {value: '2024', label: '2024'},
  {value: '2025', label: '2025'}
];

export const ECOLABEL_ASSOCIATED_WITH_PURCHASED_RENEWABLE_ELECTRICITY_OPTIONS =
  [
    {
      value: 'Green-e Certified (R) Renewable Energy',
      label: 'Green-e Certified (R) Renewable Energy'
    },
    {value: 'EKOenergy label', label: 'EKOenergy label'},
    {
      value: 'Gold Standard Renewable Energy',
      label: 'Gold Standard Renewable Energy'
    },
    {value: 'Grüner Strom Label', label: 'Grüner Strom Label'},
    {value: 'Peace-REC (PREC)', label: 'Peace-REC (PREC)'},
    {value: 'TÜV SÜD', label: 'TÜV SÜD'},
    {value: 'Other, please specify', label: 'Other, please specify'},
    {
      value: 'No additional, voluntary label.',
      label: 'No additional, voluntary label.'
    }
  ];

export const SOURCING_METHOD_3_OPTIONS = [
  {
    value: 'None (no purchases of low-carbon heat, steam, or cooling)',
    label: 'None (no purchases of low-carbon heat, steam, or cooling)'
  },
  {
    value: 'Heat/steam/cooling supply agreement',
    label: 'Heat/steam/cooling supply agreement'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const ENERGY_CARRIER_2_OPTIONS = [
  {value: 'Heat', label: 'Heat'},
  {value: 'Steam', label: 'Steam'},
  {value: 'Cooling', label: 'Cooling'},
  {
    value: 'Heat, steam, and cooling combined.',
    label: 'Heat, steam, and cooling combined.'
  }
];

export const LOW_CARBON_TECHNOLOGY_TYPE_2_OPTIONS = [
  {value: 'Solar', label: 'Solar'},
  {value: 'Sustainable biomass', label: 'Sustainable biomass'},
  {value: 'Other biomass', label: 'Other biomass'},
  {value: 'Low-carbon energy mix', label: 'Low-carbon energy mix'},
  {value: 'Renewable energy mix', label: 'Renewable energy mix'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const ENERGY_ATTRIBUTE_CERTIFICATE_TYPE_OPTIONS = [
  {value: 'GEC', label: 'GEC'},
  {value: 'GO', label: 'GO'},
  {value: 'Indian REC', label: 'Indian REC'},
  {value: 'I-REC', label: 'I-REC'},
  {value: 'J-Credit (Renewable)', label: 'J-Credit (Renewable)'},
  {value: 'Korean REC', label: 'Korean REC'},
  {value: 'Australian LGC', label: 'Australian LGC'},
  {value: 'NFC – Renewable', label: 'NFC – Renewable'},
  {value: 'NZECS', label: 'NZECS'},
  {value: 'REGO', label: 'REGO'},
  {value: 'TIGR', label: 'TIGR'},
  {value: 'T-REC', label: 'T-REC'},
  {value: 'US-REC', label: 'US-REC'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const CHALLENGES_TO_SOURCING_RENEWABLE_ELECTRICITY_OPTIONS = [
  {
    value: 'Yes, in specific countries/areas in which we operate',
    label: 'Yes, in specific countries/areas in which we operate'
  },
  {
    value: 'Yes, not specific to a country/area',
    label: 'Yes, not specific to a country/area'
  },
  {
    value: 'Yes, both in specific countries/areas and in general',
    label: 'Yes, both in specific countries/areas and in general'
  },
  {value: 'No', label: 'No'}
];

export const REASONS_WHY_IT_WAS_CHALLENGING_TO_SOURCING_RENEWABLE_ELECTRICITY_OPTIONS =
  [
    {
      value: 'Arbitrary grid usage charges',
      label: 'Arbitrary grid usage charges'
    },
    {
      value:
        'Inability to buy Energy Attribute Certificates (EACs) in small quantities',
      label:
        'Inability to buy Energy Attribute Certificates (EACs) in small quantities'
    },
    {
      value: 'Inability to make exclusive renewable electricity usage claims',
      label: 'Inability to make exclusive renewable electricity usage claims'
    },
    {value: 'Internal capacity issues', label: 'Internal capacity issues'},
    {
      value: 'Issues with landlord-tenant arrangements',
      label: 'Issues with landlord-tenant arrangements'
    },
    {
      value:
        'Lack of credible renewable electricity procurement options (e.g., EACs, Green Tariffs)',
      label:
        'Lack of credible renewable electricity procurement options (e.g., EACs, Green Tariffs)'
    },
    {value: 'Lack of market data', label: 'Lack of market data'},
    {
      value: 'Lack of electricity market structure supporting bilateral PPAs',
      label: 'Lack of electricity market structure supporting bilateral PPAs'
    },
    {
      value: 'Limited supply of renewable electricity in the market',
      label: 'Limited supply of renewable electricity in the market'
    },
    {
      value: 'Prohibitively priced renewable electricity',
      label: 'Prohibitively priced renewable electricity'
    },
    {value: 'Regulatory instability', label: 'Regulatory instability'},
    {value: 'Small load', label: 'Small load'},
    {
      value: 'Unable to get internal company approval',
      label: 'Unable to get internal company approval'
    },
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const FUELS_USED_AS_FEEDSTOCKS_OPTIONS = [
  {value: 'Anthracite', label: 'Anthracite'},
  {value: 'Coal', label: 'Coal'},
  {value: 'Lignite', label: 'Lignite'},
  {value: 'Coke', label: 'Coke'},
  {value: 'Patent fuel / BKB', label: 'Patent fuel / BKB'},
  {value: 'Petroleum coke', label: 'Petroleum coke'},
  {value: 'Diesel oil', label: 'Diesel oil'},
  {value: 'Gas oil', label: 'Gas oil'},
  {value: 'Heavy fuel oil', label: 'Heavy fuel oil'},
  {value: 'Oil shale', label: 'Oil shale'},
  {value: 'Gasoline', label: 'Gasoline'},
  {value: 'White Spirit / SBP', label: 'White Spirit / SBP'},
  {value: 'Lubricants', label: 'Lubricants'},
  {value: 'Naphtha', label: 'Naphtha'},
  {value: 'Special Naphtha', label: 'Special Naphtha'},
  {value: 'Propane liquid', label: 'Propane liquid'},
  {value: 'Propane gas', label: 'Propane gas'},
  {value: 'Ethane', label: 'Ethane'},
  {value: 'Butane', label: 'Butane'},
  {value: 'LPG', label: 'LPG'},
  {value: 'Refinery gas', label: 'Refinery gas'},
  {value: 'Natural gas', label: 'Natural gas'},
  {value: 'Solid biofuel', label: 'Solid biofuel'},
  {value: 'Liquid biofuel', label: 'Liquid biofuel'},
  {value: 'Waste biofuel', label: 'Waste biofuel'},
  {value: 'Biogas', label: 'Biogas'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TOTAL_CONSUMPTION_UNIT_OPTIONS = [
  {value: 'Metric tons', label: 'Metric tons'},
  {value: 'Thousand metric tons', label: 'Thousand metric tons'},
  {value: 'Thousand pounds', label: 'Thousand pounds'},
  {value: 'Barrels', label: 'Barrels'},
  {value: 'Thousand barrels', label: 'Thousand barrels'},
  {value: 'Gallons', label: 'Gallons'},
  {value: 'Thousand gallons', label: 'Thousand gallons'},
  {value: 'Million gallons', label: 'Million gallons'},
  {value: 'Liters', label: 'Liters'},
  {value: 'Thousand liters', label: 'Thousand liters'},
  {value: 'Million liters', label: 'Million liters'},
  {value: 'Cubic feet', label: 'Cubic feet'},
  {value: 'Thousand cubic feet', label: 'Thousand cubic feet'},
  {value: 'Million cubic feet', label: 'Million cubic feet'},
  {value: 'Cubic meters', label: 'Cubic meters'},
  {value: 'Thousand cubic meters.', label: 'Thousand cubic meters.'}
];

export const FEEDSTOCKS_STEEL = [
  {value: 'Coal', label: 'Coal'},
  {value: 'Coking coal', label: 'Coking coal'},
  {value: 'Blast furnace coal', label: 'Blast furnace coal'},
  {value: 'Coke', label: 'Coke'},
  {value: 'Fuel oil', label: 'Fuel oil'},
  {value: 'Natural gas', label: 'Natural gas'},
  {value: 'Coke oven gas', label: 'Coke oven gas'},
  {value: 'Blast furnace gas', label: 'Blast furnace gas'},
  {value: 'Renewable hydrogen', label: 'Renewable hydrogen'},
  {
    value:
      'Hydrogen derived from non-renewable sources, fitted with carbon capture and storage',
    label:
      'Hydrogen derived from non-renewable sources, fitted with carbon capture and storage'
  },
  {
    value: 'Other non-renewable hydrogen',
    label: 'Other non-renewable hydrogen'
  },
  {value: 'Charcoal', label: 'Charcoal'},
  {value: 'Other biomass', label: 'Other biomass'},
  {value: 'Liquid biofuel', label: 'Liquid biofuel'},
  {value: 'Biogas', label: 'Biogas'},
  {value: 'Biomass waste', label: 'Biomass waste'},
  {value: 'Non-biomass waste', label: 'Non-biomass waste'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const MEASUREMENT_OF_PRODUCT_SERVICE_EFFICIENCY_OPTIONS = [
  {value: 'Yes', label: 'Yes'},
  {
    value: 'No, but we plan to start doing so within the next two years',
    label: 'No, but we plan to start doing so within the next two years'
  },
  {
    value: 'No, and we do not plan to start doing so within the next two years',
    label: 'No, and we do not plan to start doing so within the next two years'
  }
];

export const CATEGORY_OF_PRODUCT_OR_SERVICE_OPTIONS = [
  {
    value: 'Agriculture, construction & mining machinery',
    label: 'Agriculture, construction & mining machinery'
  },
  {
    value: 'Batteries (including fuel cells)',
    label: 'Batteries (including fuel cells)'
  },
  {value: 'Heating & cooling systems', label: 'Heating & cooling systems'},
  {value: 'Industrial machinery', label: 'Industrial machinery'},
  {value: 'Power generation equipment', label: 'Power generation equipment'},
  {
    value: 'Power transmission, transformation and distribution equipment',
    label: 'Power transmission, transformation and distribution equipment'
  },
  {value: 'Power tools', label: 'Power tools'},
  {value: 'Solar energy equipment', label: 'Solar energy equipment'},
  {value: 'Stationary generators', label: 'Stationary generators'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METRIC_NUMERATOR_OPTIONS = [
  {value: 'GJ', label: 'GJ'},
  {value: 'Btu', label: 'Btu'},
  {value: 'Watt-hour', label: 'Watt-hour'},
  {value: 'Megawatt hour (MWh)', label: 'Megawatt hour (MWh)'},
  {value: 'tCO₂', label: 'tCO₂'},
  {value: 'tCO₂e', label: 'tCO₂e'},
  {value: 'Liter', label: 'Liter'},
  {value: 'Metric ton', label: 'Metric ton'},
  {value: 'Kg', label: 'Kg'},
  {value: 'Amp-hour', label: 'Amp-hour'},
  {value: '%', label: '%'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METRIC_DENOMINATOR_OPTIONS = [
  {value: 'Kilometer', label: 'Kilometer'},
  {value: 'Square meter', label: 'Square meter'},
  {value: 'Square foot', label: 'Square foot'},
  {value: 'Watt-hour', label: 'Watt-hour'},
  {value: 'Megawatt hour (MWh)', label: 'Megawatt hour (MWh)'},
  {value: 'Metric ton of product', label: 'Metric ton of product'},
  {value: 'Unit hour worked', label: 'Unit hour worked'},
  {value: 'Unit of production', label: 'Unit of production'},
  {value: 'Unit of service provided', label: 'Unit of service provided'},
  {value: 'Unit revenue', label: 'Unit revenue'},
  {value: 'USD ($) value-added', label: 'USD ($) value-added'},
  {value: 'Not applicable', label: 'Not applicable'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TRANSPORT_MODE_OPTIONS = [
  {value: 'Light Duty Vehicles (LDV)', label: 'Light Duty Vehicles (LDV)'},
  {value: 'Heavy Duty Vehicles (HDV)', label: 'Heavy Duty Vehicles (HDV)'},
  {value: 'Rail', label: 'Rail'},
  {value: 'Marine', label: 'Marine'},
  {value: 'Aviation', label: 'Aviation'}
];

export const METRIC_NUMERATOR_GROUPED_OPTIONS = [
  {
    label: 'LDV (Light-Duty Vehicles)',
    options: [
      {value: 'gCO₂', label: 'gCO₂'},
      {value: 'gCO₂e', label: 'gCO₂e'},
      {value: 'tCO₂', label: 'tCO₂'},
      {value: 'tCO₂e', label: 'tCO₂e'},
      {value: 'MWh', label: 'MWh'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'HDV (Heavy-Duty Vehicles)',
    options: [
      {value: 'gCO₂', label: 'gCO₂'},
      {value: 'gCO₂e', label: 'gCO₂e'},
      {value: 'tCO₂', label: 'tCO₂'},
      {value: 'tCO₂e', label: 'tCO₂e'},
      {value: 'MWh', label: 'MWh'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Rail',
    options: [
      {value: 'gCO₂', label: 'gCO₂'},
      {value: 'gCO₂e', label: 'gCO₂e'},
      {value: 'tCO₂', label: 'tCO₂'},
      {value: 'tCO₂e', label: 'tCO₂e'},
      {value: 'MWh', label: 'MWh'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Marine',
    options: [
      {value: 'gCO₂', label: 'gCO₂'},
      {value: 'gCO₂e', label: 'gCO₂e'},
      {value: 'tCO₂', label: 'tCO₂'},
      {value: 'tCO₂e', label: 'tCO₂e'},
      {value: 'MWh', label: 'MWh'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Aviation',
    options: [
      {value: 'gCO₂', label: 'gCO₂'},
      {value: 'gCO₂e', label: 'gCO₂e'},
      {value: 'tCO₂', label: 'tCO₂'},
      {value: 'tCO₂e', label: 'tCO₂e'},
      {value: 'MWh', label: 'MWh'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  }
];

export const DEVELOPMENT_TYPE_OPTIONS = [
  {value: 'Onshore', label: 'Onshore'},
  {value: 'Shallow water', label: 'Shallow water'},
  {value: 'Deep water', label: 'Deep water'},
  {value: 'Ultra-deep water', label: 'Ultra-deep water'},
  {value: 'Arctic', label: 'Arctic'},
  {value: 'Oil sand / extra heavy oil', label: 'Oil sand / extra heavy oil'},
  {value: 'Tight / shale', label: 'Tight / shale'},
  {value: 'LNG', label: 'LNG'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const OUTPUT_PRODUCT_OPTIONS_2 = [
  {
    value: 'High Value Chemicals (Steam cracking)',
    label: 'High Value Chemicals (Steam cracking)'
  },
  {value: 'Ammonia', label: 'Ammonia'},
  {value: 'Aromatics extraction', label: 'Aromatics extraction'},
  {value: 'Methanol', label: 'Methanol'},
  {value: 'Butylene', label: 'Butylene'},
  {value: 'Propylene (FCC)', label: 'Propylene (FCC)'},
  {value: 'Ethanol', label: 'Ethanol'},
  {value: 'Butadiene (C4 separation)', label: 'Butadiene (C4 separation)'},
  {value: 'Nitric acid', label: 'Nitric acid'},
  {value: 'Adipic acid', label: 'Adipic acid'},
  {value: 'Caprolactam', label: 'Caprolactam'},
  {value: 'Soda ash', label: 'Soda ash'},
  {value: 'Carbon black', label: 'Carbon black'},
  {value: 'Polymers', label: 'Polymers'},
  {value: 'Specialty chemicals', label: 'Specialty chemicals'},
  {value: 'Other base chemicals', label: 'Other base chemicals'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRODUCT_OPTIONS_2 = [
  {value: 'Hot-rolled steel', label: 'Hot-rolled steel'},
  {value: 'Blast furnace iron', label: 'Blast furnace iron'},
  {value: 'Direct reduced iron', label: 'Direct reduced iron'},
  {
    value: 'Coke (including coke breeze)',
    label: 'Coke (including coke breeze)'
  },
  {value: 'Coke oven gas (for sale)', label: 'Coke oven gas (for sale)'},
  {value: 'Sinter', label: 'Sinter'},
  {value: 'Iron ore pellets', label: 'Iron ore pellets'},
  {value: 'Lime', label: 'Lime'},
  {value: 'Metal scrap', label: 'Metal scrap'},
  {
    value: 'Oxygen (disclose in million Nm³)',
    label: 'Oxygen (disclose in million Nm³)'
  },
  {value: 'Tar and benzole', label: 'Tar and benzole'},
  {value: 'Ammonia', label: 'Ammonia'},
  {
    value: 'Benzene, toluene, and xylene (BTX)',
    label: 'Benzene, toluene, and xylene (BTX)'
  },
  {value: 'Iron ore', label: 'Iron ore'},
  {value: 'Coal', label: 'Coal'},
  {value: 'Limestone and dolomite', label: 'Limestone and dolomite'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const OUTPUT_PRODUCT_OPTIONS_3 = [
  {value: 'Bauxite', label: 'Bauxite'},
  {value: 'Copper', label: 'Copper'},
  {value: 'Gold', label: 'Gold'},
  {value: 'Platinum group metals', label: 'Platinum group metals'},
  {value: 'Silver', label: 'Silver'},
  {value: 'Iron ore', label: 'Iron ore'},
  {value: 'Nickel', label: 'Nickel'},
  {value: 'Zinc', label: 'Zinc'},
  {value: 'Lead', label: 'Lead'},
  {value: 'Diamonds', label: 'Diamonds'},
  {
    value: 'Other non-ferrous metal mining (please specify)',
    label: 'Other non-ferrous metal mining (please specify)'
  },
  {
    value: 'Other mining (please specify)',
    label: 'Other mining (please specify)'
  }
];

export const OUTPUT_PRODUCT_OPTIONS_4 = [
  {value: 'Aluminum', label: 'Aluminum'},
  {value: 'Alumina', label: 'Alumina'},
  {value: 'Copper', label: 'Copper'},
  {value: 'Gold', label: 'Gold'},
  {value: 'Platinum group metals', label: 'Platinum group metals'},
  {value: 'Silver', label: 'Silver'},
  {value: 'Nickel', label: 'Nickel'},
  {value: 'Lead', label: 'Lead'},
  {value: 'Zinc', label: 'Zinc'},
  {
    value: 'Other non-ferrous metals (Please specify)',
    label: 'Other non-ferrous metals (Please specify)'
  },
  {
    value: 'Other ferrous metals (Please specify)',
    label: 'Other ferrous metals (Please specify)'
  }
];

export const SCOPE_2_EMISSIONS_APPROACH_OPTIONS = [
  {value: 'Location-based', label: 'Location-based'},
  {value: 'Market-based', label: 'Market-based'}
];

export const PRODUCT_PRODUCED_OPTIONS = [
  {value: 'Liquified petroleum gas', label: 'Liquified petroleum gas'},
  {value: 'Gasolines', label: 'Gasolines'},
  {value: 'Naphtha', label: 'Naphtha'},
  {value: 'Kerosenes', label: 'Kerosenes'},
  {value: 'Diesel fuels', label: 'Diesel fuels'},
  {value: 'Fuel oils', label: 'Fuel oils'},
  {value: 'Lubricants', label: 'Lubricants'},
  {value: 'Waxes', label: 'Waxes'},
  {value: 'Asphalt and tar', label: 'Asphalt and tar'},
  {value: 'Petroleum coke', label: 'Petroleum coke'},
  {value: 'Still gas', label: 'Still gas'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METRIC_DENOMINATOR_OPTIONS_2 = [
  {value: 'Unit total revenue', label: 'Unit total revenue'},
  {
    value: 'Barrel of oil equivalent (BOE)',
    label: 'Barrel of oil equivalent (BOE)'
  },
  {
    value: 'Billion (currency) funds under management',
    label: 'Billion (currency) funds under management'
  },
  {
    value: 'Full-time equivalent (FTE) employee',
    label: 'Full-time equivalent (FTE) employee'
  },
  {value: 'Kilometer', label: 'Kilometer'},
  {value: 'Liter of product', label: 'Liter of product'},
  {
    value: 'Megawatt hour generated (MWh)',
    label: 'Megawatt hour generated (MWh)'
  },
  {
    value: 'Megawatt hour transmitted (MWh)',
    label: 'Megawatt hour transmitted (MWh)'
  },
  {
    value: 'Megawatt hour purchased (MWh) [EU sector only]',
    label: 'Megawatt hour purchased (MWh) [EU sector only]'
  },
  {value: 'Metric ton of product', label: 'Metric ton of product'},
  {value: 'Ounce of gold', label: 'Ounce of gold'},
  {value: 'Ounce of platinum', label: 'Ounce of platinum'},
  {value: 'Passenger kilometer', label: 'Passenger kilometer'},
  {value: 'Room night produced', label: 'Room night produced'},
  {value: 'Square foot', label: 'Square foot'},
  {value: 'Square meter', label: 'Square meter'},
  {value: 'Metric ton of aggregate', label: 'Metric ton of aggregate'},
  {value: 'Metric ton of aluminum', label: 'Metric ton of aluminum'},
  {value: 'Metric ton of coal', label: 'Metric ton of coal'},
  {value: 'Metric ton of ore processed', label: 'Metric ton of ore processed'},
  {value: 'Metric ton of steel', label: 'Metric ton of steel'},
  {value: 'Unit hour worked', label: 'Unit hour worked'},
  {value: 'Unit of production', label: 'Unit of production'},
  {value: 'Unit of service provided', label: 'Unit of service provided'},
  {value: 'Vehicle produced', label: 'Vehicle produced'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const REASONS_FOR_CHANGE_OPTIONS = [
  {
    value: 'Change in renewable energy consumption',
    label: 'Change in renewable energy consumption'
  },
  {
    value: 'Other emissions reduction activities',
    label: 'Other emissions reduction activities'
  },
  {value: 'Divestment', label: 'Divestment'},
  {value: 'Acquisitions', label: 'Acquisitions'},
  {value: 'Mergers', label: 'Mergers'},
  {value: 'Change in output', label: 'Change in output'},
  {value: 'Change in revenue', label: 'Change in revenue'},
  {value: 'Change in methodology', label: 'Change in methodology'},
  {value: 'Change in boundary', label: 'Change in boundary'},
  {
    value: 'Change in physical operating conditions',
    label: 'Change in physical operating conditions'
  },
  {value: 'Unidentified', label: 'Unidentified'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const POWER_GENERATION_TECHNOLOGY_OPTIONS = [
  {value: 'Coal – Hard', label: 'Coal – Hard'},
  {value: 'Lignite', label: 'Lignite'},
  {value: 'Oil', label: 'Oil'},
  {value: 'Gas', label: 'Gas'},
  {value: 'Sustainable biomass', label: 'Sustainable biomass'},
  {value: 'Other biomass', label: 'Other biomass'},
  {value: 'Waste (non-biomass)', label: 'Waste (non-biomass)'},
  {value: 'Nuclear', label: 'Nuclear'},
  {
    value: 'Fossil-fuel plants fitted with carbon capture and storage',
    label: 'Fossil-fuel plants fitted with carbon capture and storage'
  },
  {value: 'Geothermal', label: 'Geothermal'},
  {value: 'Hydropower', label: 'Hydropower'},
  {value: 'Wind', label: 'Wind'},
  {value: 'Solar', label: 'Solar'},
  {value: 'Marine', label: 'Marine'},
  {value: 'Other renewable', label: 'Other renewable'},
  {value: 'Other non-renewable', label: 'Other non-renewable'},
  {value: 'Not applicable', label: 'Not applicable'}
];

export const HYDROCARBON_OPTIONS = [
  {
    value: 'Thousand barrels of crude oil/condensate',
    label: 'Thousand barrels of crude oil/condensate'
  },
  {
    value: 'Thousand barrels of natural gas liquids',
    label: 'Thousand barrels of natural gas liquids'
  },
  {
    value:
      'Thousand barrels of oil sands (includes bitumen and synthetic crude)',
    label:
      'Thousand barrels of oil sands (includes bitumen and synthetic crude)'
  },
  {
    value: 'Million cubic feet of natural gas',
    label: 'Million cubic feet of natural gas'
  },
  {
    value: 'Thousand barrels of refinery throughput',
    label: 'Thousand barrels of refinery throughput'
  },
  {
    value: 'Thousand barrels of refinery net production',
    label: 'Thousand barrels of refinery net production'
  },
  {
    value: 'Thousand metric tons of “high value chemicals” (lower olefins)',
    label: 'Thousand metric tons of “high value chemicals” (lower olefins)'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const DIRECTION_OF_CHANGE_OPTIONS_2 = [
  {value: 'Increased', label: 'Increased'},
  {value: 'Decreased', label: 'Decreased'},
  {value: 'No change', label: 'No change'}
];

export const PROCESS_ROUTE_OPTIONS = [
  {
    value: 'Blast furnace – basic oxygen furnace',
    label: 'Blast furnace – basic oxygen furnace'
  },
  {
    value: 'Scrap – electric arc furnace',
    label: 'Scrap – electric arc furnace'
  },
  {
    value: 'Direct reduced iron – electric arc furnace',
    label: 'Direct reduced iron – electric arc furnace'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METHODOLOGY_APPLIED_OPTIONS = [
  {value: 'GHG Protocol', label: 'GHG Protocol'},
  {value: 'Worldsteel Association', label: 'Worldsteel Association'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METRIC_DENOMINATOR_OPTIONS_3 = [
  {
    label: 'LDV (Light-Duty Vehicles)',
    options: [
      {value: 'v.km', label: 'v.km'},
      {value: 'v.mile', label: 'v.mile'},
      {value: 't.km', label: 't.km'},
      {value: 't.mile', label: 't.mile'},
      {value: 'p.km', label: 'p.km'},
      {value: 'p.mile', label: 'p.mile'},
      {value: 'm² vehicle footprint', label: 'm² vehicle footprint'},
      {value: 'kg vehicle mass', label: 'kg vehicle mass'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'HDV (Heavy-Duty Vehicles)',
    options: [
      {value: 'v.km', label: 'v.km'},
      {value: 'v.mile', label: 'v.mile'},
      {value: 't.km', label: 't.km'},
      {value: 't.mile', label: 't.mile'},
      {value: 'm³.km', label: 'm³.km'},
      {value: 'm³.mile', label: 'm³.mile'},
      {value: 'p.km', label: 'p.km'},
      {value: 'p.mile', label: 'p.mile'},
      {value: 'm² vehicle footprint', label: 'm² vehicle footprint'},
      {value: 'kg vehicle mass', label: 'kg vehicle mass'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Rail',
    options: [
      {value: 'v.km', label: 'v.km'},
      {value: 'v.mile', label: 'v.mile'},
      {value: 't.km', label: 't.km'},
      {value: 't.mile', label: 't.mile'},
      {value: 'm³.km', label: 'm³.km'},
      {value: 'm³.mile', label: 'm³.mile'},
      {value: 'p.km', label: 'p.km'},
      {value: 'p.mile', label: 'p.mile'},
      {value: 'kg vehicle mass.km', label: 'kg vehicle mass.km'},
      {value: 'kg vehicle mass.mile', label: 'kg vehicle mass.mile'},
      {value: 'Revenue-ton.km', label: 'Revenue-ton.km'},
      {value: 'Revenue-ton.mile', label: 'Revenue-ton.mile'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Marine',
    options: [
      {value: 'v.km', label: 'v.km'},
      {value: 'v.mile', label: 'v.mile'},
      {value: 'v.nautical mile', label: 'v.nautical mile'},
      {value: 't.km', label: 't.km'},
      {value: 't.mile', label: 't.mile'},
      {value: 't.nautical mile', label: 't.nautical mile'},
      {value: 'm³.km', label: 'm³.km'},
      {value: 'm³.mile', label: 'm³.mile'},
      {value: 'm³.nautical mile', label: 'm³.nautical mile'},
      {value: 'p.km', label: 'p.km'},
      {value: 'p.mile', label: 'p.mile'},
      {value: 'p.nautical mile', label: 'p.nautical mile'},
      {value: '20ft.km', label: '20ft.km'},
      {value: '20ft.mile', label: '20ft.mile'},
      {value: '20ft.nautical mile', label: '20ft.nautical mile'},
      {value: '40ft.km', label: '40ft.km'},
      {value: '40ft.mile', label: '40ft.mile'},
      {value: '40ft.nautical mile', label: '40ft.nautical mile'},
      {value: 'Revenue-ton.km', label: 'Revenue-ton.km'},
      {value: 'Revenue-ton.mile', label: 'Revenue-ton.mile'},
      {value: 'Revenue-ton.nautical mile', label: 'Revenue-ton.nautical mile'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Aviation',
    options: [
      {value: 'v.km', label: 'v.km'},
      {value: 'v.mile', label: 'v.mile'},
      {value: 't.km', label: 't.km'},
      {value: 't.mile', label: 't.mile'},
      {value: 'p.km', label: 'p.km'},
      {value: 'p.mile', label: 'p.mile'},
      {value: 'Available seat.km', label: 'Available seat.km'},
      {value: 'Available seat.mile', label: 'Available seat.mile'},
      {value: 'Revenue-ton.km', label: 'Revenue-ton.km'},
      {value: 'Revenue-ton.mile', label: 'Revenue-ton.mile'},
      {value: 'Revenue per ASK (RASK)', label: 'Revenue per ASK (RASK)'},
      {value: 'Revenue per ASM (RASM)', label: 'Revenue per ASM (RASM)'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  }
];

export const DESCRIPTION_OPTIONS = [
  {value: 'Waste', label: 'Waste'},
  {value: 'Energy usage', label: 'Energy usage'},
  {value: 'Land use', label: 'Land use'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const ABS_OPTIONS = [
  {value: 'Abs 1', label: 'Abs 1'},
  {value: 'Abs 2', label: 'Abs 2'},
  {value: 'Abs 3', label: 'Abs 3'},
  {value: 'Abs 4', label: 'Abs 4'},
  {value: 'Abs 5', label: 'Abs 5'},
  {value: 'Abs 6', label: 'Abs 6'},
  {value: 'Abs 7', label: 'Abs 7'},
  {value: 'Abs 8', label: 'Abs 8'},
  {value: 'Abs 9', label: 'Abs 9'},
  {value: 'Abs 10', label: 'Abs 10'},
  {value: 'Abs 11', label: 'Abs 11'},
  {value: 'Abs 12', label: 'Abs 12'},
  {value: 'Abs 13', label: 'Abs 13'},
  {value: 'Abs 14', label: 'Abs 14'},
  {value: 'Abs 15', label: 'Abs 15'},
  {value: 'Abs 16', label: 'Abs 16'},
  {value: 'Abs 17', label: 'Abs 17'},
  {value: 'Abs 18', label: 'Abs 18'},
  {value: 'Abs 19', label: 'Abs 19'},
  {value: 'Abs 20', label: 'Abs 20'},
  {value: 'Abs 21', label: 'Abs 21'},
  {value: 'Abs 22', label: 'Abs 22'},
  {value: 'Abs 23', label: 'Abs 23'},
  {value: 'Abs 24', label: 'Abs 24'},
  {value: 'Abs 25', label: 'Abs 25'},
  {value: 'Abs 26', label: 'Abs 26'},
  {value: 'Abs 27', label: 'Abs 27'},
  {value: 'Abs 28', label: 'Abs 28'},
  {value: 'Abs 29', label: 'Abs 29'},
  {value: 'Abs 30', label: 'Abs 30'},
  {value: 'Abs 31', label: 'Abs 31'},
  {value: 'Abs 32', label: 'Abs 32'},
  {value: 'Abs 33', label: 'Abs 33'},
  {value: 'Abs 34', label: 'Abs 34'},
  {value: 'Abs 35', label: 'Abs 35'},
  {value: 'Abs 36', label: 'Abs 36'},
  {value: 'Abs 37', label: 'Abs 37'},
  {value: 'Abs 38', label: 'Abs 38'},
  {value: 'Abs 39', label: 'Abs 39'},
  {value: 'Abs 40', label: 'Abs 40'},
  {value: 'Abs 41', label: 'Abs 41'},
  {value: 'Abs 42', label: 'Abs 42'},
  {value: 'Abs 43', label: 'Abs 43'},
  {value: 'Abs 44', label: 'Abs 44'},
  {value: 'Abs 45', label: 'Abs 45'},
  {value: 'Abs 46', label: 'Abs 46'},
  {value: 'Abs 47', label: 'Abs 47'},
  {value: 'Abs 48', label: 'Abs 48'},
  {value: 'Abs 49', label: 'Abs 49'},
  {value: 'Abs 50', label: 'Abs 50'},
  {value: 'Abs 51', label: 'Abs 51'},
  {value: 'Abs 52', label: 'Abs 52'},
  {value: 'Abs 53', label: 'Abs 53'},
  {value: 'Abs 54', label: 'Abs 54'},
  {value: 'Abs 55', label: 'Abs 55'},
  {value: 'Abs 56', label: 'Abs 56'},
  {value: 'Abs 57', label: 'Abs 57'},
  {value: 'Abs 58', label: 'Abs 58'},
  {value: 'Abs 59', label: 'Abs 59'},
  {value: 'Abs 60', label: 'Abs 60'},
  {value: 'Abs 61', label: 'Abs 61'},
  {value: 'Abs 62', label: 'Abs 62'},
  {value: 'Abs 63', label: 'Abs 63'},
  {value: 'Abs 64', label: 'Abs 64'},
  {value: 'Abs 65', label: 'Abs 65'},
  {value: 'Abs 66', label: 'Abs 66'},
  {value: 'Abs 67', label: 'Abs 67'},
  {value: 'Abs 68', label: 'Abs 68'},
  {value: 'Abs 69', label: 'Abs 69'},
  {value: 'Abs 70', label: 'Abs 70'},
  {value: 'Abs 71', label: 'Abs 71'},
  {value: 'Abs 72', label: 'Abs 72'},
  {value: 'Abs 73', label: 'Abs 73'},
  {value: 'Abs 74', label: 'Abs 74'},
  {value: 'Abs 75', label: 'Abs 75'},
  {value: 'Abs 76', label: 'Abs 76'},
  {value: 'Abs 77', label: 'Abs 77'},
  {value: 'Abs 78', label: 'Abs 78'},
  {value: 'Abs 79', label: 'Abs 79'},
  {value: 'Abs 80', label: 'Abs 80'},
  {value: 'Abs 81', label: 'Abs 81'},
  {value: 'Abs 82', label: 'Abs 82'},
  {value: 'Abs 83', label: 'Abs 83'},
  {value: 'Abs 84', label: 'Abs 84'},
  {value: 'Abs 85', label: 'Abs 85'},
  {value: 'Abs 86', label: 'Abs 86'},
  {value: 'Abs 87', label: 'Abs 87'},
  {value: 'Abs 88', label: 'Abs 88'},
  {value: 'Abs 89', label: 'Abs 89'},
  {value: 'Abs 90', label: 'Abs 90'},
  {value: 'Abs 91', label: 'Abs 91'},
  {value: 'Abs 92', label: 'Abs 92'},
  {value: 'Abs 93', label: 'Abs 93'},
  {value: 'Abs 94', label: 'Abs 94'},
  {value: 'Abs 95', label: 'Abs 95'},
  {value: 'Abs 96', label: 'Abs 96'},
  {value: 'Abs 97', label: 'Abs 97'},
  {value: 'Abs 98', label: 'Abs 98'},
  {value: 'Abs 99', label: 'Abs 99'},
  {value: 'Abs 100', label: 'Abs 100'}
];

export const SCIENCE_BASED_TARGET_OPTIONS = [
  {
    value:
      'Yes, and this target has been approved by the Science Based Targets initiative',
    label:
      'Yes, and this target has been approved by the Science Based Targets initiative'
  },
  {
    value:
      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
    label:
      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative'
  },
  {
    value:
      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
    label:
      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years'
  },
  {
    value:
      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years',
    label:
      'Yes, we consider this a science-based target, but we have not committed to seek validation of this target by the Science Based Targets initiative within the next two years'
  },
  {
    value: 'No, but we are reporting another target that is science-based',
    label: 'No, but we are reporting another target that is science-based'
  },
  {
    value: 'No, but we anticipate setting one in the next two years',
    label: 'No, but we anticipate setting one in the next two years'
  },
  {
    value: 'No, and we do not anticipate setting one in the next two years.',
    label: 'No, and we do not anticipate setting one in the next two years.'
  }
];

export const TARGET_AMBITION_OPTIONS = [
  {value: '1.5°C aligned', label: '1.5°C aligned'},
  {value: 'Well-below 2°C aligned', label: 'Well-below 2°C aligned'},
  {value: '2°C aligned', label: '2°C aligned'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TARGET_COVERAGE_OPTIONS = [
  {value: 'Organization-wide', label: 'Organization-wide'},
  {value: 'Business division', label: 'Business division'},
  {value: 'Business activity', label: 'Business activity'},
  {value: 'Site/facility', label: 'Site/facility'},
  {value: 'Country/area/region', label: 'Country/area/region'},
  {value: 'Product-level', label: 'Product-level'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const GREENHOUSE_GAS_COVERED_BY_TARGET_OPTIONS = [
  {value: 'Carbon dioxide (CO₂)', label: 'Carbon dioxide (CO₂)'},
  {value: 'Methane (CH₄)', label: 'Methane (CH₄)'},
  {value: 'Nitrous oxide (N₂O)', label: 'Nitrous oxide (N₂O)'},
  {value: 'Hydrofluorocarbons (HFC)', label: 'Hydrofluorocarbons (HFC)'},
  {value: 'Perfluorocarbons (PFC)', label: 'Perfluorocarbons (PFC)'},
  {value: 'Sulphur hexafluoride (SF₆)', label: 'Sulphur hexafluoride (SF₆)'},
  {value: 'Nitrogen trifluoride (NF₃)', label: 'Nitrogen trifluoride (NF₃)'}
];

export const SCOPES_OPTIONS = [
  {value: 'Scope 1', label: 'Scope 1'},
  {value: 'Scope 2', label: 'Scope 2'},
  {value: 'Scope 3', label: 'Scope 3'}
];

export const LAND_RELATED_EMISSIONS_COVERED_BY_TARGET_OPTIONS = [
  {
    value: 'Yes, it covers land-related emissions only (e.g. FLAG SBT)',
    label: 'Yes, it covers land-related emissions only (e.g. FLAG SBT)'
  },
  {
    value:
      'Yes, it covers land-related and non-land-related emissions (e.g. SBT approved before the release of FLAG target-setting guidance)',
    label:
      'Yes, it covers land-related and non-land-related emissions (e.g. SBT approved before the release of FLAG target-setting guidance)'
  },
  {
    value:
      'Yes, it covers land-related emissions/removals associated with bioenergy and non-land-related emissions (e.g. non-FLAG SBT with bioenergy)',
    label:
      'Yes, it covers land-related emissions/removals associated with bioenergy and non-land-related emissions (e.g. non-FLAG SBT with bioenergy)'
  },
  {
    value:
      'No, it does not cover any land-related emissions (e.g. non-FLAG SBT).',
    label:
      'No, it does not cover any land-related emissions (e.g. non-FLAG SBT).'
  }
];

export const TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS = [
  {value: 'New', label: 'New'},
  {value: 'Underway', label: 'Underway'},
  {value: 'Achieved', label: 'Achieved'},
  {value: 'Achieved and maintained', label: 'Achieved and maintained'},
  {value: 'Expired', label: 'Expired'},
  {value: 'Revised', label: 'Revised'},
  {value: 'Replaced', label: 'Replaced'},
  {value: 'Retired', label: 'Retired'}
];

export const INT_OPTIONS = [
  {value: 'Int 1', label: 'Int 1'},
  {value: 'Int 2', label: 'Int 2'},
  {value: 'Int 3', label: 'Int 3'},
  {value: 'Int 4', label: 'Int 4'},
  {value: 'Int 5', label: 'Int 5'},
  {value: 'Int 6', label: 'Int 6'},
  {value: 'Int 7', label: 'Int 7'},
  {value: 'Int 8', label: 'Int 8'},
  {value: 'Int 9', label: 'Int 9'},
  {value: 'Int 10', label: 'Int 10'},
  {value: 'Int 11', label: 'Int 11'},
  {value: 'Int 12', label: 'Int 12'},
  {value: 'Int 13', label: 'Int 13'},
  {value: 'Int 14', label: 'Int 14'},
  {value: 'Int 15', label: 'Int 15'},
  {value: 'Int 16', label: 'Int 16'},
  {value: 'Int 17', label: 'Int 17'},
  {value: 'Int 18', label: 'Int 18'},
  {value: 'Int 19', label: 'Int 19'},
  {value: 'Int 20', label: 'Int 20'},
  {value: 'Int 21', label: 'Int 21'},
  {value: 'Int 22', label: 'Int 22'},
  {value: 'Int 23', label: 'Int 23'},
  {value: 'Int 24', label: 'Int 24'},
  {value: 'Int 25', label: 'Int 25'},
  {value: 'Int 26', label: 'Int 26'},
  {value: 'Int 27', label: 'Int 27'},
  {value: 'Int 28', label: 'Int 28'},
  {value: 'Int 29', label: 'Int 29'},
  {value: 'Int 30', label: 'Int 30'},
  {value: 'Int 31', label: 'Int 31'},
  {value: 'Int 32', label: 'Int 32'},
  {value: 'Int 33', label: 'Int 33'},
  {value: 'Int 34', label: 'Int 34'},
  {value: 'Int 35', label: 'Int 35'},
  {value: 'Int 36', label: 'Int 36'},
  {value: 'Int 37', label: 'Int 37'},
  {value: 'Int 38', label: 'Int 38'},
  {value: 'Int 39', label: 'Int 39'},
  {value: 'Int 40', label: 'Int 40'},
  {value: 'Int 41', label: 'Int 41'},
  {value: 'Int 42', label: 'Int 42'},
  {value: 'Int 43', label: 'Int 43'},
  {value: 'Int 44', label: 'Int 44'},
  {value: 'Int 45', label: 'Int 45'},
  {value: 'Int 46', label: 'Int 46'},
  {value: 'Int 47', label: 'Int 47'},
  {value: 'Int 48', label: 'Int 48'},
  {value: 'Int 49', label: 'Int 49'},
  {value: 'Int 50', label: 'Int 50'},
  {value: 'Int 51', label: 'Int 51'},
  {value: 'Int 52', label: 'Int 52'},
  {value: 'Int 53', label: 'Int 53'},
  {value: 'Int 54', label: 'Int 54'},
  {value: 'Int 55', label: 'Int 55'},
  {value: 'Int 56', label: 'Int 56'},
  {value: 'Int 57', label: 'Int 57'},
  {value: 'Int 58', label: 'Int 58'},
  {value: 'Int 59', label: 'Int 59'},
  {value: 'Int 60', label: 'Int 60'},
  {value: 'Int 61', label: 'Int 61'},
  {value: 'Int 62', label: 'Int 62'},
  {value: 'Int 63', label: 'Int 63'},
  {value: 'Int 64', label: 'Int 64'},
  {value: 'Int 65', label: 'Int 65'},
  {value: 'Int 66', label: 'Int 66'},
  {value: 'Int 67', label: 'Int 67'},
  {value: 'Int 68', label: 'Int 68'},
  {value: 'Int 69', label: 'Int 69'},
  {value: 'Int 70', label: 'Int 70'},
  {value: 'Int 71', label: 'Int 71'},
  {value: 'Int 72', label: 'Int 72'},
  {value: 'Int 73', label: 'Int 73'},
  {value: 'Int 74', label: 'Int 74'},
  {value: 'Int 75', label: 'Int 75'},
  {value: 'Int 76', label: 'Int 76'},
  {value: 'Int 77', label: 'Int 77'},
  {value: 'Int 78', label: 'Int 78'},
  {value: 'Int 79', label: 'Int 79'},
  {value: 'Int 80', label: 'Int 80'},
  {value: 'Int 81', label: 'Int 81'},
  {value: 'Int 82', label: 'Int 82'},
  {value: 'Int 83', label: 'Int 83'},
  {value: 'Int 84', label: 'Int 84'},
  {value: 'Int 85', label: 'Int 85'},
  {value: 'Int 86', label: 'Int 86'},
  {value: 'Int 87', label: 'Int 87'},
  {value: 'Int 88', label: 'Int 88'},
  {value: 'Int 89', label: 'Int 89'},
  {value: 'Int 90', label: 'Int 90'},
  {value: 'Int 91', label: 'Int 91'},
  {value: 'Int 92', label: 'Int 92'},
  {value: 'Int 93', label: 'Int 93'},
  {value: 'Int 94', label: 'Int 94'},
  {value: 'Int 95', label: 'Int 95'},
  {value: 'Int 96', label: 'Int 96'},
  {value: 'Int 97', label: 'Int 97'},
  {value: 'Int 98', label: 'Int 98'},
  {value: 'Int 99', label: 'Int 99'},
  {value: 'Int 100', label: 'Int 100'}
];

export const INT_METRIC_OPTIONS = [
  {
    value: 'Grams CO2e per revenue passenger kilometer',
    label: 'Grams CO2e per revenue passenger kilometer'
  },
  {
    value: 'Metric tons CO2e per USD($) value-added',
    label: 'Metric tons CO2e per USD($) value-added'
  },
  {
    value: 'Metric tons CO2e per square meter',
    label: 'Metric tons CO2e per square meter'
  },
  {
    value: 'Metric tons CO2e per metric ton of aluminum',
    label: 'Metric tons CO2e per metric ton of aluminum'
  },
  {
    value: 'Metric tons CO2e per metric ton of steel',
    label: 'Metric tons CO2e per metric ton of steel'
  },
  {
    value: 'Metric tons CO2e per metric ton of cement',
    label: 'Metric tons CO2e per metric ton of cement'
  },
  {
    value: 'Metric tons CO2e per metric ton of cardboard',
    label: 'Metric tons CO2e per metric ton of cardboard'
  },
  {value: 'Grams CO2e per kilometer', label: 'Grams CO2e per kilometer'},
  {
    value: 'Metric tons CO2e per unit revenue',
    label: 'Metric tons CO2e per unit revenue'
  },
  {
    value: 'Metric tons CO2e per unit FTE employee',
    label: 'Metric tons CO2e per unit FTE employee'
  },
  {
    value: 'Metric tons CO2e per unit hour worked',
    label: 'Metric tons CO2e per unit hour worked'
  },
  {
    value: 'Metric tons CO2e per metric ton of product',
    label: 'Metric tons CO2e per metric ton of product'
  },
  {
    value: 'Metric tons of CO2e per liter of product',
    label: 'Metric tons of CO2e per liter of product'
  },
  {
    value: 'Metric tons CO2e per unit of production',
    label: 'Metric tons CO2e per unit of production'
  },
  {
    value: 'Metric tons CO2e per unit of service provided',
    label: 'Metric tons CO2e per unit of service provided'
  },
  {
    value: 'Metric tons CO2e per square foot',
    label: 'Metric tons CO2e per square foot'
  },
  {
    value: 'Metric tons CO2e per kilometer',
    label: 'Metric tons CO2e per kilometer'
  },
  {
    value: 'Metric tons CO2e per passenger kilometer',
    label: 'Metric tons CO2e per passenger kilometer'
  },
  {
    value: 'Metric tons CO2e per megawatt hour (MWh)',
    label: 'Metric tons CO2e per megawatt hour (MWh)'
  },
  {
    value: 'Metric tons CO2e per barrel of oil equivalent (BOE)',
    label: 'Metric tons CO2e per barrel of oil equivalent (BOE)'
  },
  {
    value: 'Metric tons CO2e per vehicle produced',
    label: 'Metric tons CO2e per vehicle produced'
  },
  {
    value: 'Metric tons CO2e per metric ton of ore processed',
    label: 'Metric tons CO2e per metric ton of ore processed'
  },
  {
    value: 'Metric tons CO2e per ounce of gold',
    label: 'Metric tons CO2e per ounce of gold'
  },
  {
    value: 'Metric tons CO2e per ounce of platinum',
    label: 'Metric tons CO2e per ounce of platinum'
  },
  {
    value: 'Metric tons of CO2e per metric ton of aggregate',
    label: 'Metric tons of CO2e per metric ton of aggregate'
  },
  {
    value: 'Metric tons of CO2e per billion (currency) funds under management',
    label: 'Metric tons of CO2e per billion (currency) funds under management'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRIMARY_REASONS_OPTIONS = [
  {
    value: 'We are planning to introduce a target in the next two years',
    label: 'We are planning to introduce a target in the next two years'
  },
  {
    value: 'Important but not an immediate business priority',
    label: 'Important but not an immediate business priority'
  },
  {
    value: 'Judged to be unimportant, explanation provided',
    label: 'Judged to be unimportant, explanation provided'
  },
  {value: 'Lack of internal resources', label: 'Lack of internal resources'},
  {
    value: 'Insufficient data on operations',
    label: 'Insufficient data on operations'
  },
  {
    value: 'No instruction from management',
    label: 'No instruction from management'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const LOW_OPTIONS = [
  {value: 'Low 1', label: 'Low 1'},
  {value: 'Low 2', label: 'Low 2'},
  {value: 'Low 3', label: 'Low 3'},
  {value: 'Low 4', label: 'Low 4'},
  {value: 'Low 5', label: 'Low 5'},
  {value: 'Low 6', label: 'Low 6'},
  {value: 'Low 7', label: 'Low 7'},
  {value: 'Low 8', label: 'Low 8'},
  {value: 'Low 9', label: 'Low 9'},
  {value: 'Low 10', label: 'Low 10'},
  {value: 'Low 11', label: 'Low 11'},
  {value: 'Low 12', label: 'Low 12'},
  {value: 'Low 13', label: 'Low 13'},
  {value: 'Low 14', label: 'Low 14'},
  {value: 'Low 15', label: 'Low 15'},
  {value: 'Low 16', label: 'Low 16'},
  {value: 'Low 17', label: 'Low 17'},
  {value: 'Low 18', label: 'Low 18'},
  {value: 'Low 19', label: 'Low 19'},
  {value: 'Low 20', label: 'Low 20'},
  {value: 'Low 21', label: 'Low 21'},
  {value: 'Low 22', label: 'Low 22'},
  {value: 'Low 23', label: 'Low 23'},
  {value: 'Low 24', label: 'Low 24'},
  {value: 'Low 25', label: 'Low 25'},
  {value: 'Low 26', label: 'Low 26'},
  {value: 'Low 27', label: 'Low 27'},
  {value: 'Low 28', label: 'Low 28'},
  {value: 'Low 29', label: 'Low 29'},
  {value: 'Low 30', label: 'Low 30'},
  {value: 'Low 31', label: 'Low 31'},
  {value: 'Low 32', label: 'Low 32'},
  {value: 'Low 33', label: 'Low 33'},
  {value: 'Low 34', label: 'Low 34'},
  {value: 'Low 35', label: 'Low 35'},
  {value: 'Low 36', label: 'Low 36'},
  {value: 'Low 37', label: 'Low 37'},
  {value: 'Low 38', label: 'Low 38'},
  {value: 'Low 39', label: 'Low 39'},
  {value: 'Low 40', label: 'Low 40'},
  {value: 'Low 41', label: 'Low 41'},
  {value: 'Low 42', label: 'Low 42'},
  {value: 'Low 43', label: 'Low 43'},
  {value: 'Low 44', label: 'Low 44'},
  {value: 'Low 45', label: 'Low 45'},
  {value: 'Low 46', label: 'Low 46'},
  {value: 'Low 47', label: 'Low 47'},
  {value: 'Low 48', label: 'Low 48'},
  {value: 'Low 49', label: 'Low 49'},
  {value: 'Low 50', label: 'Low 50'},
  {value: 'Low 51', label: 'Low 51'},
  {value: 'Low 52', label: 'Low 52'},
  {value: 'Low 53', label: 'Low 53'},
  {value: 'Low 54', label: 'Low 54'},
  {value: 'Low 55', label: 'Low 55'},
  {value: 'Low 56', label: 'Low 56'},
  {value: 'Low 57', label: 'Low 57'},
  {value: 'Low 58', label: 'Low 58'},
  {value: 'Low 59', label: 'Low 59'},
  {value: 'Low 60', label: 'Low 60'},
  {value: 'Low 61', label: 'Low 61'},
  {value: 'Low 62', label: 'Low 62'},
  {value: 'Low 63', label: 'Low 63'},
  {value: 'Low 64', label: 'Low 64'},
  {value: 'Low 65', label: 'Low 65'},
  {value: 'Low 66', label: 'Low 66'},
  {value: 'Low 67', label: 'Low 67'},
  {value: 'Low 68', label: 'Low 68'},
  {value: 'Low 69', label: 'Low 69'},
  {value: 'Low 70', label: 'Low 70'},
  {value: 'Low 71', label: 'Low 71'},
  {value: 'Low 72', label: 'Low 72'},
  {value: 'Low 73', label: 'Low 73'},
  {value: 'Low 74', label: 'Low 74'},
  {value: 'Low 75', label: 'Low 75'},
  {value: 'Low 76', label: 'Low 76'},
  {value: 'Low 77', label: 'Low 77'},
  {value: 'Low 78', label: 'Low 78'},
  {value: 'Low 79', label: 'Low 79'},
  {value: 'Low 80', label: 'Low 80'},
  {value: 'Low 81', label: 'Low 81'},
  {value: 'Low 82', label: 'Low 82'},
  {value: 'Low 83', label: 'Low 83'},
  {value: 'Low 84', label: 'Low 84'},
  {value: 'Low 85', label: 'Low 85'},
  {value: 'Low 86', label: 'Low 86'},
  {value: 'Low 87', label: 'Low 87'},
  {value: 'Low 88', label: 'Low 88'},
  {value: 'Low 89', label: 'Low 89'},
  {value: 'Low 90', label: 'Low 90'},
  {value: 'Low 91', label: 'Low 91'},
  {value: 'Low 92', label: 'Low 92'},
  {value: 'Low 93', label: 'Low 93'},
  {value: 'Low 94', label: 'Low 94'},
  {value: 'Low 95', label: 'Low 95'},
  {value: 'Low 96', label: 'Low 96'},
  {value: 'Low 97', label: 'Low 97'},
  {value: 'Low 98', label: 'Low 98'},
  {value: 'Low 99', label: 'Low 99'},
  {value: 'Low 100', label: 'Low 100'}
];

export const TARGET_TYPE_OPTIONS = [
  {value: 'Green finance', label: 'Green finance'},
  {
    value: 'Sector Decarbonization Approach (SDA)',
    label: 'Sector Decarbonization Approach (SDA)'
  },
  {value: 'Portfolio coverage', label: 'Portfolio coverage'},
  {
    value: 'Portfolio temperature rating target',
    label: 'Portfolio temperature rating target'
  },
  {
    value: 'Absolute portfolio emissions',
    label: 'Absolute portfolio emissions'
  },
  {
    value: 'Portfolio emissions intensity',
    label: 'Portfolio emissions intensity'
  },
  {
    value: 'Weighted average carbon intensity',
    label: 'Weighted average carbon intensity'
  },
  {value: 'Engagement target', label: 'Engagement target'},
  {
    value: 'Adaptation and resilience target',
    label: 'Adaptation and resilience target'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TAXONOMY_OR_FRAMEWORK_USED_TO_DEFINE_GREEN_FINANCE_OPTIONS = [
  {
    value: 'EU Taxonomy for Sustainable Activities',
    label: 'EU Taxonomy for Sustainable Activities'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METHODOLOGY_USED_WHEN_SETTING_THE_TARGET_OPTIONS = [
  {
    value: 'PAII’s Net Zero Investment Framework',
    label: 'PAII’s Net Zero Investment Framework'
  },
  {
    value: 'SBTi for Financial Institutions',
    label: 'SBTi for Financial Institutions'
  },
  {
    value: 'NZAOA Target Setting Protocol',
    label: 'NZAOA Target Setting Protocol'
  },
  {
    value: 'NZBA Target Setting Guidelines',
    label: 'NZBA Target Setting Guidelines'
  },
  {
    value: 'NZIA Target Setting Protocol',
    label: 'NZIA Target Setting Protocol'
  },
  {value: 'A combination of the above', label: 'A combination of the above'},
  {value: 'Own methodology', label: 'Own methodology'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TARGET_IS_SET_AND_PROGRESS_AGAINST_IT_IS_TRACKED_AT_OPTIONS = [
  {value: 'Sector level', label: 'Sector level'},
  {value: 'Portfolio level', label: 'Portfolio level'},
  {value: 'Asset class level', label: 'Asset class level'}
];

export const SECTOR_OPTIONS = [
  {value: 'Apparel', label: 'Apparel'},
  {
    value: 'Biotech, health care & pharma',
    label: 'Biotech, health care & pharma'
  },
  {
    value: 'Food, beverage & agriculture',
    label: 'Food, beverage & agriculture'
  },
  {value: 'Fossil fuels', label: 'Fossil fuels'},
  {value: 'Hospitality', label: 'Hospitality'},
  {value: 'Infrastructure', label: 'Infrastructure'},
  {value: 'International bodies', label: 'International bodies'},
  {value: 'Manufacturing', label: 'Manufacturing'},
  {value: 'Materials', label: 'Materials'},
  {value: 'Power generation', label: 'Power generation'},
  {value: 'Retail', label: 'Retail'},
  {value: 'Services', label: 'Services'},
  {value: 'Transportation services', label: 'Transportation services'}
];

export const PORTFOLIOS_COVERED_BY_THE_TARGET_OPTIONS = [
  {value: 'Banking (Bank)', label: 'Banking (Bank)'},
  {value: 'Investing (Asset manager)', label: 'Investing (Asset manager)'},
  {value: 'Investing (Asset owner)', label: 'Investing (Asset owner)'},
  {
    value: 'Insurance underwriting (Insurance company)',
    label: 'Insurance underwriting (Insurance company)'
  }
];

export const ASSET_CLASSES_COVERED_BY_THE_TARGET_OPTIONS = [
  {value: 'Loans', label: 'Loans'},
  {value: 'Project finance', label: 'Project finance'},
  {value: 'Bonds', label: 'Bonds'},
  {value: 'Equity investments', label: 'Equity investments'},
  {value: 'Undrawn loan commitments', label: 'Undrawn loan commitments'},
  {value: 'Fixed income', label: 'Fixed income'},
  {
    value: 'Cash equivalents/money market instruments',
    label: 'Cash equivalents/money market instruments'
  },
  {value: 'Real estate', label: 'Real estate'},
  {value: 'Commodities', label: 'Commodities'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TARGET_TYPE_ABSOLUTE_OR_INTENSITY_OPTIONS = [
  {value: 'Absolute', label: 'Absolute'},
  {value: 'Intensity', label: 'Intensity'}
];

export const EMISSIONS_SCOPES_OF_PORTFOLIO_COMPANIES_COVERED_BY_THE_TARGET_OPTIONS =
  [
    {value: 'Scope 1 + 2', label: 'Scope 1 + 2'},
    {value: 'Scope 1 + 2 + 3', label: 'Scope 1 + 2 + 3'}
  ];

export const METRIC_OR_TARGET_NUMERATOR_IF_INTENSITY_OPTIONS = [
  {
    label: 'Green Finance',
    options: [
      {
        value:
          'Total green finance raised and facilitated (unit currency as reported in 1.2)',
        label:
          'Total green finance raised and facilitated (unit currency as reported in 1.2)'
      },
      {
        value: 'Total green investments (unit currency as reported in 1.2)',
        label: 'Total green investments (unit currency as reported in 1.2)'
      },
      {
        value:
          'Total green bonds outstanding (unit currency as reported in 1.2)',
        label:
          'Total green bonds outstanding (unit currency as reported in 1.2)'
      },
      {
        value:
          'Total green debt instruments outstanding (unit currency as reported in 1.2)',
        label:
          'Total green debt instruments outstanding (unit currency as reported in 1.2)'
      },
      {
        value: 'Green asset ratio based on turnover in the reporting year',
        label: 'Green asset ratio based on turnover in the reporting year'
      },
      {
        value: 'Green asset ratio based on CAPEX in the reporting year',
        label: 'Green asset ratio based on CAPEX in the reporting year'
      },
      {
        value: 'Other, green finance metric, please specify',
        label: 'Other, green finance metric, please specify'
      }
    ]
  },
  {
    label: 'Sector Decarbonization Approach (SDA)',
    options: [
      {value: 'Metric tons CO₂e', label: 'Metric tons CO₂e'},
      {
        value: 'Other, SDA metric, please specify',
        label: 'Other, SDA metric, please specify'
      }
    ]
  },
  {
    label: 'Portfolio Coverage',
    options: [
      {
        value: '% of portfolio setting a Science-Based Target',
        label: '% of portfolio setting a Science-Based Target'
      },
      {value: '% of taxonomy alignment', label: '% of taxonomy alignment'},
      {
        value: '% of portfolio covered under transition finance framework',
        label: '% of portfolio covered under transition finance framework'
      },
      {
        value: 'Other, portfolio coverage metric, please specify',
        label: 'Other, portfolio coverage metric, please specify'
      }
    ]
  },
  {
    label: 'Portfolio Temperature Rating Target',
    options: [{value: 'Degrees of warming', label: 'Degrees of warming'}]
  },
  {
    label: 'Absolute Portfolio Emissions',
    options: [{value: 'tCO₂e', label: 'tCO₂e'}]
  },
  {
    label: 'Portfolio Emissions Intensity',
    options: [{value: 'tCO₂e', label: 'tCO₂e'}]
  },
  {
    label: 'Weighted Average Carbon Intensity',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Engagement Target',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Other, please specify',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const TARGET_DENOMINATOR_OPTIONS = [
  {
    label: 'Green Finance Denominators',
    options: [
      {
        value: 'Total finance raised and facilitated',
        label: 'Total finance raised and facilitated'
      },
      {value: 'Total investments', label: 'Total investments'},
      {value: 'Total bonds outstanding', label: 'Total bonds outstanding'},
      {
        value: 'Total debt instruments outstanding',
        label: 'Total debt instruments outstanding'
      },
      {
        value: 'Other, green finance denominator, please specify',
        label: 'Other, green finance denominator, please specify'
      }
    ]
  },
  {
    label: 'SDA Denominators',
    options: [
      {value: 'Meters squared', label: 'Meters squared'},
      {value: 'kWh', label: 'kWh'},
      {value: 'Ton cement', label: 'Ton cement'},
      {value: 'Ton pulp and paper', label: 'Ton pulp and paper'},
      {value: 'km', label: 'km'},
      {value: 'Passenger km', label: 'Passenger km'},
      {value: 'Ton km', label: 'Ton km'},
      {value: 'Vehicle km', label: 'Vehicle km'},
      {value: 'Ton iron and steel', label: 'Ton iron and steel'},
      {value: 'Ton aluminum', label: 'Ton aluminum'},
      {
        value: 'Other, SDA denominator, please specify',
        label: 'Other, SDA denominator, please specify'
      }
    ]
  },
  {
    label: 'Portfolio Emissions Intensity Denominators',
    options: [
      {value: 'Million revenues', label: 'Million revenues'},
      {value: 'Million invested', label: 'Million invested'}
    ]
  },
  {
    label: 'Weighted Average Carbon Intensity',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Engagement Target',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Other, please specify',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const FREQUENCY_OF_TARGET_REVIEWS_OPTIONS = [
  {value: 'Quarterly', label: 'Quarterly'},
  {value: 'Semiannually', label: 'Semiannually'},
  {value: 'Annually', label: 'Annually'},
  {value: 'Every five years', label: 'Every five years'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const AGGREGATION_WEIGHTING_USED_OPTIONS = [
  {
    value: 'Weighted Average Temperature Score (WATS)',
    label: 'Weighted Average Temperature Score (WATS)'
  },
  {
    value: 'Total Emissions Weighted Temperature Score (TETS)',
    label: 'Total Emissions Weighted Temperature Score (TETS)'
  },
  {
    value: 'Market Owned Emissions Weighted Temperature Score (MOTS)',
    label: 'Market Owned Emissions Weighted Temperature Score (MOTS)'
  },
  {
    value: 'Enterprise Owned Emissions Weighted Temperature Score (EOTS)',
    label: 'Enterprise Owned Emissions Weighted Temperature Score (EOTS)'
  },
  {
    value:
      'Enterprise Value (EV) + Cash Emissions Weighted Temperature Score (ECOTS)',
    label:
      'Enterprise Value (EV) + Cash Emissions Weighted Temperature Score (ECOTS)'
  },
  {
    value: 'Total Assets Emissions Weighted Temperature Score (AOTS)',
    label: 'Total Assets Emissions Weighted Temperature Score (AOTS)'
  },
  {
    value: 'Revenue Owned Emissions Weighted Temperature Score (ROTS)',
    label: 'Revenue Owned Emissions Weighted Temperature Score (ROTS)'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const SCIENCE_BASED_TARGET_OPTIONS_2 = [
  {
    value:
      'Yes, and this target has been approved by the Science Based Targets initiative',
    label:
      'Yes, and this target has been approved by the Science Based Targets initiative'
  },
  {
    value:
      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years',
    label:
      'Yes, we consider this a science-based target, and we have committed to seek validation of this target by the Science Based Targets initiative in the next two years'
  },
  {
    value:
      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative',
    label:
      'Yes, we consider this a science-based target, and the target is currently being reviewed by the Science Based Targets initiative'
  },
  {
    value:
      'Yes, we consider this a science-based target, it has been set in line with the Glasgow Financial Alliance for Net Zero (GFANZ) commitments, and we have committed to seek validation by, or it is currently being reviewed by, the Science Based Targets initiative',
    label:
      'Yes, we consider this a science-based target, it has been set in line with the Glasgow Financial Alliance for Net Zero (GFANZ) commitments, and we have committed to seek validation by, or it is currently being reviewed by, the Science Based Targets initiative'
  },
  {
    value:
      'Yes, we consider this a science-based target, and it has been set in line with the Glasgow Financial Alliance for Net Zero (GFANZ) commitments, but we have not committed to seek validation by the Science Based Targets initiative within the next two years',
    label:
      'Yes, we consider this a science-based target, and it has been set in line with the Glasgow Financial Alliance for Net Zero (GFANZ) commitments, but we have not committed to seek validation by the Science Based Targets initiative within the next two years'
  },
  {
    value: 'No, but we are reporting another target that is science-based',
    label: 'No, but we are reporting another target that is science-based'
  },
  {
    value: 'No, but we anticipate setting one in the next two years',
    label: 'No, but we anticipate setting one in the next two years'
  },
  {
    value: 'No, and we do not anticipate setting one in the next two years',
    label: 'No, and we do not anticipate setting one in the next two years'
  }
];

export const POR_OPTIONS = [
  {value: 'Por 1', label: 'Por 1'},
  {value: 'Por 2', label: 'Por 2'},
  {value: 'Por 3', label: 'Por 3'},
  {value: 'Por 4', label: 'Por 4'},
  {value: 'Por 5', label: 'Por 5'},
  {value: 'Por 6', label: 'Por 6'},
  {value: 'Por 7', label: 'Por 7'},
  {value: 'Por 8', label: 'Por 8'},
  {value: 'Por 9', label: 'Por 9'},
  {value: 'Por 10', label: 'Por 10'},
  {value: 'Por 11', label: 'Por 11'},
  {value: 'Por 12', label: 'Por 12'},
  {value: 'Por 13', label: 'Por 13'},
  {value: 'Por 14', label: 'Por 14'},
  {value: 'Por 15', label: 'Por 15'},
  {value: 'Por 16', label: 'Por 16'},
  {value: 'Por 17', label: 'Por 17'},
  {value: 'Por 18', label: 'Por 18'},
  {value: 'Por 19', label: 'Por 19'},
  {value: 'Por 20', label: 'Por 20'},
  {value: 'Por 21', label: 'Por 21'},
  {value: 'Por 22', label: 'Por 22'},
  {value: 'Por 23', label: 'Por 23'},
  {value: 'Por 24', label: 'Por 24'},
  {value: 'Por 25', label: 'Por 25'},
  {value: 'Por 26', label: 'Por 26'},
  {value: 'Por 27', label: 'Por 27'},
  {value: 'Por 28', label: 'Por 28'},
  {value: 'Por 29', label: 'Por 29'},
  {value: 'Por 30', label: 'Por 30'},
  {value: 'Por 31', label: 'Por 31'},
  {value: 'Por 32', label: 'Por 32'},
  {value: 'Por 33', label: 'Por 33'},
  {value: 'Por 34', label: 'Por 34'},
  {value: 'Por 35', label: 'Por 35'},
  {value: 'Por 36', label: 'Por 36'},
  {value: 'Por 37', label: 'Por 37'},
  {value: 'Por 38', label: 'Por 38'},
  {value: 'Por 39', label: 'Por 39'},
  {value: 'Por 40', label: 'Por 40'},
  {value: 'Por 41', label: 'Por 41'},
  {value: 'Por 42', label: 'Por 42'},
  {value: 'Por 43', label: 'Por 43'},
  {value: 'Por 44', label: 'Por 44'},
  {value: 'Por 45', label: 'Por 45'},
  {value: 'Por 46', label: 'Por 46'},
  {value: 'Por 47', label: 'Por 47'},
  {value: 'Por 48', label: 'Por 48'},
  {value: 'Por 49', label: 'Por 49'},
  {value: 'Por 50', label: 'Por 50'},
  {value: 'Por 51', label: 'Por 51'},
  {value: 'Por 52', label: 'Por 52'},
  {value: 'Por 53', label: 'Por 53'},
  {value: 'Por 54', label: 'Por 54'},
  {value: 'Por 55', label: 'Por 55'},
  {value: 'Por 56', label: 'Por 56'},
  {value: 'Por 57', label: 'Por 57'},
  {value: 'Por 58', label: 'Por 58'},
  {value: 'Por 59', label: 'Por 59'},
  {value: 'Por 60', label: 'Por 60'},
  {value: 'Por 61', label: 'Por 61'},
  {value: 'Por 62', label: 'Por 62'},
  {value: 'Por 63', label: 'Por 63'},
  {value: 'Por 64', label: 'Por 64'},
  {value: 'Por 65', label: 'Por 65'},
  {value: 'Por 66', label: 'Por 66'},
  {value: 'Por 67', label: 'Por 67'},
  {value: 'Por 68', label: 'Por 68'},
  {value: 'Por 69', label: 'Por 69'},
  {value: 'Por 70', label: 'Por 70'},
  {value: 'Por 71', label: 'Por 71'},
  {value: 'Por 72', label: 'Por 72'},
  {value: 'Por 73', label: 'Por 73'},
  {value: 'Por 74', label: 'Por 74'},
  {value: 'Por 75', label: 'Por 75'},
  {value: 'Por 76', label: 'Por 76'},
  {value: 'Por 77', label: 'Por 77'},
  {value: 'Por 78', label: 'Por 78'},
  {value: 'Por 79', label: 'Por 79'},
  {value: 'Por 80', label: 'Por 80'},
  {value: 'Por 81', label: 'Por 81'},
  {value: 'Por 82', label: 'Por 82'},
  {value: 'Por 83', label: 'Por 83'},
  {value: 'Por 84', label: 'Por 84'},
  {value: 'Por 85', label: 'Por 85'},
  {value: 'Por 86', label: 'Por 86'},
  {value: 'Por 87', label: 'Por 87'},
  {value: 'Por 88', label: 'Por 88'},
  {value: 'Por 89', label: 'Por 89'},
  {value: 'Por 90', label: 'Por 90'},
  {value: 'Por 91', label: 'Por 91'},
  {value: 'Por 92', label: 'Por 92'},
  {value: 'Por 93', label: 'Por 93'},
  {value: 'Por 94', label: 'Por 94'},
  {value: 'Por 95', label: 'Por 95'},
  {value: 'Por 96', label: 'Por 96'},
  {value: 'Por 97', label: 'Por 97'},
  {value: 'Por 98', label: 'Por 98'},
  {value: 'Por 99', label: 'Por 99'},
  {value: 'Por 100', label: 'Por 100'}
];

export const TARGET_TYPE_ENERGY_CARRIER_OPTIONS = [
  {value: 'Electricity', label: 'Electricity'},
  {value: 'Heat', label: 'Heat'},
  {value: 'Steam', label: 'Steam'},
  {value: 'Cooling', label: 'Cooling'},
  {value: 'All energy carriers', label: 'All energy carriers'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TARGET_TYPE_ACTIVITY_OPTIONS = [
  {value: 'Consumption', label: 'Consumption'},
  {value: 'Production', label: 'Production'}
];

export const TARGET_TYPE_ENERGY_SOURCE_OPTIONS = [
  {value: 'Low-carbon energy source(s)', label: 'Low-carbon energy source(s)'},
  {
    value: 'Renewable energy source(s) only',
    label: 'Renewable energy source(s) only'
  }
];

export const TARGET_IS_PART_OF_AN_OVERARCHING_INITIATIVE_OPTIONS = [
  {value: 'RE100', label: 'RE100'},
  {
    value: 'Science Based Targets initiative',
    label: 'Science Based Targets initiative'
  },
  {
    value: 'No, it’s not part of an overarching initiative',
    label: 'No, it’s not part of an overarching initiative'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const OTH_OPTIONS = [
  {label: 'Oth 1', value: 'Oth 1'},
  {label: 'Oth 2', value: 'Oth 2'},
  {label: 'Oth 3', value: 'Oth 3'},
  {label: 'Oth 4', value: 'Oth 4'},
  {label: 'Oth 5', value: 'Oth 5'},
  {label: 'Oth 6', value: 'Oth 6'},
  {label: 'Oth 7', value: 'Oth 7'},
  {label: 'Oth 8', value: 'Oth 8'},
  {label: 'Oth 9', value: 'Oth 9'},
  {label: 'Oth 10', value: 'Oth 10'},
  {label: 'Oth 11', value: 'Oth 11'},
  {label: 'Oth 12', value: 'Oth 12'},
  {label: 'Oth 13', value: 'Oth 13'},
  {label: 'Oth 14', value: 'Oth 14'},
  {label: 'Oth 15', value: 'Oth 15'},
  {label: 'Oth 16', value: 'Oth 16'},
  {label: 'Oth 17', value: 'Oth 17'},
  {label: 'Oth 18', value: 'Oth 18'},
  {label: 'Oth 19', value: 'Oth 19'},
  {label: 'Oth 20', value: 'Oth 20'},
  {label: 'Oth 21', value: 'Oth 21'},
  {label: 'Oth 22', value: 'Oth 22'},
  {label: 'Oth 23', value: 'Oth 23'},
  {label: 'Oth 24', value: 'Oth 24'},
  {label: 'Oth 25', value: 'Oth 25'},
  {label: 'Oth 26', value: 'Oth 26'},
  {label: 'Oth 27', value: 'Oth 27'},
  {label: 'Oth 28', value: 'Oth 28'},
  {label: 'Oth 29', value: 'Oth 29'},
  {label: 'Oth 30', value: 'Oth 30'},
  {label: 'Oth 31', value: 'Oth 31'},
  {label: 'Oth 32', value: 'Oth 32'},
  {label: 'Oth 33', value: 'Oth 33'},
  {label: 'Oth 34', value: 'Oth 34'},
  {label: 'Oth 35', value: 'Oth 35'},
  {label: 'Oth 36', value: 'Oth 36'},
  {label: 'Oth 37', value: 'Oth 37'},
  {label: 'Oth 38', value: 'Oth 38'},
  {label: 'Oth 39', value: 'Oth 39'},
  {label: 'Oth 40', value: 'Oth 40'},
  {label: 'Oth 41', value: 'Oth 41'},
  {label: 'Oth 42', value: 'Oth 42'},
  {label: 'Oth 43', value: 'Oth 43'},
  {label: 'Oth 44', value: 'Oth 44'},
  {label: 'Oth 45', value: 'Oth 45'},
  {label: 'Oth 46', value: 'Oth 46'},
  {label: 'Oth 47', value: 'Oth 47'},
  {label: 'Oth 48', value: 'Oth 48'},
  {label: 'Oth 49', value: 'Oth 49'},
  {label: 'Oth 50', value: 'Oth 50'},
  {label: 'Oth 51', value: 'Oth 51'},
  {label: 'Oth 52', value: 'Oth 52'},
  {label: 'Oth 53', value: 'Oth 53'},
  {label: 'Oth 54', value: 'Oth 54'},
  {label: 'Oth 55', value: 'Oth 55'},
  {label: 'Oth 56', value: 'Oth 56'},
  {label: 'Oth 57', value: 'Oth 57'},
  {label: 'Oth 58', value: 'Oth 58'},
  {label: 'Oth 59', value: 'Oth 59'},
  {label: 'Oth 60', value: 'Oth 60'},
  {label: 'Oth 61', value: 'Oth 61'},
  {label: 'Oth 62', value: 'Oth 62'},
  {label: 'Oth 63', value: 'Oth 63'},
  {label: 'Oth 64', value: 'Oth 64'},
  {label: 'Oth 65', value: 'Oth 65'},
  {label: 'Oth 66', value: 'Oth 66'},
  {label: 'Oth 67', value: 'Oth 67'},
  {label: 'Oth 68', value: 'Oth 68'},
  {label: 'Oth 69', value: 'Oth 69'},
  {label: 'Oth 70', value: 'Oth 70'},
  {label: 'Oth 71', value: 'Oth 71'},
  {label: 'Oth 72', value: 'Oth 72'},
  {label: 'Oth 73', value: 'Oth 73'},
  {label: 'Oth 74', value: 'Oth 74'},
  {label: 'Oth 75', value: 'Oth 75'},
  {label: 'Oth 76', value: 'Oth 76'},
  {label: 'Oth 77', value: 'Oth 77'},
  {label: 'Oth 78', value: 'Oth 78'},
  {label: 'Oth 79', value: 'Oth 79'},
  {label: 'Oth 80', value: 'Oth 80'},
  {label: 'Oth 81', value: 'Oth 81'},
  {label: 'Oth 82', value: 'Oth 82'},
  {label: 'Oth 83', value: 'Oth 83'},
  {label: 'Oth 84', value: 'Oth 84'},
  {label: 'Oth 85', value: 'Oth 85'},
  {label: 'Oth 86', value: 'Oth 86'},
  {label: 'Oth 87', value: 'Oth 87'},
  {label: 'Oth 88', value: 'Oth 88'},
  {label: 'Oth 89', value: 'Oth 89'},
  {label: 'Oth 90', value: 'Oth 90'},
  {label: 'Oth 91', value: 'Oth 91'},
  {label: 'Oth 92', value: 'Oth 92'},
  {label: 'Oth 93', value: 'Oth 93'},
  {label: 'Oth 94', value: 'Oth 94'},
  {label: 'Oth 95', value: 'Oth 95'},
  {label: 'Oth 96', value: 'Oth 96'},
  {label: 'Oth 97', value: 'Oth 97'},
  {label: 'Oth 98', value: 'Oth 98'},
  {label: 'Oth 99', value: 'Oth 99'},
  {label: 'Oth 100', value: 'Oth 100'}
];

export const TARGET_TYPE_CATEGORY_METRIC_OPTIONS = [
  {
    label: 'Energy Productivity',
    options: [
      {value: 'GDP', label: 'GDP'},
      {value: 'USD($) value-added', label: 'USD($) value-added'},
      {value: 'Units of revenue', label: 'Units of revenue'},
      {value: 'Ounces of gold', label: 'Ounces of gold'},
      {value: 'Ounces of platinum', label: 'Ounces of platinum'},
      {value: 'Metric tons of aggregate', label: 'Metric tons of aggregate'},
      {value: 'Metric tons of aluminum', label: 'Metric tons of aluminum'},
      {value: 'Metric tons of steel', label: 'Metric tons of steel'},
      {value: 'Metric tons of cement', label: 'Metric tons of cement'},
      {value: 'Metric tons of cardboard', label: 'Metric tons of cardboard'},
      {value: 'Metric tons of product', label: 'Metric tons of product'},
      {
        value: 'Metric tons of ore processed',
        label: 'Metric tons of ore processed'
      },
      {value: 'Square meters', label: 'Square meters'},
      {value: 'Kilometers', label: 'Kilometers'},
      {value: 'Passenger kilometers', label: 'Passenger kilometers'},
      {
        value: 'Revenue passenger kilometers',
        label: 'Revenue passenger kilometers'
      },
      {value: 'Liters of product', label: 'Liters of product'},
      {value: 'Units of production', label: 'Units of production'},
      {value: 'Units of service provided', label: 'Units of service provided'},
      {value: 'Square feet', label: 'Square feet'},
      {value: 'Megawatt hours (MWh)', label: 'Megawatt hours (MWh)'},
      {
        value: 'Barrels of oil equivalent (BOE)',
        label: 'Barrels of oil equivalent (BOE)'
      },
      {
        value: 'Tons of oil equivalent (TOE)',
        label: 'Tons of oil equivalent (TOE)'
      },
      {
        value: 'Tons of coal equivalent (TCE)',
        label: 'Tons of coal equivalent (TCE)'
      },
      {
        value: 'Other energy productivity, please specify.',
        label: 'Other energy productivity, please specify.'
      }
    ]
  },
  {
    label: 'Energy Consumption or Efficiency',
    options: [
      {value: 'kWh', label: 'kWh'},
      {value: 'MWh', label: 'MWh'},
      {value: 'GJ', label: 'GJ'},
      {value: 'Million Btu', label: 'Million Btu'},
      {value: 'boe', label: 'boe'},
      {value: 'toe', label: 'toe'},
      {value: 'tce', label: 'tce'},
      {value: 'Gcal', label: 'Gcal'},
      {
        value: 'Other energy consumption or efficiency, please specify.',
        label: 'Other energy consumption or efficiency, please specify.'
      }
    ]
  },
  {
    label: 'Resource Consumption or Efficiency',
    options: [
      {
        value:
          'Percentage of paper from recycled or certified sustainable sources',
        label:
          'Percentage of paper from recycled or certified sustainable sources'
      },
      {
        value: 'Metric tons of paper consumed',
        label: 'Metric tons of paper consumed'
      },
      {
        value: 'Percentage of plastic from recycled sources',
        label: 'Percentage of plastic from recycled sources'
      },
      {
        value: 'Metric tons of plastic consumed',
        label: 'Metric tons of plastic consumed'
      },
      {
        value:
          'Percentage of packaging from recycled or certified sustainable sources',
        label:
          'Percentage of packaging from recycled or certified sustainable sources'
      },
      {
        value: 'Metric tons of packaging consumed',
        label: 'Metric tons of packaging consumed'
      },
      {
        value: 'Other resource consumption or efficiency, please specify.',
        label: 'Other resource consumption or efficiency, please specify.'
      }
    ]
  },
  {
    label: 'Net Emissions Target',
    options: [
      {value: 'Net metric tons CO₂e', label: 'Net metric tons CO₂e'},
      {
        value: 'Other net emissions target, please specify.',
        label: 'Other net emissions target, please specify.'
      }
    ]
  },
  {
    label: 'Low-Carbon Vehicles',
    options: [
      {
        value: 'Percentage of low-carbon vehicles in company fleet',
        label: 'Percentage of low-carbon vehicles in company fleet'
      },
      {
        value: 'Percentage of low-carbon vehicles sold',
        label: 'Percentage of low-carbon vehicles sold'
      },
      {
        value: 'Percentage of company fleet using biofuel',
        label: 'Percentage of company fleet using biofuel'
      },
      {
        value: 'Percentage of battery electric vehicles in company fleet',
        label: 'Percentage of battery electric vehicles in company fleet'
      },
      {
        value: 'Percentage of conventional hybrids in company fleet',
        label: 'Percentage of conventional hybrids in company fleet'
      },
      {
        value: 'Percentage of plug-in hybrids in company fleet',
        label: 'Percentage of plug-in hybrids in company fleet'
      },
      {
        value: 'Percentage of fuel cell electric vehicles in company fleet',
        label: 'Percentage of fuel cell electric vehicles in company fleet'
      },
      {
        value:
          'Percentage of company facilities with electric vehicle infrastructure',
        label:
          'Percentage of company facilities with electric vehicle infrastructure'
      },
      {
        value: 'Other low-carbon vehicles, please specify.',
        label: 'Other low-carbon vehicles, please specify.'
      }
    ]
  },
  {
    label: 'Low Carbon Buildings',
    options: [
      {
        value: 'Percentage of net zero carbon buildings',
        label: 'Percentage of net zero carbon buildings'
      },
      {
        value: 'Percentage of net zero energy buildings',
        label: 'Percentage of net zero energy buildings'
      },
      {
        value: 'Percentage of buildings with a green building certificate',
        label: 'Percentage of buildings with a green building certificate'
      },
      {
        value: 'Other low-carbon buildings, please specify.',
        label: 'Other low-carbon buildings, please specify.'
      }
    ]
  },
  {
    label: 'Methane Reduction Target',
    options: [
      {
        value: 'Cubic meters of methane vented',
        label: 'Cubic meters of methane vented'
      },
      {
        value: 'Cubic meters of methane leaked',
        label: 'Cubic meters of methane leaked'
      },
      {
        value: 'Cubic meters of methane flared',
        label: 'Cubic meters of methane flared'
      },
      {
        value: 'Total methane emissions in m³',
        label: 'Total methane emissions in m³'
      },
      {
        value: 'Total methane emissions in CO₂e',
        label: 'Total methane emissions in CO₂e'
      },
      {value: 'Methane leakage rate (%)', label: 'Methane leakage rate (%)'},
      {
        value: 'Other methane reduction target, please specify.',
        label: 'Other methane reduction target, please specify.'
      }
    ]
  },
  {
    label: 'Fossil Fuel Reduction Target',
    options: [
      {
        value: 'Cubic meters of natural gas consumed',
        label: 'Cubic meters of natural gas consumed'
      },
      {
        value: 'Metric tons of coal consumed',
        label: 'Metric tons of coal consumed'
      },
      {value: 'Barrels of oil consumed', label: 'Barrels of oil consumed'},
      {
        value: 'Percentage of fossil fuels in the fuel mix',
        label: 'Percentage of fossil fuels in the fuel mix'
      },
      {
        value: 'Other fossil fuel reduction target, please specify.',
        label: 'Other fossil fuel reduction target, please specify.'
      }
    ]
  },
  {
    label: 'Renewable Fuel Production',
    options: [
      {
        value: 'Metric tons of solid biomass',
        label: 'Metric tons of solid biomass'
      },
      {value: 'Liters of liquid biofuel', label: 'Liters of liquid biofuel'},
      {value: 'Cubic meters of biogas', label: 'Cubic meters of biogas'},
      {value: 'Cubic meters of hydrogen', label: 'Cubic meters of hydrogen'},
      {
        value: 'Other renewable fuel production, please specify.',
        label: 'Other renewable fuel production, please specify.'
      }
    ]
  },
  {
    label: 'Renewable Fuel Consumption',
    options: [
      {
        value: 'Metric tons of solid biomass',
        label: 'Metric tons of solid biomass'
      },
      {value: 'Liters of liquid biofuel', label: 'Liters of liquid biofuel'},
      {value: 'Cubic meters of biogas', label: 'Cubic meters of biogas'},
      {value: 'Cubic meters of hydrogen', label: 'Cubic meters of hydrogen'},
      {
        value:
          'Percentage of total fuel consumption that is from renewable sources',
        label:
          'Percentage of total fuel consumption that is from renewable sources'
      },
      {
        value: 'Other renewable fuel consumption, please specify.',
        label: 'Other renewable fuel consumption, please specify.'
      }
    ]
  },
  {
    label: 'Waste Management',
    options: [
      {
        value: 'Metric tons of waste diverted from landfill',
        label: 'Metric tons of waste diverted from landfill'
      },
      {
        value: 'Metric tons of waste recycled',
        label: 'Metric tons of waste recycled'
      },
      {
        value: 'Metric tons of waste reused',
        label: 'Metric tons of waste reused'
      },
      {
        value: 'Metric tons of waste generated',
        label: 'Metric tons of waste generated'
      },
      {
        value: 'Percentage of total waste generated that is recycled',
        label: 'Percentage of total waste generated that is recycled'
      },
      {
        value: 'Percentage of sites operating at zero-waste to landfill',
        label: 'Percentage of sites operating at zero-waste to landfill'
      },
      {
        value: 'Other waste management, please specify.',
        label: 'Other waste management, please specify.'
      }
    ]
  },
  {
    label: 'Low-Carbon Products',
    options: [
      {
        value: 'Total sales revenue from low-carbon products (in currency)',
        label: 'Total sales revenue from low-carbon products (in currency)'
      },
      {
        value: 'Percentage of revenue from low-carbon products',
        label: 'Percentage of revenue from low-carbon products'
      },
      {
        value: 'Percentage of low-carbon products in organization’s portfolio',
        label: 'Percentage of low-carbon products in organization’s portfolio'
      },
      {
        value:
          'Percentage of products made from recycled or certified sustainable materials',
        label:
          'Percentage of products made from recycled or certified sustainable materials'
      },
      {
        value: 'Percentage of products with low-carbon packaging',
        label: 'Percentage of products with low-carbon packaging'
      },
      {
        value: 'Other low-carbon products, please specify.',
        label: 'Other low-carbon products, please specify.'
      }
    ]
  },
  {
    label: 'Land Use Change',
    options: [
      {value: 'Hectares reforested', label: 'Hectares reforested'},
      {value: 'Hectares afforested', label: 'Hectares afforested'},
      {value: 'Hectares restored', label: 'Hectares restored'},
      {
        value: 'Percent of value chain compliant with zero gross deforestation',
        label: 'Percent of value chain compliant with zero gross deforestation'
      },
      {
        value: 'Other land use change, please specify.',
        label: 'Other land use change, please specify.'
      }
    ]
  },
  {
    label: 'Beyond Value Chain Mitigation (BVCM) Target',
    options: [
      {
        value: 'GHG emissions reductions and removals',
        label: 'GHG emissions reductions and removals'
      },
      {
        value: 'Volume of finance deployed to BVCM',
        label: 'Volume of finance deployed to BVCM'
      },
      {
        value: 'Share of revenue deployed to BVCM',
        label: 'Share of revenue deployed to BVCM'
      },
      {
        value: 'Share of profit deployed to BVCM',
        label: 'Share of profit deployed to BVCM'
      }
    ]
  },
  {
    label: 'Engagement with Suppliers',
    options: [
      {
        value:
          'Percentage of suppliers (by emissions) disclosing their GHG emissions',
        label:
          'Percentage of suppliers (by emissions) disclosing their GHG emissions'
      },
      {
        value:
          'Percentage of suppliers (by procurement spend) disclosing their GHG emissions',
        label:
          'Percentage of suppliers (by procurement spend) disclosing their GHG emissions'
      },
      {
        value:
          'Percentage of suppliers (by emissions) setting emissions reduction targets',
        label:
          'Percentage of suppliers (by emissions) setting emissions reduction targets'
      },
      {
        value:
          'Percentage of suppliers (by procurement spend) setting emissions reduction targets',
        label:
          'Percentage of suppliers (by procurement spend) setting emissions reduction targets'
      },
      {
        value:
          'Percentage of suppliers (by emissions) with a science-based target',
        label:
          'Percentage of suppliers (by emissions) with a science-based target'
      },
      {
        value:
          'Percentage of suppliers (by procurement spend) with a science-based target',
        label:
          'Percentage of suppliers (by procurement spend) with a science-based target'
      },
      {
        value:
          'Percentage of suppliers (by emissions) actively engaged on climate-related issues',
        label:
          'Percentage of suppliers (by emissions) actively engaged on climate-related issues'
      },
      {
        value:
          'Percentage of suppliers (by procurement spend) actively engaged on climate-related issues',
        label:
          'Percentage of suppliers (by procurement spend) actively engaged on climate-related issues'
      },
      {
        value: 'Other engagement with suppliers, please specify.',
        label: 'Other engagement with suppliers, please specify.'
      }
    ]
  },
  {
    label: 'Engagement with Customers',
    options: [
      {
        value:
          'Percentage of customers (by emissions) disclosing their GHG emissions',
        label:
          'Percentage of customers (by emissions) disclosing their GHG emissions'
      },
      {
        value:
          'Percentage of customers (by emissions) setting emissions reduction targets',
        label:
          'Percentage of customers (by emissions) setting emissions reduction targets'
      },
      {
        value:
          'Percentage of customers (by emissions) with a science-based target',
        label:
          'Percentage of customers (by emissions) with a science-based target'
      },
      {
        value:
          'Percentage of customers (by emissions) actively engaged on climate-related issues',
        label:
          'Percentage of customers (by emissions) actively engaged on climate-related issues'
      },
      {
        value: 'Other engagement with customers, please specify.',
        label: 'Other engagement with customers, please specify.'
      }
    ]
  },
  {
    label: 'R&D Investments',
    options: [
      {
        value:
          'Percentage of annual revenue invested in R&D of low-carbon products/services',
        label:
          'Percentage of annual revenue invested in R&D of low-carbon products/services'
      },
      {
        value:
          'Capital invested in R&D of low-carbon products/services (in currency)',
        label:
          'Capital invested in R&D of low-carbon products/services (in currency)'
      },
      {
        value:
          'Percentage of R&D budget/portfolio dedicated to low-carbon products/services',
        label:
          'Percentage of R&D budget/portfolio dedicated to low-carbon products/services'
      },
      {
        value: 'Other R&D investments, please specify.',
        label: 'Other R&D investments, please specify.'
      }
    ]
  },
  {
    label: 'Green Finance',
    options: [
      {
        value: 'Total amount of green bonds outstanding (green bond ratio)',
        label: 'Total amount of green bonds outstanding (green bond ratio)'
      },
      {value: 'Percentage of green bonds', label: 'Percentage of green bonds'},
      {
        value:
          'Total amount of green debt instruments outstanding (green debt ratio)',
        label:
          'Total amount of green debt instruments outstanding (green debt ratio)'
      },
      {
        value: 'Percentage of green debt instruments',
        label: 'Percentage of green debt instruments'
      },
      {
        value: 'Green finance raised and facilitated (denominated in currency)',
        label: 'Green finance raised and facilitated (denominated in currency)'
      },
      {
        value: 'Green investments (denominated in currency)',
        label: 'Green investments (denominated in currency)'
      },
      {
        value: 'Percentage of green investments',
        label: 'Percentage of green investments'
      },
      {
        value: 'Other green finance, please specify.',
        label: 'Other green finance, please specify.'
      }
    ]
  },
  {
    label: 'Other',
    options: [
      {
        value: 'Other metric, please specify.',
        label: 'Other metric, please specify.'
      }
    ]
  }
];

export const TARGET_DENOMINATOR_INTENSITY_TARGETS_ONLY_OPTIONS = [
  {value: 'KWh', label: 'KWh'},
  {value: 'MWh', label: 'MWh'},
  {value: 'GJ', label: 'GJ'},
  {value: 'Btu', label: 'Btu'},
  {value: 'boe', label: 'boe'},
  {value: 'toe', label: 'toe'},
  {value: 'tce', label: 'tce'},
  {value: 'Gcal', label: 'Gcal'},
  {value: 'Revenue passenger kilometer', label: 'Revenue passenger kilometer'},
  {value: 'USD($) value-added', label: 'USD($) value-added'},
  {value: 'Square meter', label: 'Square meter'},
  {value: 'Metric ton of aluminum', label: 'Metric ton of aluminum'},
  {value: 'Metric ton of steel', label: 'Metric ton of steel'},
  {value: 'Metric ton of cement', label: 'Metric ton of cement'},
  {value: 'Metric ton of cardboard', label: 'Metric ton of cardboard'},
  {value: 'Unit revenue', label: 'Unit revenue'},
  {value: 'Unit FTE employee', label: 'Unit FTE employee'},
  {value: 'Unit hour worked', label: 'Unit hour worked'},
  {value: 'Metric ton of product', label: 'Metric ton of product'},
  {value: 'Liter of product', label: 'Liter of product'},
  {value: 'Unit of production', label: 'Unit of production'},
  {value: 'Unit of service provided', label: 'Unit of service provided'},
  {value: 'Square foot', label: 'Square foot'},
  {value: 'Kilometer', label: 'Kilometer'},
  {value: 'Passenger kilometer', label: 'Passenger kilometer'},
  {value: 'Megawatt hour (MWh)', label: 'Megawatt hour (MWh)'},
  {
    value: 'Barrel of oil equivalent (BOE)',
    label: 'Barrel of oil equivalent (BOE)'
  },
  {value: 'Vehicle produced', label: 'Vehicle produced'},
  {value: 'Metric ton of ore processed', label: 'Metric ton of ore processed'},
  {value: 'Ounce of gold', label: 'Ounce of gold'},
  {value: 'Ounce of platinum', label: 'Ounce of platinum'},
  {value: 'Metric ton of aggregate', label: 'Metric ton of aggregate'},
  {
    value: 'Billion (currency) funds under management',
    label: 'Billion (currency) funds under management'
  },
  {value: 'Hectare', label: 'Hectare'},
  {value: 'Metric ton of waste', label: 'Metric ton of waste'},
  {value: 'Liter of fuel', label: 'Liter of fuel'},
  {value: 'Year', label: 'Year'},
  {
    value:
      'Total amount of bonds outstanding at the end of the reporting period',
    label:
      'Total amount of bonds outstanding at the end of the reporting period'
  },
  {
    value:
      'Total amount of debt outstanding at the end of the reporting period',
    label: 'Total amount of debt outstanding at the end of the reporting period'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TARGET_IS_PART_OF_AN_OVERARCHING_INITIATIVE_OPTIONS_2 = [
  {value: 'EP100', label: 'EP100'},
  {value: 'EV100', label: 'EV100'},
  {value: 'Below50 – sustainable fuels', label: 'Below50 – sustainable fuels'},
  {
    value:
      'Science Based Targets initiative - approved supplier engagement target',
    label:
      'Science Based Targets initiative - approved supplier engagement target'
  },
  {
    value:
      'Science Based Targets initiative - approved customer engagement target',
    label:
      'Science Based Targets initiative - approved customer engagement target'
  },
  {
    value: 'Science Based Targets initiative - approved other',
    label: 'Science Based Targets initiative - approved other'
  },
  {
    value: 'Reduce short-lived climate pollutants',
    label: 'Reduce short-lived climate pollutants'
  },
  {value: 'Remove deforestation', label: 'Remove deforestation'},
  {
    value: 'Low-Carbon Technology Partnerships initiative',
    label: 'Low-Carbon Technology Partnerships initiative'
  },
  {
    value: 'No, it’s not part of an overarching initiative',
    label: 'No, it’s not part of an overarching initiative'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const VALUE_CHAIN_STAGE_OPTIONS = [
  {label: 'Direct operations', value: 'Direct operations'},
  {label: 'Upstream value chain', value: 'Upstream value chain'}
];

export const REASON_OPTIONS = [
  {
    label: 'Challenges associated with traceability',
    value: 'Challenges associated with traceability'
  },
  {label: 'Data is not available', value: 'Data is not available'},
  {label: 'Embedded soy [soy row only]', value: 'Embedded soy [soy row only]'},
  {
    label: 'Recent acquisition or merger',
    value: 'Recent acquisition or merger'
  },
  {label: 'Divestiture', value: 'Divestiture'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const REASON_FOR_EXCLUSION_OPTIONS = [
  {label: 'Data is not available', value: 'Data is not available'},
  {label: 'Divestiture', value: 'Divestiture'},
  {
    label: 'Recent acquisition or merger',
    value: 'Recent acquisition or merger'
  },
  {label: 'Small volume [rainwater]', value: 'Small volume [rainwater]'},
  {label: 'Shared premises', value: 'Shared premises'},
  {
    label: 'Water used for internal WASH services',
    value: 'Water used for internal WASH services'
  },
  {label: 'Water supply network', value: 'Water supply network'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const NO_DATA_REASON_OPTIONS = [
  {
    label: 'Challenges associated with data collection and/or quality',
    value: 'Challenges associated with data collection and/or quality'
  },
  {
    label: 'Data collection is in progress',
    value: 'Data collection is in progress'
  },
  {
    label: 'Judged to be unimportant or not relevant',
    value: 'Judged to be unimportant or not relevant'
  },
  {
    label:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
    value:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
  },
  {
    label: 'No standardized procedure for collecting data',
    value: 'No standardized procedure for collecting data'
  },
  {
    label: 'Not an immediate strategic priority',
    value: 'Not an immediate strategic priority'
  },
  {
    label: 'We are planning to collect the data within the next two years',
    value: 'We are planning to collect the data within the next two years'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const VOLUME_EXCLUDED_DISCLOSURE_OPTIONS = [
  {
    label: 'Yes, we are providing the volume excluded',
    value: 'Yes, we are providing the volume excluded'
  },
  {
    label: 'No, the volume excluded is unknown',
    value: 'No, the volume excluded is unknown'
  },
  {
    label: 'No, the volume excluded is confidential',
    value: 'No, the volume excluded is confidential'
  },
  {
    label: 'No, other reason, please specify',
    value: 'No, other reason, please specify'
  }
];

export const MONITORING_FREQUENCY_OPTIONS = [
  {
    label: 'Six-monthly or more frequently',
    value: 'Six-monthly or more frequently'
  },
  {label: 'Annually', value: 'Annually'},
  {label: 'Every two years', value: 'Every two years'},
  {label: 'Every five years', value: 'Every five years'},
  {label: 'Never', value: 'Never'}
];

export const MONITORING_PROGRESS_OPTIONS = [
  {label: 'Carbon credits gained', value: 'Carbon credits gained'},
  {
    label: 'Compliance with certification',
    value: 'Compliance with certification'
  },
  {label: 'Compliance with regulation', value: 'Compliance with regulation'},
  {
    label: 'Contribution to Net Zero goals',
    value: 'Contribution to Net Zero goals'
  },
  {
    label: 'Contribution to SBTi target(s)',
    value: 'Contribution to SBTi target(s)'
  },
  {
    label: 'Creation of green jobs and sustainable livelihoods',
    value: 'Creation of green jobs and sustainable livelihoods'
  },
  {label: 'Disaster risk reduction', value: 'Disaster risk reduction'},
  {
    label:
      'Further transformative change through sharing of project design, implementation and lessons learnt',
    value:
      'Further transformative change through sharing of project design, implementation and lessons learnt'
  },
  {
    label:
      'Improvement of standard of living, especially for vulnerable and/or marginalized groups',
    value:
      'Improvement of standard of living, especially for vulnerable and/or marginalized groups'
  },
  {
    label: 'Improvement of water availability and quality',
    value: 'Improvement of water availability and quality'
  },
  {
    label: 'Improvement to environmental regulation',
    value: 'Improvement to environmental regulation'
  },
  {label: 'Improvement to soil health', value: 'Improvement to soil health'},
  {
    label: 'Improvement to sustainability of production practices',
    value: 'Improvement to sustainability of production practices'
  },
  {
    label: 'Increase in carbon sequestration',
    value: 'Increase in carbon sequestration'
  },
  {
    label: 'More inclusive, transparent, and empowering governance processes',
    value: 'More inclusive, transparent, and empowering governance processes'
  },
  {
    label: 'Net gain in biodiversity and ecosystem integrity',
    value: 'Net gain in biodiversity and ecosystem integrity'
  },
  {label: 'Protection of human rights', value: 'Protection of human rights'},
  {label: 'Protection of land tenure', value: 'Protection of land tenure'},
  {
    label: 'Reduce/halt biodiversity loss',
    value: 'Reduce/halt biodiversity loss'
  },
  {label: 'Reduction of air pollution', value: 'Reduction of air pollution'},
  {label: 'Reduction of GHG emissions', value: 'Reduction of GHG emissions'},
  {
    label: 'Restoration of natural ecosystem(s)',
    value: 'Restoration of natural ecosystem(s)'
  },
  {
    label: 'Securing continued supply of agricultural commodities',
    value: 'Securing continued supply of agricultural commodities'
  },
  {label: 'Other, please specify', value: 'Other, please specify'},
  {label: 'No measured benefits', value: 'No measured benefits'}
];

export const EXCLUSION_OPTIONS = [
  {label: 'Business activities', value: 'Business activities'},
  {label: 'Country/geographical area', value: 'Country/geographical area'},
  {label: 'Facilities', value: 'Facilities'},
  {
    label: 'Specific groups, businesses, or organizations',
    value: 'Specific groups, businesses, or organizations'
  },
  {label: 'Water aspects', value: 'Water aspects'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];
export const EXPECTED_BENEFITS_OF_PROJECT_OPTIONS = [
  {label: 'Carbon credits gained', value: 'Carbon credits gained'},
  {
    label: 'Compliance with certification',
    value: 'Compliance with certification'
  },
  {label: 'Compliance with regulation', value: 'Compliance with regulation'},
  {
    label: 'Contribution to Net Zero goals',
    value: 'Contribution to Net Zero goals'
  },
  {
    label: 'Contribution to SBTi target(s)',
    value: 'Contribution to SBTi target(s)'
  },
  {
    label: 'Creation of green jobs and sustainable livelihoods',
    value: 'Creation of green jobs and sustainable livelihoods'
  },
  {label: 'Disaster risk reduction', value: 'Disaster risk reduction'},
  {
    label:
      'Further transformative change through sharing of project design, implementation and lessons learnt',
    value:
      'Further transformative change through sharing of project design, implementation and lessons learnt'
  },
  {
    label:
      'Improvement of standard of living, especially for vulnerable and/or marginalized groups',
    value:
      'Improvement of standard of living, especially for vulnerable and/or marginalized groups'
  },
  {
    label: 'Improvement of water availability and quality',
    value: 'Improvement of water availability and quality'
  },
  {
    label: 'Improvement to environmental regulation',
    value: 'Improvement to environmental regulation'
  },
  {label: 'Improvement to soil health', value: 'Improvement to soil health'},
  {
    label: 'Improvement to sustainability of production practices',
    value: 'Improvement to sustainability of production practices'
  },
  {
    label: 'Increase in carbon sequestration',
    value: 'Increase in carbon sequestration'
  },
  {
    label: 'More inclusive, transparent, and empowering governance processes',
    value: 'More inclusive, transparent, and empowering governance processes'
  },
  {
    label: 'Net gain in biodiversity and ecosystem integrity',
    value: 'Net gain in biodiversity and ecosystem integrity'
  },
  {label: 'Protection of human rights', value: 'Protection of human rights'},
  {label: 'Protection of land tenure', value: 'Protection of land tenure'},
  {
    label: 'Reduce/halt biodiversity loss',
    value: 'Reduce/halt biodiversity loss'
  },
  {label: 'Reduction of air pollution', value: 'Reduction of air pollution'},
  {label: 'Reduction of GHG emissions', value: 'Reduction of GHG emissions'},
  {
    label: 'Restoration of natural ecosystem(s)',
    value: 'Restoration of natural ecosystem(s)'
  },
  {
    label: 'Securing continued supply of agricultural commodities',
    value: 'Securing continued supply of agricultural commodities'
  },
  {label: 'Other, please specify', value: 'Other, please specify'},
  {label: 'No measured benefits', value: 'No measured benefits'}
];

export const PROJECT_TAKING_PLACE_RELATION_OPTIONS = [
  {
    label: 'Project based in area with direct operations',
    value: 'Project based in area with direct operations'
  },
  {
    label: 'Project based in sourcing area(s)',
    value: 'Project based in sourcing area(s)'
  },
  {label: 'Project based elsewhere', value: 'Project based elsewhere'}
];

export const TARGET_YEAR_OPTIONS = [
  {label: '<2020', value: '<2020'},
  {label: '2021', value: '2021'},
  {label: '2022', value: '2022'},
  {label: '2023', value: '2023'},
  {label: '2024', value: '2024'},
  {label: '2025', value: '2025'},
  {label: '2026', value: '2026'},
  {label: '2027', value: '2027'},
  {label: '2028', value: '2028'},
  {label: '2029', value: '2029'},
  {label: '2030', value: '2030'},
  {label: '2031–2035', value: '2031–2035'},
  {label: '2036–2040', value: '2036–2040'},
  {label: '2041–2045', value: '2041–2045'},
  {label: '2046–2050', value: '2046–2050'},
  {label: '>2050', value: '>2050'},
  {label: 'Indefinitely', value: 'Indefinitely'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];
export const CLAIM_TYPE_OPTIONS = [
  {label: 'Individual claim', value: 'Individual claim'},
  {label: 'Collective claim', value: 'Collective claim'},
  {
    label: 'Both individual and collective',
    value: 'Both individual and collective'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const PRODUCE_SOURCE_DISCLOSURE_OPTIONS = [
  {
    label:
      'Yes, we do produce/source from this landscape/jurisdiction, and we are able/willing to disclose volume data',
    value:
      'Yes, we do produce/source from this landscape/jurisdiction, and we are able/willing to disclose volume data'
  },
  {
    label:
      'Yes, we do produce/source from this landscape/jurisdiction, but we are not able/willing to disclose volume data',
    value:
      'Yes, we do produce/source from this landscape/jurisdiction, but we are not able/willing to disclose volume data'
  },
  {
    label: 'No, we do not produce/source from this landscape/jurisdiction',
    value: 'No, we do not produce/source from this landscape/jurisdiction'
  }
];

export const ACTIVITIES_ENGAGEMENT_TYPE_OPTIONS = [
  {
    label: 'Involved in industry platforms',
    value: 'Involved in industry platforms'
  },
  {label: 'Engaging with communities', value: 'Engaging with communities'},
  {
    label: 'Engaging with non-governmental organizations',
    value: 'Engaging with non-governmental organizations'
  },
  {
    label: 'Funding research organizations',
    value: 'Funding research organizations'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const SUBNATIONAL_AREA_OPTIONS = [
  {label: 'Not applicable', value: 'Not applicable'},
  {label: 'Please specify', value: 'Please specify'}
];

export const ORGANIZATION_SUPPORT_OR_IMPLEMENTING_PROJECT_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {
    label: 'No but we plan to implement a project(s) within the next two years',
    value: 'No but we plan to implement a project(s) within the next two years'
  },
  {
    label:
      'No and we do not plan to implement project(s) within the next two years',
    value:
      'No and we do not plan to implement project(s) within the next two years'
  }
];

export const PROJECT_REFERENCE_OPTIONS = [
  {label: 'Project 1', value: 'Project 1'},
  {label: 'Project 2', value: 'Project 2'},
  {label: 'Project 3', value: 'Project 3'},
  {label: 'Project 4', value: 'Project 4'},
  {label: 'Project 5', value: 'Project 5'},
  {label: 'Project 6', value: 'Project 6'},
  {label: 'Project 7', value: 'Project 7'},
  {label: 'Project 8', value: 'Project 8'},
  {label: 'Project 9', value: 'Project 9'},
  {label: 'Project 10', value: 'Project 10'}
];

export const PROJECT_TYPE_OPTIONS = [
  {
    label: 'Forest ecosystem restoration',
    value: 'Forest ecosystem restoration'
  },
  {
    label: 'Mangrove protection and restoration',
    value: 'Mangrove protection and restoration'
  },
  {
    label: 'Peatland protection and restoration',
    value: 'Peatland protection and restoration'
  },
  {label: 'Other ecosystem restoration', value: 'Other ecosystem restoration'},
  {label: 'Reforestation', value: 'Reforestation'},
  {label: 'Natural regeneration', value: 'Natural regeneration'},
  {label: 'Agroforestry', value: 'Agroforestry'},
  {label: 'Afforestation', value: 'Afforestation'},
  {label: 'Soil carbon sequestration', value: 'Soil carbon sequestration'},
  {label: 'Agriculture', value: 'Agriculture'},
  {label: 'Biochar', value: 'Biochar'},
  {
    label: 'Threatened and protected species',
    value: 'Threatened and protected species'
  },
  {label: 'Set-aside land', value: 'Set-aside land'},
  {label: 'Biodiversity offsetting', value: 'Biodiversity offsetting'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];
export const COLLECTIVE_MONITORING_FRAMEWORK_OPTIONS = [
  {
    label:
      'Yes, progress is collectively monitored using a shared external framework, please specify',
    value:
      'Yes, progress is collectively monitored using a shared external framework, please specify'
  },
  {
    label: 'Yes, progress is monitored using an internally defined framework',
    value: 'Yes, progress is monitored using an internally defined framework'
  },
  {
    label: 'No, but we are planning to monitor progress in the next two years',
    value: 'No, but we are planning to monitor progress in the next two years'
  },
  {
    label: 'No, and we do not plan to monitor progress in the next two years',
    value: 'No, and we do not plan to monitor progress in the next two years'
  }
];

export const CLAIM_STATUS_OPTIONS = [
  {label: 'Yes, we are making a claim', value: 'Yes, we are making a claim'},
  {
    label:
      'No, we are not making any claims, but we plan to in the next two years',
    value:
      'No, we are not making any claims, but we plan to in the next two years'
  },
  {
    label:
      'No, we are not making any claims, and we do not plan to within the next two years',
    value:
      'No, we are not making any claims, and we do not plan to within the next two years'
  }
];

export const ORGANIZATION_ACTIONS_SUPPORTING_INITIATIVE_OPTIONS = [
  {
    label: 'Participate in planning and multi-stakeholder alignment',
    options: [
      {
        value:
          'Co-design and develop goals, strategies and an action plan with timebound targets and milestones for the initiative',
        label:
          'Co-design and develop goals, strategies and an action plan with timebound targets and milestones for the initiative'
      },
      {
        value:
          'Collaborate on establishing and managing monitoring system for deforestation, natural ecosystem conversion and/or degradation',
        label:
          'Collaborate on establishing and managing monitoring system for deforestation, natural ecosystem conversion and/or degradation'
      },
      {
        value:
          'Collaborate on establishing and managing monitoring system for biodiversity, habitat fragmentation and/or threats to IUCN Red List species in priority areas',
        label:
          'Collaborate on establishing and managing monitoring system for biodiversity, habitat fragmentation and/or threats to IUCN Red List species in priority areas'
      },
      {
        value:
          'Collaborate on establishing and managing monitoring system for livelihoods and human well-being',
        label:
          'Collaborate on establishing and managing monitoring system for livelihoods and human well-being'
      },
      {
        value:
          'Collaborate on landscape sustainability assessments through participatory mapping',
        label:
          'Collaborate on landscape sustainability assessments through participatory mapping'
      }
    ]
  },
  {
    label: 'Enhance government and capacity',
    options: [
      {
        value:
          'Support local governments (or equivalent) to enhance landscape governance structure, and provide them with resources to develop and implement sustainable landscape policies and/or management plan',
        label:
          'Support local governments (or equivalent) to enhance landscape governance structure, and provide them with resources to develop and implement sustainable landscape policies and/or management plan'
      },
      {
        value: 'Support enforcement of land-use and/or zoning plans',
        label: 'Support enforcement of land-use and/or zoning plans'
      },
      {
        value:
          'Other actions relating to enhancing government and capacity, please specify.',
        label:
          'Other actions relating to enhancing government and capacity, please specify.'
      }
    ]
  },
  {
    label:
      'Support and incentivize sustainable production and community land use practices',
    options: [
      {
        value:
          'Collaborate on management/land use planning in the landscape/jurisdiction',
        label:
          'Collaborate on management/land use planning in the landscape/jurisdiction'
      },
      {
        value:
          'Collaborate to maintain representation from all relevant stakeholders within governance structure of initiative',
        label:
          'Collaborate to maintain representation from all relevant stakeholders within governance structure of initiative'
      },
      {
        value:
          'Help establish a transparent governance platform responsible for managing the initiative and its activities with clear roles, responsibilities and balanced decision-making',
        label:
          'Help establish a transparent governance platform responsible for managing the initiative and its activities with clear roles, responsibilities and balanced decision-making'
      },
      {
        value:
          'Help establish effective mechanisms for undertaking human rights due diligence, risk management, monitoring, verification, and grievance resolution',
        label:
          'Help establish effective mechanisms for undertaking human rights due diligence, risk management, monitoring, verification, and grievance resolution'
      },
      {
        value:
          'Identify and act on opportunities for pre-competitive collaboration with your sector',
        label:
          'Identify and act on opportunities for pre-competitive collaboration with your sector'
      },
      {
        value:
          'Identify and map stakeholders (including vulnerable and/or marginalized groups) and encourage their engagement in multi-stakeholder processes',
        label:
          'Identify and map stakeholders (including vulnerable and/or marginalized groups) and encourage their engagement in multi-stakeholder processes'
      },
      {
        value:
          'Share spatial data and land management plans with other stakeholders in the landscape/jurisdiction',
        label:
          'Share spatial data and land management plans with other stakeholders in the landscape/jurisdiction'
      },
      {
        value:
          'Other actions relating to participation in planning and multi-stakeholder alignment, please specify.',
        label:
          'Other actions relating to participation in planning and multi-stakeholder alignment, please specify.'
      }
    ]
  },
  {
    label: 'Build community and multi-stakeholder capacities',
    options: [
      {
        value:
          'Communicate externally the business case for investing in landscapes/jurisdictions',
        label:
          'Communicate externally the business case for investing in landscapes/jurisdictions'
      },
      {
        value:
          'Engage stakeholders on importance of conservation, restoration and/or rehabilitation',
        label:
          'Engage stakeholders on importance of conservation, restoration and/or rehabilitation'
      },
      {
        value: 'Implement REDD+ actions in the landscape/jurisdiction',
        label: 'Implement REDD+ actions in the landscape/jurisdiction'
      },
      {
        value:
          'Promote and implement climate change adaptation and mitigation activities',
        label:
          'Promote and implement climate change adaptation and mitigation activities'
      },
      {
        value:
          'Share information on supplier non-compliance, value chain mapping and traceability with other stakeholders in the landscape/jurisdiction',
        label:
          'Share information on supplier non-compliance, value chain mapping and traceability with other stakeholders in the landscape/jurisdiction'
      },
      {
        value:
          'Support communities and smallholders in gaining access to incentives (e.g., certification, group formation, land titles, loans, preferential sourcing, etc.)',
        label:
          'Support communities and smallholders in gaining access to incentives (e.g., certification, group formation, land titles, loans, preferential sourcing, etc.)'
      },
      {
        value:
          'Support implementation of climate change vulnerability assessment',
        label:
          'Support implementation of climate change vulnerability assessment'
      },
      {
        value:
          'Other actions relating to building community and multi-stakeholder capacities, please specify.',
        label:
          'Other actions relating to building community and multi-stakeholder capacities, please specify.'
      }
    ]
  },
  {
    label: 'Capacity building and community support',
    options: [
      {
        value:
          'Capacity building for farmers, smallholders, and local communities to implement good agricultural practices (including improved efficiency, crop diversification, and adoption of certification)',
        label:
          'Capacity building for farmers, smallholders, and local communities to implement good agricultural practices (including improved efficiency, crop diversification, and adoption of certification)'
      },
      {
        value:
          'Collaborate on integrated watershed management and remediation activities',
        label:
          'Collaborate on integrated watershed management and remediation activities'
      },
      {
        value: 'Improve sustainability of waste management practices',
        label: 'Improve sustainability of waste management practices'
      },
      {
        value:
          'Provide financial support to fund FPIC processes and/or activities to halt systemic violations of workers rights',
        label:
          'Provide financial support to fund FPIC processes and/or activities to halt systemic violations of workers rights'
      },
      {
        value:
          'Support Indigenous peoples and local communities to clarify and secure land tenure rights',
        label:
          'Support Indigenous peoples and local communities to clarify and secure land tenure rights'
      },
      {
        value:
          'Other actions relating to supporting and incentivizing sustainable production and community land use practices, please specify.',
        label:
          'Other actions relating to supporting and incentivizing sustainable production and community land use practices, please specify.'
      }
    ]
  },
  {
    label:
      'Link value chain action to landscape/jurisdictional initiative through private sector collaboration',
    options: [
      {
        value: 'Collaborate on commodity traceability',
        label: 'Collaborate on commodity traceability'
      },
      {
        value:
          'Use preferential sourcing to support landscape/jurisdictional initiatives that are demonstrating progress',
        label:
          'Use preferential sourcing to support landscape/jurisdictional initiatives that are demonstrating progress'
      },
      {
        value:
          'Other actions relating to linking value chain action to landscape/jurisdictional initiatives through private sector collaboration, please specify.',
        label:
          'Other actions relating to linking value chain action to landscape/jurisdictional initiatives through private sector collaboration, please specify.'
      }
    ]
  },
  {
    label: 'Support innovative financial mechanisms',
    options: [
      {value: 'Finance carbon credits', label: 'Finance carbon credits'},
      {
        value:
          'Other actions relating to supporting innovative financial mechanisms, please specify.',
        label:
          'Other actions relating to supporting innovative financial mechanisms, please specify.'
      }
    ]
  },
  {
    label: 'Other',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const TYPE_OF_PARTNERS_ENGAGED_IN_INITIATIVE_OPTIONS = [
  {label: 'Financial institution', value: 'Financial institution'},
  {label: 'National government', value: 'National government'},
  {label: 'Sub-national government', value: 'Sub-national government'},
  {label: 'Indigenous peoples', value: 'Indigenous peoples'},
  {label: 'Local communities', value: 'Local communities'},
  {label: 'NGO and/or civil society', value: 'NGO and/or civil society'},
  {label: 'Producers', value: 'Producers'},
  {label: 'Private sector', value: 'Private sector'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];
export const ENGAGEMENT_END_YEAR_OPTIONS = [
  {label: 'Please specify', value: 'Please specify'},
  {label: 'Not defined', value: 'Not defined'}
];

export const LANDSCAPE_GOALS_SUPPORTED_BY_ENGAGEMENT_OPTIONS = [
  {
    label:
      'Avoided deforestation/conversion of other natural ecosystems and/or decreased degradation rate',
    value:
      'Avoided deforestation/conversion of other natural ecosystems and/or decreased degradation rate'
  },
  {
    label: 'Biodiversity protected and/or restored',
    value: 'Biodiversity protected and/or restored'
  },
  {label: 'Carbon offsetting', value: 'Carbon offsetting'},
  {
    label: 'Decreased ecosystem degradation rate',
    value: 'Decreased ecosystem degradation rate'
  },
  {
    label: 'Ecosystem services maintained and/or enhanced',
    value: 'Ecosystem services maintained and/or enhanced'
  },
  {
    label: 'Forest fires monitored and prevented',
    value: 'Forest fires monitored and prevented'
  },
  {
    label:
      'Improved community resilience from climate adaptation plans or mitigation efforts',
    value:
      'Improved community resilience from climate adaptation plans or mitigation efforts'
  },
  {
    label: 'Improved rate of carbon sequestration (e.g., through restoration)',
    value: 'Improved rate of carbon sequestration (e.g., through restoration)'
  },
  {
    label: 'Increased and/or maintained protected areas',
    value: 'Increased and/or maintained protected areas'
  },
  {
    label: 'Natural ecosystems conserved and/or restored',
    value: 'Natural ecosystems conserved and/or restored'
  },
  {
    label: 'Payments for Ecosystem Services (PES) scheme in place',
    value: 'Payments for Ecosystem Services (PES) scheme in place'
  },
  {
    label:
      'Reduced emissions from land use change and/or agricultural production',
    value:
      'Reduced emissions from land use change and/or agricultural production'
  },
  {
    label:
      'Adequate water availability, water quality or access to WASH (Water, Sanitation and Hygiene) services',
    value:
      'Adequate water availability, water quality or access to WASH (Water, Sanitation and Hygiene) services'
  },
  {
    label:
      'Other environmental landscape goal supported by engagement, please specify.',
    value:
      'Other environmental landscape goal supported by engagement, please specify.'
  },

  // Governance
  {
    label:
      'Governance forums that represent all relevant stakeholders in place and maintained',
    value:
      'Governance forums that represent all relevant stakeholders in place and maintained'
  },
  {
    label:
      'Promotion of transparency, participation, inclusion, and coordination in landscape policy, planning, and management',
    value:
      'Promotion of transparency, participation, inclusion, and coordination in landscape policy, planning, and management'
  },
  {
    label:
      'Other governance landscape goal supported by engagement, please specify.',
    value:
      'Other governance landscape goal supported by engagement, please specify.'
  },

  // Social
  {
    label: 'Credit available to family farms and/or local communities',
    value: 'Credit available to family farms and/or local communities'
  },
  {
    label:
      'Ensuring local communities and smallholders benefit from the outcomes of landscape/jurisdictional initiative',
    value:
      'Ensuring local communities and smallholders benefit from the outcomes of landscape/jurisdictional initiative'
  },
  {
    label:
      'Implementation of livelihood activities/practices that reduce pressure on forests',
    value:
      'Implementation of livelihood activities/practices that reduce pressure on forests'
  },
  {
    label:
      'Improved business models that enable inclusion (including smallholders)',
    value:
      'Improved business models that enable inclusion (including smallholders)'
  },
  {
    label:
      'Improved capacity for community engagement in multi-stakeholder processes',
    value:
      'Improved capacity for community engagement in multi-stakeholder processes'
  },
  {
    label:
      'Improved standard of living, especially for vulnerable and/or marginalized groups',
    value:
      'Improved standard of living, especially for vulnerable and/or marginalized groups'
  },
  {
    label: 'Income diversification amongst producers in area',
    value: 'Income diversification amongst producers in area'
  },
  {
    label: 'Increased rate of employment in the rural economy',
    value: 'Increased rate of employment in the rural economy'
  },
  {
    label: 'Respect, protect, and fulfil human rights',
    value: 'Respect, protect, and fulfil human rights'
  },
  {
    label:
      'Rights to land and resources recognized and protected, and related conflicts reduced',
    value:
      'Rights to land and resources recognized and protected, and related conflicts reduced'
  },
  {
    label:
      'Other social landscape goal supported by engagement, please specify.',
    value:
      'Other social landscape goal supported by engagement, please specify.'
  },

  // Production
  {
    label: 'Improved and/or maintained soil health',
    value: 'Improved and/or maintained soil health'
  },
  {
    label:
      'Increased adoption of sustainable production practices (e.g., input use efficiency and water management practices)',
    value:
      'Increased adoption of sustainable production practices (e.g., input use efficiency and water management practices)'
  },
  {
    label: 'Increased uptake of certification',
    value: 'Increased uptake of certification'
  },
  {
    label:
      'Multi-commodity production promoted and farmer/supplier dependency on individual companies reduced',
    value:
      'Multi-commodity production promoted and farmer/supplier dependency on individual companies reduced'
  },
  {
    label:
      'Reliable commodity traceability and landscape monitoring/data collection system',
    value:
      'Reliable commodity traceability and landscape monitoring/data collection system'
  },
  {
    label:
      'Sustainability of other natural resource-based production sectors promoted to and recognized by relevant stakeholders (e.g., mining, natural forest management and non-extractive uses)',
    value:
      'Sustainability of other natural resource-based production sectors promoted to and recognized by relevant stakeholders (e.g., mining, natural forest management and non-extractive uses)'
  },
  {
    label: 'Uptake of regenerative agriculture (e.g., agroforestry) practices',
    value: 'Uptake of regenerative agriculture (e.g., agroforestry) practices'
  },
  {
    label:
      'Other production landscape goal supported by engagement, please specify.',
    value:
      'Other production landscape goal supported by engagement, please specify.'
  },

  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const INDICATE_SIZE_OF_AREA_INITIATIVE_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No, area is unknown', value: 'No, area is unknown'},
  {
    label: 'No, other reason, please specify.',
    value: 'No, other reason, please specify.'
  }
];

export const TYPE_OF_ENGAGEMENT_OPTIONS = [
  {
    label:
      'Convener: Leads or facilitates the design, set-up, and high-level management of the initiative',
    value:
      'Convener: Leads or facilitates the design, set-up, and high-level management of the initiative'
  },
  {
    label:
      'Partner: Shares responsibility with other stakeholders to manage and implement actions',
    value:
      'Partner: Shares responsibility with other stakeholders to manage and implement actions'
  },
  {
    label: 'Implementer: Executes actions based on the collective goals',
    value: 'Implementer: Executes actions based on the collective goals'
  },
  {
    label: 'Funder: Provides full or partial financial resources',
    value: 'Funder: Provides full or partial financial resources'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const CRITERIA_FOR_PRIORITIZING_LANDSCAPE_OPTIONS = [
  {
    label:
      'Ability to contribute to/build on existing landscape/jurisdictional initiatives',
    value:
      'Ability to contribute to/build on existing landscape/jurisdictional initiatives'
  },
  {label: 'Access to new markets', value: 'Access to new markets'},
  {
    label: 'Commodity sourcing footprint',
    value: 'Commodity sourcing footprint'
  },
  {
    label: 'Organization has operational presence in area',
    value: 'Organization has operational presence in area'
  },
  {
    label: 'Current and future sourcing risk',
    value: 'Current and future sourcing risk'
  },
  {
    label: 'Local government`s commitment to sustainable land use',
    value: 'Local government`s commitment to sustainable land use'
  },
  {
    label: 'Opportunity to build resilience at scale',
    value: 'Opportunity to build resilience at scale'
  },
  {
    label: 'Opportunity for increased human well-being in area',
    value: 'Opportunity for increased human well-being in area'
  },
  {
    label:
      'Opportunity to increase market access for smallholders and local communities',
    value:
      'Opportunity to increase market access for smallholders and local communities'
  },
  {
    label:
      'Opportunity to participate in new markets or financing mechanisms for the agricultural sector',
    value:
      'Opportunity to participate in new markets or financing mechanisms for the agricultural sector'
  },
  {
    label: 'Opportunity to protect and restore natural ecosystems',
    value: 'Opportunity to protect and restore natural ecosystems'
  },
  {
    label: 'Presence of a neutral convener or implementer',
    value: 'Presence of a neutral convener or implementer'
  },
  {
    label:
      'Recognized as priority landscape by credible multi-stakeholder groups or industry platforms',
    value:
      'Recognized as priority landscape by credible multi-stakeholder groups or industry platforms'
  },
  {label: 'Response to regulation', value: 'Response to regulation'},
  {
    label: 'Response to voluntary sectoral agreement',
    value: 'Response to voluntary sectoral agreement'
  },
  {label: 'Risk of biodiversity loss', value: 'Risk of biodiversity loss'},
  {
    label:
      'Risk of deforestation, forest/land degradation, or conversion of other natural ecosystems',
    value:
      'Risk of deforestation, forest/land degradation, or conversion of other natural ecosystems'
  },
  {label: 'Risk of fires', value: 'Risk of fires'},
  {label: 'Risk of human rights issues', value: 'Risk of human rights issues'},
  {
    label: 'Risk of issues related to land tenure rights',
    value: 'Risk of issues related to land tenure rights'
  },
  {
    label: 'Risk of supplier non-compliance in area',
    value: 'Risk of supplier non-compliance in area'
  },
  {label: 'Risk of water stress', value: 'Risk of water stress'},
  {
    label: 'Stakeholder/investor request',
    value: 'Stakeholder/investor request'
  },
  {
    label: 'Supply of commodities strategically important',
    value: 'Supply of commodities strategically important'
  },
  {label: 'Other, please specify', value: 'Other, please specify'},
  {label: 'No criteria considered', value: 'No criteria considered'}
];

export const LANDSCAPE_JURISDICATION_OPTIONS = [
  {label: 'LJ 1', value: 'LJ 1'},
  {label: 'LJ 2', value: 'LJ 2'},
  {label: 'LJ 3', value: 'LJ 3'},
  {label: 'LJ 4', value: 'LJ 4'},
  {label: 'LJ 5', value: 'LJ 5'},
  {label: 'LJ 6', value: 'LJ 6'},
  {label: 'LJ 7', value: 'LJ 7'},
  {label: 'LJ 8', value: 'LJ 8'},
  {label: 'LJ 9', value: 'LJ 9'},
  {label: 'LJ 10', value: 'LJ 10'},
  {label: 'LJ 11', value: 'LJ 11'},
  {label: 'LJ 12', value: 'LJ 12'},
  {label: 'LJ 13', value: 'LJ 13'},
  {label: 'LJ 14', value: 'LJ 14'},
  {label: 'LJ 15', value: 'LJ 15'},
  {label: 'LJ 16', value: 'LJ 16'},
  {label: 'LJ 17', value: 'LJ 17'},
  {label: 'LJ 18', value: 'LJ 18'},
  {label: 'LJ 19', value: 'LJ 19'},
  {label: 'LJ 20', value: 'LJ 20'},
  {label: 'LJ 21', value: 'LJ 21'},
  {label: 'LJ 22', value: 'LJ 22'},
  {label: 'LJ 23', value: 'LJ 23'},
  {label: 'LJ 24', value: 'LJ 24'},
  {label: 'LJ 25', value: 'LJ 25'}
];

export const PROCEDURE_TO_ENSURE_LEGAL_COMPLIANCE_OPTIONS = [
  {label: 'Certification', value: 'Certification'},
  {label: 'First party audits', value: 'First party audits'},
  {label: 'Ground-based monitoring', value: 'Ground-based monitoring'},
  {
    label: 'Remote sensing or other geospatial monitoring',
    value: 'Remote sensing or other geospatial monitoring'
  },
  {label: 'Second party audits', value: 'Second party audits'},
  {label: 'Supplier self-declaration', value: 'Supplier self-declaration'},
  {label: 'Third party tools', value: 'Third party tools'},
  {label: 'Third party databases', value: 'Third party databases'},
  {label: 'Third party audits', value: 'Third party audits'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const INDICATE_COLLECT_COMPLIANCE_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {
    label:
      'No, but we plan to collect data on this indicator within the next two years',
    value:
      'No, but we plan to collect data on this indicator within the next two years'
  },
  {
    label:
      'No, and we do not plan to collect data on this indicator within the next two years',
    value:
      'No, and we do not plan to collect data on this indicator within the next two years'
  }
];

export const ENGAGEMENT_IN_LANDSCAPE_OPTIONS = [
  {
    label: 'Yes, we engage in landscape/jurisdictional initiatives',
    value: 'Yes, we engage in landscape/jurisdictional initiatives'
  },
  {
    label:
      'No, we do not engage in landscape/jurisdictional initiatives, but we plan to in the next two years',
    value:
      'No, we do not engage in landscape/jurisdictional initiatives, but we plan to in the next two years'
  },
  {
    label:
      'No, we do not engage in landscape/jurisdictional initiatives, and we do not plan to within the next two years',
    value:
      'No, we do not engage in landscape/jurisdictional initiatives, and we do not plan to within the next two years'
  }
];

export const PRIMARY_REASON_FOR_NOT_ENGAGING_OPTIONS = [
  {
    label: 'Benefits of engaging in landscapes/jurisdictions unclear',
    value: 'Benefits of engaging in landscapes/jurisdictions unclear'
  },
  {
    label: 'Insufficient data on operations',
    value: 'Insufficient data on operations'
  },
  {
    label:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
    value:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
  },
  {
    label:
      'Lack of knowledge or information on how to engage in landscape and/or jurisdictional initiatives',
    value:
      'Lack of knowledge or information on how to engage in landscape and/or jurisdictional initiatives'
  },
  {label: 'No standardized procedure', value: 'No standardized procedure'},
  {
    label: 'No suitable initiatives to engage in',
    value: 'No suitable initiatives to engage in'
  },
  {
    label: 'Not an immediate strategic priority',
    value: 'Not an immediate strategic priority'
  },
  {
    label: 'Judged to be unimportant or not relevant',
    value: 'Judged to be unimportant or not relevant'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

// export const SCOPE_OPTIONS = [
//   {label: 'Scope 1', value: 'Scope 1'},
//   {label: 'Scope 2 (location-based)', value: 'Scope 2 (location-based)'},
//   {label: 'Scope 2 (market-based)', value: 'Scope 2 (market-based)'},
//   {label: 'Scope 1+2 (location-based)', value: 'Scope 1+2 (location-based)'},
//   {label: 'Scope 1+2 (market-based)', value: 'Scope 1+2 (market-based)'},
//   {
//     label: 'Scope 1+2 (location-based) +3 (upstream)',
//     value: 'Scope 1+2 (location-based) +3 (upstream)'
//   },
//   {
//     label: 'Scope 1+2 (location-based) +3 (downstream)',
//     value: 'Scope 1+2 (location-based) +3 (downstream)'
//   },
//   {
//     label: 'Scope 1+2 (location-based) +3 (upstream & downstream)',
//     value: 'Scope 1+2 (location-based) +3 (upstream & downstream)'
//   },
//   {
//     label: 'Scope 1+2 (market-based) +3 (upstream)',
//     value: 'Scope 1+2 (market-based) +3 (upstream)'
//   },
//   {
//     label: 'Scope 1+2 (market-based) +3 (downstream)',
//     value: 'Scope 1+2 (market-based) +3 (downstream)'
//   },
//   {
//     label: 'Scope 1+2 (market-based) +3 (upstream & downstream)',
//     value: 'Scope 1+2 (market-based) +3 (upstream & downstream)'
//   },
//   {label: 'Scope 3 (upstream)', value: 'Scope 3 (upstream)'},
//   {label: 'Scope 3 (downstream)', value: 'Scope 3 (downstream)'},
//   {
//     label: 'Scope 3 (upstream & downstream)',
//     value: 'Scope 3 (upstream & downstream)'
//   },
//   {
//     label: 'Scope 3: Purchased goods & services',
//     value: 'Scope 3: Purchased goods & services'
//   },
//   {label: 'Scope 3: Capital goods', value: 'Scope 3: Capital goods'},
//   {
//     label:
//       'Scope 3: Fuel- and energy-related activities (not included in Scopes 1 or 2)',
//     value:
//       'Scope 3: Fuel- and energy-related activities (not included in Scopes 1 or 2)'
//   },
//   {
//     label: 'Scope 3: Upstream transportation & distribution',
//     value: 'Scope 3: Upstream transportation & distribution'
//   },
//   {
//     label: 'Scope 3: Waste generated in operations',
//     value: 'Scope 3: Waste generated in operations'
//   },
//   {label: 'Scope 3: Business travel', value: 'Scope 3: Business travel'},
//   {label: 'Scope 3: Employee commuting', value: 'Scope 3: Employee commuting'},
//   {
//     label: 'Scope 3: Upstream leased assets',
//     value: 'Scope 3: Upstream leased assets'
//   },
//   {label: 'Scope 3: Investments', value: 'Scope 3: Investments'},
//   {
//     label: 'Scope 3: Downstream transportation & distribution',
//     value: 'Scope 3: Downstream transportation & distribution'
//   },
//   {
//     label: 'Scope 3: Processing of sold products',
//     value: 'Scope 3: Processing of sold products'
//   },
//   {
//     label: 'Scope 3: Use of sold products',
//     value: 'Scope 3: Use of sold products'
//   },
//   {
//     label: 'Scope 3: End-of-life treatment of sold products',
//     value: 'Scope 3: End-of-life treatment of sold products'
//   },
//   {
//     label: 'Scope 3: Downstream leased assets',
//     value: 'Scope 3: Downstream leased assets'
//   },
//   {label: 'Scope 3: Franchises', value: 'Scope 3: Franchises'},
//   {label: 'Other, please specify', value: 'Other, please specify'}
// ];

export const EMISSIONS_ACCOUNTING_METHODOLOGY_OPTIONS = [
  {
    label: 'GHG Protocol Corporate Accounting and Reporting Standard',
    value: 'GHG Protocol Corporate Accounting and Reporting Standard'
  },
  {
    label: 'Corporate Value Chain (Scope 3) Standard',
    value: 'Corporate Value Chain (Scope 3) Standard'
  },
  {
    label: 'The GHG Protocol for Project Accounting',
    value: 'The GHG Protocol for Project Accounting'
  },
  {
    label: 'LULUCF Guidance for GHG Project Accounting',
    value: 'LULUCF Guidance for GHG Project Accounting'
  },
  {
    label: 'Value chain (Scope 3) intervention guidance',
    value: 'Value chain (Scope 3) intervention guidance'
  },
  {
    label: 'The GHG Protocol Agricultural Guidance',
    value: 'The GHG Protocol Agricultural Guidance'
  },
  {
    label: 'Accounting for natural climate solutions guidance',
    value: 'Accounting for natural climate solutions guidance'
  },
  {label: 'ISO 14064-1:2018', value: 'ISO 14064-1:2018'},
  {
    label: 'An established project-level methodology, please specify.',
    value: 'An established project-level methodology, please specify.'
  }
];

export const ASSESS_LEGAL_COMPLIANCE_OPTIONS = [
  {label: 'Yes, from suppliers', value: 'Yes, from suppliers'},
  {
    label: 'Yes, from owned, managed and/or controlled land',
    value: 'Yes, from owned, managed and/or controlled land'
  },
  {
    label: 'Yes, from both suppliers and owned/managed/controlled land',
    value: 'Yes, from both suppliers and owned/managed/controlled land'
  },
  {
    label: 'No, but we plan to within the next two years',
    value: 'No, but we plan to within the next two years'
  },
  {
    label: 'No, and we do not plan to within the next two years',
    value: 'No, and we do not plan to within the next two years'
  }
];

export const ASPECTS_OF_LEGISLATION_OPTIONS = [
  {label: 'Land use rights', value: 'Land use rights'},
  {label: 'Environmental protection', value: 'Environmental protection'},
  {
    label:
      'Forest-related rules, including forest management and biodiversity conservation, where directly related to wood harvesting',
    value:
      'Forest-related rules, including forest management and biodiversity conservation, where directly related to wood harvesting'
  },
  {label: 'Third parties’ rights', value: 'Third parties’ rights'},
  {label: 'Labor rights', value: 'Labor rights'},
  {
    label: 'Human rights protected under international law',
    value: 'Human rights protected under international law'
  },
  {
    label:
      'The principle of free, prior and informed consent (FPIC), including as set out in the UN Declaration on the Rights of Indigenous Peoples',
    value:
      'The principle of free, prior and informed consent (FPIC), including as set out in the UN Declaration on the Rights of Indigenous Peoples'
  },
  {
    label: 'Tax, anti-corruption, trade and customs regulations',
    value: 'Tax, anti-corruption, trade and customs regulations'
  }
];

export const CERTIFICATE_DETAILS_VOLUME_SOLID_OPTIONS = [
  {
    label: 'Development of certification and sustainability standards',
    value: 'Development of certification and sustainability standards'
  },
  {
    label:
      'Development of certification and sustainability standards across entire landscapes/jurisdictions',
    value:
      'Development of certification and sustainability standards across entire landscapes/jurisdictions'
  },
  {
    label:
      'Greater alignment between company goals and goals at landscape/jurisdictional level',
    value:
      'Greater alignment between company goals and goals at landscape/jurisdictional level'
  },
  {
    label: 'Greater community support to facilitate sustainable agriculture',
    value: 'Greater community support to facilitate sustainable agriculture'
  },
  {label: 'Greater customer awareness', value: 'Greater customer awareness'},
  {
    label: 'Greater enforcement of regulations',
    value: 'Greater enforcement of regulations'
  },
  {
    label: 'Greater stakeholder engagement and collaboration',
    value: 'Greater stakeholder engagement and collaboration'
  },
  {
    label: 'Greater supplier awareness/engagement',
    value: 'Greater supplier awareness/engagement'
  },
  {label: 'Greater transparency', value: 'Greater transparency'},
  {
    label: 'Increased demand for certified products',
    value: 'Increased demand for certified products'
  },
  {
    label:
      'Increased knowledge on commodity driven deforestation, forest degradation and/or conversion',
    value:
      'Increased knowledge on commodity driven deforestation, forest degradation and/or conversion'
  },
  {
    label: 'Investment in monitoring tools and traceability systems',
    value: 'Investment in monitoring tools and traceability systems'
  },
  {
    label: 'Improvement in data collection and quality',
    value: 'Improvement in data collection and quality'
  },
  {
    label: 'Involvement in landscape and/or jurisdictional initiatives',
    value: 'Involvement in landscape and/or jurisdictional initiatives'
  },
  {
    label: 'Involvement in multi-stakeholder initiatives',
    value: 'Involvement in multi-stakeholder initiatives'
  },
  {
    label: 'Minimizing food loss and waste',
    value: 'Minimizing food loss and waste'
  },
  {
    label: 'Price premium for certified materials',
    value: 'Price premium for certified materials'
  },
  {
    label: 'Reduced cost of certification/certified products',
    value: 'Reduced cost of certification/certified products'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const PRIMARY_REASON_CERTIFICATION_OPTIONS = [
  {
    label: 'In the process of certifying this commodity',
    value: 'In the process of certifying this commodity'
  },
  {label: 'Data is confidential', value: 'Data is confidential'},
  {
    label: 'Insufficient resources to complete collection of data',
    value: 'Insufficient resources to complete collection of data'
  },
  {
    label:
      'No requirement from customers to track certification levels in the past',
    value:
      'No requirement from customers to track certification levels in the past'
  },
  {
    label: 'Levels of certification are not recorded at the corporate level',
    value: 'Levels of certification are not recorded at the corporate level'
  },
  {
    label: 'Insufficient data on what is sold to requesting member',
    value: 'Insufficient data on what is sold to requesting member'
  },
  {
    label: 'Judged to be unimportant or not relevant',
    value: 'Judged to be unimportant or not relevant'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const FORM_OF_COMMODITY_OPTIONS = [
  {
    label: 'Timber products',
    options: [
      {
        value: 'Boards, plywood, engineered wood',
        label: 'Boards, plywood, engineered wood'
      },
      {
        value: 'Cellulose-based textile fiber',
        label: 'Cellulose-based textile fiber'
      },
      {
        value: 'Goods not for resale (GNFR)',
        label: 'Goods not for resale (GNFR)'
      },
      {value: 'Hardwood logs', label: 'Hardwood logs'},
      {value: 'Paper', label: 'Paper'},
      {value: 'Primary packaging', label: 'Primary packaging'},
      {value: 'Pulp', label: 'Pulp'},
      {
        value: 'Sawn timber, veneer, chips',
        label: 'Sawn timber, veneer, chips'
      },
      {value: 'Secondary packaging', label: 'Secondary packaging'},
      {value: 'Softwood logs', label: 'Softwood logs'},
      {value: 'Tertiary packaging', label: 'Tertiary packaging'},
      {value: 'Unprocessed wood fiber', label: 'Unprocessed wood fiber'},
      {value: 'Wood-based bioenergy', label: 'Wood-based bioenergy'},
      {
        value: 'Other form of timber products, please specify.',
        label: 'Other form of timber products, please specify.'
      }
    ]
  },
  {
    label: 'Palm oil',
    options: [
      {
        value: 'Crude palm kernel oil (CPKO)',
        label: 'Crude palm kernel oil (CPKO)'
      },
      {value: 'Crude palm oil (CPO)', label: 'Crude palm oil (CPO)'},
      {value: 'Fresh fruit bunches (FFB)', label: 'Fresh fruit bunches (FFB)'},
      {value: 'Palm biodiesel', label: 'Palm biodiesel'},
      {value: 'Palm kernel meal (PKM)', label: 'Palm kernel meal (PKM)'},
      {
        value: 'Palm kernel oil derivatives',
        label: 'Palm kernel oil derivatives'
      },
      {value: 'Palm oil derivatives', label: 'Palm oil derivatives'},
      {value: 'Refined palm oil', label: 'Refined palm oil'},
      {
        value: 'Other form of palm oil, please specify.',
        label: 'Other form of palm oil, please specify.'
      }
    ]
  },
  {
    label: 'Cattle products',
    options: [
      {value: 'Beef', label: 'Beef'},
      {
        value: 'By-products (e.g., glycerin, gelatin)',
        label: 'By-products (e.g., glycerin, gelatin)'
      },
      {value: 'Cattle', label: 'Cattle'},
      {value: 'Hides/leather', label: 'Hides/leather'},
      {value: 'Tallow', label: 'Tallow'},
      {value: 'Tallow biodiesel', label: 'Tallow biodiesel'},
      {
        value: 'Other form of cattle products, please specify.',
        label: 'Other form of cattle products, please specify.'
      }
    ]
  },
  {
    label: 'Soy',
    options: [
      {value: 'Embedded soy', label: 'Embedded soy'},
      {value: 'Soybean meal', label: 'Soybean meal'},
      {value: 'Soybean oil', label: 'Soybean oil'},
      {value: 'Soy biodiesel', label: 'Soy biodiesel'},
      {value: 'Soy derivatives', label: 'Soy derivatives'},
      {value: 'Whole soybeans', label: 'Whole soybeans'},
      {
        value: 'Other form of soy, please specify.',
        label: 'Other form of soy, please specify.'
      }
    ]
  },
  {
    label: 'Other, please specify',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const MEASUREMENT_UNITS_OPTIONS = [
  {label: 'Metric tons', value: 'Metric tons'},
  {label: 'Spend', value: 'Spend'},
  {label: 'Liters', value: 'Liters'},
  {label: 'Gallons', value: 'Gallons'},
  {label: 'Round wood equivalent (RWE)', value: 'Round wood equivalent (RWE)'},
  {
    label: 'Wood raw material equivalent (WRME)',
    value: 'Wood raw material equivalent (WRME)'
  },
  {label: 'Cubic meters', value: 'Cubic meters'},
  {label: 'Square meters', value: 'Square meters'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const GHG_EMISSIONS_REDUCTIONS_OPTIONS = [
  {
    label:
      'Yes, and willing to share details with requesting CDP Supply Chain members',
    value:
      'Yes, and willing to share details with requesting CDP Supply Chain members'
  },
  {
    label:
      'Yes, but not willing to share details with requesting CDP Supply Chain members',
    value:
      'Yes, but not willing to share details with requesting CDP Supply Chain members'
  },
  {
    label: 'No, but plan to do so in the next two years',
    value: 'No, but plan to do so in the next two years'
  },
  {
    label: 'No, and do not plan to do so in the next two years',
    value: 'No, and do not plan to do so in the next two years'
  }
];

export const EMISSIONS_ACCOUNTING_BOUNDARY_OPTIONS = [
  {
    label: 'Included in the corporate GHG inventory boundary',
    value: 'Included in the corporate GHG inventory boundary'
  },
  {
    label: 'Partly included in the corporate GHG inventory boundary',
    value: 'Partly included in the corporate GHG inventory boundary'
  },
  {
    label: 'Not included in the corporate GHG inventory',
    value: 'Not included in the corporate GHG inventory'
  },
  {label: 'Uncertain', value: 'Uncertain'}
];

export const TARGET_STATUS_REPORT_YEAR_OPTIONS = [
  {label: 'New', value: 'New'},
  {label: 'Underway', value: 'Underway'},
  {label: 'Achieved', value: 'Achieved'},
  {label: 'Achieved and maintained', value: 'Achieved and maintained'},
  {label: 'Expired', value: 'Expired'},
  {label: 'Revised', value: 'Revised'},
  {label: 'Re placed', value: 'Re placed'},
  {label: 'Retired', value: 'Retired'}
];

export const GLOBAL_ENVIRONMENTAL_TREATIES_OPTIONS = [
  {
    label: 'Kunming-Montreal Global Biodiversity Framework',
    value: 'Kunming-Montreal Global Biodiversity Framework'
  },
  {label: 'Paris Agreement', value: 'Paris Agreement'},
  {
    label: 'Sustainable Development Goals',
    value: 'Sustainable Development Goals'
  },
  {label: 'Planetary Boundaries', value: 'Planetary Boundaries'},
  {
    label: 'None, alignment not assessed',
    value: 'None, alignment not assessed'
  },
  {
    label: 'None, no alignment after assessment',
    value: 'None, no alignment after assessment'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const TRACEABILITY_SYSTEM_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {
    label: 'No, but we plan to establish one within the next two years',
    value: 'No, but we plan to establish one within the next two years'
  },
  {
    label: 'No, and we do not plan to establish one within the next two years',
    value: 'No, and we do not plan to establish one within the next two years'
  }
];

export const METHOD_TOOL_TRACEABILITY_OPTIONS = [
  {
    label: 'Chain-of-custody certification',
    value: 'Chain-of-custody certification'
  },
  {label: 'Value chain mapping', value: 'Value chain mapping'},
  {
    label: 'Supplier engagement/communication',
    value: 'Supplier engagement/communication'
  },
  {
    label: 'Internal traceability system',
    value: 'Internal traceability system'
  },
  {
    label: 'Landscape and jurisdictional approaches',
    value: 'Landscape and jurisdictional approaches'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const PRIMARY_REASON_ORGANIZATION_OPTIONS = [
  {
    label:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
    value:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
  },
  {
    label: 'No standardized procedure',
    value: 'No standardized procedure'
  },
  {
    label: 'Not an immediate strategic priority',
    value: 'Not an immediate strategic priority'
  },
  {
    label: 'Judged to be unimportant or not relevant',
    value: 'Judged to be unimportant or not relevant'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const DF_DCF_STATUS_ASSESSED_OPTIONS = [
  {
    label: 'Yes, deforestation and conversion-free (DCF) status assessed',
    value: 'Yes, deforestation and conversion-free (DCF) status assessed'
  },
  {
    label: 'Yes, deforestation-free (DF) status assessed',
    value: 'Yes, deforestation-free (DF) status assessed'
  },
  {
    label: 'No, but we plan to do so within the next two years',
    value: 'No, but we plan to do so within the next two years'
  },
  {
    label: 'No, and we do not plan to do so within the next two years',
    value: 'No, and we do not plan to do so within the next two years'
  }
];

export const ADDITIONAL_CONTROL_METHODS_OPTIONS = [
  {label: 'Production unit monitoring', value: 'Production unit monitoring'},
  {label: 'Sourcing area monitoring', value: 'Sourcing area monitoring'},
  {
    label: 'Third-party certification providing full DF/DCF assurance',
    value: 'Third-party certification providing full DF/DCF assurance'
  },
  {label: 'No', value: 'No'}
];

export const PRODUCTION_UNIT_MONITORING_OPTIONS = [
  {
    label: 'Geospatial monitoring or remote sensing tool',
    value: 'Geospatial monitoring or remote sensing tool'
  },
  {
    label: 'Ground-based monitoring system',
    value: 'Ground-based monitoring system'
  },
  {label: 'Community-based monitoring', value: 'Community-based monitoring'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const TYPE_OF_VERIFICATION_OPTIONS = [
  {label: 'First party', value: 'First party'},
  {label: ' Second party', value: ' Second party'},
  {label: 'Third party', value: 'Third party'}
];

export const MONITORING_APPROACH_OPTIONS = [
  {
    label:
      'Collaborating with other organizations to develop and share risk profiles',
    value:
      'Collaborating with other organizations to develop and share risk profiles'
  },
  {
    label: 'Consultation with rights holders and other stakeholders',
    value: 'Consultation with rights holders and other stakeholders'
  },
  {label: 'Ground-based monitoring', value: 'Ground-based monitoring'},
  {label: 'Independent studies', value: 'Independent studies'},
  {
    label: 'Information gathered through grievance mechanisms',
    value: 'Information gathered through grievance mechanisms'
  },
  {
    label: 'Landscape or jurisdictional approaches',
    value: 'Landscape or jurisdictional approaches'
  },
  {
    label: 'Pre-existing current and credible risk profiles/indexes',
    value: 'Pre-existing current and credible risk profiles/indexes'
  },
  {
    label: 'Remote sensing or other geospatial data',
    value: 'Remote sensing or other geospatial data'
  },
  {label: 'Third-party assessment tool', value: 'Third-party assessment tool'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const MONITORING_OR_ESTIMATING_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {
    label:
      'No, but we plan to monitor or estimate our deforestation and conversion footprint in the next two years',
    value:
      'No, but we plan to monitor or estimate our deforestation and conversion footprint in the next two years'
  },
  {
    label:
      'No, and we do not plan to monitor or estimate our deforestation and conversion footprint in the next two years',
    value:
      'No, and we do not plan to monitor or estimate our deforestation and conversion footprint in the next two years'
  }
];

export const MONITORING_AND_ESTIMATING_OPTIONS = [
  {
    label:
      'We monitor the deforestation and conversion footprint on the land we own, manage or control',
    value:
      'We monitor the deforestation and conversion footprint on the land we own, manage or control'
  },
  {
    label:
      'We monitor the deforestation and conversion footprint in our value chain',
    value:
      'We monitor the deforestation and conversion footprint in our value chain'
  },
  {
    label:
      'We estimate the deforestation and conversion footprint based on sourcing area',
    value:
      'We estimate the deforestation and conversion footprint based on sourcing area'
  }
];

export const REPORTING_OF_DEFORESTATION_OPTIONS = [
  {label: 'During the reporting period', value: 'During the reporting period'},
  {
    label: 'Since a specified cutoff date',
    value: 'Since a specified cutoff date'
  },
  {label: 'During the last 5 years', value: 'During the last 5 years'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const ACTION_TYPE = [
  {label: 'Increasing traceability', value: 'Increasing traceability'},
  {
    label: 'Increasing physical certification',
    value: 'Increasing physical certification'
  },
  {
    label: 'Increasing production unit monitoring',
    value: 'Increasing production unit monitoring'
  },
  {
    label: 'Increasing sourcing area level monitoring',
    value: 'Increasing sourcing area level monitoring'
  },
  {
    label: 'Increasing supplier control systems',
    value: 'Increasing supplier control systems'
  },
  {
    label: 'Working with noncompliant suppliers',
    value: 'Working with noncompliant suppliers'
  },
  {label: 'Working with smallholders', value: 'Working with smallholders'},
  {
    label:
      'Engaging and working collaboratively in landscape/jurisdictional initiatives',
    value:
      'Engaging and working collaboratively in landscape/jurisdictional initiatives'
  },
  {
    label: 'Working collaboratively in sector initiatives',
    value: 'Working collaboratively in sector initiatives'
  },
  {
    label: 'Working to remediate past conversion',
    value: 'Working to remediate past conversion'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const MAIN_MEASURES_IDENTIFIED_OPTIONS = [
  {
    label: 'Development of certification and sustainability standards',
    value: 'Development of certification and sustainability standards'
  },
  {
    label:
      'Development of certification and sustainability standards across entire landscapes/jurisdictions',
    value:
      'Development of certification and sustainability standards across entire landscapes/jurisdictions'
  },
  {
    label:
      'Greater alignment between company goals and goals at landscape/jurisdictional level',
    value:
      'Greater alignment between company goals and goals at landscape/jurisdictional level'
  },
  {
    label: 'Greater community support to facilitate sustainable agriculture',
    value: 'Greater community support to facilitate sustainable agriculture'
  },
  {label: 'Greater customer awareness', value: 'Greater customer awareness'},
  {
    label: 'Greater enforcement of regulations',
    value: 'Greater enforcement of regulations'
  },
  {
    label: 'Greater stakeholder engagement and collaboration',
    value: 'Greater stakeholder engagement and collaboration'
  },
  {
    label: 'Greater supplier awareness/engagement',
    value: 'Greater supplier awareness/engagement'
  },
  {label: 'Greater transparency', value: 'Greater transparency'},
  {
    label: 'Increased demand for certified products',
    value: 'Increased demand for certified products'
  },
  {
    label:
      'Increased knowledge on commodity driven deforestation, forest degradation and/or conversion',
    value:
      'Increased knowledge on commodity driven deforestation, forest degradation and/or conversion'
  },
  {
    label: 'Investment in monitoring tools and traceability systems',
    value: 'Investment in monitoring tools and traceability systems'
  },
  {
    label: 'Improvement in data collection and quality',
    value: 'Improvement in data collection and quality'
  },
  {
    label: 'Involvement in landscape and/or jurisdictional initiatives',
    value: 'Involvement in landscape and/or jurisdictional initiatives'
  },
  {
    label: 'Involvement in multi-stakeholder initiatives',
    value: 'Involvement in multi-stakeholder initiatives'
  },
  {
    label: 'Minimizing food loss and waste',
    value: 'Minimizing food loss and waste'
  },
  {
    label: 'Price premium for certified materials',
    value: 'Price premium for certified materials'
  },
  {
    label: 'Reduced cost of certification/certified products',
    value: 'Reduced cost of certification/certified products'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const TARGET_LIST_OPTIONS = [
  {label: 'Target 1', value: 'Target 1'},
  {label: 'Target 2', value: 'Target 2'},
  {label: 'Target 3', value: 'Target 3'},
  {label: 'Target 4', value: 'Target 4'},
  {label: 'Target 5', value: 'Target 5'},
  {label: 'Target 6', value: 'Target 6'},
  {label: 'Target 7', value: 'Target 7'},
  {label: 'Target 8', value: 'Target 8'},
  {label: 'Target 9', value: 'Target 9'},
  {label: 'Target 10', value: 'Target 10'},
  {label: 'Target 11', value: 'Target 11'},
  {label: 'Target 12', value: 'Target 12'},
  {label: 'Target 13', value: 'Target 13'},
  {label: 'Target 14', value: 'Target 14'},
  {label: 'Target 15', value: 'Target 15'},
  {label: 'Target 16', value: 'Target 16'},
  {label: 'Target 17', value: 'Target 17'},
  {label: 'Target 18', value: 'Target 18'},
  {label: 'Target 19', value: 'Target 19'},
  {label: 'Target 20', value: 'Target 20'},
  {label: 'Target 21', value: 'Target 21'},
  {label: 'Target 22', value: 'Target 22'},
  {label: 'Target 23', value: 'Target 23'},
  {label: 'Target 24', value: 'Target 24'},
  {label: 'Target 25', value: 'Target 25'}
];

export const TARGET_CONTRIBUTION_OPTIONS = [
  {
    label: 'Yes, this target contributes to our no-deforestation target',
    value: 'Yes, this target contributes to our no-deforestation target'
  },
  {
    label: 'Yes, this target contributes to our no-conversion target',
    value: 'Yes, this target contributes to our no-conversion target'
  },
  {
    label:
      'No, this target is separate from our no-deforestation or no-conversion target',
    value:
      'No, this target is separate from our no-deforestation or no-conversion target'
  }
];

export const TARGET_LEVEL_OPTIONS = [
  {label: 'Business activity', value: 'Business activity'},
  {label: 'Business division', value: 'Business division'},
  {
    label: 'Organization-wide (direct operations only)',
    value: 'Organization-wide (direct operations only)'
  },
  {
    label: 'Organization-wide (including suppliers)',
    value: 'Organization-wide (including suppliers)'
  },
  {label: 'Country/area/region', value: 'Country/area/region'},
  {label: 'Product level', value: 'Product level'},
  {label: 'Site/facility', value: 'Site/facility'},
  {label: 'Suppliers', value: 'Suppliers'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const TARGET_VOLUME_OPTIONS = [
  {label: 'Disclosure volume', value: 'Disclosure volume'},
  {label: 'Total commodity volume', value: 'Total commodity volume'},
  {
    label:
      'Total commodity volume associated with operations or locations covered by target',
    value:
      'Total commodity volume associated with operations or locations covered by target'
  },
  {
    label: 'Other volume, please specify.',
    value: 'Other volume, please specify.'
  }
];

export const TARGET_METRIC_OPTIONS = [
  {
    label: 'Traceability',
    options: [
      {
        value: '% of volume traceable to traceability point',
        label: '% of volume traceable to traceability point'
      },
      {
        value: 'Other traceability target metric, please specify.',
        label: 'Other traceability target metric, please specify.'
      }
    ]
  },
  {
    label: 'Third-party certification',
    options: [
      {
        value: '% of volume third-party certified',
        label: '% of volume third-party certified'
      },
      {
        value: 'Other third-party certification target metric, please specify.',
        label: 'Other third-party certification target metric, please specify.'
      }
    ]
  },
  {
    label: 'Engagement with smallholders',
    options: [
      {value: '% of smallholders engaged', label: '% of smallholders engaged'},
      {
        value: 'Investment in programs to support smallholders',
        label: 'Investment in programs to support smallholders'
      },
      {
        value: 'Number of smallholders engaged',
        label: 'Number of smallholders engaged'
      },
      {
        value:
          'Volume sourced from smallholders supported to enter responsible value chains',
        label:
          'Volume sourced from smallholders supported to enter responsible value chains'
      },
      {
        value: 'Other smallholders engagement target metric, please specify.',
        label: 'Other smallholders engagement target metric, please specify.'
      }
    ]
  },
  {
    label: 'Engagement with Tier 1 suppliers',
    options: [
      {
        value:
          '% of procurement spend from Tier 1 suppliers compliant with your no-deforestation or no-conversion target',
        label:
          '% of procurement spend from Tier 1 suppliers compliant with your no-deforestation or no-conversion target'
      },
      {
        value:
          '% of processing facilities with deforestation/conversion monitoring systems in place',
        label:
          '% of processing facilities with deforestation/conversion monitoring systems in place'
      },
      {
        value: '% of processing facilities with DCF/NDPE commitments',
        label: '% of processing facilities with DCF/NDPE commitments'
      },
      {
        value: '% of processing facilities compliant with DCF/NDPE commitments',
        label: '% of processing facilities compliant with DCF/NDPE commitments'
      },
      {
        value:
          '% of processing facilities with public time-bound action plans in place',
        label:
          '% of processing facilities with public time-bound action plans in place'
      },
      {
        value:
          'Other owned or managed processing facilities performance target metric, please specify.',
        label:
          'Other owned or managed processing facilities performance target metric, please specify.'
      }
    ]
  },
  {
    label: 'Performance of processing facilities in value chain',
    options: [
      {
        value:
          '% of processing facilities with public time-bound action plans in place',
        label:
          '% of processing facilities with public time-bound action plans in place'
      },
      {
        value:
          '% of processing facilities in value chain with DCF/NDPE commitments',
        label:
          '% of processing facilities in value chain with DCF/NDPE commitments'
      },
      {
        value:
          '% of processing facilities in value chain compliant with DCF/NDPE commitments',
        label:
          '% of processing facilities in value chain compliant with DCF/NDPE commitments'
      },
      {
        value:
          '% of processing facilities in value chain with deforestation or conversion monitoring systems in place',
        label:
          '% of processing facilities in value chain with deforestation or conversion monitoring systems in place'
      },
      {
        value:
          'Other processing facilities in value chain performance target metric, please specify.',
        label:
          'Other processing facilities in value chain performance target metric, please specify.'
      }
    ]
  },
  {
    label: 'Engagement in landscapes/jurisdictions',
    options: [
      {
        value:
          'Hectares of land area invested in under jurisdictional/landscape approach',
        label:
          'Hectares of land area invested in under jurisdictional/landscape approach'
      },
      {
        value: 'Investment in landscapes and jurisdictions',
        label: 'Investment in landscapes and jurisdictions'
      },
      {
        value:
          '% of procurement spend from Tier 1 suppliers with their own commitments across their entire commodity operations',
        label:
          '% of procurement spend from Tier 1 suppliers with their own commitments across their entire commodity operations'
      },
      {
        value: '% of Tier 1 suppliers engaged',
        label: '% of Tier 1 suppliers engaged'
      },
      {
        value:
          '% of Tier 1 suppliers with no-deforestation or no-conversion target across their entire business',
        label:
          '% of Tier 1 suppliers with no-deforestation or no-conversion target across their entire business'
      },
      {
        value:
          '% of Tier 1 suppliers with public time-bound action plans in place',
        label:
          '% of Tier 1 suppliers with public time-bound action plans in place'
      },
      {
        value:
          '% of volume from Tier 1 suppliers compliant with your no-deforestation or no-conversion target',
        label:
          '% of volume from Tier 1 suppliers compliant with your no-deforestation or no-conversion target'
      },
      {
        value:
          'Other Tier 1 suppliers engagement target metric, please specify.',
        label:
          'Other Tier 1 suppliers engagement target metric, please specify.'
      }
    ]
  },
  {
    label: 'Engagement with Tier 2+ suppliers',
    options: [
      {
        value:
          '% of procurement spend from Tier 2+ suppliers compliant with your no-deforestation or no-conversion target',
        label:
          '% of procurement spend from Tier 2+ suppliers compliant with your no-deforestation or no-conversion target'
      },
      {
        value: '% of Tier 2+ suppliers engaged',
        label: '% of Tier 2+ suppliers engaged'
      },
      {
        value:
          '% of Tier 2+ suppliers with public time-bound action plans in place',
        label:
          '% of Tier 2+ suppliers with public time-bound action plans in place'
      },
      {
        value:
          '% of volume from Tier 2+ suppliers compliant with your no-deforestation or no-conversion target',
        label:
          '% of volume from Tier 2+ suppliers compliant with your no-deforestation or no-conversion target'
      },
      {
        value:
          'Other Tier 2+ suppliers engagement target metric, please specify.',
        label:
          'Other Tier 2+ suppliers engagement target metric, please specify.'
      },
      {
        value: 'Number of landscape/jurisdictional initiatives supported',
        label: 'Number of landscape/jurisdictional initiatives supported'
      },
      {
        value:
          'Other landscapes/jurisdictions engagement target metric, please specify.',
        label:
          'Other landscapes/jurisdictions engagement target metric, please specify.'
      }
    ]
  },
  {
    label: 'Natural ecosystem restoration and long-term protection',
    options: [
      {
        value:
          '% decrease in absolute agricultural land footprint from direct operations',
        label:
          '% decrease in absolute agricultural land footprint from direct operations'
      },
      {
        value:
          '% decrease in agricultural land footprint intensity from direct operations',
        label:
          '% decrease in agricultural land footprint intensity from direct operations'
      },
      {value: 'Hectares afforested', label: 'Hectares afforested'},
      {value: 'Hectares reforested', label: 'Hectares reforested'},
      {value: 'Hectares under protection', label: 'Hectares under protection'},
      {
        value: 'Hectares under restoration',
        label: 'Hectares under restoration'
      },
      {
        value: 'Investment in restoration and conservation projects',
        label: 'Investment in restoration and conservation projects'
      },
      {
        value: 'Number of carbon credits originated (metric tons CO2e)',
        label: 'Number of carbon credits originated (metric tons CO2e)'
      },
      {
        value: 'Total number of restoration and/or conservation projects',
        label: 'Total number of restoration and/or conservation projects'
      },
      {
        value:
          'Other natural ecosystem restoration and long-term protection target metric, please specify.',
        label:
          'Other natural ecosystem restoration and long-term protection target metric, please specify.'
      }
    ]
  },
  {
    label: 'Resource use and efficiency',
    options: [
      {
        value: '% of commodity volume discarded as waste',
        label: '% of commodity volume discarded as waste'
      },
      {
        value:
          '% decrease in average weight of packaging per product unit (grams)',
        label:
          '% decrease in average weight of packaging per product unit (grams)'
      },
      {
        value:
          '% of paper and packaging products using alternative fibers that consider full life cycle, biodiversity, and food security impacts',
        label:
          '% of paper and packaging products using alternative fibers that consider full life cycle, biodiversity, and food security impacts'
      },
      {
        value: '% of recycled content used in paper and packaging products',
        label: '% of recycled content used in paper and packaging products'
      },
      {
        value:
          '% of revenue from beef replaced with alternative sources (e.g., alternative protein) [Cattle products only]',
        label:
          '% of revenue from beef replaced with alternative sources (e.g., alternative protein) [Cattle products only]'
      },
      {
        value:
          '% decrease in material inputs for paper and packaging products (metric tons)',
        label:
          '% decrease in material inputs for paper and packaging products (metric tons)'
      },
      {
        value:
          'Other resource use and efficiency target metric, please specify.',
        label:
          'Other resource use and efficiency target metric, please specify.'
      }
    ]
  },
  {
    label: 'Other target category, please specify',
    options: [
      {
        value: 'Other target metric, please specify.',
        label: 'Other target metric, please specify.'
      }
    ]
  }
];

export const TRACEABILITY_POINT_OPTIONS = [
  {label: 'Production unit', value: 'Production unit'},
  {
    label: 'Sourcing area, but not to production unit',
    value: 'Sourcing area, but not to production unit'
  },
  {label: 'Country/area of origin', value: 'Country/area of origin'}
];

export const THIRD_PARTY_CERTIFICATION_SCHEME_OPTIONS = [
  {
    label: 'Forest management unit/Producer certification',
    options: [
      {
        value:
          'Biosuisse organic [Palm oil, Cattle products, Soy, Coffee, Cocoa]',
        label:
          'Biosuisse organic [Palm oil, Cattle products, Soy, Coffee, Cocoa]'
      },
      {value: 'Donau Soja [Soy]', label: 'Donau Soja [Soy]'},
      {value: 'Europe Soja [Soy]', label: 'Europe Soja [Soy]'},
      {
        value: 'FSC Controlled Wood certification [Timber, Rubber]',
        label: 'FSC Controlled Wood certification [Timber, Rubber]'
      },
      {
        value: 'FSC Forest Management certification [Timber products, Rubber]',
        label: 'FSC Forest Management certification [Timber products, Rubber]'
      },
      {
        value: 'ISCC CORSIA',
        label: 'ISCC CORSIA'
      },
      {
        value:
          'ISCC EU [Palm oil, Cattle products, Soy, Timber products, Coffee, Cocoa]',
        label:
          'ISCC EU [Palm oil, Cattle products, Soy, Timber products, Coffee, Cocoa]'
      },
      {
        value:
          'Other forest management/producer certification, please specify.',
        label: 'Other forest management/producer certification, please specify.'
      }
    ]
  },
  {
    label: 'Chain-of-custody certification',
    options: [
      {
        value: 'Donau Soja – Segregated [Soy]',
        label: 'Donau Soja – Segregated [Soy]'
      },
      {
        value: 'Europe Soja – Segregated [Soy]',
        label: 'Europe Soja – Segregated [Soy]'
      },
      {
        value:
          'FSC Chain-of-Custody certification (any type) [Timber products, Rubber]',
        label:
          'FSC Chain-of-Custody certification (any type) [Timber products, Rubber]'
      },
      {
        value: 'FSC Recycled certification [Timber products]',
        label: 'FSC Recycled certification [Timber products]'
      },
      {
        value: 'ISCC CORSIA – Identity preserved',
        label: 'ISCC CORSIA – Identity preserved'
      },
      {
        value: 'ISCC CORSIA - Mass Balance',
        label: 'ISCC CORSIA - Mass Balance'
      },
      {
        value: 'ISCC CORSIA – Segregated',
        label: 'ISCC CORSIA – Segregated'
      },
      {
        value: 'ISCC Japan FIT [Palm oil]',
        label: 'ISCC Japan FIT [Palm oil]'
      },
      {value: 'ISCC PLUS', label: 'ISCC PLUS'},
      {
        value: 'Naturland [Cattle products, Soy, Coffee, Cocoa]',
        label: 'Naturland [Cattle products, Soy, Coffee, Cocoa]'
      },
      {
        value:
          'PEFC Sustainable Forest Management certification [Timber products, Rubber]',
        label:
          'PEFC Sustainable Forest Management certification [Timber products, Rubber]'
      },
      {
        value: 'Preferred by Nature Sustainability Framework',
        label: 'Preferred by Nature Sustainability Framework'
      },
      {
        value:
          'ProTerra certification [Soy, Coffee, Cocoa, Cattle products, Palm oil]',
        label:
          'ProTerra certification [Soy, Coffee, Cocoa, Cattle products, Palm oil]'
      },
      {
        value:
          'RA Sustainable Agriculture standard: Farm certificate [Coffee, Cocoa]',
        label:
          'RA Sustainable Agriculture standard: Farm certificate [Coffee, Cocoa]'
      },
      {
        value: 'RSB Global Advanced Products',
        label: 'RSB Global Advanced Products'
      },
      {
        value: 'RSB Global Fuels',
        label: 'RSB Global Fuels'
      },
      {
        value: 'RSB ICAO CORSIA',
        label: 'RSB ICAO CORSIA'
      },
      {
        value: 'RSB Japan FIT Biomass [Palm oil]',
        label: 'RSB Japan FIT Biomass [Palm oil]'
      },
      {
        value: 'RSPO producer/grower certification [Palm oil]',
        label: 'RSPO producer/grower certification [Palm oil]'
      },
      {
        value: 'RTRS standard for Responsible Soy Production [Soy]',
        label: 'RTRS standard for Responsible Soy Production [Soy]'
      },
      {
        value: 'SFI Forest Management standard [Timber products]',
        label: 'SFI Forest Management standard [Timber products]'
      },
      {
        value:
          'Soil Association Organic Farming & Growing (GB and Northern Ireland) [Cattle products, Soy]',
        label:
          'Soil Association Organic Farming & Growing (GB and Northern Ireland) [Cattle products, Soy]'
      },
      {
        value: 'SURE [Timber products, Palm oil, Soy]',
        label: 'SURE [Timber products, Palm oil, Soy]'
      },
      {
        value: 'Sustainable Biomass Program [Timber products]',
        label: 'Sustainable Biomass Program [Timber products]'
      }
    ]
  }
];

export const LAND_CONTROL_TYPE_OPTIONS = [
  {label: 'Own land', value: 'Own land'},
  {label: 'Concessions/lease', value: 'Concessions/lease'},
  {
    label: 'Company-affiliated smallholders',
    value: 'Company-affiliated smallholders'
  },
  {label: 'Other type of control, please specify', value: 'Other'}
];

export const LAND_USE_TYPE_OPTIONS = [
  {label: 'Area for infrastructure', value: 'Area for infrastructure'},
  {
    label: 'Unplanted land (designated for future planting)',
    value: 'Unplanted land (designated for future planting)'
  },
  {
    label: 'Set-aside land for conservation',
    value: 'Set-aside land for conservation'
  },
  {
    label:
      'Natural ecosystems with potential to be legally converted for commodity production',
    value: 'Natural ecosystems with potential to be legally converted'
  },
  {
    label: 'Degraded/abandoned area with potential for commodity production',
    value: 'Degraded/abandoned area with potential for commodity production'
  },
  {
    label: 'Land managed by company-affiliated smallholders',
    value: 'Land managed by company-affiliated smallholders'
  },
  {
    label: 'Land protected by certifications',
    value: 'Land protected by certifications'
  },
  {
    label: 'Land leased for natural resource exploration and/or extraction',
    value: 'Land leased for natural resource exploration/extraction'
  },
  {label: 'Other land type, please specify', value: 'Other'}
];

export const JURISDICTION_OPTIONS = [
  {
    label: 'States/equivalent jurisdictions',
    value: 'States/equivalent jurisdictions'
  },
  {label: 'Unknown', value: 'Unknown'},
  {label: 'Not disclosing', value: 'Not disclosing'}
];

export const PRODUCER_TYPES_OPTIONS = [
  {
    label: 'Independent smallholders',
    value: 'Independent smallholders'
  },
  {
    label: 'Company-affiliated smallholders',
    value: 'Company-affiliated smallholders'
  },
  {
    label: 'Single contracted producer',
    value: 'Single contracted producer'
  },
  {
    label: 'Multiple contracted producers',
    value: 'Multiple contracted producers'
  },
  {
    label: 'Trader/broker/commodity market',
    value: 'Trader/broker/commodity market'
  },
  {
    label: 'Contracted suppliers (processors)',
    value: 'Contracted suppliers (processors)'
  },
  {
    label: 'Contracted suppliers (manufacturers)',
    value: 'Contracted suppliers (manufacturers)'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const VOLUME_TYPE_OPTIONS = [
  {label: 'Produced', value: 'Produced'},
  {label: 'Sourced', value: 'Sourced'}
];

export const METRIC_OPTIONS = [
  {
    label: 'Metric tons',
    value: 'Metric tons'
  },
  {
    label: 'Liters',
    value: 'Liters'
  },
  {
    label: 'Gallons',
    value: 'Gallons'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const PERCENTAGE_DISCLOSURE_VOLUME_OPTIONS = [
  {label: '<1%', value: '<1%'},
  {label: '1-5%', value: '1-5%'},
  {label: '6-10%', value: '6-10%'},
  {label: '11-20%', value: '11-20%'},
  {label: '21-30%', value: '21-30%'},
  {label: '31-40%', value: '31-40%'},
  {label: '41-50%', value: '41-50%'},
  {label: '51-60%', value: '51-60%'},
  {label: '61-70%', value: '61-70%'},
  {label: '71-80%', value: '71-80%'},
  {label: '81-90%', value: '81-90%'},
  {label: '91-99%', value: '91-99%'},
  {label: '100%', value: '100%'},
  {label: 'Unknown', value: 'Unknown'},
  {label: 'Not applicable', value: 'Not applicable'}
];

export const YES_NO_UNKNOWN_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No', value: 'No'},
  {label: 'Unknown', value: 'Unknown'},
  {label: 'Not disclosing', value: 'Not disclosing'}
];

export const YES_NO_UNKNOWN_ONLY_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No', value: 'No'},
  {label: 'Unknown', value: 'Unknown'}
];

export const YES_NO_NOT_APPLICABLE_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No', value: 'No'},
  {label: 'Not applicable', value: 'Not applicable'}
];

export const ACTIVE_DEFORESTATION_TARGET_OPTIONS = [
  {
    label: 'Yes, we have a no-deforestation target',
    value: 'Yes, we have a no-deforestation target'
  },
  {
    label: 'Yes, we have a no-conversion target',
    value: 'Yes, we have a no-conversion target'
  },
  {
    label:
      'No, but we plan to have a no-deforestation or no-conversion target in the next two years',
    value:
      'No, but we plan to have a no-deforestation or no-conversion target in the next two years'
  },
  {
    label:
      'No, and we do not plan to have a no-deforestation or no-conversion target in the next two years',
    value:
      'No, and we do not plan to have a no-deforestation or no-conversion target in the next two years'
  }
];

export const NO_DEFORESTATION_TARGET_OPTIONS = [
  {
    label: 'Organization-wide (including suppliers)',
    value: 'Organization-wide (including suppliers)'
  },
  {
    label: 'Organization-wide (direct operations only)',
    value: 'Organization-wide (direct operations only)'
  },
  {
    label: 'Business division',
    value: 'Business division'
  },
  {
    label: 'Business activity',
    value: 'Business activity'
  },
  {
    label: 'Country/area/region',
    value: 'Country/area/region'
  },
  {
    label: 'Product level',
    value: 'Product level'
  },
  {
    label: 'Site/facility',
    value: 'Site/facility'
  },
  {
    label: 'Suppliers',
    value: 'Suppliers'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const TARGET_CHALLENGES_OPTIONS = [
  {
    label:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
    value:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
  },
  {
    label: 'No standardized procedure',
    value: 'No standardized procedure'
  },
  {
    label: 'Not an immediate strategic priority',
    value: 'Not an immediate strategic priority'
  },
  {
    label: 'Judged to be unimportant or not relevant',
    value: 'Judged to be unimportant or not relevant'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const OTHER_COMMODITY_TARGET_OPTIONS = [
  {
    label: 'Yes, we have other targets related to this commodity',
    value: 'Yes, we have other targets related to this commodity'
  },
  {
    label:
      'No, but we plan to have other targets related to this commodity in the next two years',
    value:
      'No, but we plan to have other targets related to this commodity in the next two years'
  },
  {
    label:
      'No, and we do not plan to have other targets related to this commodity in the next two years',
    value:
      'No, and we do not plan to have other targets related to this commodity in the next two years'
  }
];

export const CUTOFF_YEAR_OPTIONS = [
  {label: '<1987', value: '<1987'},
  {label: '1987-1992', value: '1987-1992'},
  {label: '1993-1997', value: '1993-1997'},
  {label: '1998', value: '1998'},
  {label: '1999', value: '1999'},
  {label: '2000', value: '2000'},
  {label: '2001', value: '2001'},
  {label: '2002', value: '2002'},
  {label: '2003', value: '2003'},
  {label: '2004', value: '2004'},
  {label: '2005', value: '2005'},
  {label: '2006', value: '2006'},
  {label: '2007', value: '2007'},
  {label: '2008', value: '2008'},
  {label: '2009', value: '2009'},
  {label: '2010', value: '2010'},
  {label: '2011', value: '2011'},
  {label: '2012', value: '2012'},
  {label: '2013', value: '2013'},
  {label: '2014', value: '2014'},
  {label: '2015', value: '2015'},
  {label: '2016', value: '2016'},
  {label: '2017', value: '2017'},
  {label: '2018', value: '2018'},
  {label: '2019', value: '2019'},
  {label: '2020', value: '2020'},
  {label: '2021', value: '2021'},
  {label: '2022', value: '2022'},
  {label: '2023', value: '2023'},
  {label: '2024', value: '2024'},
  {label: 'No cutoff date', value: 'No cutoff date'}
];

export const GEOGRAPHIC_SCOPE_CUTOFF_YEAR_OPTIONS = [
  {
    label: 'Applied globally',
    value: 'Applied globally'
  },
  {
    label: 'Country/area, please specify',
    value: 'Country/area, please specify'
  },
  {
    label: 'Biome, please specify',
    value: 'Biome, please specify'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const RATIONALE_SELECTING_CUTOFF_OPTIONS = [
  {
    label: 'Sector-wide agreement/recommendation',
    value: 'Sector-wide agreement/recommendation'
  },
  {
    label: 'Region-wide agreement/recommendation',
    value: 'Region-wide agreement/recommendation'
  },
  {
    label: 'In line with supplier commitments',
    value: 'In line with supplier commitments'
  },
  {
    label: 'Legal requirements',
    value: 'Legal requirements'
  },
  {
    label: 'Compliance with initiative, please specify',
    value: 'Compliance with initiative, please specify'
  },
  {
    label:
      'In line with organizational commitments, because no sector- or region-wide cutoff date is available',
    value:
      'In line with organizational commitments, because no sector- or region-wide cutoff date is available'
  },
  {
    label:
      'In line with organizational commitments, but sector- or region-wide cutoff date is available',
    value:
      'In line with organizational commitments, but sector- or region-wide cutoff date is available'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const TARGET_DATE_OPTIONS = [
  {label: '<2017', value: '<2017'},
  {label: '2017', value: '2017'},
  {label: '2018', value: '2018'},
  {label: '2019', value: '2019'},
  {label: '2020', value: '2020'},
  {label: '2021', value: '2021'},
  {label: '2022', value: '2022'},
  {label: '2023', value: '2023'},
  {label: '2024', value: '2024'},
  {label: '2025', value: '2025'},
  {label: '2026-2030', value: '2026-2030'},
  {label: '>2030', value: '>2030'},
  {label: 'No target date', value: 'No target date'}
];

export const YES_NO_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No', value: 'No'}
];

export const CERTIFICATION_OPTIONS = [
  {label: 'Biosuisse organic', value: 'Biosuisse organic'},
  {label: 'Donau Soja', value: 'Donau Soja'},
  {label: 'Europe Soja', value: 'Europe Soja'},
  {
    label: 'FSC Controlled Wood certification',
    value: 'FSC Controlled Wood certification'
  },
  {
    label: 'FSC Forest Management certification',
    value: 'FSC Forest Management certification'
  },
  {label: 'ISCC CORSIA', value: 'ISCC CORSIA'},
  {label: 'ISCC EU', value: 'ISCC EU'},
  {label: 'ISCC Japan FIT', value: 'ISCC Japan FIT'},
  {label: 'ISCC PLUS', value: 'ISCC PLUS'},
  {label: 'Naturland', value: 'Naturland'},
  {
    label: 'PEFC Sustainable Forest Management certification',
    value: 'PEFC Sustainable Forest Management certification'
  },
  {
    label: 'Preferred by Nature Sustainability Framework',
    value: 'Preferred by Nature Sustainability Framework'
  },
  {label: 'ProTerra certification', value: 'ProTerra certification'},
  {
    label: 'RA Sustainable Agriculture standard: Farm certificate',
    value: 'RA Sustainable Agriculture standard: Farm certificate'
  },
  {
    label: 'RSB Certificate for Smallholder Groups',
    value: 'RSB Certificate for Smallholder Groups'
  },
  {
    label: 'RSB Global Advanced Products',
    value: 'RSB Global Advanced Products'
  },
  {label: 'RSB Global Fuels', value: 'RSB Global Fuels'},
  {label: 'RSB ICAO CORSIA', value: 'RSB ICAO CORSIA'},
  {label: 'RSB Japan FIT Biomass', value: 'RSB Japan FIT Biomass'},
  {
    label: 'RSPO producer/grower certification',
    value: 'RSPO producer/grower certification'
  },
  {
    label: 'RTRS standard for Responsible Soy Production',
    value: 'RTRS standard for Responsible Soy Production'
  },
  {
    label: 'SFI Forest Management standard',
    value: 'SFI Forest Management standard'
  },
  {
    label:
      'Soil Association Organic Farming & Growing (GB and Northern Ireland)',
    value:
      'Soil Association Organic Farming & Growing (GB and Northern Ireland)'
  },
  {label: 'SURE', value: 'SURE'},
  {label: 'Sustainable Biomass Program', value: 'Sustainable Biomass Program'},
  {
    label:
      'No certified area in this country/area, state or equivalent jurisdiction',
    value:
      'No certified area in this country/area, state or equivalent jurisdiction'
  },
  {
    label: 'Other forest management/producer certification, please specify',
    value: 'Other forest management/producer certification, please specify'
  }
];

export const DISCLOSURE_OF_EMBEDDED_SOY_OPTIONS = [
  {
    label:
      'Some or all of our embedded soy volume is included in our “Sourced volume” as reported in column 4 of 8.2',
    value:
      'Some or all of our embedded soy volume is included in our “Sourced volume” as reported in column 4 of 8.2'
  },
  {
    label:
      'All of our embedded soy volume is excluded from our disclosure as reported in 8.1.1',
    value:
      'All of our embedded soy volume is excluded from our disclosure as reported in 8.1.1'
  }
];

export const TRACEABILITY_SYSTEM_SOY_OPTIONS = [
  {
    label: 'Yes, we have a traceability system for our embedded soy',
    value: ' Yes, we have a traceability system for our embedded soy'
  },
  {
    label: 'No, but we plan to establish one within the next two years',
    value: 'No, but we plan to establish one within the next two years'
  },
  {
    label: 'No, and we do not plan to establish one within the next two years',
    value: 'No, and we do not plan to establish one within the next two years'
  }
];

export const LAND_TYPE_OPTIONS = [
  {
    label: 'Managed natural forests',
    value: 'Managed natural forests'
  },
  {label: 'Tree plantations', value: 'Tree plantations'},
  {
    label: 'Other land type, please specify.',
    value: 'Other land type, please specify.'
  }
];

export const INDICATE_IF_YOU_CAN_PROVIDE_VOLUME = [
  {label: 'Yes', value: 'Yes'},
  {
    label: 'No, data is not available',
    value: 'No, data is not available'
  },
  {
    label: 'No, data is confidential',
    value: 'No, data is confidential'
  },
  {
    label: 'No, other reason, please specify.',
    value: 'No, other reason, please specify.'
  }
];

export const INDICATE_IF_LAND_OWN_MANAGED_OPTIONS = [
  {
    label: 'All the land we own manage and/or control is used for production',
    value: 'All the land we own manage and/or control is used for production'
  },
  {
    label:
      'Some of the land we own manage and/or control is not used for production',
    value:
      'Some of the land we own manage and/or control is not used for production'
  }
];

// export const PRIMARY_REASON_OPTIONS = [
//   {
//     label: 'Challenges associated with data collection and/or quality',
//     value: 'Challenges associated with data collection and/or quality'
//   },
//   {
//     label: 'Data collection is in progress',
//     value: 'Data collection is in progress'
//   },
//   {
//     label: 'Judged to be unimportant or not relevant',
//     value: 'Judged to be unimportant or not relevant'
//   },
//   {
//     label:
//       'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
//     value:
//       'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
//   },
//   {
//     label: 'No standardized procedure for collecting data',
//     value: 'No standardized procedure for collecting data'
//   },
//   {
//     label: 'Not an immediate strategic priority',
//     value: 'Not an immediate strategic priority'
//   },
//   {
//     label: 'We are planning to collect the data within the next two years',
//     value: 'We are planning to collect the data within the next two years'
//   },
//   {
//     label: 'Other, please specify',
//     value: 'Other, please specify'
//   }
// ];

export const PERCENTAGE_RANGE_OPTIONS = [
  {label: 'Less than 1%', value: 'Less than 1%'},
  {label: '1-5%', value: '1-5%'},
  {label: '6-10%', value: '6-10%'},
  {label: '11-20%', value: '11-20%'},
  {label: '21-30%', value: '21-30%'},
  {label: '31-40%', value: '31-40%'},
  {label: '41-50%', value: '41-50%'},
  {label: '51-60%', value: '51-60%'},
  {label: '61-70%', value: '61-70%'},
  {label: '71-80%', value: '71-80%'},
  {label: '81-90%', value: '81-90%'},
  {label: '91-99%', value: '91-99%'},
  {label: '100%', value: '100%'},
  {label: 'Unknown', value: 'Unknown'}
];

export const WATER_ASPECTS_MONITORED_OPTIONS = [
  {
    label: 'Water withdrawals – total volume',
    value: 'Water withdrawals – total volume'
  },
  {
    label: 'Water withdrawals - volumes by source',
    value: 'Water withdrawals - volumes by source'
  },
  {
    label:
      '[Metals & Mining and Coal sectors only] Entrained water associated with your metals & mining and/or coal sector activities – total volume',
    value:
      '[Metals & Mining and Coal sectors only] Entrained water associated with your metals & mining and/or coal sector activities – total volume'
  },
  {
    label:
      '[Oil & Gas sector only] Produced water associated with your oil & gas sector activities – total volume',
    value:
      '[Oil & Gas sector only] Produced water associated with your oil & gas sector activities – total volume'
  },
  {
    label: 'Water withdrawals quality',
    value: 'Water withdrawals quality'
  },
  {
    label: 'Water discharges – total volume',
    value: 'Water discharges – total volume'
  },
  {
    label: 'Water discharges - volumes by destination',
    value: 'Water discharges - volumes by destination'
  },
  {
    label: 'Water discharges - volumes by treatment method',
    value: 'Water discharges - volumes by treatment method'
  },
  {
    label: 'Water discharge quality – by standard effluent parameters',
    value: 'Water discharge quality – by standard effluent parameters'
  },
  {
    label:
      'Water discharge quality – emissions to water (nitrates, phosphates, pesticides, and/or other priority substances)',
    value:
      'Water discharge quality – emissions to water (nitrates, phosphates, pesticides, and/or other priority substances)'
  },
  {
    label: 'Water discharge quality – temperature',
    value: 'Water discharge quality – temperature'
  },
  {
    label: 'Water consumption – total volume',
    value: 'Water consumption – total volume'
  },
  {
    label: 'Water recycled/reused',
    value: 'Water recycled/reused'
  },
  {
    label:
      'The provision of fully-functioning, safely managed WASH services to all workers',
    value:
      'The provision of fully-functioning, safely managed WASH services to all workers'
  }
];

export const COVERAGE_PERCENTAGE_OPTIONS = [
  {label: 'Not monitored', value: 'Not monitored'},
  {label: 'Less than 1%', value: 'Less than 1%'},
  {label: '1-25%', value: '1-25%'},
  {label: '26-50%', value: '26-50%'},
  {label: '51-75%', value: '51-75%'},
  {label: '76-99%', value: '76-99%'},
  {label: '100%', value: '100%'},
  {label: 'Not relevant', value: 'Not relevant'}
];

export const FREQUENCY_OF_MEASUREMENT_OPTIONS = [
  {label: 'Continuously', value: 'Continuously'},
  {label: 'Daily', value: 'Daily'},
  {label: 'Monthly', value: 'Monthly'},
  {label: 'Quarterly', value: 'Quarterly'},
  {label: 'Yearly', value: 'Yearly'},
  {label: 'Unknown', value: 'Unknown'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const PRIMARY_REASON_FOR_COMPARISON_OPTIONS = [
  {
    label: 'Change in accounting methodology',
    value: 'Change in accounting methodology'
  },
  {
    label: 'Divestment from water-intensive technology/process',
    value: 'Divestment from water-intensive technology/process'
  },
  {
    label: 'Facility closure',
    value: 'Facility closure'
  },
  {
    label: 'Facility expansion',
    value: 'Facility expansion'
  },
  {
    label: 'Increase/decrease in business activity',
    value: 'Increase/decrease in business activity'
  },
  {
    label: 'Increase/decrease in efficiency',
    value: 'Increase/decrease in efficiency'
  },
  {
    label: 'Investment in water-smart technology/process',
    value: 'Investment in water-smart technology/process'
  },
  {
    label: 'Maximum potential volume reduction already achieved',
    value: 'Maximum potential volume reduction already achieved'
  },
  {
    label: 'Mergers and acquisitions',
    value: 'Mergers and acquisitions'
  },
  {
    label: 'Unknown',
    value: 'Unknown'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const FIVE_YEAR_FORECAST_OPTIONS = [
  {label: 'Much lower', value: 'Much lower'},
  {label: 'Lower', value: 'Lower'},
  {label: 'About the same', value: 'About the same'},
  {label: 'Higher', value: 'Higher'},
  {label: 'Much higher', value: 'Much higher'},
  {label: 'Unknown', value: 'Unknown'}
];

export const HYDROPOWER_ENVIRONMENTAL_FLOW_ASPECTS_OPTIONS = [
  {
    label: 'Fulfilment of downstream environmental flows',
    value: 'Fulfilment of downstream environmental flows'
  },
  {
    label: 'Sediment loading',
    value: 'Sediment loading'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const WATER_ACCOUNTING_BY_BUSINESS_DIVISION_OPTIONS = [
  {
    label: 'Total withdrawals – upstream',
    value: 'Total withdrawals – upstream'
  },
  {
    label: 'Total discharges – upstream',
    value: 'Total discharges – upstream'
  },
  {
    label: 'Total consumption – upstream',
    value: 'Total consumption – upstream'
  },
  {
    label: 'Total withdrawals – midstream',
    value: 'Total withdrawals – midstream'
  },
  {
    label: 'Total discharges – midstream',
    value: 'Total discharges – midstream'
  },
  {
    label: 'Total consumption – midstream',
    value: 'Total consumption – midstream'
  },
  {
    label: 'Total withdrawals – downstream',
    value: 'Total withdrawals – downstream'
  },
  {
    label: 'Total discharges – downstream',
    value: 'Total discharges – downstream'
  },
  {
    label: 'Total consumption – downstream',
    value: 'Total consumption – downstream'
  },
  {
    label: 'Total withdrawals – chemicals',
    value: 'Total withdrawals – chemicals'
  },
  {
    label: 'Total discharges – chemicals',
    value: 'Total discharges – chemicals'
  },
  {
    label: 'Total consumption – chemicals',
    value: 'Total consumption – chemicals'
  },
  {
    label: 'Total withdrawals – other business division',
    value: 'Total withdrawals – other business division'
  },
  {
    label: 'Total discharges – other business division',
    value: 'Total discharges – other business division'
  },
  {
    label: 'Total consumption – other business division',
    value: 'Total consumption – other business division'
  }
];

export const IDENTIFICATION_TOOL_OPTIONS = [
  {
    label: 'WRI Aqueduct',
    value: 'WRI Aqueduct'
  },
  {
    label: 'WWF Water Risk Filter',
    value: 'WWF Water Risk Filter'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const DATA_AVAILABILITY_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'No, but we intend to obtain this data within the next two years',
    value: 'No, but we intend to obtain this data within the next two years'
  },
  {
    label: 'No, we do not have this data and have no plans to obtain it',
    value: 'No, we do not have this data and have no plans to obtain it'
  }
];

export const PERCENTAGE_COVERAGE_ZERO_START_OPTIONS = [
  {label: '0%', value: '0%'},
  {label: 'Less than 1%', value: 'Less than 1%'},
  {label: '1-10%', value: '1-10%'},
  {label: '11-25%', value: '11-25%'},
  {label: '26-50%', value: '26-50%'},
  {label: '51-75%', value: '51-75%'},
  {label: '76-99%', value: '76-99%'},
  {label: '100%', value: '100%'}
];

export const WATER_SOURCE_TYPE_OPTIONS = [
  {
    label:
      'Fresh surface water, including rainwater, water from wetlands, rivers, and lakes',
    value:
      'Fresh surface water, including rainwater, water from wetlands, rivers, and lakes'
  },
  {
    label: 'Brackish surface water/Seawater',
    value: 'Brackish surface water/Seawater'
  },
  {
    label: 'Groundwater – renewable',
    value: 'Groundwater – renewable'
  },
  {
    label: 'Groundwater – non-renewable',
    value: 'Groundwater – non-renewable'
  },
  {
    label: 'Produced/Entrained water',
    value: 'Produced/Entrained water'
  },
  {
    label: 'Third party sources',
    value: 'Third party sources'
  }
];

export const RELEVANCE_OPTIONS = [
  {label: 'Relevant', value: 'Relevant'},
  {label: 'Relevant but volume unknown', value: 'Relevant but volume unknown'},
  {label: 'Not relevant', value: 'Not relevant'}
];

export const WATER_DISCHARGE_DESTINATION_OPTIONS = [
  {label: 'Fresh surface water', value: 'Fresh surface water'},
  {
    label: 'Brackish surface water/seawater',
    value: 'Brackish surface water/seawater'
  },
  {label: 'Groundwater', value: 'Groundwater'},
  {label: 'Third-party destinations', value: 'Third-party destinations'}
];

export const NO_DEFORESTATION_OR_NO_CONVERSION_TARGET_OPTIONS = [
  {label: 'No-deforestation', value: 'No-deforestation'},
  {label: 'No-conversion', value: 'No-conversion'}
];

export const HIGHEST_LEVEL_OF_TREATMENT_OPTIONS = [
  {label: 'Tertiary treatment', value: 'Tertiary treatment'},
  {label: 'Secondary treatment', value: 'Secondary treatment'},
  {label: 'Primary treatment only', value: 'Primary treatment only'},
  {
    label: 'Discharge to the natural environment without treatment',
    value: 'Discharge to the natural environment without treatment'
  },
  {
    label: 'Discharge to a third party without treatment',
    value: 'Discharge to a third party without treatment'
  },
  {label: 'Other', value: 'Other'}
];

export const PERCENTAGE_WITH_NOT_MONITORED_OPTIONS = [
  {label: 'Not monitored', value: 'Not monitored'},
  {label: 'Less than 1%', value: 'Less than 1%'},
  {label: '1-10%', value: '1-10%'},
  {label: '11-20%', value: '11-20%'},
  {label: '21-30%', value: '21-30%'},
  {label: '31-40%', value: '31-40%'},
  {label: '41-50%', value: '41-50%'},
  {label: '51-60%', value: '51-60%'},
  {label: '61-70%', value: '61-70%'},
  {label: '71-80%', value: '71-80%'},
  {label: '81-90%', value: '81-90%'},
  {label: '91-99%', value: '91-99%'},
  {label: '100%', value: '100%'},
  {label: 'Unknown', value: 'Unknown'}
];

export const PRIORITY_SUBSTANCES_DISCHARGED_OPTIONS = [
  {
    label: 'Nitrates',
    value: 'Nitrates'
  },
  {
    label: 'Phosphates',
    value: 'Phosphates'
  },
  {
    label: 'Pesticides',
    value: 'Pesticides'
  },
  {
    label: 'Priority substances listed under the EU Water Framework Directive',
    value: 'Priority substances listed under the EU Water Framework Directive'
  }
];

export const VALUE_CHAIN_ASSESSMENT_STATUS_OPTIONS = [
  {
    label:
      'Yes, we have assessed this value chain stage and identified facilities with water-related dependencies, impacts, risks, and opportunities',
    value:
      'Yes, we have assessed this value chain stage and identified facilities with water-related dependencies, impacts, risks, and opportunities'
  },
  {
    label:
      'No, we have assessed this value chain stage but did not identify any facilities with water-related dependencies, impacts, risks, and opportunities',
    value:
      'No, we have assessed this value chain stage but did not identify any facilities with water-related dependencies, impacts, risks, and opportunities'
  },
  {
    label:
      'No, we have not assessed this value chain stage for facilities with water-related dependencies, impacts, risks, and opportunities, and are not planning to do so in the next two years',
    value:
      'No, we have not assessed this value chain stage for facilities with water-related dependencies, impacts, risks, and opportunities, and are not planning to do so in the next two years'
  },
  {
    label:
      'No, we have not assessed this value chain stage for facilities with water-related dependencies, impacts, risks, and opportunities, but we are planning to do so in the next two years',
    value:
      'No, we have not assessed this value chain stage for facilities with water-related dependencies, impacts, risks, and opportunities, but we are planning to do so in the next two years'
  }
];

export const PERCENTAGE_SIMPLE_RANGE_OPTIONS = [
  {label: 'Less than 1%', value: 'Less than 1%'},
  {label: '1-25%', value: '1-25%'},
  {label: '26-50%', value: '26-50%'},
  {label: '51-75%', value: '51-75%'},
  {label: '76-99%', value: '76-99%'},
  {label: '100%', value: '100%'},
  {label: 'Unknown', value: 'Unknown'}
];

export const FACILITY_OPTIONS = [
  {label: 'Facility 1', value: 'Facility 1'},
  {label: 'Facility 2', value: 'Facility 2'},
  {label: 'Facility 3', value: 'Facility 3'},
  {label: 'Facility 4', value: 'Facility 4'},
  {label: 'Facility 5', value: 'Facility 5'},
  {label: 'Facility 6', value: 'Facility 6'},
  {label: 'Facility 7', value: 'Facility 7'},
  {label: 'Facility 8', value: 'Facility 8'},
  {label: 'Facility 9', value: 'Facility 9'},
  {label: 'Facility 10', value: 'Facility 10'},
  {label: 'Facility 11', value: 'Facility 11'},
  {label: 'Facility 12', value: 'Facility 12'},
  {label: 'Facility 13', value: 'Facility 13'},
  {label: 'Facility 14', value: 'Facility 14'},
  {label: 'Facility 15', value: 'Facility 15'},
  {label: 'Facility 16', value: 'Facility 16'},
  {label: 'Facility 17', value: 'Facility 17'},
  {label: 'Facility 18', value: 'Facility 18'},
  {label: 'Facility 19', value: 'Facility 19'},
  {label: 'Facility 20', value: 'Facility 20'},
  {label: 'Facility 21', value: 'Facility 21'},
  {label: 'Facility 22', value: 'Facility 22'},
  {label: 'Facility 23', value: 'Facility 23'},
  {label: 'Facility 24', value: 'Facility 24'},
  {label: 'Facility 25', value: 'Facility 25'},
  {label: 'Facility 26', value: 'Facility 26'},
  {label: 'Facility 27', value: 'Facility 27'},
  {label: 'Facility 28', value: 'Facility 28'},
  {label: 'Facility 29', value: 'Facility 29'},
  {label: 'Facility 30', value: 'Facility 30'},
  {label: 'Facility 31', value: 'Facility 31'},
  {label: 'Facility 32', value: 'Facility 32'},
  {label: 'Facility 33', value: 'Facility 33'},
  {label: 'Facility 34', value: 'Facility 34'},
  {label: 'Facility 35', value: 'Facility 35'},
  {label: 'Facility 36', value: 'Facility 36'},
  {label: 'Facility 37', value: 'Facility 37'},
  {label: 'Facility 38', value: 'Facility 38'},
  {label: 'Facility 39', value: 'Facility 39'},
  {label: 'Facility 40', value: 'Facility 40'},
  {label: 'Facility 41', value: 'Facility 41'},
  {label: 'Facility 42', value: 'Facility 42'},
  {label: 'Facility 43', value: 'Facility 43'},
  {label: 'Facility 44', value: 'Facility 44'},
  {label: 'Facility 45', value: 'Facility 45'},
  {label: 'Facility 46', value: 'Facility 46'},
  {label: 'Facility 47', value: 'Facility 47'},
  {label: 'Facility 48', value: 'Facility 48'},
  {label: 'Facility 49', value: 'Facility 49'},
  {label: 'Facility 50', value: 'Facility 50'},
  {label: 'Facility 51', value: 'Facility 51'},
  {label: 'Facility 52', value: 'Facility 52'},
  {label: 'Facility 53', value: 'Facility 53'},
  {label: 'Facility 54', value: 'Facility 54'},
  {label: 'Facility 55', value: 'Facility 55'},
  {label: 'Facility 56', value: 'Facility 56'},
  {label: 'Facility 57', value: 'Facility 57'},
  {label: 'Facility 58', value: 'Facility 58'},
  {label: 'Facility 59', value: 'Facility 59'},
  {label: 'Facility 60', value: 'Facility 60'},
  {label: 'Facility 61', value: 'Facility 61'},
  {label: 'Facility 62', value: 'Facility 62'},
  {label: 'Facility 63', value: 'Facility 63'},
  {label: 'Facility 64', value: 'Facility 64'},
  {label: 'Facility 65', value: 'Facility 65'},
  {label: 'Facility 66', value: 'Facility 66'},
  {label: 'Facility 67', value: 'Facility 67'},
  {label: 'Facility 68', value: 'Facility 68'},
  {label: 'Facility 69', value: 'Facility 69'},
  {label: 'Facility 70', value: 'Facility 70'},
  {label: 'Facility 71', value: 'Facility 71'},
  {label: 'Facility 72', value: 'Facility 72'},
  {label: 'Facility 73', value: 'Facility 73'},
  {label: 'Facility 74', value: 'Facility 74'},
  {label: 'Facility 75', value: 'Facility 75'},
  {label: 'Facility 76', value: 'Facility 76'},
  {label: 'Facility 77', value: 'Facility 77'},
  {label: 'Facility 78', value: 'Facility 78'},
  {label: 'Facility 79', value: 'Facility 79'},
  {label: 'Facility 80', value: 'Facility 80'},
  {label: 'Facility 81', value: 'Facility 81'},
  {label: 'Facility 82', value: 'Facility 82'},
  {label: 'Facility 83', value: 'Facility 83'},
  {label: 'Facility 84', value: 'Facility 84'},
  {label: 'Facility 85', value: 'Facility 85'},
  {label: 'Facility 86', value: 'Facility 86'},
  {label: 'Facility 87', value: 'Facility 87'},
  {label: 'Facility 88', value: 'Facility 88'},
  {label: 'Facility 89', value: 'Facility 89'},
  {label: 'Facility 90', value: 'Facility 90'},
  {label: 'Facility 91', value: 'Facility 91'},
  {label: 'Facility 92', value: 'Facility 92'},
  {label: 'Facility 93', value: 'Facility 93'},
  {label: 'Facility 94', value: 'Facility 94'},
  {label: 'Facility 95', value: 'Facility 95'},
  {label: 'Facility 96', value: 'Facility 96'},
  {label: 'Facility 97', value: 'Facility 97'},
  {label: 'Facility 98', value: 'Facility 98'},
  {label: 'Facility 99', value: 'Facility 99'},
  {label: 'Facility 100', value: 'Facility 100'}
];

export const WATER_RELATED_ASPECTS_OPTIONS = [
  {label: 'Dependencies', value: 'Dependencies'},
  {label: 'Impacts', value: 'Impacts'},
  {label: 'Risks', value: 'Risks'},
  {label: 'Opportunities', value: 'Opportunities'}
];

export const WITHDRAWALS_AND_DISCHARGES_OPTIONS = [
  {
    label: 'Yes, withdrawals and discharges',
    value: 'Yes, withdrawals and discharges'
  },
  {
    label: 'Yes, withdrawals only',
    value: 'Yes, withdrawals only'
  },
  {
    label: 'Yes, discharges only',
    value: 'Yes, discharges only'
  },
  {label: 'No', value: 'No'}
];

export const WATER_ACCOUNTING_DATA_COLLECTED_OPTIONS = [
  {
    label: 'Water withdrawals – total volumes',
    value: 'Water withdrawals – total volumes'
  },
  {
    label: 'Water withdrawals – volume by source',
    value: 'Water withdrawals – volume by source'
  },
  {
    label: 'Water withdrawals – quality by standard water quality parameters',
    value: 'Water withdrawals – quality by standard water quality parameters'
  },
  {
    label: 'Water discharges – total volumes',
    value: 'Water discharges – total volumes'
  },
  {
    label: 'Water discharges – volume by destination',
    value: 'Water discharges – volume by destination'
  },
  {
    label: 'Water discharges – volume by final treatment level',
    value: 'Water discharges – volume by final treatment level'
  },
  {
    label: 'Water discharges – quality by standard water quality parameters',
    value: 'Water discharges – quality by standard water quality parameters'
  },
  {
    label: 'Water consumption – total volume',
    value: 'Water consumption – total volume'
  }
];

export const VERIFICATION_COVERAGE_OPTIONS = [
  {label: 'Not verified', value: 'Not verified'},
  {label: '1-25%', value: '1-25%'},
  {label: '26-50%', value: '26-50%'},
  {label: '51-75%', value: '51-75%'},
  {label: '76-100%', value: '76-100%'},
  {label: 'Not relevant', value: 'Not relevant'}
];

export const CHEMICAL_PRODUCTS_OPTIONS = [
  {
    label: 'Bulk organic chemicals',
    options: [
      {value: 'Adipic acid', label: 'Adipic acid'},
      {value: 'Aromatics', label: 'Aromatics'},
      {value: 'Ethanol', label: 'Ethanol'},
      {
        value: 'Ethylene oxide & Ethylene glycol',
        label: 'Ethylene oxide & Ethylene glycol'
      },
      {value: 'Lower olefins (cracking)', label: 'Lower olefins (cracking)'},
      {value: 'Methanol', label: 'Methanol'},
      {value: 'Polymers', label: 'Polymers'}
    ]
  },
  {
    label: 'Bulk inorganic chemicals',
    options: [
      {value: 'Ammonia', label: 'Ammonia'},
      {value: 'Carbon black', label: 'Carbon black'},
      {
        value: 'Chlorine and sodium hydroxide',
        label: 'Chlorine and sodium hydroxide'
      },
      {value: 'Fertilizers', label: 'Fertilizers'},
      {value: 'Hydrogen', label: 'Hydrogen'},
      {value: 'Nitric acid', label: 'Nitric acid'},
      {value: 'Other industrial gases', label: 'Other industrial gases'},
      {value: 'Oxygen', label: 'Oxygen'},
      {value: 'Soda ash', label: 'Soda ash'},
      {value: 'Titanium dioxide', label: 'Titanium dioxide'}
    ]
  },
  {
    label: 'Other chemicals',
    options: [
      {
        value: 'Specialty inorganic chemicals',
        label: 'Specialty inorganic chemicals'
      },
      {
        value: 'Specialty organic chemicals',
        label: 'Specialty organic chemicals'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  }
];

export const WATER_INTENSITY_METRIC_OPTIONS = [
  {
    label: 'Freshwater withdrawals',
    value: 'Freshwater withdrawals'
  },
  {
    label: 'Freshwater consumption',
    value: 'Freshwater consumption'
  },
  {
    label: 'Total water withdrawals',
    value: 'Total water withdrawals'
  },
  {
    label: 'Total water consumption',
    value: 'Total water consumption'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const WATER_INTENSITY_UNIT_OPTIONS = [
  {label: 'm³', value: 'm³'},
  {label: 'Ton', value: 'Ton'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const ELECTRICITY_GENERATION_INTENSITY_UNIT_OPTIONS = [
  {label: 'MWh', value: 'MWh'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const WATER_INTENSITY_CALCULATION_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label:
      'No, not currently but we intend to collect/calculate this data within the next two years',
    value:
      'No, not currently but we intend to collect/calculate this data within the next two years'
  },
  {
    label:
      'No, not currently and we have no plans to collect/calculate this data within the next two years',
    value:
      'No, not currently and we have no plans to collect/calculate this data within the next two years'
  }
];

export const WEIGHT_VOLUME_UNIT_OPTIONS = [
  {label: 'Dozens', value: 'Dozens'},
  {label: 'Kilograms', value: 'Kilograms'},
  {label: 'Liters', value: 'Liters'},
  {label: 'Metric tons', value: 'Metric tons'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const METALS_MINING_INTENSITY_UNIT_OPTIONS = [
  {
    label: 'Ton of material moved',
    value: 'Ton of material moved'
  },
  {
    label: 'Ton of ore mined',
    value: 'Ton of ore mined'
  },
  {
    label: 'Ton of ore processed',
    value: 'Ton of ore processed'
  },
  {
    label: 'Ton of final product',
    value: 'Ton of final product'
  },
  {
    label: 'Ounce of final product',
    value: 'Ounce of final product'
  },
  {
    label: 'Thousand carats of final product',
    value: 'Thousand carats of final product'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const OIL_GAS_BUSINESS_DIVISION_OPTIONS = [
  {label: 'Upstream', value: 'Upstream'},
  {label: 'Midstream', value: 'Midstream'},
  {label: 'Downstream', value: 'Downstream'},
  {label: 'Chemicals', value: 'Chemicals'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const OIL_GAS_INTENSITY_UNIT_OPTIONS = [
  {
    label: 'Barrel of oil equivalent',
    value: 'Barrel of oil equivalent'
  },
  {
    label: 'Barrel of crude oil throughput',
    value: 'Barrel of crude oil throughput'
  },
  {
    label: 'Barrel of petrochemical product',
    value: 'Barrel of petrochemical product'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const WATER_ASPECT_OPTIONS = [
  {label: 'Water withdrawn', value: 'Water withdrawn'},
  {label: 'Water consumed', value: 'Water consumed'},
  {label: 'Other please specify', value: 'Other please specify'}
];

export const HAZARDOUS_SUBSTANCE_REGULATORY_LISTS_OPTIONS = [
  {
    label: 'Annex XVII of EU REACH Regulation',
    value: 'Annex XVII of EU REACH Regulation'
  },
  {
    label:
      'Candidate List of Substances of Very High Concern for Authorisation above 0.1% by weight (EU Regulation)',
    value:
      'Candidate List of Substances of Very High Concern for Authorisation above 0.1% by weight (EU Regulation)'
  },
  {
    label: 'EU Persistent Organic Pollutants (POPs) Regulation',
    value: 'EU Persistent Organic Pollutants (POPs) Regulation'
  },
  {
    label: 'Annex XIV of UK REACH Regulation',
    value: 'Annex XIV of UK REACH Regulation'
  },
  {
    label: 'Candidate List of Substances of Very High Concern (UK Regulation)',
    value: 'Candidate List of Substances of Very High Concern (UK Regulation)'
  },
  {
    label:
      'Federal Water Pollution Control Act / Clean Water Act (United States Regulation)',
    value:
      'Federal Water Pollution Control Act / Clean Water Act (United States Regulation)'
  },
  {
    label: 'Water Pollution Prevention Act (Japan Regulation)',
    value: 'Water Pollution Prevention Act (Japan Regulation)'
  },
  {
    label:
      'Guidelines for Controlling the Use of Key Chemical Substances in Consumer Products (China Regulation)',
    value:
      'Guidelines for Controlling the Use of Key Chemical Substances in Consumer Products (China Regulation)'
  },
  {
    label: 'Brazilian Regulatory Standards',
    value: 'Brazilian Regulatory Standards'
  },
  {
    label:
      'Official Mexican Standards (NOMs) / National Inventory of Chemical Substances',
    value:
      'Official Mexican Standards (NOMs) / National Inventory of Chemical Substances'
  },
  {
    label: 'List of substances (Canadian Environmental Protection Act)',
    value: 'List of substances (Canadian Environmental Protection Act)'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];
/* eslint-disable quotes */
export const REVENUE_FROM_LOW_WATER_IMPACT_PRODUCTS_OPTIONS = [
  {label: 'Do not know', value: 'Do not know'},
  {label: 'Less than 10%', value: 'Less than 10%'},
  {label: '10-20%', value: '10-20%'},
  {label: '21-40%', value: '21-40%'},
  {label: '41-60%', value: '41-60%'},
  {label: '61-80%', value: '61-80%'},
  {label: 'More than 80%', value: 'More than 80%'}
];

export const YES_NO_WITH_PLAN_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'No, but we intend to do so within the next two years',
    value: 'No, but we intend to do so within the next two years'
  },
  {
    label: 'No, and we have no plans to do so in the next two years',
    value: 'No, and we have no plans to do so in the next two years'
  }
];

export const REASON_FOR_NO_TARGET_OPTIONS = [
  {
    label: 'Important but not an immediate business priority',
    value: 'Important but not an immediate business priority'
  },
  {
    label: 'Judged to be unimportant, explanation provided',
    value: 'Judged to be unimportant, explanation provided'
  },
  {
    label: 'Lack of internal resources',
    value: 'Lack of internal resources'
  },
  {
    label: 'No instruction from management',
    value: 'No instruction from management'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const WATER_TARGET_CATEGORY_OPTIONS = [
  {label: 'Water pollution', value: 'Water pollution'},
  {label: 'Water withdrawals', value: 'Water withdrawals'},
  {
    label: 'Water, Sanitation, and Hygiene',
    value: 'Water, Sanitation, and Hygiene'
  },
  {label: '(WASH) services', value: '(WASH) services'},
  {label: 'Other', value: 'Other'}
];

export const TARGET_50_OPTIONS = [
  {label: 'Target 1', value: 'Target 1'},
  {label: 'Target 2', value: 'Target 2'},
  {label: 'Target 3', value: 'Target 3'},
  {label: 'Target 4', value: 'Target 4'},
  {label: 'Target 5', value: 'Target 5'},
  {label: 'Target 6', value: 'Target 6'},
  {label: 'Target 7', value: 'Target 7'},
  {label: 'Target 8', value: 'Target 8'},
  {label: 'Target 9', value: 'Target 9'},
  {label: 'Target 10', value: 'Target 10'},
  {label: 'Target 11', value: 'Target 11'},
  {label: 'Target 12', value: 'Target 12'},
  {label: 'Target 13', value: 'Target 13'},
  {label: 'Target 14', value: 'Target 14'},
  {label: 'Target 15', value: 'Target 15'},
  {label: 'Target 16', value: 'Target 16'},
  {label: 'Target 17', value: 'Target 17'},
  {label: 'Target 18', value: 'Target 18'},
  {label: 'Target 19', value: 'Target 19'},
  {label: 'Target 20', value: 'Target 20'},
  {label: 'Target 21', value: 'Target 21'},
  {label: 'Target 22', value: 'Target 22'},
  {label: 'Target 23', value: 'Target 23'},
  {label: 'Target 24', value: 'Target 24'},
  {label: 'Target 25', value: 'Target 25'},
  {label: 'Target 26', value: 'Target 26'},
  {label: 'Target 27', value: 'Target 27'},
  {label: 'Target 28', value: 'Target 28'},
  {label: 'Target 29', value: 'Target 29'},
  {label: 'Target 30', value: 'Target 30'},
  {label: 'Target 31', value: 'Target 31'},
  {label: 'Target 32', value: 'Target 32'},
  {label: 'Target 33', value: 'Target 33'},
  {label: 'Target 34', value: 'Target 34'},
  {label: 'Target 35', value: 'Target 35'},
  {label: 'Target 36', value: 'Target 36'},
  {label: 'Target 37', value: 'Target 37'},
  {label: 'Target 38', value: 'Target 38'},
  {label: 'Target 39', value: 'Target 39'},
  {label: 'Target 40', value: 'Target 40'},
  {label: 'Target 41', value: 'Target 41'},
  {label: 'Target 42', value: 'Target 42'},
  {label: 'Target 43', value: 'Target 43'},
  {label: 'Target 44', value: 'Target 44'},
  {label: 'Target 45', value: 'Target 45'},
  {label: 'Target 46', value: 'Target 46'},
  {label: 'Target 47', value: 'Target 47'},
  {label: 'Target 48', value: 'Target 48'},
  {label: 'Target 49', value: 'Target 49'},
  {label: 'Target 50', value: 'Target 50'}
];

export const WATER_TARGET_TYPE_OPTIONS = [
  {
    label: 'Community engagement',
    options: [
      {
        value:
          'Increase in number of population participating in community engagement activities',
        label:
          'Increase in number of population participating in community engagement activities'
      },
      {
        value: 'Increase in investment in community engagement initiatives',
        label: 'Increase in investment in community engagement initiatives'
      },
      {
        value: 'Other community engagement, please specify.',
        label: 'Other community engagement, please specify.'
      }
    ]
  },
  {
    label: 'Monitoring of water use',
    options: [
      {
        value:
          'Increase in the proportion of sites monitoring water withdrawals total volumes',
        label:
          'Increase in the proportion of sites monitoring water withdrawals total volumes'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water withdrawal by source',
        label:
          'Increase in the proportion of sites monitoring water withdrawal by source'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water recycled/reused',
        label:
          'Increase in the proportion of sites monitoring water recycled/reused'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water discharge total volumes',
        label:
          'Increase in the proportion of sites monitoring water discharge total volumes'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water discharges by destination',
        label:
          'Increase in the proportion of sites monitoring water discharges by destination'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water discharge quality – by treatment method',
        label:
          'Increase in the proportion of sites monitoring water discharge quality – by treatment method'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water discharge quality – by standard effluent parameter',
        label:
          'Increase in the proportion of sites monitoring water discharge quality – by standard effluent parameter'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water discharge quality – temperature',
        label:
          'Increase in the proportion of sites monitoring water discharge quality – temperature'
      },
      {
        value:
          'Increase in the proportion of sites monitoring water consumption total volumes',
        label:
          'Increase in the proportion of sites monitoring water consumption total volumes'
      },
      {
        value:
          'Increase in the proportion of sites monitoring employee access to safely managed drinking water and sanitation services around our facilities and operations',
        label:
          'Increase in the proportion of sites monitoring employee access to safely managed drinking water and sanitation services around our facilities and operations'
      },
      {
        value:
          'Increase in the proportion of sites monitoring population access to safely managed drinking water and sanitation services around our facilities and operations',
        label:
          'Increase in the proportion of sites monitoring population access to safely managed drinking water and sanitation services around our facilities and operations'
      },
      {
        value: 'Other monitoring water use, please specify.',
        label: 'Other monitoring water use, please specify.'
      }
    ]
  },
  {
    label: 'Water pollution',
    options: [
      {
        value:
          'Increase in the proportion of wastewater that is safely treated',
        label: 'Increase in the proportion of wastewater that is safely treated'
      },
      {
        value: 'Reduction in water discharge volumes',
        label: 'Reduction in water discharge volumes'
      },
      {
        value: 'Reduction in water discharges per business unit',
        label: 'Reduction in water discharges per business unit'
      },
      {
        value: 'Reduction in water discharges per revenue',
        label: 'Reduction in water discharges per revenue'
      },
      {
        value: 'Reduction in water discharges per product',
        label: 'Reduction in water discharges per product'
      },
      {
        value: 'Reduction in water discharges per unit of production',
        label: 'Reduction in water discharges per unit of production'
      },
      {
        value: 'Reduction in concentration of pollutants',
        label: 'Reduction in concentration of pollutants'
      },
      {
        value: 'Reduction of hazardous substance use',
        label: 'Reduction of hazardous substance use'
      },
      {
        value:
          'Substitution of hazardous substances with less harmful substances',
        label:
          'Substitution of hazardous substances with less harmful substances'
      },
      {
        value: 'Increase in water use met through recycling/reuse',
        label: 'Increase in water use met through recycling/reuse'
      },
      {
        value: 'Increase in investment related to reducing water pollution',
        label: 'Increase in investment related to reducing water pollution'
      },
      {
        value: 'Other water pollution, please specify.',
        label: 'Other water pollution, please specify.'
      }
    ]
  },
  {
    label: 'Water recycling/reuse',
    options: [
      {
        value: 'Increase in water use met through recycling/reuse',
        label: 'Increase in water use met through recycling/reuse'
      },
      {
        value: 'Increase in investment related to water recycling/reuse',
        label: 'Increase in investment related to water recycling/reuse'
      },
      {
        value: 'Other water recycling/reuse, please specify.',
        label: 'Other water recycling/reuse, please specify.'
      }
    ]
  },
  {
    label: 'Procurement/production of sustainable raw materials',
    options: [
      {
        value:
          'Reduction in procurement/production of high water impact commodities',
        label:
          'Reduction in procurement/production of high water impact commodities'
      },
      {
        value: 'Increase in procurement/production of certified crops',
        label: 'Increase in procurement/production of certified crops'
      },
      {
        value:
          'Increase in procurement/production of crops using sustainable agriculture practices',
        label:
          'Increase in procurement/production of crops using sustainable agriculture practices'
      },
      {
        value:
          'Reduction in procurement/production of commodities from water-stressed areas',
        label:
          'Reduction in procurement/production of commodities from water-stressed areas'
      },
      {
        value:
          'Increase in procurement/production of commodities with improved water management practices',
        label:
          'Increase in procurement/production of commodities with improved water management practices'
      },
      {
        value:
          'Other procurement/production of sustainable raw materials, please specify.',
        label:
          'Other procurement/production of sustainable raw materials, please specify.'
      }
    ]
  },
  {
    label: 'Product use phase',
    options: [
      {
        value:
          'Increase in revenue from products designed for use phase resource efficiency',
        label:
          'Increase in revenue from products designed for use phase resource efficiency'
      },
      {
        value:
          'Decrease in total revenue associated with water-polluting products',
        label:
          'Decrease in total revenue associated with water-polluting products'
      },
      {
        value: 'Other product use phase, please specify.',
        label: 'Other product use phase, please specify.'
      }
    ]
  },
  {
    label: 'Product water intensity',
    options: [
      {
        value: 'Reduction per business unit',
        label: 'Reduction per business unit'
      },
      {value: 'Reduction per revenue', label: 'Reduction per revenue'},
      {value: 'Reduction per product', label: 'Reduction per product'},
      {
        value: 'Reduction per unit of production',
        label: 'Reduction per unit of production'
      },
      {
        value: 'Increase in investment related to product water intensity',
        label: 'Increase in investment related to product water intensity'
      },
      {
        value: 'Increase in water use met through recycling/reuse',
        label: 'Increase in water use met through recycling/reuse'
      },
      {
        value: 'Other product water intensity, please specify.',
        label: 'Other product water intensity, please specify.'
      }
    ]
  },
  {
    label: 'Supplier engagement',
    options: [
      {
        value: 'Increase in the proportion of suppliers engaged',
        label: 'Increase in the proportion of suppliers engaged'
      },
      {
        value: 'Increase in number of suppliers engaged',
        label: 'Increase in number of suppliers engaged'
      },
      {
        value: 'Increase in investment in supplier engagement initiatives',
        label: 'Increase in investment in supplier engagement initiatives'
      },
      {
        value:
          'Increase in the proportion of suppliers in compliance with water-related requirements',
        label:
          'Increase in the proportion of suppliers in compliance with water-related requirements'
      },
      {
        value: 'Other supplier engagement, please specify.',
        label: 'Other supplier engagement, please specify.'
      }
    ]
  },
  {
    label: 'Water use efficiency',
    options: [
      {
        value: 'Reduction in total water withdrawals',
        label: 'Reduction in total water withdrawals'
      },
      {
        value: 'Reduction of water withdrawals from surface water',
        label: 'Reduction of water withdrawals from surface water'
      },
      {
        value: 'Reduction of water withdrawals from groundwater',
        label: 'Reduction of water withdrawals from groundwater'
      },
      {
        value:
          'Reduction of water withdrawals from municipal supply or other third-party sources',
        label:
          'Reduction of water withdrawals from municipal supply or other third-party sources'
      },
      {
        value:
          'Increase in water withdrawal efficiency (i.e., revenue generation per water withdrawal volume)',
        label:
          'Increase in water withdrawal efficiency (i.e., revenue generation per water withdrawal volume)'
      },
      {
        value: 'Reduction in total water discharge',
        label: 'Reduction in total water discharge'
      },
      {
        value: 'Increase in water use met through recycling/reuse',
        label: 'Increase in water use met through recycling/reuse'
      },
      {
        value: 'Other water use efficiency, please specify.',
        label: 'Other water use efficiency, please specify.'
      }
    ]
  },
  {
    label: 'Water withdrawals',
    options: [
      {
        value: 'Reduction in total water withdrawals',
        label: 'Reduction in total water withdrawals'
      },
      {
        value: 'Reduction of water withdrawals from surface water',
        label: 'Reduction of water withdrawals from surface water'
      },
      {
        value: 'Reduction of water withdrawals from groundwater',
        label: 'Reduction of water withdrawals from groundwater'
      },
      {
        value:
          'Reduction of water withdrawals from municipal supply or other third-party sources',
        label:
          'Reduction of water withdrawals from municipal supply or other third-party sources'
      },
      {
        value: 'Increase in rainwater harvesting',
        label: 'Increase in rainwater harvesting'
      },
      {
        value: 'Increase in water use met through recycling/reuse',
        label: 'Increase in water use met through recycling/reuse'
      },
      {
        value: 'Reduction in withdrawals per business unit',
        label: 'Reduction in withdrawals per business unit'
      },
      {
        value: 'Reduction in withdrawals per revenue',
        label: 'Reduction in withdrawals per revenue'
      },
      {
        value: 'Reduction in withdrawals per product',
        label: 'Reduction in withdrawals per product'
      },
      {
        value: 'Reduction in withdrawals per unit of production',
        label: 'Reduction in withdrawals per unit of production'
      },
      {
        value: 'Increase in investment related to reducing water withdrawals',
        label: 'Increase in investment related to reducing water withdrawals'
      },
      {
        value: 'Other water withdrawals, please specify.',
        label: 'Other water withdrawals, please specify.'
      }
    ]
  },
  {
    label: 'Water consumption',
    options: [
      {
        value: 'Reduction in total water consumption',
        label: 'Reduction in total water consumption'
      },
      {
        value: 'Reduction per business unit',
        label: 'Reduction per business unit'
      },
      {value: 'Reduction per revenue', label: 'Reduction per revenue'},
      {value: 'Reduction per product', label: 'Reduction per product'},
      {
        value: 'Reduction per unit of production',
        label: 'Reduction per unit of production'
      },
      {
        value: 'Increase in investment related to reducing water consumption',
        label: 'Increase in investment related to reducing water consumption'
      },
      {
        value: 'Other water consumption, please specify.',
        label: 'Other water consumption, please specify.'
      }
    ]
  },
  {
    label: 'Water, Sanitation, and Hygiene (WASH) services',
    options: [
      {
        value:
          'Increase in the proportion of employees using safely managed drinking water services',
        label:
          'Increase in the proportion of employees using safely managed drinking water services'
      },
      {
        value:
          'Increase in the proportion of employees using safely managed sanitation services, including a hand-washing facility with soap and water',
        label:
          'Increase in the proportion of employees using safely managed sanitation services, including a hand-washing facility with soap and water'
      },
      {
        value:
          'Increase in the proportion of local population using safely managed drinking water services around our facilities and operations',
        label:
          'Increase in the proportion of local population using safely managed drinking water services around our facilities and operations'
      },
      {
        value:
          'Increase in the proportion of local population using safely managed sanitation services, including a hand-washing facility with soap and water around our facilities and operations',
        label:
          'Increase in the proportion of local population using safely managed sanitation services, including a hand-washing facility with soap and water around our facilities and operations'
      },
      {
        value: 'Other WASH, please specify.',
        label: 'Other WASH, please specify.'
      }
    ]
  },
  {
    label:
      'Watershed remediation and habitat restoration, ecosystem preservation',
    options: [
      {
        value:
          'Increase in watershed remediation and habitat restoration, ecosystem preservation activities',
        label:
          'Increase in watershed remediation and habitat restoration, ecosystem preservation activities'
      },
      {
        value: 'Improvement in health of water-related ecosystems over time',
        label: 'Improvement in health of water-related ecosystems over time'
      },
      {
        value:
          'Increase in investment in watershed remediation and habitat restoration, ecosystem preservation activities',
        label:
          'Increase in investment in watershed remediation and habitat restoration, ecosystem preservation activities'
      },
      {
        value:
          'Other watershed remediation and habitat restoration, ecosystem preservation, please specify.',
        label:
          'Other watershed remediation and habitat restoration, ecosystem preservation, please specify.'
      }
    ]
  },
  {
    label: 'Other',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const WATER_TARGET_ALIGNMENT_FRAMEWORKS_OPTIONS = [
  {
    label: 'Fair Water Footprints',
    value: 'Fair Water Footprints'
  },
  {
    label: 'Kunming-Montreal Global Biodiversity Framework',
    value: 'Kunming-Montreal Global Biodiversity Framework'
  },
  {
    label: 'Planetary Boundaries',
    value: 'Planetary Boundaries'
  },
  {
    label: 'Science Based Targets for Nature',
    value: 'Science Based Targets for Nature'
  },
  {
    label: 'Sustainable Development Goal 6',
    value: 'Sustainable Development Goal 6'
  },
  {
    label: 'Water Resilience Coalition',
    value: 'Water Resilience Coalition'
  },
  {
    label: 'Wastewater Zero Commitment',
    value: 'Wastewater Zero Commitment'
  },
  {
    label: 'Zero Discharge of Hazardous Chemicals (ZDHC)',
    value: 'Zero Discharge of Hazardous Chemicals (ZDHC)'
  },
  {
    label: 'None, alignment not assessed',
    value: 'None, alignment not assessed'
  },
  {
    label: 'None, no alignment after assessment',
    value: 'None, no alignment after assessment'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const REASON_FOR_NO_WATER_TARGET_OPTIONS = [
  {
    label: 'We are planning to introduce a target within the next two years',
    value: 'We are planning to introduce a target within the next two years'
  },
  {
    label: 'Important but not an immediate business priority',
    value: 'Important but not an immediate business priority'
  },
  {
    label: 'Judged to be unimportant, explanation provided',
    value: 'Judged to be unimportant, explanation provided'
  },
  {
    label: 'Lack of internal resources',
    value: 'Lack of internal resources'
  },
  {
    label: 'Insufficient data on operations',
    value: 'Insufficient data on operations'
  },
  {
    label: 'No instruction from management',
    value: 'No instruction from management'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const CDP_SUPPLY_CHAIN_LINKAGE_OPTIONS = [
  {
    label:
      'Yes, CDP supply chain members buy goods or services from facilities listed in 9.3.1',
    value:
      'Yes, CDP supply chain members buy goods or services from facilities listed in 9.3.1'
  },
  {
    label:
      'No, CDP supply chain members do not buy goods or services from facilities listed in 9.3.1',
    value:
      'No, CDP supply chain members do not buy goods or services from facilities listed in 9.3.1'
  },
  {
    label: 'No facilities were reported in 9.3.1',
    value: 'No facilities were reported in 9.3.1'
  },
  {
    label:
      'We do not have this data but we intend to collect it within two years',
    value:
      'We do not have this data but we intend to collect it within two years'
  },
  {
    label: 'We do not have this data and have no intentions to collect it',
    value: 'We do not have this data and have no intentions to collect it'
  },
  {
    label: 'This is confidential',
    value: 'This is confidential'
  }
];

export const OTHER_ENVIRONMENTAL_INFO_VERIFICATION_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'Third-party verification/assurance is currently in progress',
    value: 'Third-party verification/assurance is currently in progress'
  },
  {
    label:
      'No, but we plan to obtain third-party verification/assurance of other environmental information in our CDP response within the next two years',
    value:
      'No, but we plan to obtain third-party verification/assurance of other environmental information in our CDP response within the next two years'
  },
  {
    label:
      'No, and we do not plan to obtain third-party verification/assurance of other environmental information in our CDP response within the next two years',
    value:
      'No, and we do not plan to obtain third-party verification/assurance of other environmental information in our CDP response within the next two years'
  }
];

export const ENVIRONMENTAL_ISSUES_OPTIONS = [
  {label: 'Climate change', value: 'Climate change'},
  {label: 'Forests', value: 'Forests'},
  {label: 'Water', value: 'Water'},
  {label: 'Plastics', value: 'Plastics'},
  {label: 'Biodiversity', value: 'Biodiversity'}
];

export const THIRD_PARTY_VERIFICATION_DATA_POINTS_OPTIONS = [
  {
    label: 'Introduction',
    options: [
      {
        value: 'Facility geolocation data [W only], [SC only]',
        label: 'Facility geolocation data [W only], [SC only]'
      },
      {
        value: 'All data points in module 1',
        label: 'All data points in module 1'
      },
      {
        value: 'Other data point in module 1, please specify',
        label: 'Other data point in module 1, please specify'
      }
    ]
  },
  {
    label:
      'Identification, Assessment, and Management of Dependencies, Impacts, Risks, and Opportunities',
    options: [
      {
        value: 'Classification of tailings dams [W only], [MM/CO only]',
        label: 'Classification of tailings dams [W only], [MM/CO only]'
      },
      {
        value: 'Identification of priority locations [F, W, B only]',
        label: 'Identification of priority locations [F, W, B only]'
      },
      {
        value: 'Identification, assessment, and management processes',
        label: 'Identification, assessment, and management processes'
      },
      {
        value: 'All data points in module 2',
        label: 'All data points in module 2'
      },
      {
        value: 'Other data point in module 2, please specify',
        label: 'Other data point in module 2, please specify'
      }
    ]
  },
  {
    label: 'Disclosure of Risks and Opportunities',
    options: [
      {
        value:
          'Financial effect of environmental opportunities [CC, F, W, B only]',
        label:
          'Financial effect of environmental opportunities [CC, F, W, B only]'
      },
      {
        value: 'Financial effect of environmental risks',
        label: 'Financial effect of environmental risks'
      },
      {
        value: 'Risk exposure by river basin [W only]',
        label: 'Risk exposure by river basin [W only]'
      },
      {
        value: 'All data points in module 3',
        label: 'All data points in module 3'
      }
    ]
  },
  {
    label: 'Environmental Performance – Forests',
    options: [
      {
        value: 'Ecosystem restoration and long-term protection projects',
        label: 'Ecosystem restoration and long-term protection projects'
      },
      {
        value: 'Origins of sourced volumes',
        label: 'Origins of sourced volumes'
      },
      {value: 'Traceability data', label: 'Traceability data'},
      {
        value: 'All data points in module 8',
        label: 'All data points in module 8'
      },
      {
        value: 'Other data point in module 8, please specify',
        label: 'Other data point in module 8, please specify'
      }
    ]
  },
  {
    label: 'Environmental Performance – Water Security',
    options: [
      {
        value: 'Emissions to water in the reporting year',
        label: 'Emissions to water in the reporting year'
      },
      {
        value:
          'Facilities with water-related dependencies, impacts, risks and opportunities',
        label:
          'Facilities with water-related dependencies, impacts, risks and opportunities'
      },
      {
        value:
          'Revenue associated with products containing hazardous substances',
        label:
          'Revenue associated with products containing hazardous substances'
      },
      {
        value: 'Volume withdrawn from areas with water stress (megaliters)',
        label: 'Volume withdrawn from areas with water stress (megaliters)'
      },
      {
        value: 'Water consumption – total volume',
        label: 'Water consumption – total volume'
      },
      {
        value: 'Water discharges – total volumes',
        label: 'Water discharges – total volumes'
      },
      {
        value: 'Water discharges – volumes by destination',
        label: 'Water discharges – volumes by destination'
      },
      {
        value: 'Water discharges – volumes by treatment method',
        label: 'Water discharges – volumes by treatment method'
      },
      {
        value: 'Other data point in module 3, please specify',
        label: 'Other data point in module 3, please specify'
      }
    ]
  },
  {
    label: 'Governance',
    options: [
      {
        value: 'Environmental policies [CC, F, W, B only]',
        label: 'Environmental policies [CC, F, W, B only]'
      },
      {
        value: 'All data points in module 4',
        label: 'All data points in module 4'
      },
      {
        value: 'Other data point in module 4, please specify',
        label: 'Other data point in module 4, please specify'
      }
    ]
  },
  {
    label: 'Business Strategy',
    options: [
      {
        value: 'Internal pricing of environmental externalities [CC, W only]',
        label: 'Internal pricing of environmental externalities [CC, W only]'
      },
      {
        value: 'Scenario analysis [CC, F, W only]',
        label: 'Scenario analysis [CC, F, W only]'
      },
      {
        value:
          'Supplier compliance with environmental requirements [CC, F, W, P only]',
        label:
          'Supplier compliance with environmental requirements [CC, F, W, P only]'
      },
      {
        value:
          'Sustainable finance taxonomy aligned spending/revenue [CC only]',
        label: 'Sustainable finance taxonomy aligned spending/revenue [CC only]'
      },
      {
        value: 'Transition plans [CC only]',
        label: 'Transition plans [CC only]'
      },
      {
        value: 'All data points in module 5',
        label: 'All data points in module 5'
      },
      {
        value: 'Other data point in module 5, please specify',
        label: 'Other data point in module 5, please specify'
      }
    ]
  },
  {
    label: 'Environmental Performance – Consolidation Approach',
    options: [
      {value: 'Consolidation approach', label: 'Consolidation approach'},
      {
        value: 'All data points in module 6',
        label: 'All data points in module 6'
      },
      {
        value: 'Other data point in module 6, please specify',
        label: 'Other data point in module 6, please specify'
      }
    ]
  },
  {
    label: 'Environmental Performance – Climate Change',
    options: [
      {
        value: 'Allocation of emissions to customers [SC only]',
        label: 'Allocation of emissions to customers [SC only]'
      },
      {value: 'Base year emissions', label: 'Base year emissions'},
      {value: 'Carbon removals', label: 'Carbon removals'},
      {
        value: 'Electricity/Steam/Heat/Cooling consumption',
        label: 'Electricity/Steam/Heat/Cooling consumption'
      },
      {
        value: 'Electricity/Steam/Heat/Cooling generation',
        label: 'Electricity/Steam/Heat/Cooling generation'
      },
      {
        value: 'Emissions breakdown by business division',
        label: 'Emissions breakdown by business division'
      },
      {
        value: 'Emissions breakdown by country/area',
        label: 'Emissions breakdown by country/area'
      },
      {
        value: 'Emissions reduction initiatives/activities',
        label: 'Emissions reduction initiatives/activities'
      },
      {
        value: 'Energy attribute certificates (EACs)',
        label: 'Energy attribute certificates (EACs)'
      },
      {value: 'Fuel consumption', label: 'Fuel consumption'},
      {value: 'Methane emissions', label: 'Methane emissions'},
      {value: 'Product footprint', label: 'Product footprint'},
      {value: 'Progress against targets', label: 'Progress against targets'},
      {
        value: 'Project-based carbon credits',
        label: 'Project-based carbon credits'
      },
      {
        value: 'Renewable Electricity/Steam/Heat/Cooling consumption',
        label: 'Renewable Electricity/Steam/Heat/Cooling consumption'
      },
      {
        value: 'Renewable Electricity/Steam/Heat/Cooling generation',
        label: 'Renewable Electricity/Steam/Heat/Cooling generation'
      },
      {
        value: 'Renewable fuel consumption',
        label: 'Renewable fuel consumption'
      },
      {
        value: 'Target-setting methodology',
        label: 'Target-setting methodology'
      },
      {value: 'Waste data', label: 'Waste data'},
      {
        value: 'Year on year change in absolute emissions (Scope 1 and 2)',
        label: 'Year on year change in absolute emissions (Scope 1 and 2)'
      },
      {
        value: 'Year on year change in absolute emissions (Scope 3)',
        label: 'Year on year change in absolute emissions (Scope 3)'
      },
      {
        value: 'Year on year change in emissions intensity (Scope 1 and 2)',
        label: 'Year on year change in emissions intensity (Scope 1 and 2)'
      },
      {
        value: 'Year on year change in emissions intensity (Scope 3)',
        label: 'Year on year change in emissions intensity (Scope 3)'
      },
      {
        value: 'Year on year change in land use change emissions',
        label: 'Year on year change in land use change emissions'
      },
      {
        value: 'All data points in module 7',
        label: 'All data points in module 7'
      },
      {
        value: 'Other data point in module 7, please specify',
        label: 'Other data point in module 7, please specify'
      }
    ]
  },
  {
    label:
      'Environmental Performance – Products and Services (Water & Plastics Modules)',
    options: [
      {
        value: 'Water intensities of products and services',
        label: 'Water intensities of products and services'
      },
      {
        value: 'Water withdrawals – total volumes',
        label: 'Water withdrawals – total volumes'
      },
      {
        value: 'Water withdrawals – volumes by source',
        label: 'Water withdrawals – volumes by source'
      },
      {
        value: 'All data points in module 9',
        label: 'All data points in module 9'
      },
      {
        value: 'Other data point in module 9, please specify',
        label: 'Other data point in module 9, please specify'
      }
    ]
  },
  {
    label: 'Environmental Performance – Plastics',
    options: [
      {
        value: 'Circularity potential of plastic packaging',
        label: 'Circularity potential of plastic packaging'
      },
      {
        value: 'End-of-life management pathways',
        label: 'End-of-life management pathways'
      },
      {
        value:
          'Raw material content – durable goods/products and/or durable components',
        label:
          'Raw material content – durable goods/products and/or durable components'
      },
      {
        value: 'Raw material content – plastic packaging',
        label: 'Raw material content – plastic packaging'
      },
      {
        value: 'Raw material content – plastic polymers',
        label: 'Raw material content – plastic polymers'
      },
      {value: 'Waste generated', label: 'Waste generated'},
      {
        value: 'All data points in module 10',
        label: 'All data points in module 10'
      },
      {
        value: 'Other data point in module 10, please specify',
        label: 'Other data point in module 10, please specify'
      }
    ]
  },
  {
    label: 'Environmental Performance – Biodiversity',
    options: [
      {
        value: 'Area associated with biodiversity offsets [M-B only]',
        label: 'Area associated with biodiversity offsets [M-B only]'
      },
      {
        value: 'Area rehabilitated in the reporting year [M-B only]',
        label: 'Area rehabilitated in the reporting year [M-B only]'
      },
      {
        value:
          'Artisanal and small-scale mining (ASM) operations in mining project area or area of influence [M-B only]',
        label:
          'Artisanal and small-scale mining (ASM) operations in mining project area or area of influence [M-B only]'
      },
      {
        value: 'Criteria for Biodiversity Action Plans (BAPs) [M-B only]',
        label: 'Criteria for Biodiversity Action Plans (BAPs) [M-B only]'
      },
      {
        value: 'Mining projects [M-B only]',
        label: 'Mining projects [M-B only]'
      },
      {
        value:
          'Potential impact of activities on areas important for biodiversity [M-B only]',
        label:
          'Potential impact of activities on areas important for biodiversity [M-B only]'
      },
      {
        value:
          'Proximity of activities to areas important for biodiversity [M-B only]',
        label:
          'Proximity of activities to areas important for biodiversity [M-B only]'
      },
      {
        value: 'Total area rehabilitated [M-B only]',
        label: 'Total area rehabilitated [M-B only]'
      },
      {
        value:
          'Total area restored to date to mitigate significant impacts on biodiversity [M-B only]',
        label:
          'Total area restored to date to mitigate significant impacts on biodiversity [M-B only]'
      },
      {
        value: 'All data points in module 11 [M-B only]',
        label: 'All data points in module 11 [M-B only]'
      },
      {
        value: 'Other data point in module 11, please specify [M-B only]',
        label: 'Other data point in module 11, please specify [M-B only]'
      }
    ]
  },
  {
    label: 'Environmental Performance – Financial Services',
    options: [
      {
        value: 'Alignment with a sustainable finance taxonomy [FS only]',
        label: 'Alignment with a sustainable finance taxonomy [FS only]'
      },
      {
        value: 'Products and services footprint verification [FS only]',
        label: 'Products and services footprint verification [FS only]'
      },
      {
        value: 'Progress against targets [FS only]',
        label: 'Progress against targets [FS only]'
      },
      {
        value: 'All data points in module 12 [FS only]',
        label: 'All data points in module 12 [FS only]'
      },
      {
        value: 'Other data point in module 12, please specify [FS only]',
        label: 'Other data point in module 12, please specify [FS only]'
      }
    ]
  },
  {
    label: 'All Data',
    options: [
      {
        value: 'All data points in CDP response',
        label: 'All data points in CDP response'
      }
    ]
  }
];

export const VERIFICATION_STANDARDS_OPTIONS = [
  {
    label: 'General Standards',
    options: [
      {value: 'AA1000AS', label: 'AA1000AS'},
      {
        value: 'Aluminium Stewardship Initiative (ASW)',
        label: 'Aluminium Stewardship Initiative (ASW)'
      },
      {value: 'ASAE 3000 [CC and W only]', label: 'ASAE 3000 [CC and W only]'},
      {
        value: 'Attestation Standards (AT-C Section 105 & 210/205) — AICPA',
        label: 'Attestation Standards (AT-C Section 105 & 210/205) — AICPA'
      },
      {
        value: 'Compagnie Nationale des Commissaires aux Comptes (CNCC)',
        label: 'Compagnie Nationale des Commissaires aux Comptes (CNCC)'
      },
      {
        value: 'CRevR 6 Assurance of Sustainability (Sweden)',
        label: 'CRevR 6 Assurance of Sustainability (Sweden)'
      },
      {value: 'CSAE 3000 [CC and W only]', label: 'CSAE 3000 [CC and W only]'},
      {value: 'DNV Verisustain Protocol', label: 'DNV Verisustain Protocol'},
      {value: 'Dutch Standard 3000A', label: 'Dutch Standard 3000A'},
      {
        value: 'IDW AsS 821 [CC and W only]',
        label: 'IDW AsS 821 [CC and W only]'
      },
      {
        value:
          'International Sustainability and Carbon Certification (ISCC) [CC and F only]',
        label:
          'International Sustainability and Carbon Certification (ISCC) [CC and F only]'
      },
      {value: 'ISAE 3000', label: 'ISAE 3000'},
      {
        value: 'ISAE 3410 (GHG statements)',
        label: 'ISAE 3410 (GHG statements)'
      },
      {
        value:
          'RevR6 Procedure for assurance of sustainability report (Sweden)',
        label: 'RevR6 Procedure for assurance of sustainability report (Sweden)'
      },
      {
        value: 'Roundtable on Sustainable Biomaterials (RSB) [CC and F only]',
        label: 'Roundtable on Sustainable Biomaterials (RSB) [CC and F only]'
      },
      {
        value: 'SGS Sustainability Report Assurance',
        label: 'SGS Sustainability Report Assurance'
      },
      {
        value: 'Standard 3810N (Netherlands)',
        label: 'Standard 3810N (Netherlands)'
      },
      {
        value:
          'SURE (Sustainable Resources Verification Scheme) [CC and F only]',
        label:
          'SURE (Sustainable Resources Verification Scheme) [CC and F only]'
      },
      {
        value: 'Sustainable Biomass Program (SBP) [CC and F only]',
        label: 'Sustainable Biomass Program (SBP) [CC and F only]'
      },
      {
        value: 'Verified Carbon Standard (VCS) [CC and F only]',
        label: 'Verified Carbon Standard (VCS) [CC and F only]'
      },
      {
        value: 'Other general verification standard, please specify',
        label: 'Other general verification standard, please specify'
      }
    ]
  },
  {
    label: 'Water-Related Standards',
    options: [
      {
        value: 'Alliance for Water Stewardship certification',
        label: 'Alliance for Water Stewardship certification'
      },
      {
        value: 'Other water verification standard, please specify',
        label: 'Other water verification standard, please specify'
      }
    ]
  },
  {
    label: 'Forests-Related Standards',
    options: [
      {
        value: 'Forest Stewardship Council (FSC)',
        label: 'Forest Stewardship Council (FSC)'
      },
      {
        value: 'IRF data verification protocol',
        label: 'IRF data verification protocol'
      },
      {
        value: 'Programme for the Endorsement of Forest Certification (PEFC)',
        label: 'Programme for the Endorsement of Forest Certification (PEFC)'
      },
      {value: 'ProTerra', label: 'ProTerra'},
      {value: 'Rainforest Alliance', label: 'Rainforest Alliance'},
      {
        value: 'Round Table on Responsible Soy (RTRS)',
        label: 'Round Table on Responsible Soy (RTRS)'
      },
      {
        value: 'Roundtable on Sustainable Palm Oil (RSPO)',
        label: 'Roundtable on Sustainable Palm Oil (RSPO)'
      },
      {
        value: 'Sustainable Forestry Initiative (SFI)',
        label: 'Sustainable Forestry Initiative (SFI)'
      },
      {
        value: 'Other forests verification standard, please specify',
        label: 'Other forests verification standard, please specify'
      }
    ]
  },
  {
    label: 'Climate Change-Related Standards',
    options: [
      {value: 'ABNT NBR ISO 14064-3:2007', label: 'ABNT NBR ISO 14064-3:2007'},
      {
        value:
          'Advanced technologies promotion Subsidy Scheme with Emission Reduction Target (ASSET)',
        label:
          'Advanced technologies promotion Subsidy Scheme with Emission Reduction Target (ASSET)'
      },
      {
        value: 'Airport Carbon Accreditation (ACA)',
        label: 'Airport Carbon Accreditation (ACA)'
      },
      {
        value: 'Alberta Specified Gas Emitters Regulation',
        label: 'Alberta Specified Gas Emitters Regulation'
      },
      {value: 'ASAE 3410', label: 'ASAE 3410'},
      {
        value: 'Australia National GHG and Energy Regulations (NGER Act)',
        label: 'Australia National GHG and Energy Regulations (NGER Act)'
      },
      {
        value: 'California Mandatory GHG Reporting Regulations (CARB)',
        label: 'California Mandatory GHG Reporting Regulations (CARB)'
      },
      {
        value: 'Canadian CICA Assurance Section 5025',
        label: 'Canadian CICA Assurance Section 5025'
      },
      {value: 'Carbon Trust Standard', label: 'Carbon Trust Standard'},
      {
        value: 'Chicago Climate Exchange verification standard',
        label: 'Chicago Climate Exchange verification standard'
      },
      {value: 'Climate Action Reserve', label: 'Climate Action Reserve'},
      {
        value: 'ERT Corporate GHG Verification Guidelines',
        label: 'ERT Corporate GHG Verification Guidelines'
      },
      {value: 'CSAE 3410', label: 'CSAE 3410'},
      {value: 'EarthCheck Certified', label: 'EarthCheck Certified'},
      {
        value: 'ERM GHG Performance Data Assurance Methodology',
        label: 'ERM GHG Performance Data Assurance Methodology'
      },
      {
        value: 'ERT Standard “Corporate Greenhouse Gas Verification”',
        label: 'ERT Standard “Corporate Greenhouse Gas Verification”'
      },
      {value: 'IDW PS 821', label: 'IDW PS 821'},
      {value: 'IRECS', label: 'IRECS'},
      {value: 'ISO 14064-1', label: 'ISO 14064-1'},
      {value: 'ISO 14064-3', label: 'ISO 14064-3'},
      {
        value: 'JVETS Guideline for Verification',
        label: 'JVETS Guideline for Verification'
      },
      {
        value: 'Korean GHG & Energy Target Management System',
        label: 'Korean GHG & Energy Target Management System'
      },
      {value: 'NMX-SAA-14064-3-IMNC', label: 'NMX-SAA-14064-3-IMNC'},
      {
        value: 'Saitama Target-Setting Emissions Trading Program',
        label: 'Saitama Target-Setting Emissions Trading Program'
      },
      {value: 'ICJCE (Spain)', label: 'ICJCE (Spain)'},
      {value: 'SSAE 3000', label: 'SSAE 3000'},
      {
        value:
          'Israel Ministry of Environmental Protection — Verification Guidance',
        label:
          'Israel Ministry of Environmental Protection — Verification Guidance'
      },
      {value: 'Swiss Climate CO₂ label', label: 'Swiss Climate CO₂ label'},
      {value: 'TGO (Thailand)', label: 'TGO (Thailand)'},
      {value: 'The Climate Registry GVP', label: 'The Climate Registry GVP'},
      {value: 'Toitū carbon reduce', label: 'Toitū carbon reduce'},
      {value: 'Toitū climate positive', label: 'Toitū climate positive'},
      {value: 'Toitū net carbon zero', label: 'Toitū net carbon zero'},
      {
        value: 'Tokyo Emissions Trading Scheme',
        label: 'Tokyo Emissions Trading Scheme'
      },
      {
        value: 'Verification under the EU ETS',
        label: 'Verification under the EU ETS'
      },
      {
        value: 'Other climate change verification standard, please specify',
        label: 'Other climate change verification standard, please specify'
      }
    ]
  },
  {
    label: 'Plastics-Related Standards',
    options: [
      {value: 'ISO 15270:2008', label: 'ISO 15270:2008'},
      {
        value: 'SCS Recycled Content Certification',
        label: 'SCS Recycled Content Certification'
      },
      {
        value: 'Other plastics verification standard, please specify',
        label: 'Other plastics verification standard, please specify'
      }
    ]
  },
  {
    label: 'Biodiversity-Related Standards',
    options: [
      {value: 'Plan Vivo [M-B only]', label: 'Plan Vivo [M-B only]'},
      {
        value:
          'Other biodiversity verification standard, please specify [M-B only]',
        label:
          'Other biodiversity verification standard, please specify [M-B only]'
      }
    ]
  }
];

export const SIGN_OFF_JOB_TITLE_OPTIONS = [
  {label: 'Board chair', value: 'Board chair'},
  {label: 'Director on board', value: 'Director on board'},
  {
    label: 'Chief Executive Officer (CEO)',
    value: 'Chief Executive Officer (CEO)'
  },
  {
    label: 'Chief Financial Officer (CFO)',
    value: 'Chief Financial Officer (CFO)'
  },
  {
    label: 'Chief Operating Officer (COO)',
    value: 'Chief Operating Officer (COO)'
  },
  {
    label: 'Chief Procurement Officer (CPO)',
    value: 'Chief Procurement Officer (CPO)'
  },
  {label: 'Chief Risk Officer (CRO)', value: 'Chief Risk Officer (CRO)'},
  {
    label: 'Chief Sustainability Officer (CSO)',
    value: 'Chief Sustainability Officer (CSO)'
  },
  {label: 'Other C-Suite Officer', value: 'Other C-Suite Officer'},
  {label: 'President', value: 'President'},
  {label: 'General Counsel', value: 'General Counsel'},
  {label: 'Business unit manager', value: 'Business unit manager'},
  {label: 'Energy manager', value: 'Energy manager'},
  {
    label: 'Environmental, health and safety manager',
    value: 'Environmental, health and safety manager'
  },
  {
    label: 'Environment/Sustainability manager',
    value: 'Environment/Sustainability manager'
  },
  {label: 'Facilities manager', value: 'Facilities manager'},
  {label: 'Process operation manager', value: 'Process operation manager'},
  {label: 'Procurement manager', value: 'Procurement manager'},
  {label: 'Public affairs manager', value: 'Public affairs manager'},
  {label: 'Risk manager', value: 'Risk manager'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const CDP_SHARE_YES_NO_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {
    label:
      'CDP may share our Disclosure Submission Lead contact details with the Pacific Institute',
    value:
      'CDP may share our Disclosure Submission Lead contact details with the Pacific Institute'
  },
  {label: 'No', value: 'No'}
];

export const PLASTICS_TARGET_TYPE_OPTIONS_FULL = [
  {
    label: 'Plastic polymers',
    options: [
      {
        value:
          'Reduce the total weight of virgin content in plastic polymers produced and/or sold',
        label:
          'Reduce the total weight of virgin content in plastic polymers produced and/or sold'
      },
      {
        value:
          'Increase the proportion of post-consumer recycled content in plastic polymers produced and/or sold',
        label:
          'Increase the proportion of post-consumer recycled content in plastic polymers produced and/or sold'
      },
      {
        value: 'Reduce or eliminate the use of hazardous substances',
        label: 'Reduce or eliminate the use of hazardous substances'
      },
      {
        value:
          'Reduce the use of polymers with properties that may hinder their reusability, recyclability, and disposal',
        label:
          'Reduce the use of polymers with properties that may hinder their reusability, recyclability, and disposal'
      },
      {
        value: 'Other plastic polymers target, please specify.',
        label: 'Other plastic polymers target, please specify.'
      }
    ]
  },
  {
    label: 'Plastic packaging',
    options: [
      {
        value:
          'Reduce the total weight of plastic packaging used and/or produced',
        label:
          'Reduce the total weight of plastic packaging used and/or produced'
      },
      {
        value: 'Eliminate problematic and unnecessary plastic packaging',
        label: 'Eliminate problematic and unnecessary plastic packaging'
      },
      {
        value: 'Eliminate single-use plastic packaging',
        label: 'Eliminate single-use plastic packaging'
      },
      {
        value: 'Reduce the total weight of virgin content in plastic packaging',
        label: 'Reduce the total weight of virgin content in plastic packaging'
      },
      {
        value:
          'Increase the proportion of post-consumer recycled content in plastic packaging',
        label:
          'Increase the proportion of post-consumer recycled content in plastic packaging'
      },
      {
        value:
          'Increase the proportion of renewable content from responsibly managed sources in plastic packaging',
        label:
          'Increase the proportion of renewable content from responsibly managed sources in plastic packaging'
      },
      {
        value:
          'Increase the proportion of plastic packaging that is recyclable in practice and at scale',
        label:
          'Increase the proportion of plastic packaging that is recyclable in practice and at scale'
      },
      {
        value: 'Increase the proportion of plastic packaging that is reusable',
        label: 'Increase the proportion of plastic packaging that is reusable'
      },
      {
        value:
          'Increase the proportion of plastic packaging that is compostable',
        label:
          'Increase the proportion of plastic packaging that is compostable'
      },
      {
        value: 'Reduce or eliminate the use of hazardous substances',
        label: 'Reduce or eliminate the use of hazardous substances'
      },
      {
        value: 'Other plastic packaging target, please specify.',
        label: 'Other plastic packaging target, please specify.'
      }
    ]
  },
  {
    label: 'Plastic goods/products',
    options: [
      {
        value: 'Eliminate single-use plastic products',
        label: 'Eliminate single-use plastic products'
      },
      {
        value: 'Reduce the total weight of plastics in our goods/products',
        label: 'Reduce the total weight of plastics in our goods/products'
      },
      {
        value:
          'Increase the proportion of plastic goods/products which are reusable',
        label:
          'Increase the proportion of plastic goods/products which are reusable'
      },
      {
        value:
          'Eliminate problematic and unnecessary plastics within our goods/products',
        label:
          'Eliminate problematic and unnecessary plastics within our goods/products'
      },
      {
        value:
          'Reduce the total weight of virgin content in plastic goods/products',
        label:
          'Reduce the total weight of virgin content in plastic goods/products'
      },
      {
        value:
          'Increase the proportion of post-consumer recycled content in plastic goods/products',
        label:
          'Increase the proportion of post-consumer recycled content in plastic goods/products'
      },
      {
        value:
          'Increase the proportion of renewable content from responsibly managed sources in plastic goods/products',
        label:
          'Increase the proportion of renewable content from responsibly managed sources in plastic goods/products'
      },
      {
        value:
          'Increase the proportion of our goods/products that are recyclable in practice and at scale',
        label:
          'Increase the proportion of our goods/products that are recyclable in practice and at scale'
      },
      {
        value:
          'Increase the proportion of our goods/products that are compostable',
        label:
          'Increase the proportion of our goods/products that are compostable'
      },
      {
        value: 'Other plastic goods/products target, please specify.',
        label: 'Other plastic goods/products target, please specify.'
      }
    ]
  },
  {
    label: 'Microplastics',
    options: [
      {
        value:
          'Eliminate the use of primary microplastics and plastic particles',
        label:
          'Eliminate the use of primary microplastics and plastic particles'
      },
      {
        value:
          'Reduce the potential release of microplastics and plastic particles',
        label:
          'Reduce the potential release of microplastics and plastic particles'
      },
      {
        value: 'Other microplastics target, please specify.',
        label: 'Other microplastics target, please specify.'
      }
    ]
  },
  {
    label: 'End-of-life management',
    options: [
      {
        value:
          'Increase the proportion of recyclable plastic waste that we collect, sort, and recycle',
        label:
          'Increase the proportion of recyclable plastic waste that we collect, sort, and recycle'
      },
      {
        value:
          'Increase the proportion of recyclable plastic waste that is collected, sorted, and recycled',
        label:
          'Increase the proportion of recyclable plastic waste that is collected, sorted, and recycled'
      },
      {
        value:
          'Increase the proportion of plastic waste which is prepared for reuse or composted',
        label:
          'Increase the proportion of plastic waste which is prepared for reuse or composted'
      },
      {
        value:
          'Reduce the proportion of plastic waste which is sent to landfill and/or incinerated',
        label:
          'Reduce the proportion of plastic waste which is sent to landfill and/or incinerated'
      },
      {
        value: 'Reduce the proportion of plastic waste which is mismanaged',
        label: 'Reduce the proportion of plastic waste which is mismanaged'
      },
      {
        value: 'Other end-of-life management target, please specify.',
        label: 'Other end-of-life management target, please specify.'
      }
    ]
  },
  {
    label: 'Extended Producer Responsibility (EPR)',
    options: [
      {
        value: 'Ensure compliance with EPR policies and schemes',
        label: 'Ensure compliance with EPR policies and schemes'
      },
      {
        value: 'Adhere to eco-design requirements',
        label: 'Adhere to eco-design requirements'
      },
      {
        value: 'Other Extended Producer Responsibility target, please specify.',
        label: 'Other Extended Producer Responsibility target, please specify.'
      }
    ]
  },
  {
    label: 'Other',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const PACKAGING_RECYCLABILITY_OPTIONS = [
  {
    label: '% reusable',
    value: '% reusable'
  },
  {
    label: '% technically recyclable',
    value: '% technically recyclable'
  },
  {
    label: '% recyclable in practice and at scale',
    value: '% recyclable in practice and at scale'
  },
  {
    label: 'None',
    value: 'None'
  }
];

export const DURABLE_GOODS_SOLD_USED_OPTIONS = [
  {
    label: 'Durable goods and durable components sold*',
    value: 'Durable goods and durable components sold*'
  },
  {
    label: 'Durable goods and durable components used*',
    value: 'Durable goods and durable components used*'
  }
];

export const PLASTIC_PACKAGE_SOLD_USED_OPTIONS = [
  {
    label: 'Plastic packaging sold*',
    value: 'Plastic packaging sold*'
  },
  {
    label: 'Plastic packaging used*',
    value: 'Plastic packaging used*'
  }
];

export const END_OF_LIFE_MANAGEMENT_PATHWAY_OPTIONS = [
  {
    label: 'Preparation for reuse',
    value: 'Preparation for reuse'
  },
  {
    label: 'Recycling',
    value: 'Recycling'
  },
  {
    label: 'Composting (industrial/home)',
    value: 'Composting (industrial/home)'
  },
  {
    label: 'Waste to energy',
    value: 'Waste to energy'
  },
  {
    label: 'Incineration',
    value: 'Incineration'
  },
  {
    label: 'Landfill',
    value: 'Landfill'
  },
  {
    label: 'Mismanaged waste',
    value: 'Mismanaged waste'
  },
  {
    label: 'Leakage',
    value: 'Leakage'
  },
  {
    label: 'Other end-of-life management pathway, please specify.',
    value: 'Other end-of-life management pathway, please specify.'
  }
];

export const PLASTIC_RELATED_ACTIVITIES_OPTIONS = [
  {
    label:
      'Production/commercialization of plastic polymers (including plastic converters)',
    value:
      'Production/commercialization of plastic polymers (including plastic converters)'
  },
  {
    label:
      'Production/commercialization of durable plastic goods and/or components (including mixed materials)',
    value:
      'Production/commercialization of durable plastic goods and/or components (including mixed materials)'
  },
  {
    label:
      'Usage of durable plastic goods and/or components (including mixed materials)',
    value:
      'Usage of durable plastic goods and/or components (including mixed materials)'
  },
  {
    label: 'Production/commercialization of plastic packaging',
    value: 'Production/commercialization of plastic packaging'
  },
  {
    label:
      'Production/commercialization of goods/products packaged in plastics',
    value: 'Production/commercialization of goods/products packaged in plastics'
  },
  {
    label:
      'Provision/commercialization of services that use plastic packaging (e.g., food services)',
    value:
      'Provision/commercialization of services that use plastic packaging (e.g., food services)'
  },
  {
    label: 'Provision of waste management and/or water management services',
    value: 'Provision of waste management and/or water management services'
  },
  {
    label:
      'Provision of financial products and/or services for plastics-related activities',
    value:
      'Provision of financial products and/or services for plastics-related activities'
  },
  {
    label: 'Other activities not specified',
    value: 'Other activities not specified'
  }
];

export const PLASTIC_CONTENT_TYPE_OPTIONS = [
  {
    label: '% virgin fossil-based content',
    value: '% virgin fossil-based content'
  },
  {
    label: '% virgin renewable content',
    value: '% virgin renewable content'
  },
  {
    label: '% pre-consumer recycled content',
    value: '% pre-consumer recycled content'
  },
  {
    label: '% post-consumer recycled content',
    value: '% post-consumer recycled content'
  },
  {
    label: 'None',
    value: 'None'
  }
];

export const PLAN_TO_DO_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'No, but we plan to do so in the next two years',
    value: 'No, but we plan to do so in the next two years'
  },
  {
    label: 'No, and we do not plan to do so in the next two years',
    value: 'No, and we do not plan to do so in the next two years'
  }
];

export const DISCLOSER_METRIC_OPTIONS = [
  {
    label: 'Financed emissions',
    value: 'Financed emissions'
  },
  {
    label:
      'Other carbon footprinting and/or exposure metrics (as defined by TCFD)',
    value:
      'Other carbon footprinting and/or exposure metrics (as defined by TCFD)'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const EMISSIONS_CALCULATION_METHODOLOGY_GHG_OPTIONS = [
  {
    label:
      'The Global GHG Accounting and Reporting Standard for the Financial Industry (PCAF)',
    value:
      'The Global GHG Accounting and Reporting Standard for the Financial Industry (PCAF)'
  },
  {
    label: 'GHG Protocol: A Corporate Accounting and Reporting Standard',
    value: 'GHG Protocol: A Corporate Accounting and Reporting Standard'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const PORTFOLIO_METRIC_OPTIONS = [
  {
    label: 'Climate',
    options: [
      {
        value: 'Weighted average carbon intensity (tCO₂e/Million revenue)',
        label: 'Weighted average carbon intensity (tCO₂e/Million revenue)'
      },
      {
        value: 'Portfolio carbon footprint (tCO₂e/Million invested)',
        label: 'Portfolio carbon footprint (tCO₂e/Million invested)'
      },
      {
        value: 'Carbon intensity (tCO₂e/Million revenue)',
        label: 'Carbon intensity (tCO₂e/Million revenue)'
      },
      {
        value: 'Avoided emissions financed (tCO₂e)',
        label: 'Avoided emissions financed (tCO₂e)'
      },
      {
        value: 'Carbon removals financed (tCO₂e)',
        label: 'Carbon removals financed (tCO₂e)'
      },
      {
        value: 'Insurance-associated emissions (tCO₂e)',
        label: 'Insurance-associated emissions (tCO₂e)'
      },
      {
        value: 'Facilitated emissions (tCO₂e)',
        label: 'Facilitated emissions (tCO₂e)'
      },
      {
        value: 'Energy consumption (GWh/Million revenue of investee company)',
        label: 'Energy consumption (GWh/Million revenue of investee company)'
      },
      {
        value: 'Other metric for impact on climate change, please specify',
        label: 'Other metric for impact on climate change, please specify'
      }
    ]
  },
  {
    label: 'Forests',
    options: [
      {
        value:
          'Share of investments in companies that engage in activities that cause land degradation, desertification, or soil sealing',
        label:
          'Share of investments in companies that engage in activities that cause land degradation, desertification, or soil sealing'
      },
      {
        value:
          'Share of investments in companies without a policy to address deforestation (i.e., a no-deforestation policy)',
        label:
          'Share of investments in companies without a policy to address deforestation (i.e., a no-deforestation policy)'
      },
      {
        value:
          'Share of investments in companies without a no-conversion of natural ecosystems policy',
        label:
          'Share of investments in companies without a no-conversion of natural ecosystems policy'
      },
      {
        value:
          'Share of investments in companies with 100% deforestation-free (DF) status',
        label:
          'Share of investments in companies with 100% deforestation-free (DF) status'
      },
      {
        value:
          'Share of investments in companies with 100% deforestation- and conversion-free (DCF) status',
        label:
          'Share of investments in companies with 100% deforestation- and conversion-free (DCF) status'
      },
      {
        value:
          'Share of investments in companies that engage in integrated, multi-stakeholder landscape/watershed/river basin/jurisdictional initiatives to promote shared sustainability goals',
        label:
          'Share of investments in companies that engage in integrated, multi-stakeholder landscape/watershed/river basin/jurisdictional initiatives to promote shared sustainability goals'
      },
      {
        value:
          'Share of investments in companies that engage in ecosystem restoration',
        label:
          'Share of investments in companies that engage in ecosystem restoration'
      },
      {
        value:
          'Share of investments in companies with sites/operations located in or near biodiversity-sensitive or legally protected areas where activities negatively affect those areas',
        label:
          'Share of investments in companies with sites/operations located in or near biodiversity-sensitive or legally protected areas where activities negatively affect those areas'
      },
      {
        value: 'Other metric for impact on forests, please specify',
        label: 'Other metric for impact on forests, please specify'
      }
    ]
  },
  {
    label: 'Water',
    options: [
      {
        value:
          'Weighted average emissions to water (tonnes of emissions to water generated by investee companies per million invested)',
        label:
          'Weighted average emissions to water (tonnes of emissions to water generated by investee companies per million invested)'
      },
      {
        value: 'Other metric for impact on water, please specify',
        label: 'Other metric for impact on water, please specify'
      }
    ]
  },
  {
    label: 'Biodiversity',
    options: [
      {
        value:
          'Share of investments in investee companies with sites/operations located in or near biodiversity-sensitive or legally protected areas where activities negatively affect those areas',
        label:
          'Share of investments in investee companies with sites/operations located in or near biodiversity-sensitive or legally protected areas where activities negatively affect those areas'
      },
      {
        value:
          'Share of investments in investee companies whose operations affect threatened species',
        label:
          'Share of investments in investee companies whose operations affect threatened species'
      },
      {
        value:
          'Share of investments in investee companies without a biodiversity protection policy covering operational sites owned, leased, managed in, or adjacent to, a protected area or an area of high biodiversity value',
        label:
          'Share of investments in investee companies without a biodiversity protection policy covering operational sites owned, leased, managed in, or adjacent to, a protected area or an area of high biodiversity value'
      },
      {
        value: 'Financed absolute biodiversity footprint (MSA/km²/year)',
        label: 'Financed absolute biodiversity footprint (MSA/km²/year)'
      },
      {
        value: 'Financed absolute biodiversity footprint (PDF/km²/year)',
        label: 'Financed absolute biodiversity footprint (PDF/km²/year)'
      },
      {
        value:
          'Biodiversity intensity per unit of capital employed (MSA per million of capital employed)',
        label:
          'Biodiversity intensity per unit of capital employed (MSA per million of capital employed)'
      },
      {
        value:
          'Biodiversity intensity per unit of capital employed (PDF per million of capital employed)',
        label:
          'Biodiversity intensity per unit of capital employed (PDF per million of capital employed)'
      },
      {
        value: 'Other metric for impact on biodiversity, please specify',
        label: 'Other metric for impact on biodiversity, please specify'
      }
    ]
  }
];

export const PORTFOLIO_BREAKDOWN_OPTIONS = [
  {
    label: 'Yes, by asset class',
    value: 'Yes, by asset class'
  },
  {
    label: 'Yes, by industry',
    value: 'Yes, by industry'
  },
  {
    label: 'Yes, by scope',
    value: 'Yes, by scope'
  },
  {
    label: 'None of the above, but we plan to do this in the next two years',
    value: 'None of the above, but we plan to do this in the next two years'
  },
  {
    label: 'None of the above and we do not plan to do this',
    value: 'None of the above and we do not plan to do this'
  }
];

export const PORTFOLIO_METRIC_UNIT_OPTIONS = [
  {
    label: 'Absolute portfolio emissions (tCO₂e)',
    value: 'Absolute portfolio emissions (tCO₂e)'
  },
  {
    label: 'Weighted average carbon intensity (tCO₂e/Million revenue)',
    value: 'Weighted average carbon intensity (tCO₂e/Million revenue)'
  },
  {
    label: 'Portfolio carbon footprint (tCO₂e/Million invested)',
    value: 'Portfolio carbon footprint (tCO₂e/Million invested)'
  },
  {
    label: 'Carbon intensity (tCO₂e/Million revenue)',
    value: 'Carbon intensity (tCO₂e/Million revenue)'
  },
  {
    label: 'Avoided emissions financed (tCO₂e)',
    value: 'Avoided emissions financed (tCO₂e)'
  },
  {
    label: 'Carbon removals financed (tCO₂e)',
    value: 'Carbon removals financed (tCO₂e)'
  },
  {
    label: 'Insurance-associated emissions (tCO₂e)',
    value: 'Insurance-associated emissions (tCO₂e)'
  },
  {
    label: 'Facilitated emissions (tCO₂e)',
    value: 'Facilitated emissions (tCO₂e)'
  },
  {
    label: 'Energy consumption (GWh/Million revenue of investee company)',
    value: 'Energy consumption (GWh/Million revenue of investee company)'
  },
  {
    label: 'Emissions intensity (tCO₂e/MWh)',
    value: 'Emissions intensity (tCO₂e/MWh)'
  },
  {
    label: 'Emissions intensity (tCO₂e/m²)',
    value: 'Emissions intensity (tCO₂e/m²)'
  },
  {
    label: 'Emissions intensity (tCO₂e/tonne steel produced)',
    value: 'Emissions intensity (tCO₂e/tonne steel produced)'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const REPORTING_VALUES_OF_FINANCING_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label:
      'No, but we plan to report our portfolios exposure to fossil fuel in the next two years',
    value:
      'No, but we plan to report our portfolios exposure to fossil fuel in the next two years'
  },
  {
    label:
      'No, and we do not plan to report our portfolios exposure to fossil fuel in the next two years',
    value:
      'No, and we do not plan to report our portfolios exposure to fossil fuel in the next two years'
  }
];

export const PRIMARY_REASON_FOR_NOT_PROVIDING_VALUES_OPTIONS = [
  {
    label:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
    value:
      'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
  },
  {
    label: 'No standardized procedure',
    value: 'No standardized procedure'
  },
  {
    label: 'Not an immediate strategic priority',
    value: 'Not an immediate strategic priority'
  },
  {
    label: 'Lack of tools or methodologies available',
    value: 'Lack of tools or methodologies available'
  },
  {
    label: 'Judged to be unimportant or not relevant',
    value: 'Judged to be unimportant or not relevant'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  }
];

export const COMMODITY_VALUE_CHAIN_STAGE_COVERAGE_OPTIONS = [
  {
    label: 'Production',
    value: 'Production'
  },
  {
    label: 'Processing',
    value: 'Processing'
  },
  {
    label: 'Trading',
    value: 'Trading'
  },
  {
    label: 'Manufacturing',
    value: 'Manufacturing'
  },
  {
    label: 'Retailing',
    value: 'Retailing'
  }
];

export const MITIGATION_ADAPTATION_OPTIONS = [
  {
    label: 'Mitigation',
    value: 'Mitigation'
  },
  {
    label: 'Adaptation',
    value: 'Adaptation'
  }
];

export const TYPE_OF_PRODUCT_CLASSIFICATION_OPTIONS = [
  {
    label: 'Products that promote environmental and/or social characteristics',
    value: 'Products that promote environmental and/or social characteristics'
  },
  {
    label: 'Products that have sustainable investment as their core objective',
    value: 'Products that have sustainable investment as their core objective'
  },
  {
    label: 'Other product classification, please specify',
    value: 'Other product classification, please specify'
  },
  {
    label: 'Not applicable',
    value: 'Not applicable'
  }
];

export const TAXONOMY_OR_METHODOLOGY_OPTIONS = [
  {
    label: 'Low-Carbon Investment (LCI) Registry Taxonomy',
    value: 'Low-Carbon Investment (LCI) Registry Taxonomy'
  },
  {
    label: 'Climate Bonds Taxonomy',
    value: 'Climate Bonds Taxonomy'
  },
  {
    label:
      'The EU Taxonomy for environmentally sustainable economic activities',
    value: 'The EU Taxonomy for environmentally sustainable economic activities'
  },
  {
    label: 'Evaluating the carbon-reducing impacts of ICT',
    value: 'Evaluating the carbon-reducing impacts of ICT'
  },
  {
    label: 'Green Bond Principles (ICMA)',
    value: 'Green Bond Principles (ICMA)'
  },
  {
    label: 'ISO 14040/44 standards',
    value: 'ISO 14040/44 standards'
  },
  {
    label: 'LMA Green Loan Principles',
    value: 'LMA Green Loan Principles'
  },
  {
    label: 'LMA Sustainability-Linked Loans Principles',
    value: 'LMA Sustainability-Linked Loans Principles'
  },
  {
    label:
      'Externally classified using other taxonomy or methodology, please specify',
    value:
      'Externally classified using other taxonomy or methodology, please specify'
  },
  {
    label: 'Internally classified',
    value: 'Internally classified'
  }
];

export const TYPE_OF_SOLUTION_FINANCED_INVESTED_INSURED_OPTIONS = [
  {
    label: 'Carbon removal [CC only]',
    value: 'Carbon removal [CC only]'
  },
  {
    label: 'Ecosystem protection',
    value: 'Ecosystem protection'
  },
  {
    label: 'Ecosystem restoration',
    value: 'Ecosystem restoration'
  },
  {
    label: 'Emerging climate technology, please specify [CC only]',
    value: 'Emerging climate technology, please specify [CC only]'
  },
  {
    label: 'Energy efficiency measures [CC only]',
    value: 'Energy efficiency measures [CC only]'
  },
  {
    label: 'Flood/drought resilience [W only]',
    value: 'Flood/drought resilience [W only]'
  },
  {
    label: 'Fortified buildings [CC only]',
    value: 'Fortified buildings [CC only]'
  },
  {
    label: 'Green buildings and equipment [CC only]',
    value: 'Green buildings and equipment [CC only]'
  },
  {
    label: 'Landscape and/or jurisdictional initiative [F and W only]',
    value: 'Landscape and/or jurisdictional initiative [F and W only]'
  },
  {
    label: 'Low-emission transport [CC only]',
    value: 'Low-emission transport [CC only]'
  },
  {
    label: 'Nature-based solutions',
    value: 'Nature-based solutions'
  },
  {
    label: 'Paperless/digital service [CC only]',
    value: 'Paperless/digital service [CC only]'
  },
  {
    label: 'Reforestation [F only]',
    value: 'Reforestation [F only]'
  },
  {
    label: 'Regenerative production',
    value: 'Regenerative production'
  },
  {
    label: 'Renewable energy [CC only]',
    value: 'Renewable energy [CC only]'
  },
  {
    label: 'Risk transfer mechanisms for underinsured or uninsured [CC only]',
    value: 'Risk transfer mechanisms for underinsured or uninsured [CC only]'
  },
  {
    label: 'Sustainable forest management [F only]',
    value: 'Sustainable forest management [F only]'
  },
  {
    label: 'WASH services [W only]',
    value: 'WASH services [W only]'
  },
  {
    label: 'Wastewater treatment infrastructure [W only]',
    value: 'Wastewater treatment infrastructure [W only]'
  },
  {
    label: 'Water resources and ecosystem protection [W only]',
    value: 'Water resources and ecosystem protection [W only]'
  },
  {
    label: 'Water supply and sewer networks infrastructure [W only]',
    value: 'Water supply and sewer networks infrastructure [W only]'
  },
  {
    label: 'Water treatment infrastructure [W only]',
    value: 'Water treatment infrastructure [W only]'
  },
  {
    label: 'Other, please specify',
    value: 'Other, please specify'
  },
  {
    label: 'Not applicable',
    value: 'Not applicable'
  }
];

export const TARGET_SET_OPTIONS = [
  {
    label:
      'Yes, we have set deforestation and conversion-free lending, investing and/or insuring targets',
    value:
      'Yes, we have set deforestation and conversion-free lending, investing and/or insuring targets'
  },
  {
    label:
      'No, we have not set such targets, but we plan to within the next two years',
    value:
      'No, we have not set such targets, but we plan to within the next two years'
  },
  {
    label:
      'No, we have not set such targets and we do not plan to in the next two years',
    value:
      'No, we have not set such targets and we do not plan to in the next two years'
  }
];

export const TARGET_SET_FULL_OPTIONS = [
  {
    label: 'Targets for deforestation-free lending [F only]',
    value: 'Targets for deforestation-free lending [F only]'
  },
  {
    label: 'Targets for deforestation- and conversion-free lending [F only]',
    value: 'Targets for deforestation- and conversion-free lending [F only]'
  },
  {
    label: 'Targets for water-secure lending [W only]',
    value: 'Targets for water-secure lending [W only]'
  },
  {
    label: 'Targets for deforestation-free investments [F only]',
    value: 'Targets for deforestation-free investments [F only]'
  },
  {
    label:
      'Targets for deforestation- and conversion-free investments [F only]',
    value: 'Targets for deforestation- and conversion-free investments [F only]'
  },
  {
    label: 'Targets for water-secure investments [W only]',
    value: 'Targets for water-secure investments [W only]'
  },
  {
    label: 'Targets for deforestation-free insurance provided [F only]',
    value: 'Targets for deforestation-free insurance provided [F only]'
  },
  {
    label:
      'Targets for deforestation- and conversion-free insurance provided [F only]',
    value:
      'Targets for deforestation- and conversion-free insurance provided [F only]'
  },
  {
    label: 'Targets for water-secure insurance provided [W only]',
    value: 'Targets for water-secure insurance provided [W only]'
  },
  {
    label:
      'Targets for providing products and services that enable clients to mitigate deforestation [F only]',
    value:
      'Targets for providing products and services that enable clients to mitigate deforestation [F only]'
  },
  {
    label:
      'Targets for providing products and services that enable clients to mitigate water insecurity [W only]',
    value:
      'Targets for providing products and services that enable clients to mitigate water insecurity [W only]'
  },
  {
    label:
      'Targets for proportion of your clients/investees compliant with your deforestation-free requirements [F only]',
    value:
      'Targets for proportion of your clients/investees compliant with your deforestation-free requirements [F only]'
  },
  {
    label:
      'Targets for proportion of your clients/investees compliant with your deforestation- and conversion-free requirements [F only]',
    value:
      'Targets for proportion of your clients/investees compliant with your deforestation- and conversion-free requirements [F only]'
  },
  {
    label:
      'Targets for proportion of your clients/investees compliant with your water-related requirements [W only]',
    value:
      'Targets for proportion of your clients/investees compliant with your water-related requirements [W only]'
  },
  {
    label: 'Other, please specify [F/W]',
    value: 'Other, please specify [F/W]'
  }
];

export const NATURE_TARGET_SETTING_REFERENCES_OPTIONS = [
  {
    label: 'PRB Nature Target Setting Guidance [F/W]',
    value: 'PRB_NATURE_TARGET_SETTING_GUIDANCE'
  },
  {
    label: 'Guidance on Biodiversity Target-Setting [F/W]',
    value: 'GUIDANCE_ON_BIODIVERSITY_TARGET_SETTING'
  },
  {
    label: 'Global Canopy Finance Sector Roadmap [F]',
    value: 'GLOBAL_CANOPY_FINANCE_SECTOR_ROADMAP'
  },
  {
    label: 'The Finance Sector Deforestation Action (FSDA) Initiative [F]',
    value: 'FINANCE_SECTOR_DEFORESTATION_ACTION_FSDA_INITIATIVE'
  },
  {
    label: 'Kunming–Montreal Global Biodiversity Framework [F/W]',
    value: 'KUNMING_MONTREAL_GLOBAL_BIODIVERSITY_FRAMEWORK'
  },
  {label: 'Paris Agreement [F/W]', value: 'PARIS_AGREEMENT'},
  {
    label: 'Sustainable Development Goals [F/W]',
    value: 'SUSTAINABLE_DEVELOPMENT_GOALS'
  },
  {label: 'Planetary Boundaries [F/W]', value: 'PLANETARY_BOUNDARIES'},
  {
    label: 'Sustainable Blue Economy (SBE) [W only]',
    value: 'SUSTAINABLE_BLUE_ECONOMY_SBE'
  },
  {label: 'Other, please specify [F/W]', value: 'OTHER_PLEASE_SPECIFY'}
];

export const METRIC_TYPE_OPTIONS = [
  {
    label: 'Total value (unit currency – as specified in 1.2)',
    value: 'TOTAL_VALUE'
  },
  {
    label: '% of total lending/investment/insurance',
    value: 'PERCENT_OF_TOTAL_LENDING_INVESTMENT_INSURANCE'
  },
  {
    label: 'Number of products and services',
    value: 'NUMBER_OF_PRODUCTS_AND_SERVICES'
  },
  {
    label: '% of all products and services',
    value: 'PERCENT_OF_ALL_PRODUCTS_AND_SERVICES'
  },
  {
    label:
      'Resources allocated to products and services (unit currency – as specified in 1.2)',
    value: 'RESOURCES_ALLOCATED_TO_PRODUCTS_AND_SERVICES'
  },
  {label: '% of your clients/investees', value: 'PERCENT_OF_CLIENTS_INVESTEES'},
  {label: '% of your portfolio value', value: 'PERCENT_OF_PORTFOLIO_VALUE'},
  {
    label: 'Other percentage metric, please specify',
    value: 'OTHER_PERCENTAGE_METRIC'
  },
  {
    label: 'Other non-percentage metric, please specify',
    value: 'OTHER_NON_PERCENTAGE_METRIC'
  }
];

export const REPORTING_SCOPE_OPTIONS = [
  {label: 'Country/area', value: 'Country/area'},
  {label: 'Business units', value: 'Business units'},
  {label: 'Mining projects', value: 'Mining projects'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_RISK_POTENTIAL_OPTIONS = [
  {label: 'No potential', value: 'No potential'},
  {
    label: 'Potential for biodiversity-related risks but not evaluated',
    value: 'Potential for biodiversity-related risks but not evaluated'
  },
  {
    label:
      'Potential for biodiversity-related risks evaluated, but not disclosing to CDP',
    value:
      'Potential for biodiversity-related risks evaluated, but not disclosing to CDP'
  },
  {label: 'Don’t know', value: 'Don’t know'}
];

export const BIODIVERSITY_ACTION_PROGRESS_OPTIONS = [
  {
    label:
      'Yes, we are taking actions to progress our biodiversity-related commitments',
    value:
      'Yes, we are taking actions to progress our biodiversity-related commitments'
  },
  {
    label:
      'No, we are not taking any actions to progress our biodiversity-related commitments',
    value:
      'No, we are not taking any actions to progress our biodiversity-related commitments'
  },
  {
    label:
      'No, we are not taking any actions to progress our biodiversity-related commitments, but we plan to within the next two years',
    value:
      'No, we are not taking any actions to progress our biodiversity-related commitments, but we plan to within the next two years'
  },
  {
    label:
      'No, and we do not plan to undertake any biodiversity-related actions',
    value:
      'No, and we do not plan to undertake any biodiversity-related actions'
  }
];

export const BIODIVERSITY_ACTION_TYPE_OPTIONS = [
  {label: 'Land/water protection', value: 'Land/water protection'},
  {label: 'Land/water management', value: 'Land/water management'},
  {label: 'Species management', value: 'Species management'},
  {label: 'Education & awareness', value: 'Education & awareness'},
  {label: 'Law & policy', value: 'Law & policy'},
  {
    label: 'Livelihood, economic & other incentives',
    value: 'Livelihood, economic & other incentives'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_INDICATOR_USAGE_OPTIONS = [
  {label: 'Yes, we use indicators', value: 'Yes, we use indicators'},
  {
    label:
      'No, we do not use indicators, but plan to within the next two years',
    value: 'No, we do not use indicators, but plan to within the next two years'
  },
  {label: 'No', value: 'No'}
];

export const BIODIVERSITY_INDICATOR_TYPE_OPTIONS = [
  {
    label: 'State and benefit indicators',
    value: 'State and benefit indicators'
  },
  {label: 'Pressure indicators', value: 'Pressure indicators'},
  {label: 'Response indicators', value: 'Response indicators'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_IMPORTANT_AREA_OPTIONS = [
  {label: 'Legally protected areas', value: 'Legally protected areas'},
  {label: 'UNESCO World Heritage sites', value: 'UNESCO World Heritage sites'},
  {
    label: 'UNESCO Man and the Biosphere Reserves',
    value: 'UNESCO Man and the Biosphere Reserves'
  },
  {label: 'Ramsar sites', value: 'Ramsar sites'},
  {label: 'Key Biodiversity Areas', value: 'Key Biodiversity Areas'},
  {
    label: 'Other areas important for biodiversity',
    value: 'Other areas important for biodiversity'
  }
];

export const BIODIVERSITY_ASSESSMENT_STATUS_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'Yes (partial assessment)', value: 'Yes (partial assessment)'},
  {label: 'No', value: 'No'},
  {label: 'Not assessed', value: 'Not assessed'},
  {label: 'Data not available', value: 'Data not available'}
];

export const PROTECTED_AREA_CATEGORY_OPTIONS = [
  {label: 'Category Ia-III', value: 'Category Ia-III'},
  {label: 'Category IV-VI', value: 'Category IV-VI'},
  {label: 'Unknown', value: 'Unknown'},
  {label: 'Not applicable', value: 'Not applicable'}
];

export const BIODIVERSITY_PROXIMITY_OPTIONS = [
  {label: 'Overlap', value: 'Overlap'},
  {label: 'Adjacent', value: 'Adjacent'},
  {label: 'Up to 5 km', value: 'Up to 5 km'},
  {label: 'Up to 10 km', value: 'Up to 10 km'},
  {label: 'Up to 25 km', value: 'Up to 25 km'},
  {label: 'Up to 50 km', value: 'Up to 50 km'},
  {label: 'Up to 70 km', value: 'Up to 70 km'},
  {label: 'Data not available', value: 'Data not available'}
];

export const BIODIVERSITY_IMPACT_MITIGATION_OPTIONS = [
  {
    label: 'Yes, but mitigation measures have been implemented',
    value: 'Yes, but mitigation measures have been implemented'
  },
  {
    label: 'Yes, and no mitigation measures have been implemented',
    value: 'Yes, and no mitigation measures have been implemented'
  },
  {label: 'No', value: 'No'},
  {label: 'Not assessed', value: 'Not assessed'}
];

export const BIODIVERSITY_MITIGATION_TYPE_OPTIONS = [
  {label: 'Site selection', value: 'Site selection'},
  {label: 'Project design', value: 'Project design'},
  {label: 'Scheduling', value: 'Scheduling'},
  {label: 'Physical controls', value: 'Physical controls'},
  {label: 'Operational controls', value: 'Operational controls'},
  {label: 'Abatement controls', value: 'Abatement controls'},
  {label: 'Restoration', value: 'Restoration'},
  {label: 'Biodiversity offsets', value: 'Biodiversity offsets'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_ACTION_EFFECTIVENESS_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'Partially', value: 'Partially'},
  {label: 'No', value: 'No'},
  {label: 'Data not available', value: 'Data not available'}
];

export const YES_NO_PARTIALLY_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'Partially', value: 'Partially'},
  {label: 'No', value: 'No'}
];

export const YES_NO_NO_DATA_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No', value: 'No'},
  {label: 'Data not available', value: 'Data not available'}
];

export const BIODIVERSITY_HABITAT_DISTURBED_OPTIONS = [
  {label: 'Modified habitat', value: 'Modified habitat'},
  {label: 'Natural habitat', value: 'Natural habitat'},
  {label: 'Data not available', value: 'Data not available'}
];

export const MINING_PROJECT_LOCATION_OPTIONS = [
  {
    label: 'Inside mining project area/lease',
    value: 'Inside mining project area/lease'
  },
  {
    label: 'Adjacent to mining project area/lease',
    value: 'Adjacent to mining project area/lease'
  },
  {
    label: 'In the area of influence of the mining project',
    value: 'In the area of influence of the mining project'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const MINING_OPERATION_LEGAL_STATUS_OPTIONS = [
  {label: 'Legal / formalised', value: 'Legal / formalised'},
  {label: 'Illegal/informal', value: 'Illegal/informal'},
  {label: 'Both, legal and illegal', value: 'Both, legal and illegal'},
  {label: 'Data not available', value: 'Data not available'}
];

export const MINING_PROJECT_CHALLENGES_OPTIONS = [
  {
    label: 'Deforestation and/or forest degradation',
    value: 'Deforestation and/or forest degradation'
  },
  {label: 'Natural habitat conversion', value: 'Natural habitat conversion'},
  {label: 'Pollution', value: 'Pollution'},
  {label: 'Poaching', value: 'Poaching'},
  {
    label: 'Opposition to the mining project',
    value: 'Opposition to the mining project'
  },
  {label: 'Human rights issues', value: 'Human rights issues'},
  {label: 'No challenge identified', value: 'No challenge identified'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const ENVIRONMENTAL_MANAGEMENT_DOCUMENT_TYPE_OPTIONS = [
  {label: 'Stand-alone document', value: 'Stand-alone document'},
  {
    label: 'Part of general Environmental Management System',
    value: 'Part of general Environmental Management System'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const ENVIRONMENTAL_REVIEW_FREQUENCY_OPTIONS = [
  {label: 'Regularly', value: 'Regularly'},
  {label: 'Eventually', value: 'Eventually'},
  {label: 'Not reviewed', value: 'Not reviewed'}
];

export const ENVIRONMENTAL_DISCLOSURE_STATUS_OPTIONS = [
  {label: 'Yes', value: 'Yes'},
  {label: 'No', value: 'No'},
  {label: 'Data not available', value: 'Data not available'},
  {
    label: 'Data available but not disclosing',
    value: 'Data available but not disclosing'
  }
];

export const ENVIRONMENTAL_IMPACT_TYPE_OPTIONS = [
  {label: 'Direct', value: 'Direct'},
  {label: 'Indirect', value: 'Indirect'},
  {label: 'Cumulative', value: 'Cumulative'}
];

export const ENVIRONMENTAL_IMPACT_SEVERITY_OPTIONS = [
  {label: 'Moderate', value: 'Moderate'},
  {label: 'Serious', value: 'Serious'},
  {label: 'Extreme', value: 'Extreme'},
  {label: 'Catastrophic', value: 'Catastrophic'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const ENVIRONMENTAL_IMPACT_LIKELIHOOD_OPTIONS = [
  {label: 'Almost certain', value: 'Almost certain'},
  {label: 'Likely', value: 'Likely'},
  {label: 'Possible', value: 'Possible'},
  {label: 'Unlikely', value: 'Unlikely'},
  {label: 'Rare', value: 'Rare'}
];

export const ENVIRONMENTAL_ASPECT_STRATEGY_OPTIONS = [
  {
    label: 'Long-term business objectives',
    value: 'Long-term business objectives'
  },
  {
    label: 'Strategy for long-term objectives',
    value: 'Strategy for long-term objectives'
  }
];

export const BIODIVERSITY_STRATEGIC_INTEGRATION_OPTIONS = [
  {
    label: 'Yes, biodiversity-related issues are integrated',
    value: 'Yes, biodiversity-related issues are integrated'
  },
  {
    label:
      'No, biodiversity-related issues were reviewed but not considered as strategically relevant/significant',
    value:
      'No, biodiversity-related issues were reviewed but not considered as strategically relevant/significant'
  },
  {
    label:
      'No, biodiversity-related issues not yet reviewed, but there are plans to do so in the next two years',
    value:
      'No, biodiversity-related issues not yet reviewed, but there are plans to do so in the next two years'
  },
  {
    label:
      'No, biodiversity-related issues were not reviewed and there are no plans to do so',
    value:
      'No, biodiversity-related issues were not reviewed and there are no plans to do so'
  }
];

export const BIODIVERSITY_TEAM_SIZE_OPTIONS = [
  {label: '5-10', value: '5-10'},
  {label: '11-15', value: '11-15'},
  {label: '16-20', value: '16-20'},
  {label: '21-30', value: '21-30'},
  {label: '>30', value: '>30'}
];

export const BIODIVERSITY_TEAM_COVERAGE_OPTIONS = [
  {label: '0%', value: '0%'},
  {label: '1-10%', value: '1-10%'},
  {label: '11-20%', value: '11-20%'},
  {label: '21-30%', value: '21-30%'},
  {label: '31-40%', value: '31-40%'},
  {label: '41-50%', value: '41-50%'},
  {label: '51-60%', value: '51-60%'},
  {label: '61-70%', value: '61-70%'},
  {label: '71-80%', value: '71-80%'},
  {label: '81-90%', value: '81-90%'},
  {label: '91-99%', value: '91-99%'},
  {label: '100%', value: '100%'},
  {label: 'Data not available', value: 'Data not available'}
];

export const AVOIDANCE_MINIMIZATION_OPTIONS = [
  {
    label: 'Avoidance',
    options: [
      {value: 'Site selection', label: 'Site selection'},
      {value: 'Project design', label: 'Project design'},
      {value: 'Scheduling', label: 'Scheduling'},
      {
        value: 'Other avoidance measure, please specify',
        label: 'Other avoidance measure, please specify'
      }
    ]
  },
  {
    label: 'Minimization',
    options: [
      {value: 'Physical controls', label: 'Physical controls'},
      {value: 'Operational controls', label: 'Operational controls'},
      {value: 'Abatement controls', label: 'Abatement controls'},
      {
        value: 'Other minimization measure, please specify',
        label: 'Other minimization measure, please specify'
      }
    ]
  }
];

export const ECOSYSTEM_TYPE_OPTIONS = [
  {label: 'Forest ecosystems', value: 'Forest ecosystems'},
  {label: 'Other ecosystems', value: 'Other ecosystems'},
  {label: 'Data not available', value: 'Data not available'}
];

export const COMPLIANCE_TYPE_OPTIONS = [
  {label: 'Voluntary', value: 'Voluntary'},
  {label: 'Lender requirements', value: 'Lender requirements'},
  {label: 'Legal requirements', value: 'Legal requirements'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_OFFSET_TYPE_OPTIONS = [
  {
    label: 'Restoration offset (forests)',
    value: 'Restoration offset (forests)'
  },
  {label: 'Restoration offset (other)', value: 'Restoration offset (other)'},
  {
    label: 'Averted loss offset (forests)',
    value: 'Averted loss offset (forests)'
  },
  {label: 'Averted loss offset (other)', value: 'Averted loss offset (other)'},
  {label: 'Compensation agreements', value: 'Compensation agreements'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_ACTION_AREA_OPTIONS = [
  {label: 'Forest conservation', value: 'Forest conservation'},
  {label: 'Protected areas', value: 'Protected areas'},
  {label: 'Threatened species', value: 'Threatened species'},
  {label: 'Restoration (forests)', value: 'Restoration (forests)'},
  {label: 'Restoration (other)', value: 'Restoration (other)'},
  {label: 'Community development', value: 'Community development'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const INFLUENCE_MINING_PROJECT_OPTIONS = [
  {
    label: 'In the area of influence of mining project',
    value: 'In the area of influence of mining project'
  },
  {
    label: 'Outside the area of influence of mining project',
    value: 'Outside the area of influence of mining project'
  }
];

export const TIMEFRAME_OPTIONS = [
  {
    label: 'Defined',
    value: 'Defined'
  },
  {
    label: 'Undefined',
    value: 'Undefined'
  }
];

export const YES_NO_NOT_ALL_PROJECTS_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'Partially (not all projects)',
    value: 'Partially (not all projects)'
  },
  {
    label: 'No',
    value: 'No'
  }
];

export const IS_FINANCE_PROVISION_MINE_CLOSURE_OPTIONS = [
  {
    label: 'Yes for all mines',
    value: 'Yes for all mines'
  },
  {
    label: 'Yes for some mines',
    value: 'Yes for some mines'
  },
  {
    label: 'No',
    value: 'No'
  }
];

export const BIODIVERSITY_REVIEW_FREQUENCY_OPTIONS = [
  {label: 'Regularly (all projects)', value: 'Regularly (all projects)'},
  {label: 'Regularly (some projects)', value: 'Regularly (some projects)'},
  {label: 'Occasionally (all projects)', value: 'Occasionally (all projects)'},
  {
    label: 'Occasionally (some projects)',
    value: 'Occasionally (some projects)'
  },
  {label: 'Not reviewed (all projects)', value: 'Not reviewed (all projects)'},
  {label: 'Not reviewed (some projects)', value: 'Not reviewed (some projects)'}
];

export const IS_COLLABORATING_WITH_NGO_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'No but plan to get involved in the next 2 years',
    value: 'No but plan to get involved in the next 2 years'
  },
  {
    label: 'No',
    value: 'No'
  }
];

export const SCOPE_OF_COLLABORATION_OPTIONS = [
  {label: 'Companywide', value: 'Companywide'},
  {label: 'Specific mining projects', value: 'Specific mining projects'}
];

export const BIODIVERSITY_MANAGEMENT_MEASURE_OPTIONS = [
  {
    label: 'Deforestation and/or forest degradation',
    value: 'Deforestation and/or forest degradation'
  },
  {label: 'Biodiversity Action Plans', value: 'Biodiversity Action Plans'},
  {label: 'Protected areas', value: 'Protected areas'},
  {label: 'Endangered species', value: 'Endangered species'},
  {label: 'Offsets', value: 'Offsets'},
  {label: 'Restoration', value: 'Restoration'},
  {label: 'Landscape-scale assessments', value: 'Landscape-scale assessments'},
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_TIMEFRAME_OPTIONS = [
  {label: '2018-2020', value: '2018-2020'},
  {label: '2021-2025', value: '2021-2025'},
  {label: '2026-2030', value: '2026-2030'},
  {label: '>2030', value: '>2030'},
  {label: 'No specified timeframe', value: 'No specified timeframe'}
];

export const ASM_INTERVENTION_TYPE_OPTIONS = [
  {label: 'Regularisation of ASM', value: 'Regularisation of ASM'},
  {
    label: 'Establishment of alternative livelihood programs',
    value: 'Establishment of alternative livelihood programs'
  },
  {label: 'Resettlement of ASM miners', value: 'Resettlement of ASM miners'},
  {
    label: 'Employment of ASM miners as workers',
    value: 'Employment of ASM miners as workers'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const LANDSCAPE_INITIATIVE_PARTICIPATION_OPTIONS = [
  {
    label: 'Participating in landscape-scale planning processes',
    value: 'Participating in landscape-scale planning processes'
  },
  {
    label: 'Engaging with local communities',
    value: 'Engaging with local communities'
  },
  {
    label: 'Engaging with indigenous peoples',
    value: 'Engaging with indigenous peoples'
  },
  {
    label: 'Funding research organizations',
    value: 'Funding research organizations'
  },
  {
    label: 'Participating in government-led initiatives',
    value: 'Participating in government-led initiatives'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const BIODIVERSITY_IMPACT_TYPES_OPTIONS = [
  {
    label: 'Deforestation and/or forest degradation',
    value: 'Deforestation and/or forest degradation'
  },
  {
    label:
      'Conversion and/or degradation of natural habitats (other than forests)',
    value:
      'Conversion and/or degradation of natural habitats (other than forests)'
  },
  {
    label: 'Negative impacts on legally or internationally recognized areas',
    value: 'Negative impacts on legally or internationally recognized areas'
  },
  {label: 'Fragmentation of ecosystems', value: 'Fragmentation of ecosystems'},
  {
    label: 'Loss of rare and threatened species',
    value: 'Loss of rare and threatened species'
  },
  {
    label: 'Effects on sensitive or migratory species',
    value: 'Effects on sensitive or migratory species'
  },
  {
    label: 'Negative impacts on ecosystem service provision',
    value: 'Negative impacts on ecosystem service provision'
  },
  {label: 'Other, please specify', value: 'Other, please specify'}
];

export const ENVIRONMENT_RESPONSIBILITIES_OF_THE_POSITION_OPTIONS = [
  {
    label: 'Dependencies, impacts, risks and opportunities',
    options: [
      {
        label:
          'Assessing future trends in environmental dependencies, impacts, risks, and opportunities',
        value:
          'Assessing future trends in environmental dependencies, impacts, risks, and opportunities'
      },
      {
        label:
          'Assessing environmental dependencies, impacts, risks, and opportunities',
        value:
          'Assessing environmental dependencies, impacts, risks, and opportunities'
      },
      {
        label:
          'Managing environmental dependencies, impacts, risks, and opportunities',
        value:
          'Managing environmental dependencies, impacts, risks, and opportunities'
      }
    ]
  },
  {
    label: 'Policies, commitments, and targets',
    options: [
      {
        label: 'Setting corporate environmental policies and/or commitments',
        value: 'Setting corporate environmental policies and/or commitments'
      },
      {
        label:
          'Monitoring compliance with corporate environmental policies and/or commitments',
        value:
          'Monitoring compliance with corporate environmental policies and/or commitments'
      },
      {
        label: 'Setting corporate environmental targets',
        value: 'Setting corporate environmental targets'
      },
      {
        label: 'Measuring progress towards environmental corporate targets',
        value: 'Measuring progress towards environmental corporate targets'
      },
      {
        label: 'Measuring progress towards environmental science-based targets',
        value: 'Measuring progress towards environmental science-based targets'
      }
    ]
  },
  {
    label: 'Engagement',
    options: [
      {
        label:
          'Managing public policy engagement related to environmental issues',
        value:
          'Managing public policy engagement related to environmental issues'
      },
      {
        label:
          'Managing value chain engagement related to environmental issues',
        value: 'Managing value chain engagement related to environmental issues'
      },
      {
        label: 'Managing engagement in landscapes and/or jurisdictions',
        value: 'Managing engagement in landscapes and/or jurisdictions'
      },
      {
        label: 'Managing supplier compliance with environmental requirements',
        value: 'Managing supplier compliance with environmental requirements'
      },
      {
        label: 'Conducting environmental scenario analysis',
        value: 'Conducting environmental scenario analysis'
      },
      {
        label: 'Developing a climate transition plan [CC only]',
        value: 'Developing a climate transition plan [CC only]'
      },
      {
        label: 'Implementing a climate transition plan [CC only]',
        value: 'Implementing a climate transition plan [CC only]'
      },
      {
        label:
          'Developing a business strategy which considers environmental issues',
        value:
          'Developing a business strategy which considers environmental issues'
      },
      {
        label:
          'Implementing the business strategy related to environmental issues',
        value:
          'Implementing the business strategy related to environmental issues'
      },
      {
        label:
          'Managing acquisitions, mergers, and divestitures related to environmental issues',
        value:
          'Managing acquisitions, mergers, and divestitures related to environmental issues'
      },
      {
        label:
          'Managing major capital and/or operational expenditures relating to environmental issues',
        value:
          'Managing major capital and/or operational expenditures relating to environmental issues'
      },
      {
        label: 'Managing annual budgets related to environmental issues',
        value: 'Managing annual budgets related to environmental issues'
      },
      {
        label:
          'Managing priorities related to innovation/low-environmental impact products or services (including R&D)',
        value:
          'Managing priorities related to innovation/low-environmental impact products or services (including R&D)'
      },
      {
        label:
          'Managing environmental reporting, audit, and verification processes',
        value:
          'Managing environmental reporting, audit, and verification processes'
      }
    ]
  },
  {
    label: 'Other',
    options: [
      {
        label:
          'Providing employee incentives related to environmental performance',
        value:
          'Providing employee incentives related to environmental performance'
      },
      {
        label: 'Managing supplier compliance with environmental requirements',
        value: 'Managing supplier compliance with environmental requirements'
      },
      {
        label: 'Other, please specify',
        value: 'Other, please specify'
      }
    ]
  }
];

export const Q5_5_1_OPTIONS = [
  {
    label: 'Alternative low-CO2 cements/binders',
    value: 'Alternative low-CO2 cements/binders'
  },
  {
    label: 'Carbon capture, utilization, and storage (CCUS)',
    value: 'Carbon capture, utilization, and storage (CCUS)'
  },
  {label: 'Control systems', value: 'Control systems'},
  {label: 'Fuel switching', value: 'Fuel switching'},
  {label: 'High temperature heating', value: 'High temperature heating'},
  {label: 'Low clinker cement', value: 'Low clinker cement'},
  {
    label: 'Low to medium temperature heating',
    value: 'Low to medium temperature heating'
  },
  {label: 'Waste heat recovery', value: 'Waste heat recovery'},
  {label: 'Other, please specify', value: 'Other, please specify'},
  {
    label: 'Unable to disaggregate by technology area',
    value: 'Unable to disaggregate by technology area'
  }
];

export const Q5_5_2_OPTIONS = [
  {
    label: 'Carbon capture, utilization, and storage (CCUS)',
    value: 'Carbon capture, utilization, and storage (CCUS)'
  },
  {label: 'Control systems', value: 'Control systems'},
  {
    label: 'Distributed energy resources (DER)',
    value: 'Distributed energy resources (DER)'
  },
  {label: 'Electromobility components', value: 'Electromobility components'},
  {label: 'Energy storage', value: 'Energy storage'},
  {label: 'High temperature heating', value: 'High temperature heating'},
  {label: 'Hydrogen power', value: 'Hydrogen power'},
  {
    label: 'Low to medium temperature heating',
    value: 'Low to medium temperature heating'
  },
  {label: 'Machinery automation', value: 'Machinery automation'},
  {label: 'Recycling', value: 'Recycling'},
  {label: 'Remanufacturing', value: 'Remanufacturing'},
  {label: 'Renewable energy', value: 'Renewable energy'},
  {label: 'Other, please specify', value: 'Other, please specify'},
  {
    label: 'Unable to disaggregate by technology area',
    value: 'Unable to disaggregate by technology area'
  }
];

export const Q5_5_3_OPTIONS = [
  {label: 'Alternative liquid fuels', value: 'Alternative liquid fuels'},
  {label: 'Bio technology', value: 'Bio technology'},
  {
    label: 'Carbon capture, utilization, and storage (CCUS)',
    value: 'Carbon capture, utilization, and storage (CCUS)'
  },
  {
    label: 'Chemical production using variable renewables',
    value: 'Chemical production using variable renewables'
  },
  {label: 'Control systems', value: 'Control systems'},
  {label: 'Electrolysis', value: 'Electrolysis'},
  {label: 'High temperature heating', value: 'High temperature heating'},
  {
    label: 'Low to medium temperature heating',
    value: 'Low to medium temperature heating'
  },
  {label: 'Methane reforming with CCUS', value: 'Methane reforming with CCUS'},
  {label: 'Process step integration', value: 'Process step integration'},
  {label: 'Product redesign', value: 'Product redesign'},
  {label: 'Radical process redesign', value: 'Radical process redesign'},
  {label: 'Waste heat recovery', value: 'Waste heat recovery'},
  {label: 'Other, please specify', value: 'Other, please specify'},
  {
    label: 'Unable to disaggregate by technology area',
    value: 'Unable to disaggregate by technology area'
  }
];

export const Q5_5_4_OPTIONS = [
  {label: 'Alternative fuels', value: 'Alternative fuels'},
  {label: 'Control systems', value: 'Control systems'},
  {label: 'High temperature heating', value: 'High temperature heating'},
  {label: 'Inert smelting anodes', value: 'Inert smelting anodes'},
  {
    label: 'Low-to-medium temperature heating',
    value: 'Low-to-medium temperature heating'
  },
  {label: 'Metal recycling', value: 'Metal recycling'},
  {label: 'Other, please specify', value: 'Other, please specify'},
  {
    label: 'Unable to disaggregate by technology area',
    value: 'Unable to disaggregate by technology area'
  }
];

export const Q5_5_5_OPTIONS = [
  {
    label: 'Alternative steelmaking processes',
    value: 'Alternative steelmaking processes'
  },
  {
    label: 'Carbon capture, utilization, and storage (CCUS)',
    value: 'Carbon capture, utilization, and storage (CCUS)'
  },
  {label: 'Control systems', value: 'Control systems'},
  {
    label: 'Efficiency/recovery equipment on existing process plant',
    value: 'Efficiency/recovery equipment on existing process plant'
  },
  {
    label: 'Electrolytic hydrogen blending',
    value: 'Electrolytic hydrogen blending'
  },
  {label: 'High temperature heating', value: 'High temperature heating'},
  {
    label: 'Low-to-medium temperature heating',
    value: 'Low-to-medium temperature heating'
  },
  {
    label: 'New process plant with improved efficiency',
    value: 'New process plant with improved efficiency'
  },
  {label: 'Other, please specify', value: 'Other, please specify'},
  {
    label: 'Unable to disaggregate by technology area',
    value: 'Unable to disaggregate by technology area'
  }
];

export const Q5_5_6_OPTIONS = [
  {label: 'Air-to-air heat pump', value: 'Air-to-air heat pump'},
  {label: 'Air-to-water heat pump', value: 'Air-to-water heat pump'},
  {label: 'Biofuel appliances', value: 'Biofuel appliances'},
  {
    label: 'Building integrated photovoltaic systems',
    value: 'Building integrated photovoltaic systems'
  },
  {
    label: 'Building integrated solar thermal collector (BIST)',
    value: 'Building integrated solar thermal collector (BIST)'
  },
  {
    label: 'Combined solar PV and heat pump',
    value: 'Combined solar PV and heat pump'
  },
  {label: 'Demand response', value: 'Demand response'},
  {label: 'Design tools', value: 'Design tools'},
  {
    label: 'Direct current buildings system',
    value: 'Direct current buildings system'
  },
  {label: 'Double smart grid', value: 'Double smart grid'},
  {label: 'Evaporative cooling', value: 'Evaporative cooling'},
  {label: 'Extending building lifetime', value: 'Extending building lifetime'},
  {label: 'Ground-source heat pump', value: 'Ground-source heat pump'},
  {label: 'Heat exchanger', value: 'Heat exchanger'},
  {label: 'Hybrid heat pump', value: 'Hybrid heat pump'},
  {label: 'Hydrogen boiler', value: 'Hydrogen boiler'},
  {label: 'Insulation', value: 'Insulation'},
  {label: 'Large-scale heat pump', value: 'Large-scale heat pump'},
  {label: 'Lightweighting', value: 'Lightweighting'},
  {label: 'Passive buildings', value: 'Passive buildings'},
  {
    label: 'Pellets burning stove and boiler',
    value: 'Pellets burning stove and boiler'
  },
  {label: 'Polymer/Organic LED', value: 'Polymer/Organic LED'},
  {label: 'Reducing material losses', value: 'Reducing material losses'},
  {label: 'Resilient buildings', value: 'Resilient buildings'},
  {label: 'Thermal storage', value: 'Thermal storage'},
  {
    label: 'Water heating heat pump booster',
    value: 'Water heating heat pump booster'
  },
  {label: 'Other, please specify', value: 'Other, please specify'},
  {
    label: 'Unable to disaggregate by technology area',
    value: 'Unable to disaggregate by technology area'
  }
];

export const NZ_OPTIONS = [
  {value: 'NZ 1', label: 'NZ 1'},
  {value: 'NZ 2', label: 'NZ 2'},
  {value: 'NZ 3', label: 'NZ 3'},
  {value: 'NZ 4', label: 'NZ 4'},
  {value: 'NZ 5', label: 'NZ 5'},
  {value: 'NZ 6', label: 'NZ 6'},
  {value: 'NZ 7', label: 'NZ 7'},
  {value: 'NZ 8', label: 'NZ 8'},
  {value: 'NZ 9', label: 'NZ 9'},
  {value: 'NZ 10', label: 'NZ 10'},
  {value: 'NZ 11', label: 'NZ 11'},
  {value: 'NZ 12', label: 'NZ 12'},
  {value: 'NZ 13', label: 'NZ 13'},
  {value: 'NZ 14', label: 'NZ 14'},
  {value: 'NZ 15', label: 'NZ 15'},
  {value: 'NZ 16', label: 'NZ 16'},
  {value: 'NZ 17', label: 'NZ 17'},
  {value: 'NZ 18', label: 'NZ 18'},
  {value: 'NZ 19', label: 'NZ 19'},
  {value: 'NZ 20', label: 'NZ 20'},
  {value: 'NZ 21', label: 'NZ 21'},
  {value: 'NZ 22', label: 'NZ 22'},
  {value: 'NZ 23', label: 'NZ 23'},
  {value: 'NZ 24', label: 'NZ 24'},
  {value: 'NZ 25', label: 'NZ 25'},
  {value: 'NZ 26', label: 'NZ 26'},
  {value: 'NZ 27', label: 'NZ 27'},
  {value: 'NZ 28', label: 'NZ 28  '},
  {value: 'NZ 29', label: 'NZ 29'},
  {value: 'NZ 30', label: 'NZ 30'},
  {value: 'NZ 31', label: 'NZ 31'},
  {value: 'NZ 32', label: 'NZ 32'},
  {value: 'NZ 33', label: 'NZ 33'},
  {value: 'NZ 34', label: 'NZ 34'},
  {value: 'NZ 35', label: 'NZ 35'},
  {value: 'NZ 36', label: 'NZ 36'},
  {value: 'NZ 37', label: 'NZ 37'},
  {value: 'NZ 38', label: 'NZ 38'},
  {value: 'NZ 39', label: 'NZ 39'},
  {value: 'NZ 40', label: 'NZ 40'},
  {value: 'NZ 41', label: 'NZ 41'},
  {value: 'NZ 42', label: 'NZ 42'},
  {value: 'NZ 43', label: 'NZ 43'},
  {value: 'NZ 44', label: 'NZ 44'},
  {value: 'NZ 45', label: 'NZ 45'},
  {value: 'NZ 46', label: 'NZ 46'},
  {value: 'NZ 47', label: 'NZ 47'},
  {value: 'NZ 48', label: 'NZ 48'},
  {value: 'NZ 49', label: 'NZ 49'},
  {value: 'NZ 50', label: 'NZ 50'},
  {value: 'NZ 51', label: 'NZ 51'},
  {value: 'NZ 52', label: 'NZ 52'},
  {value: 'NZ 53', label: 'NZ 53'},
  {value: 'NZ 54', label: 'NZ 54'},
  {value: 'NZ 55', label: 'NZ 55'},
  {value: 'NZ 56', label: 'NZ 56'},
  {value: 'NZ 57', label: 'NZ 57'},
  {value: 'NZ 58', label: 'NZ 58'},
  {value: 'NZ 59', label: 'NZ 59'},
  {value: 'NZ 60', label: 'NZ 60'},
  {value: 'NZ 61', label: 'NZ 61'},
  {value: 'NZ 62', label: 'NZ 62'},
  {value: 'NZ 63', label: 'NZ 63'},
  {value: 'NZ 64', label: 'NZ 64'},
  {value: 'NZ 65', label: 'NZ 65'},
  {value: 'NZ 66', label: 'NZ 66'},
  {value: 'NZ 67', label: 'NZ 67'},
  {value: 'NZ 68', label: 'NZ 68'},
  {value: 'NZ 69', label: 'NZ 69'},
  {value: 'NZ 70', label: 'NZ 70'},
  {value: 'NZ 71', label: 'NZ 71'},
  {value: 'NZ 72', label: 'NZ 72'},
  {value: 'NZ 73', label: 'NZ 73'},
  {value: 'NZ 74', label: 'NZ 74'},
  {value: 'NZ 75', label: 'NZ 75'},
  {value: 'NZ 76', label: 'NZ 76'},
  {value: 'NZ 77', label: 'NZ 77'},
  {value: 'NZ 78', label: 'NZ 78'},
  {value: 'NZ 79', label: 'NZ 79'},
  {value: 'NZ 80', label: 'NZ 80'},
  {value: 'NZ 81', label: 'NZ 81'},
  {value: 'NZ 82', label: 'NZ 82'},
  {value: 'NZ 83', label: 'NZ 83'},
  {value: 'NZ 84', label: 'NZ 84'},
  {value: 'NZ 85', label: 'NZ 85'},
  {value: 'NZ 86', label: 'NZ 86'},
  {value: 'NZ 87', label: 'NZ 87'},
  {value: 'NZ 88', label: 'NZ 88'},
  {value: 'NZ 89', label: 'NZ 89'},
  {value: 'NZ 90', label: 'NZ 90'},
  {value: 'NZ 91', label: 'NZ 91'},
  {value: 'NZ 92', label: 'NZ 92'},
  {value: 'NZ 93', label: 'NZ 93'},
  {value: 'NZ 94', label: 'NZ 94'},
  {value: 'NZ 95', label: 'NZ 95'},
  {value: 'NZ 96', label: 'NZ 96'},
  {value: 'NZ 97', label: 'NZ 97'},
  {value: 'NZ 98', label: 'NZ 98'},
  {value: 'NZ 99', label: 'NZ 99'},
  {value: 'NZ 100', label: 'NZ 100'}
];

export const TARGET_COVERAGE_OPTIONS_2 = [
  {
    value: 'Organization-wide companywide',
    label: 'Organization-wide companywide'
  },
  {
    value: 'Organization-wide excluding portfolio [FS only]',
    label: 'Organization-wide excluding portfolio [FS only]'
  },
  {value: 'Business division', label: 'Business division'},
  {value: 'Business activity', label: 'Business activity'},
  {value: 'Site/facility', label: 'Site/facility'},
  {value: 'Country/area/region', label: 'Country/area/region'},
  {value: 'Banking (Bank) [FS only]', label: 'Banking (Bank) [FS only]'},
  {
    value: 'Investing (Asset manager) [FS only]',
    label: 'Investing (Asset manager) [FS only]'
  },
  {
    value: 'Investing (Asset owner) [FS only]',
    label: 'Investing (Asset owner) [FS only]'
  },
  {
    value: 'Insurance underwriting (Insurance company) [FS only]',
    label: 'Insurance underwriting (Insurance company) [FS only]'
  },
  {value: 'Product-level', label: 'Product-level'},
  {value: 'Other, please specify.', label: 'Other, please specify.'}
];

export const TARGETS_LINKED_TO_THIS_NET_ZERO_TARGET_OPTIONS = [
  {value: 'Abs1–Abs100', label: 'Abs1–Abs100'},
  {value: 'Int1–Int100', label: 'Int1–Int100'},
  {value: 'Por1–Por100 [FS only]', label: 'Por1–Por100 [FS only]'},
  {value: 'Low1–Low100', label: 'Low1–Low100'},
  {value: 'Not applicable', label: 'Not applicable'}
];

export const PLAN_TO_MITIGATE_EMISSIONS_BEYOND_VALUE_CHAIN_OPTIONS = [
  {
    value: 'Yes, and we have already acted on this in the reporting year',
    label: 'Yes, and we have already acted on this in the reporting year'
  },
  {
    value: 'No, but we plan to within the next two years',
    label: 'No, but we plan to within the next two years'
  },
  {
    value: 'No, and we do not plan to within the next two years',
    label: 'No, and we do not plan to within the next two years'
  },
  {
    value: 'No, we do not plan to mitigate emissions beyond our value chain',
    label: 'No, we do not plan to mitigate emissions beyond our value chain'
  }
];

export const PLAN_TO_PURCHASE_AND_CANCEL_CARBON_CREDITS_FOR_NEUTRALIZATION_AND_OR_BEYOND_VALUE_CHAIN_MITIGATION_OPTIONS =
  [
    {
      value:
        'Yes, we are currently purchasing and cancelling carbon credits for beyond value chain mitigation',
      label:
        'Yes, we are currently purchasing and cancelling carbon credits for beyond value chain mitigation'
    },
    {
      value:
        'Yes, we plan to purchase and cancel carbon credits for beyond value chain mitigation',
      label:
        'Yes, we plan to purchase and cancel carbon credits for beyond value chain mitigation'
    },
    {
      value:
        'Yes, we plan to purchase and cancel carbon credits for neutralization at the end of the target',
      label:
        'Yes, we plan to purchase and cancel carbon credits for neutralization at the end of the target'
    },
    {
      value:
        'No, we do not plan to purchase and cancel carbon credits for neutralization and/or beyond value chain mitigation',
      label:
        'No, we do not plan to purchase and cancel carbon credits for neutralization and/or beyond value chain mitigation'
    }
  ];

export const INITIATIVE_CATEGORY_AND_INITIATIVE_TYPE_OPTIONS = [
  {
    label: 'Energy efficiency in buildings',
    options: [
      {value: 'Insulation', label: 'Insulation'},
      {value: 'Maintenance program', label: 'Maintenance program'},
      {value: 'Draught proofing', label: 'Draught proofing'},
      {value: 'Solar shading', label: 'Solar shading'},
      {
        value: 'Building Energy Management Systems (BEMS)',
        label: 'Building Energy Management Systems (BEMS)'
      },
      {
        value: 'Heating, ventilation, and air conditioning (HVAC)',
        label: 'Heating, ventilation, and air conditioning (HVAC)'
      },
      {value: 'Lighting', label: 'Lighting'},
      {value: 'Motors and drives', label: 'Motors and drives'},
      {
        value: 'Combined heat and power (cogeneration)',
        label: 'Combined heat and power (cogeneration)'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Low-carbon energy consumption',
    options: [
      {value: 'Solid biofuels', label: 'Solid biofuels'},
      {value: 'Liquid biofuels', label: 'Liquid biofuels'},
      {value: 'Biogas', label: 'Biogas'},
      {value: 'Geothermal', label: 'Geothermal'},
      {value: 'Large hydropower (>25 MW)', label: 'Large hydropower (>25 MW)'},
      {value: 'Small hydropower (<25 MW)', label: 'Small hydropower (<25 MW)'},
      {
        value: 'Hydropower (capacity unknown)',
        label: 'Hydropower (capacity unknown)'
      },
      {
        value: 'Renewable hydrogen fuel cell',
        label: 'Renewable hydrogen fuel cell'
      },
      {value: 'Solar heating and cooling', label: 'Solar heating and cooling'},
      {value: 'Solar PV', label: 'Solar PV'},
      {value: 'Solar CSP', label: 'Solar CSP'},
      {value: 'Nuclear', label: 'Nuclear'},
      {value: 'Wind', label: 'Wind'},
      {value: 'Tidal', label: 'Tidal'},
      {value: 'Wave', label: 'Wave'},
      {
        value: 'Fossil fuel plant fitted with CCS',
        label: 'Fossil fuel plant fitted with CCS'
      },
      {
        value: 'Low-carbon electricity mix',
        label: 'Low-carbon electricity mix'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Energy efficiency in production processes',
    options: [
      {value: 'Waste heat recovery', label: 'Waste heat recovery'},
      {value: 'Cooling technology', label: 'Cooling technology'},
      {value: 'Process optimization', label: 'Process optimization'},
      {value: 'Fuel switch', label: 'Fuel switch'},
      {value: 'Compressed air', label: 'Compressed air'},
      {
        value: 'Combined heat and power (cogeneration)',
        label: 'Combined heat and power (cogeneration)'
      },
      {value: 'Wastewater treatment', label: 'Wastewater treatment'},
      {value: 'Reuse of water', label: 'Reuse of water'},
      {value: 'Reuse of steam', label: 'Reuse of steam'},
      {
        value: 'Machine/equipment replacement',
        label: 'Machine/equipment replacement'
      },
      {value: 'Automation', label: 'Automation'},
      {value: 'Electrification', label: 'Electrification'},
      {value: 'Smart control system', label: 'Smart control system'},
      {value: 'Motors and drives', label: 'Motors and drives'},
      {value: 'Product or service design', label: 'Product or service design'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Waste reduction and material circularity',
    options: [
      {value: 'Waste reduction', label: 'Waste reduction'},
      {value: 'Product or service design', label: 'Product or service design'},
      {
        value: 'Product/component/material reuse',
        label: 'Product/component/material reuse'
      },
      {
        value: 'Product/component/material recycling',
        label: 'Product/component/material recycling'
      },
      {value: 'Remanufacturing', label: 'Remanufacturing'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Fugitive emissions reductions',
    options: [
      {
        value: 'Agricultural methane capture',
        label: 'Agricultural methane capture'
      },
      {
        value: 'Agricultural nitrous oxide reduction',
        label: 'Agricultural nitrous oxide reduction'
      },
      {value: 'Landfill methane capture', label: 'Landfill methane capture'},
      {
        value: 'Oil/natural gas methane leak capture/prevention',
        label: 'Oil/natural gas methane leak capture/prevention'
      },
      {
        value: 'Refrigerant leakage reduction',
        label: 'Refrigerant leakage reduction'
      },
      {
        value: 'Carbon capture and storage/utilization (CCS/U)',
        label: 'Carbon capture and storage/utilization (CCS/U)'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Low-carbon energy generation',
    options: [
      {value: 'Solid biofuels', label: 'Solid biofuels'},
      {value: 'Liquid biofuels', label: 'Liquid biofuels'},
      {value: 'Biogas', label: 'Biogas'},
      {value: 'Geothermal', label: 'Geothermal'},
      {value: 'Large hydropower (>25 MW)', label: 'Large hydropower (>25 MW)'},
      {value: 'Small hydropower (<25 MW)', label: 'Small hydropower (<25 MW)'},
      {
        value: 'Hydropower (capacity unknown)',
        label: 'Hydropower (capacity unknown)'
      },
      {
        value: 'Renewable hydrogen fuel cell',
        label: 'Renewable hydrogen fuel cell'
      },
      {value: 'Nuclear', label: 'Nuclear'},
      {value: 'Solar heating and cooling', label: 'Solar heating and cooling'},
      {value: 'Solar PV', label: 'Solar PV'},
      {value: 'Solar CSP', label: 'Solar CSP'},
      {value: 'Wind', label: 'Wind'},
      {value: 'Tidal', label: 'Tidal'},
      {value: 'Wave', label: 'Wave'},
      {
        value: 'Fossil fuel plant fitted with CCS',
        label: 'Fossil fuel plant fitted with CCS'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Non-energy industrial process emissions reductions',
    options: [
      {
        value: 'Process equipment replacement',
        label: 'Process equipment replacement'
      },
      {
        value: 'Process material substitution',
        label: 'Process material substitution'
      },
      {
        value: 'Process material efficiency',
        label: 'Process material efficiency'
      },
      {
        value: 'Carbon capture and storage/utilization (CCS/U)',
        label: 'Carbon capture and storage/utilization (CCS/U)'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Company policy or behavioral change',
    options: [
      {value: 'Supplier engagement', label: 'Supplier engagement'},
      {value: 'Customer engagement', label: 'Customer engagement'},
      {
        value: 'Site consolidation/closure',
        label: 'Site consolidation/closure'
      },
      {
        value: 'Change in purchasing practices',
        label: 'Change in purchasing practices'
      },
      {value: 'Resource efficiency', label: 'Resource efficiency'},
      {value: 'Waste management', label: 'Waste management'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Transportation',
    options: [
      {value: 'Business travel policy', label: 'Business travel policy'},
      {value: 'Teleworking', label: 'Teleworking'},
      {value: 'Employee commuting', label: 'Employee commuting'},
      {
        value: 'Company fleet vehicle replacement',
        label: 'Company fleet vehicle replacement'
      },
      {
        value: 'Company fleet vehicle efficiency',
        label: 'Company fleet vehicle efficiency'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  }
];

export const PAYBACK_PERIOD_OPTIONS = [
  {value: '<1 year', label: '<1 year'},
  {value: '1–3 years', label: '1–3 years'},
  {value: '4–10 years', label: '4–10 years'},
  {value: '11–15 years', label: '11–15 years'},
  {value: '16–20 years', label: '16–20 years'},
  {value: '21–25 years', label: '21–25 years'},
  {value: '>25 years', label: '>25 years'},
  {value: 'No payback', label: 'No payback'}
];

export const OTHER_INITIATIVE_LIFETIME_OPTIONS = [
  {value: '<1 year', label: '<1 year'},
  {value: '1–2 years', label: '1–2 years'},
  {value: '3–5 years', label: '3–5 years'},
  {value: '6–10 years', label: '6–10 years'},
  {value: '11–15 years', label: '11–15 years'},
  {value: '16–20 years', label: '16–20 years'},
  {value: '21–30 years', label: '21–30 years'},
  {value: '>30 years', label: '>30 years'},
  {value: 'Ongoing', label: 'Ongoing'}
];

export const METHOD_OPTIONS = [
  {
    value: 'Compliance with regulatory requirements/standards',
    label: 'Compliance with regulatory requirements/standards'
  },
  {
    value: 'Dedicated budget for energy efficiency',
    label: 'Dedicated budget for energy efficiency'
  },
  {
    value: 'Dedicated budget for low-carbon product R&D',
    label: 'Dedicated budget for low-carbon product R&D'
  },
  {
    value: 'Dedicated budget for other emissions reduction activities',
    label: 'Dedicated budget for other emissions reduction activities'
  },
  {value: 'Employee engagement', label: 'Employee engagement'},
  {
    value: 'Financial optimization calculations',
    label: 'Financial optimization calculations'
  },
  {value: 'Internal price on carbon', label: 'Internal price on carbon'},
  {
    value: 'Internal incentives/recognition programs',
    label: 'Internal incentives/recognition programs'
  },
  {value: 'Internal finance mechanisms', label: 'Internal finance mechanisms'},
  {
    value: 'Lower return on investment (ROI) specification',
    label: 'Lower return on investment (ROI) specification'
  },
  {
    value: 'Marginal abatement cost curve',
    label: 'Marginal abatement cost curve'
  },
  {
    value: 'Partnering with governments on technology development',
    label: 'Partnering with governments on technology development'
  },
  {value: 'Other', label: 'Other'}
];

export const PROJECT_AREA_OPTIONS = [
  {value: 'Buildings', label: 'Buildings'},
  {
    value: 'Energy efficiency (including public lighting)',
    label: 'Energy efficiency (including public lighting)'
  },
  {value: 'Renewable energy', label: 'Renewable energy'},
  {value: 'Transport', label: 'Transport'},
  {
    value: 'Waste management (including waste recycling)',
    label: 'Waste management (including waste recycling)'
  },
  {value: 'Water management', label: 'Water management'},
  {value: 'Health systems and services', label: 'Health systems and services'},
  {
    value: 'Sustainable food consumption/production',
    label: 'Sustainable food consumption/production'
  },
  {value: 'Land-Use', label: 'Land-Use'},
  {value: 'Nature-Based Solutions', label: 'Nature-Based Solutions'},
  {value: 'Public and green spaces', label: 'Public and green spaces'},
  {
    value: 'Landscape and Jurisdictional Approaches',
    label: 'Landscape and Jurisdictional Approaches'
  },
  {
    value: 'Jurisdictional REDD+ Program',
    label: 'Jurisdictional REDD+ Program'
  },
  {value: 'Other, please specify', label: 'Other, please specify'},
  {value: 'No relevant projects', label: 'No relevant projects'}
];

export const STAGE_OF_PROJECT_DEVELOPMENT_OPTIONS = [
  {value: 'Scoping', label: 'Scoping'},
  {
    value: 'Prefeasibility/impact assessment',
    label: 'Prefeasibility/impact assessment'
  },
  {value: 'Project feasibility', label: 'Project feasibility'},
  {value: 'Project structuring', label: 'Project structuring'},
  {value: 'Transaction preparation', label: 'Transaction preparation'},
  {value: 'Implementation', label: 'Implementation'},
  {value: 'Post implementation', label: 'Post implementation'}
];

export const STATUS_OF_FINANCING_OPTIONS = [
  {
    value: 'Project not funded and seeking partial funding',
    label: 'Project not funded and seeking partial funding'
  },
  {
    value: 'Project not funded and seeking full funding',
    label: 'Project not funded and seeking full funding'
  },
  {
    value: 'Project partially funded and seeking additional funding',
    label: 'Project partially funded and seeking additional funding'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const IDENTIFIED_FINANCING_MODEL_OPTIONS = [
  {value: 'Grants', label: 'Grants'},
  {value: 'Loans from commercial banks', label: 'Loans from commercial banks'},
  {value: 'Bonds', label: 'Bonds'},
  {
    value: 'Loans from International Financial Institutions',
    label: 'Loans from International Financial Institutions'
  },
  {value: 'Private investment', label: 'Private investment'},
  {value: 'Public finance - own budget', label: 'Public finance - own budget'},
  {
    value: 'Public finance - national government',
    label: 'Public finance - national government'
  },
  {value: 'Public-private partnership', label: 'Public-private partnership'},
  {value: 'Carbon markets', label: 'Carbon markets'},
  {
    value: 'No financing model identified',
    label: 'No financing model identified'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRIMARY_REASON_FOR_NOT_HAVING_TECHNIQUE_OPTIONS = [
  {
    value: 'Other priorities are being met first',
    label: 'Other priorities are being met first'
  },
  {
    value: 'Payback period considered too long',
    label: 'Payback period considered too long'
  },
  {
    value: 'Improvement potential considered insignificant',
    label: 'Improvement potential considered insignificant'
  },
  {
    value: 'Considered infeasible due to site-specific conditions',
    label: 'Considered infeasible due to site-specific conditions'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TYPES_OF_CO2_TRANSFER_OPTIONS = [
  {
    value: 'Transfer from a flue gas system',
    label: 'Transfer from a flue gas system'
  },
  {
    value: 'Transfer from an industrial process',
    label: 'Transfer from an industrial process'
  },
  {
    value: 'Purchase from a naturally-occurring underground source',
    label: 'Purchase from a naturally-occurring underground source'
  },
  {
    value: 'Transfer from another company under a storage agreement',
    label: 'Transfer from another company under a storage agreement'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const INJECTION_AND_STORAGE_PATHWAY_OPTIONS = [
  {
    value:
      'Acid gas injection (CO₂ and H₂S co-injected into a production reservoir)',
    label:
      'Acid gas injection (CO₂ and H₂S co-injected into a production reservoir)'
  },
  {
    value: 'CO₂ used for enhanced oil recovery (EOR)',
    label: 'CO₂ used for enhanced oil recovery (EOR)'
  },
  {
    value: 'CO₂ used for enhanced shale gas recovery (ESGR)',
    label: 'CO₂ used for enhanced shale gas recovery (ESGR)'
  },
  {
    value: 'CO₂ used for other enhanced gas recovery (EGR)',
    label: 'CO₂ used for other enhanced gas recovery (EGR)'
  },
  {
    value: 'CO₂ used for enhanced coal bed methane (ECBM) operations',
    label: 'CO₂ used for enhanced coal bed methane (ECBM) operations'
  },
  {
    value: 'CO₂ injected into saline formations for long-term storage',
    label: 'CO₂ injected into saline formations for long-term storage'
  },
  {
    value:
      'CO₂ injected into depleted oil and gas reservoirs for long-term storage',
    label:
      'CO₂ injected into depleted oil and gas reservoirs for long-term storage'
  },
  {
    value:
      'CO₂ injected into other deep geological formations for long-term storage',
    label:
      'CO₂ injected into other deep geological formations for long-term storage'
  },
  {
    value: 'CO₂ injected into basalts for long-term storage',
    label: 'CO₂ injected into basalts for long-term storage'
  },
  {
    value: 'CO₂ injected for storage through mineral carbonation',
    label: 'CO₂ injected for storage through mineral carbonation'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const MP_OPTIONS = [
  {value: 'MP1', label: 'MP1'},
  {value: 'MP2', label: 'MP2'},
  {value: 'MP3', label: 'MP3'},
  {value: 'MP4', label: 'MP4'},
  {value: 'MP5', label: 'MP5'},
  {value: 'MP6', label: 'MP6'},
  {value: 'MP7', label: 'MP7'},
  {value: 'MP8', label: 'MP8'},
  {value: 'MP9', label: 'MP9'},
  {value: 'MP10', label: 'MP10'},
  {value: 'MP11', label: 'MP11'},
  {value: 'MP12', label: 'MP12'},
  {value: 'MP13', label: 'MP13'},
  {value: 'MP14', label: 'MP14'},
  {value: 'MP15', label: 'MP15'},
  {value: 'MP16', label: 'MP16'},
  {value: 'MP17', label: 'MP17'},
  {value: 'MP18', label: 'MP18'},
  {value: 'MP19', label: 'MP19'},
  {value: 'MP20', label: 'MP20'}
];

export const MANAGEMENT_PRACTICE_OPTIONS = [
  {value: 'Afforestation', label: 'Afforestation'},
  {value: 'Agroforestry', label: 'Agroforestry'},
  {value: 'Biodiversity considerations', label: 'Biodiversity considerations'},
  {
    value: 'Change in the topography or landscapes',
    label: 'Change in the topography or landscapes'
  },
  {value: 'Composting', label: 'Composting'},
  {value: 'Crop diversity', label: 'Crop diversity'},
  {value: 'Contour farming', label: 'Contour farming'},
  {value: 'Crop rotation', label: 'Crop rotation'},
  {value: 'Diversifying farmer income', label: 'Diversifying farmer income'},
  {value: 'Efficient equipment use', label: 'Efficient equipment use'},
  {
    value: 'Equipment maintenance and calibration',
    label: 'Equipment maintenance and calibration'
  },
  {
    value: 'Enhanced forest regeneration practices',
    label: 'Enhanced forest regeneration practices'
  },
  {value: 'Fertilizer management', label: 'Fertilizer management'},
  {value: 'Fire control', label: 'Fire control'},
  {
    value: 'Governmental or institutional policies and programs',
    label: 'Governmental or institutional policies and programs'
  },
  {value: 'Green harvesting', label: 'Green harvesting'},
  {value: 'Integrated pest management', label: 'Integrated pest management'},
  {value: 'Knowledge sharing', label: 'Knowledge sharing'},
  {value: 'Land use change', label: 'Land use change'},
  {value: 'Low carbon energy use', label: 'Low carbon energy use'},
  {
    value: 'Low tillage and residue management',
    label: 'Low tillage and residue management'
  },
  {value: 'Livestock management', label: 'Livestock management'},
  {value: 'Manure management', label: 'Manure management'},
  {
    value: 'Nitrogen-fixing plants as cover crop',
    label: 'Nitrogen-fixing plants as cover crop'
  },
  {value: 'Organic farming', label: 'Organic farming'},
  {
    value: 'Practices to increase wood production and forest productivity',
    label: 'Practices to increase wood production and forest productivity'
  },
  {
    value: 'Permanent soil cover (including cover crops)',
    label: 'Permanent soil cover (including cover crops)'
  },
  {
    value: 'Pest, disease, and weed management practices',
    label: 'Pest, disease, and weed management practices'
  },
  {value: 'Reducing energy use', label: 'Reducing energy use'},
  {value: 'Reforestation', label: 'Reforestation'},
  {value: 'Restoration', label: 'Restoration'},
  {
    value: 'Replacing fossil fuels by renewable energy sources',
    label: 'Replacing fossil fuels by renewable energy sources'
  },
  {
    value: 'Restoration of degraded lands and cultivated organic soils',
    label: 'Restoration of degraded lands and cultivated organic soils'
  },
  {value: 'Rice management', label: 'Rice management'},
  {value: 'Seed variety selection', label: 'Seed variety selection'},
  {value: 'Selective logging', label: 'Selective logging'},
  {
    value: 'Selecting species to maximize carbon capture',
    label: 'Selecting species to maximize carbon capture'
  },
  {value: 'Species introduction', label: 'Species introduction'},
  {value: 'Timing of farm operations', label: 'Timing of farm operations'},
  {value: 'Waste management', label: 'Waste management'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRIMARY_CLIMATE_CHANGE_RELATED_BENEFIT_OPTIONS = [
  {
    value: 'Emission reductions (mitigation)',
    label: 'Emission reductions (mitigation)'
  },
  {
    value: 'Increasing resilience to climate change (adaptation)',
    label: 'Increasing resilience to climate change (adaptation)'
  },
  {
    value: 'Increase carbon sink (mitigation)',
    label: 'Increase carbon sink (mitigation)'
  },
  {
    value: 'Reduced demand for fossil fuel (adaptation)',
    label: 'Reduced demand for fossil fuel (adaptation)'
  },
  {
    value: 'Reduced demand for fertilizers (adaptation)',
    label: 'Reduced demand for fertilizers (adaptation)'
  },
  {
    value: 'Reduced demand for pesticides (adaptation)',
    label: 'Reduced demand for pesticides (adaptation)'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const YOUR_ROLE_IN_THE_IMPLEMENTATION_OPTIONS = [
  {value: 'Financial', label: 'Financial'},
  {value: 'Knowledge sharing', label: 'Knowledge sharing'},
  {value: 'Operational', label: 'Operational'},
  {value: 'Procurement', label: 'Procurement'},
  {value: 'None', label: 'None'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PRIMARY_REASON_OPTIONS = [
  {value: 'Lack of internal resources', label: 'Lack of internal resources'},
  {
    value: 'We plan to introduce a process in the next two years',
    label: 'We plan to introduce a process in the next two years'
  },
  {
    value: 'Not an immediate business priority',
    label: 'Not an immediate business priority'
  },
  {value: 'Judged to be unimportant', label: 'Judged to be unimportant'},
  {
    value: 'No instruction from management',
    label: 'No instruction from management'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const OVERALL_EFFECT_OPTIONS = [
  {value: 'Positive', label: 'Positive'},
  {value: 'Negative', label: 'Negative'},
  {value: 'Neutral', label: 'Neutral'},
  {value: 'Mixed', label: 'Mixed'}
];

export const IMPACTED_ASPECTS_OPTIONS = [
  {value: 'Biodiversity', label: 'Biodiversity'},
  {value: 'Soil', label: 'Soil'},
  {value: 'Water', label: 'Water'},
  {value: 'Yield', label: 'Yield'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const ASSESSMENT_OF_LIFE_CYCLE_EMISSIONS_OPTIONS = [
  {value: 'Yes', label: 'Yes'},
  {
    value: 'No, but we plan to start doing so within the next two years',
    label: 'No, but we plan to start doing so within the next two years'
  },
  {
    value: 'No, and we do not plan to start doing so within the next two years',
    label: 'No, and we do not plan to start doing so within the next two years'
  }
];

export const PRODUCT_OR_SERVICE_OPTIONS = [
  {
    value: 'All existing products/services',
    label: 'All existing products/services'
  },
  {
    value: 'All new products/services under development',
    label: 'All new products/services under development'
  },
  {
    value: 'All existing and new products/services',
    label: 'All existing and new products/services'
  },
  {
    value: 'Representative selection of products/services',
    label: 'Representative selection of products/services'
  },
  {value: 'On a case-by-case basis', label: 'On a case-by-case basis'},
  {
    value: 'Products/services meeting certain criteria (please specify)',
    label: 'Products/services meeting certain criteria (please specify)'
  }
];

export const LIFE_CYCLE_STAGES_COVERED_OPTIONS = [
  {value: 'Cradle-to-gate', label: 'Cradle-to-gate'},
  {value: 'Cradle-to-grave', label: 'Cradle-to-grave'},
  {
    value: 'Cradle-to-cradle/closed loop production',
    label: 'Cradle-to-cradle/closed loop production'
  },
  {
    value: 'Cradle-to-gate + end-of-life stage',
    label: 'Cradle-to-gate + end-of-life stage'
  },
  {value: 'Gate-to-gate', label: 'Gate-to-gate'},
  {value: 'Use stage', label: 'Use stage'},
  {value: 'End-of-life stage', label: 'End-of-life stage'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS = [
  {value: 'Bilan Carbone', label: 'Bilan Carbone'},
  {
    value: 'EU Product Environmental Footprint (EUPEF)',
    label: 'EU Product Environmental Footprint (EUPEF)'
  },
  {
    value: 'French Product Environmental Footprint',
    label: 'French Product Environmental Footprint'
  },
  {
    value: 'GHG Protocol Product Accounting & Reporting Standard',
    label: 'GHG Protocol Product Accounting & Reporting Standard'
  },
  {value: 'ISO 14025', label: 'ISO 14025'},
  {value: 'ISO 14040 & 14044', label: 'ISO 14040 & 14044'},
  {value: 'ISO 14067', label: 'ISO 14067'},
  {value: 'PAS 2050', label: 'PAS 2050'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const ASSESSMENT_OF_LIFE_CYCLE_EMISSIONS_OPTIONS_2 = [
  {
    value: 'Yes, quantitative assessment',
    label: 'Yes, quantitative assessment'
  },
  {value: 'Yes, qualitative assessment', label: 'Yes, qualitative assessment'},
  {
    value: 'Yes, both qualitative and quantitative assessment',
    label: 'Yes, both qualitative and quantitative assessment'
  },
  {
    value: 'No, but we plan to for upcoming projects',
    label: 'No, but we plan to for upcoming projects'
  },
  {
    value: 'No, and we do not plan to for upcoming projects',
    label: 'No, and we do not plan to for upcoming projects'
  }
];

export const PROJECTS_ASSESSED_OPTIONS = [
  {
    value: 'All new construction and major renovation projects',
    label: 'All new construction and major renovation projects'
  },
  {
    value:
      'New construction and major renovation projects meeting certain criteria (please specify)',
    label:
      'New construction and major renovation projects meeting certain criteria (please specify)'
  },
  {value: 'On a case-by-case basis', label: 'On a case-by-case basis'}
];

export const EARLIEST_PROJECT_PHASE_THAT_MOST_COMMONLY_INCLUDES_AN_ASSESSMENT_OPTIONS =
  [
    {value: 'Pre-design phase', label: 'Pre-design phase'},
    {value: 'Design phase', label: 'Design phase'},
    {value: 'Construction', label: 'Construction'},
    {value: 'Operation', label: 'Operation'}
  ];

export const METHODOLOGIES_STANDARDS_TOOLS_APPLIED_OPTIONS_2 = [
  {
    value: 'BBCA Label (Bâtiment Bas Carbone)',
    label: 'BBCA Label (Bâtiment Bas Carbone)'
  },
  {
    value: 'E+C- Label (Énergie Positive & Réduction Carbone)',
    label: 'E+C- Label (Énergie Positive & Réduction Carbone)'
  },
  {
    value: 'Embodied Carbon in Construction Calculator (EC3) Tool',
    label: 'Embodied Carbon in Construction Calculator (EC3) Tool'
  },
  {value: 'EN 15978', label: 'EN 15978'},
  {value: 'EN 15804', label: 'EN 15804'},
  {
    value:
      'GHG Protocol - Product Life Cycle Accounting and Reporting Standard',
    label: 'GHG Protocol - Product Life Cycle Accounting and Reporting Standard'
  },
  {value: 'ISO 14040/44', label: 'ISO 14040/44'},
  {value: 'ISO 14025', label: 'ISO 14025'},
  {value: 'One Click LCA', label: 'One Click LCA'},
  {
    value: 'The Carbon Smart Materials Palette®',
    label: 'The Carbon Smart Materials Palette®'
  },
  {
    value: 'Whole life carbon assessment for the built environment (RICS)',
    label: 'Whole life carbon assessment for the built environment (RICS)'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const PROPERTY_SECTOR_OPTIONS = [
  {value: 'Retail', label: 'Retail'},
  {value: 'Office', label: 'Office'},
  {value: 'Industrial', label: 'Industrial'},
  {value: 'Residential', label: 'Residential'},
  {value: 'Hotel', label: 'Hotel'},
  {
    value: 'Lodging, Leisure & Recreation',
    label: 'Lodging, Leisure & Recreation'
  },
  {value: 'Education', label: 'Education'},
  {value: 'Technology/Science', label: 'Technology/Science'},
  {value: 'Healthcare', label: 'Healthcare'},
  {value: 'Mixed use', label: 'Mixed use'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TYPE_OF_PROJECT_OPTIONS = [
  {value: 'New construction', label: 'New construction'},
  {value: 'Major renovation', label: 'Major renovation'}
];

export const NORMALIZATION_FACTOR_DENOMINATOR_OPTIONS = [
  {value: 'IPMS 1', label: 'IPMS 1'},
  {value: 'IPMS 2 – Office', label: 'IPMS 2 – Office'},
  {value: 'IPMS 2 – Industrial', label: 'IPMS 2 – Industrial'},
  {value: 'IPMS 2 – Residential', label: 'IPMS 2 – Residential'},
  {value: 'IPMS 2 – Retail', label: 'IPMS 2 – Retail'},
  {value: 'IPMS 3 – Office', label: 'IPMS 3 – Office'},
  {value: 'IPMS 3A – Industrial', label: 'IPMS 3A – Industrial'},
  {value: 'IPMS 3A – Residential', label: 'IPMS 3A – Residential'},
  {value: 'IPMS 3A – Retail', label: 'IPMS 3A – Retail'},
  {value: 'IPMS 3B – Industrial', label: 'IPMS 3B – Industrial'},
  {value: 'IPMS 3B – Residential', label: 'IPMS 3B – Residential'},
  {value: 'IPMS 3B – Retail', label: 'IPMS 3B – Retail'},
  {value: 'IPMS 3C – Residential', label: 'IPMS 3C – Residential'},
  {value: 'IPMS 3C – Retail', label: 'IPMS 3C – Retail'},
  {value: 'Internal building volume', label: 'Internal building volume'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const DENOMINATOR_UNIT_OPTIONS = [
  {value: 'square foot', label: 'square foot'},
  {value: 'square meter', label: 'square meter'},
  {value: 'cubic foot', label: 'cubic foot'},
  {value: 'cubic meter', label: 'cubic meter'}
];

export const ARE_YOU_PROVIDING_PRODUCT_LEVEL_DATA_FOR_YOUR_ORGANIZATION_S_GOODS_OR_SERVICES_OPTIONS =
  [
    {
      value:
        'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool',
      label:
        'Yes I will provide data through the CDP x CO2 AI Product Ecosystem tool'
    },
    {
      value: 'Yes I will provide data through the CDP questionnaire',
      label: 'Yes I will provide data through the CDP questionnaire'
    },
    {value: 'No I am not providing data ', label: 'No I am not providing data '}
  ];

export const TYPE_OF_PRODUCT_OPTIONS = [
  {value: 'Final', label: 'Final'},
  {value: 'Intermediate', label: 'Intermediate'}
];

export const SCOPE_OPTIONS = [
  {value: 'Scope 1', label: 'Scope 1'},
  {value: 'Scope 2', label: 'Scope 2'},
  {value: 'Scope 3', label: 'Scope 3'},
  {value: 'Scope 1 & 2', label: 'Scope 1 & 2'},
  {value: 'Scope 1, 2 & 3', label: 'Scope 1, 2 & 3'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const LIFECYCLE_STAGE_OPTIONS = [
  {value: 'Assembly', label: 'Assembly'},
  {value: 'Consumer use', label: 'Consumer use'},
  {value: 'Cradle to gate', label: 'Cradle to gate'},
  {value: 'Cradle to grave', label: 'Cradle to grave'},
  {value: 'Distribution', label: 'Distribution'},
  {value: 'End of life/final disposal', label: 'End of life/final disposal'},
  {value: 'Energy/fuel', label: 'Energy/fuel'},
  {value: 'Manufacturing', label: 'Manufacturing'},
  {value: 'Material acquisition', label: 'Material acquisition'},
  {value: 'Operation of premises', label: 'Operation of premises'},
  {value: 'Packaging', label: 'Packaging'},
  {value: 'Pre-processing processing', label: 'Pre-processing processing'},
  {value: 'Production', label: 'Production'},
  {value: 'Recycling', label: 'Recycling'},
  {value: 'Storage', label: 'Storage'},
  {value: 'Transportation', label: 'Transportation'},
  {value: 'Waste', label: 'Waste'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const TYPE_OF_DATA_USED_OPTIONS = [
  {value: 'Primary', label: 'Primary'},
  {value: 'Secondary', label: 'Secondary'},
  {value: 'Primary & secondary', label: 'Primary & secondary'}
];

export const INITIATIVE_ID_OPTIONS = [
  {value: 'Initiative 1', label: 'Initiative 1'},
  {value: 'Initiative 2', label: 'Initiative 2'},
  {value: 'Initiative 3', label: 'Initiative 3'},
  {value: 'Initiative 5', label: 'Initiative 5'},
  {value: 'Initiative 6', label: 'Initiative 6'},
  {value: 'Initiative 7', label: 'Initiative 7'},
  {value: 'Initiative 8', label: 'Initiative 8'},
  {value: 'Initiative 9', label: 'Initiative 9'},
  {value: 'Initiative 10', label: 'Initiative 10'},
  {value: 'Initiative 11', label: 'Initiative 11'},
  {value: 'Initiative 12', label: 'Initiative 12'},
  {value: 'Initiative 13', label: 'Initiative 13'},
  {value: 'Initiative 14', label: 'Initiative 14'},
  {value: 'Initiative 15', label: 'Initiative 15'},
  {value: 'Initiative 16', label: 'Initiative 16'},
  {value: 'Initiative 17', label: 'Initiative 17'},
  {value: 'Initiative 18', label: 'Initiative 18'},
  {value: 'Initiative 19', label: 'Initiative 19'},
  {value: 'Initiative 20', label: 'Initiative 20'},
  {value: 'Initiative 21', label: 'Initiative 21'},
  {value: 'Initiative 22', label: 'Initiative 22'},
  {value: 'Initiative 23', label: 'Initiative 23'},
  {value: 'Initiative 24', label: 'Initiative 24'},
  {value: 'Initiative 25', label: 'Initiative 25'},
  {value: 'Initiative 26', label: 'Initiative 26'},
  {value: 'Initiative 27', label: 'Initiative 27'},
  {value: 'Initiative 28', label: 'Initiative 28'},
  {value: 'Initiative 29', label: 'Initiative 29'},
  {value: 'Initiative 30', label: 'Initiative 30'}
];

export const COMPLETED_OR_PLANNED_OPTIONS = [
  {value: 'Completed', label: 'Completed'},
  {value: 'Ongoing', label: 'Ongoing'},
  {value: 'Planned', label: 'Planned'}
];

export const LEVEL_OF_AGGREGATION_OPTIONS = [
  {value: 'Product or service', label: 'Product or service'},
  {
    value: 'Group of products or services',
    label: 'Group of products or services'
  }
];

export const TAXONOMY_USED_TO_CLASSIFY_PRODUCTS_OR_SERVICES_AS_LOW_CARBON_OPTIONS =
  [
    {
      value: 'Low-Carbon Investment (LCI) Registry Taxonomy',
      label: 'Low-Carbon Investment (LCI) Registry Taxonomy'
    },
    {value: 'Climate Bonds Taxonomy', label: 'Climate Bonds Taxonomy'},
    {
      value:
        'The EU Taxonomy for environmentally sustainable economic activities',
      label:
        'The EU Taxonomy for environmentally sustainable economic activities'
    },
    {
      value: 'Green Bond Principles (ICMA)',
      label: 'Green Bond Principles (ICMA)'
    },
    {
      value:
        'The IEA Energy Technology Perspectives Clean Energy Technology Guide',
      label:
        'The IEA Energy Technology Perspectives Clean Energy Technology Guide'
    },
    {
      value: 'WBCSD Guidance on Avoided Emissions',
      label: 'WBCSD Guidance on Avoided Emissions'
    },
    {
      value:
        'No taxonomy used to classify product(s) or service(s) as low carbon',
      label:
        'No taxonomy used to classify product(s) or service(s) as low carbon'
    },
    {value: 'Other, please specify', label: 'Other, please specify'}
  ];

export const TYPES_OF_PRODUCTS_OR_SERVICES_OPTIONS = [
  {
    label: 'Power',
    options: [
      {value: 'Dry steam plant [EU]', label: 'Dry steam plant [EU]'},
      {value: 'Flash steam plant [EU]', label: 'Flash steam plant [EU]'},
      {value: 'Flywheel [EU]', label: 'Flywheel [EU]'},
      {
        value: 'Geothermal electricity [EU]',
        label: 'Geothermal electricity [EU]'
      },
      {value: 'Hydropower [EU]', label: 'Hydropower [EU]'},
      {
        value: 'Large-scale light-water nuclear reactor [EU]',
        label: 'Large-scale light-water nuclear reactor [EU]'
      },
      {
        value: 'Liquid air energy storage (LAES) [EU]',
        label: 'Liquid air energy storage (LAES) [EU]'
      },
      {
        value: 'Lithium-ion batteries [EU, TO, TS]',
        label: 'Lithium-ion batteries [EU, TO, TS]'
      },
      {value: 'Multi-junction cell [EU]', label: 'Multi-junction cell [EU]'},
      {value: 'Onshore wind [EU]', label: 'Onshore wind [EU]'},
      {
        value: 'Organic Rankine cycle [EU]',
        label: 'Organic Rankine cycle [EU]'
      },
      {value: 'Parabolic trough [EU]', label: 'Parabolic trough [EU]'},
      {value: 'Pumped storage [EU]', label: 'Pumped storage [EU]'},
      {
        value: 'Seabed fixed offshore wind turbine [EU]',
        label: 'Seabed fixed offshore wind turbine [EU]'
      },
      {
        value: 'Small-scale light-water nuclear reactor [EU]',
        label: 'Small-scale light-water nuclear reactor [EU]'
      },
      {value: 'Solar PV [EU, CN, RE]', label: 'Solar PV [EU, CN, RE]'},
      {value: 'Solar tower [CN, RE, EU]', label: 'Solar tower [CN, RE, EU]'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Heat',
    options: [
      {
        value: 'Geothermal heat management',
        label: 'Geothermal heat management'
      },
      {value: 'Large-scale heat pump', label: 'Large-scale heat pump'},
      {value: 'Latent heat storage (LHS)', label: 'Latent heat storage (LHS)'},
      {
        value: 'Solar thermal district heating [EU]',
        label: 'Solar thermal district heating [EU]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Biofules',
    options: [
      {value: 'Anaerobic digestor', label: 'Anaerobic digestor'},
      {value: 'Bioethanol', label: 'Bioethanol'},
      {value: 'Biomass gasification', label: 'Biomass gasification'},
      {
        value: 'Fatty acid methyl ester (FAME) [TO, TS]',
        label: 'Fatty acid methyl ester (FAME) [TO, TS]'
      },
      {
        value: 'Hydrogenated vegetable oil',
        label: 'Hydrogenated vegetable oil'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Hydrogen',
    options: [
      {value: 'Electrolysis [EU]', label: 'Electrolysis [EU]'},
      {value: 'Hydrogen pipelines [EU]', label: 'Hydrogen pipelines [EU]'},
      {value: 'Hydrogen storage tanks', label: 'Hydrogen storage tanks'},
      {
        value: 'Salt cavern hydrogen storage',
        label: 'Salt cavern hydrogen storage'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Ammonia',
    options: [
      {value: 'Ammonia tankers', label: 'Ammonia tankers'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Batteries',
    options: [
      {value: 'Copper recycling', label: 'Copper recycling'},
      {value: 'Cathode recycling', label: 'Cathode recycling'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Road',
    options: [
      {
        value: 'Compressed biogas engines [TO, TS]',
        label: 'Compressed biogas engines [TO, TS]'
      },
      {
        value: 'Ethanol-fuelled diesel engine [TO, TS]',
        label: 'Ethanol-fuelled diesel engine [TO, TS]'
      },
      {
        value: 'Hydrogen fuel cell [TO, TS]',
        label: 'Hydrogen fuel cell [TO, TS]'
      },
      {
        value: 'Hydrogen Refuelling Station [TO, TS]',
        label: 'Hydrogen Refuelling Station [TO, TS]'
      },
      {
        value: 'Liquified biogas engines [TO, TS]',
        label: 'Liquified biogas engines [TO, TS]'
      },
      {
        value: 'Lithium-ion batteries [EU, TO, TS]',
        label: 'Lithium-ion batteries [EU, TO, TS]'
      },
      {
        value: 'Polymer electrolyte membrane fuel cell [TO, TS]',
        label: 'Polymer electrolyte membrane fuel cell [TO, TS]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Rail',
    options: [
      {
        value: 'Magnetic levitation [TO, TS]',
        label: 'Magnetic levitation [TO, TS]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Shipping',
    options: [
      {
        value: 'Ammonia bunkering [TO, TS]',
        label: 'Ammonia bunkering [TO, TS]'
      },
      {
        value: 'Cold ironing / alternative maritime power [TO, TS]',
        label: 'Cold ironing / alternative maritime power [TO, TS]'
      },
      {
        value: 'Foul Release Hull Coating [TO, TS]',
        label: 'Foul Release Hull Coating [TO, TS]'
      },
      {
        value: 'Liquified biogas engines [TO, TS]',
        label: 'Liquified biogas engines [TO, TS]'
      },
      {value: 'Rudder bulb [TO, TS]', label: 'Rudder bulb [TO, TS]'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Aviation',
    options: [
      {
        value: 'Geared Turbo Fan / Ultra-High Bypass Ratio engine [TO, TS]',
        label: 'Geared Turbo Fan / Ultra-High Bypass Ratio engine [TO, TS]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Chemicals and Plastics',
    options: [
      {
        value: 'Chemical absorption of CO₂ [CH, ST]',
        label: 'Chemical absorption of CO₂ [CH, ST]'
      },
      {
        value: 'Physical absorption of CO₂ [CH]',
        label: 'Physical absorption of CO₂ [CH]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Iron and Steel',
    options: [
      {
        value: 'Chemical absorption of CO₂ [CH, ST]',
        label: 'Chemical absorption of CO₂ [CH, ST]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Cement and Concrete',
    options: [
      {value: 'Calcined clay [CE]', label: 'Calcined clay [CE]'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Pulp and Paper',
    options: [
      {value: 'Lignin extraction [CH]', label: 'Lignin extraction [CH]'},
      {
        value: 'Black liquor gasification [EU, CH]',
        label: 'Black liquor gasification [EU, CH]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Aluminum',
    options: [
      {
        value: 'Additive manufacturing [CG]',
        label: 'Additive manufacturing [CG]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'CO₂ Storage',
    options: [
      {
        value: 'CO₂-enhanced oil recovery [OG]',
        label: 'CO₂-enhanced oil recovery [OG]'
      },
      {value: 'Saline formation', label: 'Saline formation'},
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Buildings Construction and Renovation',
    options: [
      {
        value: 'Building orientation: Lighting [CN, RE]',
        label: 'Building orientation: Lighting [CN, RE]'
      },
      {
        value: 'Building orientation: Thermal performance [CN, RE]',
        label: 'Building orientation: Thermal performance [CN, RE]'
      },
      {value: 'Composite materials [CN]', label: 'Composite materials [CN]'},
      {
        value: 'Dual flow ventilation [CN, RE]',
        label: 'Dual flow ventilation [CN, RE]'
      },
      {
        value: 'Dynamic simulation [CN, RE]',
        label: 'Dynamic simulation [CN, RE]'
      },
      {
        value: 'Foam, caulk, tape, or gaskets [CN]',
        label: 'Foam, caulk, tape, or gaskets [CN]'
      },
      {
        value: 'Modular components [CN, RE]',
        label: 'Modular components [CN, RE]'
      },
      {
        value: 'Natural ventilation [CN, RE]',
        label: 'Natural ventilation [CN, RE]'
      },
      {value: 'Pre-casting [CN]', label: 'Pre-casting [CN]'},
      {
        value: 'Structural Insulated Panel [CN, RE]',
        label: 'Structural Insulated Panel [CN, RE]'
      },
      {
        value: 'Thick crystal products or thin-film products [CN, RE]',
        label: 'Thick crystal products or thin-film products [CN, RE]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Heating and Cooling',
    options: [
      {
        value: 'Advanced heat exchanger [CN, RE]',
        label: 'Advanced heat exchanger [CN, RE]'
      },
      {
        value: 'Air-source heat pump using heat recovery [CN, RE]',
        label: 'Air-source heat pump using heat recovery [CN, RE]'
      },
      {
        value: 'Aquifer thermal energy storage (ATES) [CN, RE]',
        label: 'Aquifer thermal energy storage (ATES) [CN, RE]'
      },
      {
        value: 'Borehole thermal energy storage (BTES) [CN]',
        label: 'Borehole thermal energy storage (BTES) [CN]'
      },
      {
        value: 'Central heat pump water heaters [CN, RE]',
        label: 'Central heat pump water heaters [CN, RE]'
      },
      {value: 'Chilled water storage', label: 'Chilled water storage'},
      {value: 'Ground-source heat pump', label: 'Ground-source heat pump'},
      {value: 'Hot water tank', label: 'Hot water tank'},
      {value: 'Hydrogen boiler [CN, RE]', label: 'Hydrogen boiler [CN, RE]'},
      {
        value: 'Pellets burning stove and boiler [CN, RE]',
        label: 'Pellets burning stove and boiler [CN, RE]'
      },
      {
        value: 'Solid-liquid ice storage [CN, RE]',
        label: 'Solid-liquid ice storage [CN, RE]'
      },
      {
        value: 'State-of-the-art air-to-air technology [CN, RE]',
        label: 'State-of-the-art air-to-air technology [CN, RE]'
      },
      {
        value: 'Wood burning stove [CN, RE]',
        label: 'Wood burning stove [CN, RE]'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  [
    {
      label: 'Cooking',
      options: [
        {value: 'Bag digester', label: 'Bag digester'},
        {
          value: 'Composite material digester [CN]',
          label: 'Composite material digester [CN]'
        },
        {
          value: 'Improved biomass cooking stove [CN, RE]',
          label: 'Improved biomass cooking stove [CN, RE]'
        },
        {
          value: 'Induction cooker [CN, RE]',
          label: 'Induction cooker [CN, RE]'
        },
        {
          value: 'LPG cooking stove [CN, RE]',
          label: 'LPG cooking stove [CN, RE]'
        },
        {
          value: 'Vitroceramic / hot plate cooking stoves [CN, RE]',
          label: 'Vitroceramic / hot plate cooking stoves [CN, RE]'
        },
        {value: 'Other, please specify', label: 'Other, please specify'}
      ]
    },
    {
      label: 'Lighting',
      options: [
        {value: 'Conventional LED', label: 'Conventional LED'},
        {value: 'Organic LED', label: 'Organic LED'},
        {value: 'Polymer LED [CN, RE]', label: 'Polymer LED [CN, RE]'},
        {value: 'Other, please specify', label: 'Other, please specify'}
      ]
    },
    {
      label: 'Systems Integration',
      options: [
        {value: 'Double smart grid', label: 'Double smart grid'},
        {value: 'Smart meter', label: 'Smart meter'},
        {value: 'Other, please specify', label: 'Other, please specify'}
      ]
    },
    {
      label: 'CO₂ Transport',
      options: [
        {value: 'Pipeline', label: 'Pipeline'},
        {value: 'Other, please specify', label: 'Other, please specify'}
      ]
    },
    {
      label: 'Other',
      options: [
        {
          value: 'Hybrid flexible demand and battery network',
          label: 'Hybrid flexible demand and battery network'
        },
        {
          value: 'Induction heating for large-scale industrial processes',
          label: 'Induction heating for large-scale industrial processes'
        },
        {
          value: 'Infrared heating for large-scale industrial processes',
          label: 'Infrared heating for large-scale industrial processes'
        },
        {value: 'Other, please specify', label: 'Other, please specify'}
      ]
    }
  ]
];

export const METHOD_USED_TO_CALCULATE_AVOIDED_EMISSIONS_OPTIONS = [
  {
    value: 'Addressing the Avoided Emissions Challenge – Chemicals sector',
    label: 'Addressing the Avoided Emissions Challenge – Chemicals sector'
  },
  {
    value: 'The Avoided Emissions Framework (AEF)',
    label: 'The Avoided Emissions Framework (AEF)'
  },
  {
    value: 'Evaluating the carbon-reducing impacts of ICT',
    label: 'Evaluating the carbon-reducing impacts of ICT'
  },
  {
    value:
      'Estimating and Reporting the Comparative Emissions Impacts of Products (WRI)',
    label:
      'Estimating and Reporting the Comparative Emissions Impacts of Products (WRI)'
  },
  {
    value:
      'Guidelines for Assessing the Contribution of Products to Avoided Greenhouse Gas Emissions (ILCA)',
    label:
      'Guidelines for Assessing the Contribution of Products to Avoided Greenhouse Gas Emissions (ILCA)'
  },
  {
    value:
      'Methodology for Environmental Life-Cycle Assessment of Information and Communication Technology Goods, Networks and Services (ITUTL.1410)',
    label:
      'Methodology for Environmental Life-Cycle Assessment of Information and Communication Technology Goods, Networks and Services (ITUTL.1410)'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

// export const METRIC_OPTIONS = [
//   {value: 'Production', label: 'Production'},
//   {value: 'Sales', label: 'Sales'},
//   {value: 'Fleet adoption', label: 'Fleet adoption'},
//   {value: 'Yearly purchase', label: 'Yearly purchase'},
//   {value: 'Other, please specify', label: 'Other, please specify'}
// ];

export const TECHNOLOGY_OPTIONS = [
  {
    label: 'LDV / HDV',
    options: [
      {value: 'Vehicle using biofuel', label: 'Vehicle using biofuel'},
      {value: 'Conventional hybrid', label: 'Conventional hybrid'},
      {value: 'Plug-in hybrid (PHEV)', label: 'Plug-in hybrid (PHEV)'},
      {
        value: 'Battery electric vehicle (BEV)',
        label: 'Battery electric vehicle (BEV)'
      },
      {
        value: 'Fuel cell electric vehicle (FCEV)',
        label: 'Fuel cell electric vehicle (FCEV)'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Rail',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Marine',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Aviation',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const METRIC_UNIT_OPTIONS = [
  {
    label: 'LDV / HDV',
    options: [
      {value: 'Units', label: 'Units'},
      {value: '% of fleet', label: '% of fleet'},
      {value: '% of total sales', label: '% of total sales'},
      {value: '% of estimated yearly VKT', label: '% of estimated yearly VKT'},
      {value: '% of estimated yearly VMT', label: '% of estimated yearly VMT'},
      {
        value: '% of estimated lifetime VKT',
        label: '% of estimated lifetime VKT'
      },
      {
        value: '% of estimated lifetime VMT',
        label: '% of estimated lifetime VMT'
      },
      {value: 'Other, please specify', label: 'Other, please specify'}
    ]
  },
  {
    label: 'Rail',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Marine',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  },
  {
    label: 'Aviation',
    options: [{value: 'Other, please specify', label: 'Other, please specify'}]
  }
];

export const DEFINITION_OF_NET_ZERO_CARBON_OPTIONS = [
  {
    value: 'National/local green building council standard(s), please specify',
    label: 'National/local green building council standard(s), please specify'
  },
  {
    value: 'National/local government standard(s), please specify',
    label: 'National/local government standard(s), please specify'
  },
  {
    value: 'International standard(s), please specify',
    label: 'International standard(s), please specify'
  },
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const CERTIFICATION_SCHEME_OPTIONS = [
  {
    value: 'CaGBC Zero Carbon Building Standard – Performance',
    label: 'CaGBC Zero Carbon Building Standard – Performance'
  },
  {
    value:
      'Carbon neutral certification against the National Carbon Offset Standard for Building through NABERS Energy',
    label:
      'Carbon neutral certification against the National Carbon Offset Standard for Building through NABERS Energy'
  },
  {
    value:
      'Carbon neutral certification against the National Carbon Offset Standard for Building through Green Star – Performance Innovation Challenges',
    label:
      'Carbon neutral certification against the National Carbon Offset Standard for Building through Green Star – Performance Innovation Challenges'
  },
  {value: 'carboNZeroCert™ (NZGBC)', label: 'carboNZeroCert™ (NZGBC)'},
  {
    value: 'E+C- Label (Énergie Positive & Réduction Carbone)',
    label: 'E+C- Label (Énergie Positive & Réduction Carbone)'
  },
  {value: 'EDGE Zero Carbon', label: 'EDGE Zero Carbon'},
  {value: 'Climate Positive (DGNB)', label: 'Climate Positive (DGNB)'},
  {
    value: 'GBC Brazil Zero Energy Standard',
    label: 'GBC Brazil Zero Energy Standard'
  },
  {
    value: 'GBCSA Net Zero/Net Positive Carbon Certification',
    label: 'GBCSA Net Zero/Net Positive Carbon Certification'
  },
  {
    value: 'GREENSHIP Zero (GBC Indonesia)',
    label: 'GREENSHIP Zero (GBC Indonesia)'
  },
  {
    value: 'Indian GBC Zero Energy Standard',
    label: 'Indian GBC Zero Energy Standard'
  },
  {
    value: 'ILFI Living Building Challenge',
    label: 'ILFI Living Building Challenge'
  },
  {
    value: 'ILFI Zero Carbon Certification',
    label: 'ILFI Zero Carbon Certification'
  },
  {
    value: 'ILFI Zero Energy Building Certification',
    label: 'ILFI Zero Energy Building Certification'
  },
  {value: 'LEED Zero Carbon', label: 'LEED Zero Carbon'},
  {value: 'LEED Zero Energy', label: 'LEED Zero Energy'},
  {value: 'NollCO2 (SwedenGBC)', label: 'NollCO2 (SwedenGBC)'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const FURTURE_PLANS_OPTIONS = [
  {
    value: 'No but we plan to in the future',
    label: 'No but we plan to in the future'
  },
  {value: 'Yes', label: 'Yes'},
  {
    value: 'No and we do not plan to in the future',
    label: 'No and we do not plan to in the future'
  }
];

// export const PROJECT_TYPE_OPTIONS = [
//   {value: 'Afforestation', label: 'Afforestation'},
//   {value: 'Agriculture', label: 'Agriculture'},
//   {value: 'Agroforestry', label: 'Agroforestry'},
//   {value: 'Biochar', label: 'Biochar'},
//   {
//     value: 'Bioenergy with carbon capture and storage (BECCS)',
//     label: 'Bioenergy with carbon capture and storage (BECCS)'
//   },
//   {value: 'Biomass energy', label: 'Biomass energy'},
//   {value: 'Cement', label: 'Cement'},
//   {value: 'Coal mine/bed methane', label: 'Coal mine/bed methane'},
//   {
//     value: 'Clean cookstove distribution',
//     label: 'Clean cookstove distribution'
//   },
//   {value: 'Community projects', label: 'Community projects'},
//   {value: 'Direct air capture (DAC)', label: 'Direct air capture (DAC)'},
//   {value: 'Energy distribution', label: 'Energy distribution'},
//   {
//     value: 'Energy efficiency: households',
//     label: 'Energy efficiency: households'
//   },
//   {value: 'Energy efficiency: industry', label: 'Energy efficiency: industry'},
//   {
//     value: 'Energy efficiency: own generation',
//     label: 'Energy efficiency: own generation'
//   },
//   {value: 'Energy efficiency: service', label: 'Energy efficiency: service'},
//   {
//     value: 'Energy efficiency: supply side',
//     label: 'Energy efficiency: supply side'
//   },
//   {
//     value: 'Enhanced weathering and ocean alkalization',
//     label: 'Enhanced weathering and ocean alkalization'
//   },
//   {
//     value: 'Forest ecosystem restoration',
//     label: 'Forest ecosystem restoration'
//   },
//   {value: 'Fossil fuel switch', label: 'Fossil fuel switch'},
//   {value: 'Fugitive', label: 'Fugitive'},
//   {value: 'Geothermal', label: 'Geothermal'},
//   {value: 'HFCs', label: 'HFCs'},
//   {value: 'Hydro', label: 'Hydro'},
//   {value: 'Landfill gas', label: 'Landfill gas'},
//   {value: 'Landscape projects', label: 'Landscape projects'},
//   {value: 'Natural regeneration', label: 'Natural regeneration'},
//   {
//     value: 'Mangrove protection and restoration',
//     label: 'Mangrove protection and restoration'
//   },
//   {value: 'Methane avoidance', label: 'Methane avoidance'},
//   {value: 'Mixed renewables', label: 'Mixed renewables'},
//   {value: 'N₂O', label: 'N₂O'},
//   {value: 'Ocean fertilization', label: 'Ocean fertilization'},
//   {
//     value: 'Peatland protection and restoration',
//     label: 'Peatland protection and restoration'
//   },
//   {value: 'PFCs and SF₆', label: 'PFCs and SF₆'},
//   {value: 'Reforestation', label: 'Reforestation'},
//   {value: 'Soil carbon sequestration', label: 'Soil carbon sequestration'},
//   {value: 'Solar', label: 'Solar'},
//   {value: 'Tidal', label: 'Tidal'},
//   {value: 'Transport', label: 'Transport'},
//   {value: 'Waste management', label: 'Waste management'},
//   {value: 'Wind', label: 'Wind'},
//   {value: 'Other, please specify', label: 'Other, please specify'}
// ];

export const TYPE_OF_MITIGATION_ACTIVITY_OPTIONS = [
  {value: 'Emission reduction', label: 'Emission reduction'},
  {value: 'Carbon removal', label: 'Carbon removal'}
];

export const PURPOSE_OF_RETIREMENT_OPTIONS = [
  {
    value: 'Compliance with a carbon pricing system',
    label: 'Compliance with a carbon pricing system'
  },
  {value: 'Voluntary offsetting', label: 'Voluntary offsetting'},
  {value: 'Other, please specify', label: 'Other, please specify'}
];

export const WERE_THESE_CREDITS_ISSUED_OR_PURCHASED_BY_YOUR_ORGANIZATION_OPTIONS =
  [
    {value: 'Issued', label: 'Issued'},
    {value: 'Purchased', label: 'Purchased'}
  ];

export const CARBON_CREDITING_PROGRAM_BY_WHICH_THE_CREDITS_WERE_ISSUED_OPTIONS =
  [
    {
      value: 'Alberta TIER Emission Offset System',
      label: 'Alberta TIER Emission Offset System'
    },
    {
      value: 'ACR (American Carbon Registry)',
      label: 'ACR (American Carbon Registry)'
    },
    {
      value: 'California Air Resources Board Compliance Offset Program',
      label: 'California Air Resources Board Compliance Offset Program'
    },
    {
      value: 'CAR (The Climate Action Reserve)',
      label: 'CAR (The Climate Action Reserve)'
    },
    {
      value: 'CCBS (Climate, Community and Biodiversity Standards)',
      label: 'CCBS (Climate, Community and Biodiversity Standards)'
    },
    {
      value: 'CDM (Clean Development Mechanism)',
      label: 'CDM (Clean Development Mechanism)'
    },
    {value: 'Cercarbono', label: 'Cercarbono'},
    {
      value: 'Emissions Reduction Fund of the Australian Government',
      label: 'Emissions Reduction Fund of the Australian Government'
    },
    {value: 'JI (Joint Implementation)', label: 'JI (Joint Implementation)'},
    {value: 'Plan Vivo', label: 'Plan Vivo'},
    {value: 'Puro.earth', label: 'Puro.earth'},
    {value: 'REDD+', label: 'REDD+'},
    {value: 'Social Carbon', label: 'Social Carbon'},
    {
      value: 'TREES (The REDD+ Environmental Excellence Standard)',
      label: 'TREES (The REDD+ Environmental Excellence Standard)'
    },
    {
      value: 'T-COP (Thailand Carbon Offsetting Program)',
      label: 'T-COP (Thailand Carbon Offsetting Program)'
    },
    {
      value: 'VCS/Verra (Verified Carbon Standard)',
      label: 'VCS/Verra (Verified Carbon Standard)'
    },
    {value: 'VER+ (TÜV SÜD Standard)', label: 'VER+ (TÜV SÜD Standard)'},
    {value: 'Gold Standard', label: 'Gold Standard'},
    {
      value: 'ERS (Ecosystem Restoration Standard)',
      label: 'ERS (Ecosystem Restoration Standard)'
    },
    {value: 'Isometric', label: 'Isometric'},
    {
      value: 'JCM (Joint Crediting Mechanism)',
      label: 'JCM (Joint Crediting Mechanism)'
    },
    {value: 'J-credit (offsets)', label: 'J-credit (offsets)'},
    {value: 'Wilder Carbon', label: 'Wilder Carbon'},
    {value: 'Not issued by a program', label: 'Not issued by a program'},
    {
      value: 'Other private carbon crediting program, please specify',
      label: 'Other private carbon crediting program, please specify'
    },
    {
      value: 'Other regulatory carbon crediting program, please specify',
      label: 'Other regulatory carbon crediting program, please specify'
    }
  ];

export const METHODS_THE_PROGRAM_USES_TO_ASSESS_ADDITIONALITY_FOR_THIS_PROJECT_OPTIONS =
  [
    {
      value: 'Consideration of legal requirements',
      label: 'Consideration of legal requirements'
    },
    {value: 'Investment analysis', label: 'Investment analysis'},
    {value: 'Barrier analysis', label: 'Barrier analysis'},
    {
      value: 'Market penetration assessment',
      label: 'Market penetration assessment'
    },
    {value: 'Standardized Approaches', label: 'Standardized Approaches'},
    {value: 'Other, please specify', label: 'Other, please specify'},
    {value: 'Not assessed', label: 'Not assessed'}
  ];

export const APPROACHES_BY_WHICH_THE_SELECTED_PROGRAM_REQUIRES_THIS_PROJECT_TO_ADDRESS_REVERSAL_RISK_OPTIONS =
  [
    {
      value: 'Monitoring and compensation',
      label: 'Monitoring and compensation'
    },
    {value: 'Temporary crediting', label: 'Temporary crediting'},
    {value: 'Other, please specify', label: 'Other, please specify'},
    {value: 'No requirements', label: 'No requirements'},
    {value: 'No risk of reversal', label: 'No risk of reversal'}
  ];

export const POTENTIAL_SOURCES_OF_LEAKAGE_THE_SELECTED_PROGRAM_REQUIRES_THIS_PROJECT_TO_HAVE_ASSESSED_OPTIONS =
  [
    {
      value: 'Upstream/downstream emissions',
      label: 'Upstream/downstream emissions'
    },
    {value: 'Activity-shifting', label: 'Activity-shifting'},
    {value: 'Market leakage', label: 'Market leakage'},
    {value: 'Ecological leakage', label: 'Ecological leakage'},
    {value: 'Other, please specify', label: 'Other, please specify'},
    {value: 'Not assessed', label: 'Not assessed'}
  ];
